(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRequire.register("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRequire.register("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRequire.register("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRequire.register("kSiIs", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.36
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.36", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRequire.register("jpdgm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $L7tyD = parcelRequire("L7tyD");
function $e20aa3d84dea372f$var$emptyFunction() {}
function $e20aa3d84dea372f$var$emptyFunctionWithReset() {}
$e20aa3d84dea372f$var$emptyFunctionWithReset.resetWarningCache = $e20aa3d84dea372f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $L7tyD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e20aa3d84dea372f$var$emptyFunctionWithReset,
        resetWarningCache: $e20aa3d84dea372f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("L7tyD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $08da306d15728f79$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $08da306d15728f79$var$ReactPropTypesSecret;

});


parcelRequire.register("beWdq", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $82ee28eaccf33045$export$2b8d127b894957b9; }, function (v) { return $82ee28eaccf33045$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $82ee28eaccf33045$export$cea3a54a6425200c; }, function (v) { return $82ee28eaccf33045$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $82ee28eaccf33045$export$a7c73072b1a182ae; }, function (v) { return $82ee28eaccf33045$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $82ee28eaccf33045$export$9f27bc3417b4524d; }, function (v) { return $82ee28eaccf33045$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $82ee28eaccf33045$export$db77ccec0bb4ccac; }, function (v) { return $82ee28eaccf33045$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $82ee28eaccf33045$export$8392c0c9d3dcbd35; }, function (v) { return $82ee28eaccf33045$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $82ee28eaccf33045$export$ffb0004e005737fa; }, function (v) { return $82ee28eaccf33045$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $82ee28eaccf33045$export$b624eff549462981; }, function (v) { return $82ee28eaccf33045$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $82ee28eaccf33045$export$7897aa7841a5380c; }, function (v) { return $82ee28eaccf33045$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $82ee28eaccf33045$export$602eac185826482c; }, function (v) { return $82ee28eaccf33045$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $82ee28eaccf33045$export$e2c29f18771995cb; }, function (v) { return $82ee28eaccf33045$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $82ee28eaccf33045$export$5f8d39834fd61797; }, function (v) { return $82ee28eaccf33045$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $82ee28eaccf33045$export$74bf444e3cd11ea5; }, function (v) { return $82ee28eaccf33045$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $82ee28eaccf33045$export$92387174baf9b227; }, function (v) { return $82ee28eaccf33045$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $82ee28eaccf33045$export$ec112efeb987d9c6; }, function (v) { return $82ee28eaccf33045$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $82ee28eaccf33045$export$b706b080d889d2c9; }, function (v) { return $82ee28eaccf33045$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $82ee28eaccf33045$export$5be5a87408f70ddc; }, function (v) { return $82ee28eaccf33045$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $82ee28eaccf33045$export$45a5e7f76e0caa8d; }, function (v) { return $82ee28eaccf33045$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $82ee28eaccf33045$export$455c2e768291efa6; }, function (v) { return $82ee28eaccf33045$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $82ee28eaccf33045$export$9522e17588c12572; }, function (v) { return $82ee28eaccf33045$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $82ee28eaccf33045$export$2110ac352bb060b9; }, function (v) { return $82ee28eaccf33045$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $82ee28eaccf33045$export$56885ab8b9c456ab; }, function (v) { return $82ee28eaccf33045$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $82ee28eaccf33045$export$d927fcb6adf8f9de; }, function (v) { return $82ee28eaccf33045$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $82ee28eaccf33045$export$b82d16f27459e05a; }, function (v) { return $82ee28eaccf33045$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $82ee28eaccf33045$export$522c17b4f5e123e8; }, function (v) { return $82ee28eaccf33045$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $82ee28eaccf33045$export$1aabd8a0274ecfd6; }, function (v) { return $82ee28eaccf33045$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $82ee28eaccf33045$export$9b621391a187a31a; }, function (v) { return $82ee28eaccf33045$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $82ee28eaccf33045$export$f5bbd400c2f4426f; }, function (v) { return $82ee28eaccf33045$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82ee28eaccf33045$export$2b8d127b894957b9;
var $82ee28eaccf33045$export$cea3a54a6425200c;
var $82ee28eaccf33045$export$a7c73072b1a182ae;
var $82ee28eaccf33045$export$9f27bc3417b4524d;
var $82ee28eaccf33045$export$db77ccec0bb4ccac;
var $82ee28eaccf33045$export$8392c0c9d3dcbd35;
var $82ee28eaccf33045$export$ffb0004e005737fa;
var $82ee28eaccf33045$export$b624eff549462981;
var $82ee28eaccf33045$export$7897aa7841a5380c;
var $82ee28eaccf33045$export$602eac185826482c;
var $82ee28eaccf33045$export$e2c29f18771995cb;
var $82ee28eaccf33045$export$5f8d39834fd61797;
var $82ee28eaccf33045$export$74bf444e3cd11ea5;
var $82ee28eaccf33045$export$92387174baf9b227;
var $82ee28eaccf33045$export$ec112efeb987d9c6;
var $82ee28eaccf33045$export$b706b080d889d2c9;
var $82ee28eaccf33045$export$5be5a87408f70ddc;
var $82ee28eaccf33045$export$45a5e7f76e0caa8d;
var $82ee28eaccf33045$export$455c2e768291efa6;
var $82ee28eaccf33045$export$9522e17588c12572;
var $82ee28eaccf33045$export$2110ac352bb060b9;
var $82ee28eaccf33045$export$56885ab8b9c456ab;
var $82ee28eaccf33045$export$d927fcb6adf8f9de;
var $82ee28eaccf33045$export$b82d16f27459e05a;
var $82ee28eaccf33045$export$522c17b4f5e123e8;
var $82ee28eaccf33045$export$1aabd8a0274ecfd6;
var $82ee28eaccf33045$export$9b621391a187a31a;
var $82ee28eaccf33045$export$f5bbd400c2f4426f;
"use strict";
var $82ee28eaccf33045$var$b = "function" === typeof Symbol && Symbol.for, $82ee28eaccf33045$var$c = $82ee28eaccf33045$var$b ? Symbol.for("react.element") : 60103, $82ee28eaccf33045$var$d = $82ee28eaccf33045$var$b ? Symbol.for("react.portal") : 60106, $82ee28eaccf33045$var$e = $82ee28eaccf33045$var$b ? Symbol.for("react.fragment") : 60107, $82ee28eaccf33045$var$f = $82ee28eaccf33045$var$b ? Symbol.for("react.strict_mode") : 60108, $82ee28eaccf33045$var$g = $82ee28eaccf33045$var$b ? Symbol.for("react.profiler") : 60114, $82ee28eaccf33045$var$h = $82ee28eaccf33045$var$b ? Symbol.for("react.provider") : 60109, $82ee28eaccf33045$var$k = $82ee28eaccf33045$var$b ? Symbol.for("react.context") : 60110, $82ee28eaccf33045$var$l = $82ee28eaccf33045$var$b ? Symbol.for("react.async_mode") : 60111, $82ee28eaccf33045$var$m = $82ee28eaccf33045$var$b ? Symbol.for("react.concurrent_mode") : 60111, $82ee28eaccf33045$var$n = $82ee28eaccf33045$var$b ? Symbol.for("react.forward_ref") : 60112, $82ee28eaccf33045$var$p = $82ee28eaccf33045$var$b ? Symbol.for("react.suspense") : 60113, $82ee28eaccf33045$var$q = $82ee28eaccf33045$var$b ? Symbol.for("react.suspense_list") : 60120, $82ee28eaccf33045$var$r = $82ee28eaccf33045$var$b ? Symbol.for("react.memo") : 60115, $82ee28eaccf33045$var$t = $82ee28eaccf33045$var$b ? Symbol.for("react.lazy") : 60116, $82ee28eaccf33045$var$v = $82ee28eaccf33045$var$b ? Symbol.for("react.block") : 60121, $82ee28eaccf33045$var$w = $82ee28eaccf33045$var$b ? Symbol.for("react.fundamental") : 60117, $82ee28eaccf33045$var$x = $82ee28eaccf33045$var$b ? Symbol.for("react.responder") : 60118, $82ee28eaccf33045$var$y = $82ee28eaccf33045$var$b ? Symbol.for("react.scope") : 60119;
function $82ee28eaccf33045$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $82ee28eaccf33045$var$c:
                switch(a = a.type, a){
                    case $82ee28eaccf33045$var$l:
                    case $82ee28eaccf33045$var$m:
                    case $82ee28eaccf33045$var$e:
                    case $82ee28eaccf33045$var$g:
                    case $82ee28eaccf33045$var$f:
                    case $82ee28eaccf33045$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $82ee28eaccf33045$var$k:
                            case $82ee28eaccf33045$var$n:
                            case $82ee28eaccf33045$var$t:
                            case $82ee28eaccf33045$var$r:
                            case $82ee28eaccf33045$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $82ee28eaccf33045$var$d:
                return u;
        }
    }
}
function $82ee28eaccf33045$var$A(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$m;
}
$82ee28eaccf33045$export$2b8d127b894957b9 = $82ee28eaccf33045$var$l;
$82ee28eaccf33045$export$cea3a54a6425200c = $82ee28eaccf33045$var$m;
$82ee28eaccf33045$export$a7c73072b1a182ae = $82ee28eaccf33045$var$k;
$82ee28eaccf33045$export$9f27bc3417b4524d = $82ee28eaccf33045$var$h;
$82ee28eaccf33045$export$db77ccec0bb4ccac = $82ee28eaccf33045$var$c;
$82ee28eaccf33045$export$8392c0c9d3dcbd35 = $82ee28eaccf33045$var$n;
$82ee28eaccf33045$export$ffb0004e005737fa = $82ee28eaccf33045$var$e;
$82ee28eaccf33045$export$b624eff549462981 = $82ee28eaccf33045$var$t;
$82ee28eaccf33045$export$7897aa7841a5380c = $82ee28eaccf33045$var$r;
$82ee28eaccf33045$export$602eac185826482c = $82ee28eaccf33045$var$d;
$82ee28eaccf33045$export$e2c29f18771995cb = $82ee28eaccf33045$var$g;
$82ee28eaccf33045$export$5f8d39834fd61797 = $82ee28eaccf33045$var$f;
$82ee28eaccf33045$export$74bf444e3cd11ea5 = $82ee28eaccf33045$var$p;
$82ee28eaccf33045$export$92387174baf9b227 = function(a) {
    return $82ee28eaccf33045$var$A(a) || $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$l;
};
$82ee28eaccf33045$export$ec112efeb987d9c6 = $82ee28eaccf33045$var$A;
$82ee28eaccf33045$export$b706b080d889d2c9 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$k;
};
$82ee28eaccf33045$export$5be5a87408f70ddc = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$h;
};
$82ee28eaccf33045$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $82ee28eaccf33045$var$c;
};
$82ee28eaccf33045$export$455c2e768291efa6 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$n;
};
$82ee28eaccf33045$export$9522e17588c12572 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$e;
};
$82ee28eaccf33045$export$2110ac352bb060b9 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$t;
};
$82ee28eaccf33045$export$56885ab8b9c456ab = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$r;
};
$82ee28eaccf33045$export$d927fcb6adf8f9de = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$d;
};
$82ee28eaccf33045$export$b82d16f27459e05a = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$g;
};
$82ee28eaccf33045$export$522c17b4f5e123e8 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$f;
};
$82ee28eaccf33045$export$1aabd8a0274ecfd6 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$p;
};
$82ee28eaccf33045$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $82ee28eaccf33045$var$e || a === $82ee28eaccf33045$var$m || a === $82ee28eaccf33045$var$g || a === $82ee28eaccf33045$var$f || a === $82ee28eaccf33045$var$p || a === $82ee28eaccf33045$var$q || "object" === typeof a && null !== a && (a.$$typeof === $82ee28eaccf33045$var$t || a.$$typeof === $82ee28eaccf33045$var$r || a.$$typeof === $82ee28eaccf33045$var$h || a.$$typeof === $82ee28eaccf33045$var$k || a.$$typeof === $82ee28eaccf33045$var$n || a.$$typeof === $82ee28eaccf33045$var$w || a.$$typeof === $82ee28eaccf33045$var$x || a.$$typeof === $82ee28eaccf33045$var$y || a.$$typeof === $82ee28eaccf33045$var$v);
};
$82ee28eaccf33045$export$f5bbd400c2f4426f = $82ee28eaccf33045$var$z;

});

parcelRequire.register("flL8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2cd6289b57fc858$export$2e2bcd8739ae039; });
/* global window */ 
var $cctDJ = parcelRequire("cctDJ");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $cctDJ.default)(root);
var $b2cd6289b57fc858$export$2e2bcd8739ae039 = result;

});
parcelRequire.register("cctDJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e1d98e358940a28$export$2e2bcd8739ae039; });
function $8e1d98e358940a28$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}

});


parcelRequire.register("7HKs8", function(module, exports) {

var $8ThvE = parcelRequire("8ThvE");

var $jjS2x = parcelRequire("jjS2x");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8ThvE.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $jjS2x;
module.exports = isBuffer;

});
parcelRequire.register("8ThvE", function(module, exports) {

var $lyxRX = parcelRequire("lyxRX");
/** Detect free variable `self`. */ var $67910ad3df1b1086$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $67910ad3df1b1086$var$root = $lyxRX || $67910ad3df1b1086$var$freeSelf || Function("return this")();
module.exports = $67910ad3df1b1086$var$root;

});
parcelRequire.register("lyxRX", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $fb170ba8a9c2191f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $fb170ba8a9c2191f$var$freeGlobal;

});


parcelRequire.register("jjS2x", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e109b5e12b59d0d6$var$stubFalse() {
    return false;
}
module.exports = $e109b5e12b59d0d6$var$stubFalse;

});


parcelRequire.register("7vc1R", function(module, exports) {

var $lyxRX = parcelRequire("lyxRX");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $lyxRX.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("6ObR8"));


parcelRequire("exYeM");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";
var $97dc602bd7e23afa$exports = {};
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

$97dc602bd7e23afa$exports = (parcelRequire("h8vP0"));


var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $97dc602bd7e23afa$exports.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $97dc602bd7e23afa$exports.hydrateRoot;



parcelRequire("exYeM");

parcelRequire("exYeM");

parcelRequire("exYeM");
const $0560d699d69cf4bb$export$3f68a6c8e931da17 = "Connections";
const $0560d699d69cf4bb$export$7ea57ed97bda1046 = 4;


/**
 * lucide-react v0.288.0 - ISC
 */ /**
 * lucide-react v0.288.0 - ISC
 */ 
var $exYeM = parcelRequire("exYeM");
/**
 * lucide-react v0.288.0 - ISC
 */ var $52e2014e5c8e37ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


const $84967fc29334d97c$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $84967fc29334d97c$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $exYeM.forwardRef)(({ color: color = "currentColor" , size: size = 24 , strokeWidth: strokeWidth = 2 , absoluteStrokeWidth: absoluteStrokeWidth , children: children , ...rest }, ref)=>(0, $exYeM.createElement)("svg", {
            ref: ref,
            ...(0, $52e2014e5c8e37ec$export$2e2bcd8739ae039),
            width: size,
            height: size,
            stroke: color,
            strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
            className: `lucide lucide-${$84967fc29334d97c$export$73bda83cddbc7187(iconName)}`,
            ...rest
        }, [
            ...iconNode.map(([tag, attrs])=>(0, $exYeM.createElement)(tag, attrs)),
            ...(Array.isArray(children) ? children : [
                children
            ]) || []
        ]));
    Component.displayName = `${iconName}`;
    return Component;
};


const $84da28061cdedf92$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Info", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
]);




var $exYeM = parcelRequire("exYeM");
function $7d07ba38ace95d14$export$2e2bcd8739ae039() {
    $7d07ba38ace95d14$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d07ba38ace95d14$export$2e2bcd8739ae039.apply(this, arguments);
}



var $exYeM = parcelRequire("exYeM");
function $a20bcd1655f7f422$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $exYeM = parcelRequire("exYeM");
function $e1a745ecb8941240$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $exYeM.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $exYeM.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $exYeM.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $e1a745ecb8941240$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $exYeM.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $exYeM.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $exYeM.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $exYeM.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $e1a745ecb8941240$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $e1a745ecb8941240$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope , scopeName: scopeName  })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $exYeM.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$a0301a3b12ffad9c$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $exYeM.useCallback)($a0301a3b12ffad9c$export$43e446d32b3d21af(...refs), refs);
}




var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = (0, $exYeM.Children).toArray(children);
    const slottable = childrenArray.find($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $exYeM.Children).count(newElement) > 1) return (0, $exYeM.Children).only(null);
                return /*#__PURE__*/ (0, $exYeM.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $exYeM.createElement)($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $exYeM.isValidElement)(newElement) ? /*#__PURE__*/ (0, $exYeM.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $exYeM.createElement)($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$8d4dfd758f40b63f$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if (/*#__PURE__*/ (0, $exYeM.isValidElement)(children)) return /*#__PURE__*/ (0, $exYeM.cloneElement)(children, {
        ...$8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $a0301a3b12ffad9c$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $exYeM.Children).count(children) > 1 ? (0, $exYeM.Children).only(null) : null;
});
$8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $exYeM.isValidElement)(child) && child.type === $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45;
}
function $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $8d4dfd758f40b63f$export$be92b6f5f03c0fe9 = $8d4dfd758f40b63f$export$8c6ed5c666ac1360;


// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $ac7c84a01af4e06e$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $96a334e7374a91f2$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $exYeM.useLayoutEffect) : ()=>{};


const $6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$useReactId = $exYeM["useId".toString()] || (()=>undefined);
let $6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$count = 0;
function $6e53b15deb1e14e9$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $exYeM.useState($6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}




var $exYeM = parcelRequire("exYeM");


const $9b1158d53fe98b0a$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $9b1158d53fe98b0a$export$250ffa63cdc0d034 = $9b1158d53fe98b0a$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : node;
        (0, $exYeM.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $exYeM.createElement)(Comp, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $9b1158d53fe98b0a$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $97dc602bd7e23afa$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $9b1158d53fe98b0a$export$be92b6f5f03c0fe9 = $9b1158d53fe98b0a$export$250ffa63cdc0d034;



var $exYeM = parcelRequire("exYeM");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $cec6513cd2787f04$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $exYeM.useRef)(callback);
    (0, $exYeM.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $exYeM.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $exYeM = parcelRequire("exYeM");

function $ceaa710ce91b202b$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $ceaa710ce91b202b$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $exYeM.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $ceaa710ce91b202b$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = (0, $exYeM.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $exYeM.useRef)(value);
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    (0, $exYeM.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $exYeM = parcelRequire("exYeM");
const $9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $9cee77c98b858c29$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)($9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $9cee77c98b858c29$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $exYeM.useContext)($9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $9cee77c98b858c29$export$2881499e37b75b9a = $9cee77c98b858c29$export$c760c09fdd558351;


const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $71edc3b1c9a6f9c6$export$c7109489551a4f4] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $71edc3b1c9a6f9c6$export$8699f7c8af148338 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($71edc3b1c9a6f9c6$export$8699f7c8af148338, {
    displayName: $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , ...groupProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $exYeM.useState)(false);
    const handleEntryFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $exYeM.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $exYeM.useState)(0);
    (0, $exYeM.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $exYeM.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $exYeM.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $exYeM.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $exYeM.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $71edc3b1c9a6f9c6$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    (0, $exYeM.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($71edc3b1c9a6f9c6$export$ab9df7c53fe8454, {
    displayName: $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9 = $71edc3b1c9a6f9c6$export$8699f7c8af148338;
const $71edc3b1c9a6f9c6$export$6d08773d2e66f8f2 = $71edc3b1c9a6f9c6$export$ab9df7c53fe8454;



var $exYeM = parcelRequire("exYeM");



function $4a876f8b5705075b$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $exYeM.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $4a876f8b5705075b$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $4a876f8b5705075b$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $exYeM.Children).only(children);
    const ref = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $exYeM.cloneElement)(child, {
        ref: ref
    }) : null;
};
$4a876f8b5705075b$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $4a876f8b5705075b$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $exYeM.useState)();
    const stylesRef = (0, $exYeM.useRef)({});
    const prevPresentRef = (0, $exYeM.useRef)(present);
    const prevAnimationNameRef = (0, $exYeM.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $4a876f8b5705075b$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $exYeM.useEffect)(()=>{
        const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $97dc602bd7e23afa$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $exYeM.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}






/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$7fe50bc4532e8371$var$$69cb30bb0017df05$var$createTabsContext, $7fe50bc4532e8371$export$355f5bd209d7b13a] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TABS_NAME, [
    (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)
]);
const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useRovingFocusGroupScope = (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)();
const [$7fe50bc4532e8371$var$$69cb30bb0017df05$var$TabsProvider, $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useTabsContext] = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$createTabsContext($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TABS_NAME);
const $7fe50bc4532e8371$export$b2539bed5023c21c = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = "horizontal" , dir: dir , activationMode: activationMode = "automatic" , ...tabsProps } = props;
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($7fe50bc4532e8371$export$b2539bed5023c21c, {
    displayName: $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $7fe50bc4532e8371$export$9712d22edc0d78c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useTabsContext($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($7fe50bc4532e8371$export$9712d22edc0d78c1, {
    displayName: $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $7fe50bc4532e8371$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useTabsContext($7fe50bc4532e8371$var$$69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $71edc3b1c9a6f9c6$export$6d08773d2e66f8f2), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? "active" : "inactive",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else event.preventDefault();
        }),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if ([
                " ",
                "Enter"
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== "manual";
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($7fe50bc4532e8371$export$8114b9fdfdf9f3ba, {
    displayName: $7fe50bc4532e8371$var$$69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $7fe50bc4532e8371$var$$69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $7fe50bc4532e8371$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$useTabsContext($7fe50bc4532e8371$var$$69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0, $exYeM.useRef)(isSelected);
    (0, $exYeM.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected
    }, ({ present: present  })=>/*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
            "data-state": isSelected ? "active" : "inactive",
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? "0s" : undefined
            }
        }), present && children));
});
/*#__PURE__*/ Object.assign($7fe50bc4532e8371$export$bd905d70e8fd2ebb, {
    displayName: $7fe50bc4532e8371$var$$69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $7fe50bc4532e8371$var$$69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $7fe50bc4532e8371$export$be92b6f5f03c0fe9 = $7fe50bc4532e8371$export$b2539bed5023c21c;
const $7fe50bc4532e8371$export$54c2e3dc7acea9f5 = $7fe50bc4532e8371$export$9712d22edc0d78c1;
const $7fe50bc4532e8371$export$41fb9f06171c75f4 = $7fe50bc4532e8371$export$8114b9fdfdf9f3ba;
const $7fe50bc4532e8371$export$7c6e2c02157bb7d2 = $7fe50bc4532e8371$export$bd905d70e8fd2ebb;


function $fecb99b999628060$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $fecb99b999628060$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $fecb99b999628060$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $fecb99b999628060$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fecb99b999628060$export$2e2bcd8739ae039 = $fecb99b999628060$export$4f5d2d50c9deca37;


var $550799e1245f55b5$var$CLASS_PART_SEPARATOR = "-";
function $550799e1245f55b5$export$e3a687438e51f555(config) {
    var classMap = $550799e1245f55b5$export$936eaf1f027937d7(config);
    var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
    function getClassGroupId(className) {
        var classParts = className.split($550799e1245f55b5$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
        if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
        return $550799e1245f55b5$var$getGroupRecursive(classParts, classMap) || $550799e1245f55b5$var$getGroupIdForArbitraryProperty(className);
    }
    function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
        var conflicts = conflictingClassGroups[classGroupId] || [];
        if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
        return conflicts;
    }
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
}
function $550799e1245f55b5$var$getGroupRecursive(classParts, classPartObject) {
    if (classParts.length === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[0];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    var classGroupFromNextClassPart = nextClassPartObject ? $550799e1245f55b5$var$getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
    if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
    if (classPartObject.validators.length === 0) return undefined;
    var classRest = classParts.join($550799e1245f55b5$var$CLASS_PART_SEPARATOR);
    return classPartObject.validators.find(function(_ref) {
        var validator = _ref.validator;
        return validator(classRest);
    })?.classGroupId;
}
var $550799e1245f55b5$var$arbitraryPropertyRegex = /^\[(.+)\]$/;
function $550799e1245f55b5$var$getGroupIdForArbitraryProperty(className) {
    if ($550799e1245f55b5$var$arbitraryPropertyRegex.test(className)) {
        var arbitraryPropertyClassName = $550799e1245f55b5$var$arbitraryPropertyRegex.exec(className)[1];
        var property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
        if (property) // I use two dots here because one dot is used as prefix for class groups in plugins
        return "arbitrary.." + property;
    }
}
/**
 * Exported for testing only
 */ function $550799e1245f55b5$export$936eaf1f027937d7(config) {
    var theme = config.theme, prefix = config.prefix;
    var classMap = {
        nextPart: new Map(),
        validators: []
    };
    var prefixedClassGroupEntries = $550799e1245f55b5$var$getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
    prefixedClassGroupEntries.forEach(function(_ref2) {
        var classGroupId = _ref2[0], classGroup = _ref2[1];
        $550799e1245f55b5$var$processClassesRecursively(classGroup, classMap, classGroupId, theme);
    });
    return classMap;
}
function $550799e1245f55b5$var$processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
    classGroup.forEach(function(classDefinition) {
        if (typeof classDefinition === "string") {
            var classPartObjectToEdit = classDefinition === "" ? classPartObject : $550799e1245f55b5$var$getPart(classPartObject, classDefinition);
            classPartObjectToEdit.classGroupId = classGroupId;
            return;
        }
        if (typeof classDefinition === "function") {
            if ($550799e1245f55b5$var$isThemeGetter(classDefinition)) {
                $550799e1245f55b5$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
                return;
            }
            classPartObject.validators.push({
                validator: classDefinition,
                classGroupId: classGroupId
            });
            return;
        }
        Object.entries(classDefinition).forEach(function(_ref3) {
            var key = _ref3[0], classGroup = _ref3[1];
            $550799e1245f55b5$var$processClassesRecursively(classGroup, $550799e1245f55b5$var$getPart(classPartObject, key), classGroupId, theme);
        });
    });
}
function $550799e1245f55b5$var$getPart(classPartObject, path) {
    var currentClassPartObject = classPartObject;
    path.split($550799e1245f55b5$var$CLASS_PART_SEPARATOR).forEach(function(pathPart) {
        if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
            nextPart: new Map(),
            validators: []
        });
        currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
    });
    return currentClassPartObject;
}
function $550799e1245f55b5$var$isThemeGetter(func) {
    return func.isThemeGetter;
}
function $550799e1245f55b5$var$getPrefixedClassGroupEntries(classGroupEntries, prefix) {
    if (!prefix) return classGroupEntries;
    return classGroupEntries.map(function(_ref4) {
        var classGroupId = _ref4[0], classGroup = _ref4[1];
        var prefixedClassGroup = classGroup.map(function(classDefinition) {
            if (typeof classDefinition === "string") return prefix + classDefinition;
            if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
                var key = _ref5[0], value = _ref5[1];
                return [
                    prefix + key,
                    value
                ];
            }));
            return classDefinition;
        });
        return [
            classGroupId,
            prefixedClassGroup
        ];
    });
}


// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
function $83f7e2d4329bc780$export$cf6a7cbaa5f64437(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function get() {
            return undefined;
        },
        set: function set() {}
    };
    var cacheSize = 0;
    var cache = new Map();
    var previousCache = new Map();
    function update(key, value) {
        cache.set(key, value);
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = new Map();
        }
    }
    return {
        get: function get(key) {
            var value = cache.get(key);
            if (value !== undefined) return value;
            if ((value = previousCache.get(key)) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (cache.has(key)) cache.set(key, value);
            else update(key, value);
        }
    };
}


var $0c28dbc97d0ab2b4$export$61823b46426d06fa = "!";
function $0c28dbc97d0ab2b4$export$b5f40ac45a8dd583(config) {
    var separator = config.separator || ":";
    var isSeparatorSingleCharacter = separator.length === 1;
    var firstSeparatorCharacter = separator[0];
    var separatorLength = separator.length;
    // splitModifiers inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
    return function splitModifiers(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        for(var index = 0; index < className.length; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0) {
                if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + separatorLength;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
        var hasImportantModifier = baseClassNameWithImportantModifier.startsWith($0c28dbc97d0ab2b4$export$61823b46426d06fa);
        var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return {
            modifiers: modifiers,
            hasImportantModifier: hasImportantModifier,
            baseClassName: baseClassName,
            maybePostfixModifierPosition: maybePostfixModifierPosition
        };
    };
}
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ function $0c28dbc97d0ab2b4$export$4f247a60f8a83b3a(modifiers) {
    if (modifiers.length <= 1) return modifiers;
    var sortedModifiers = [];
    var unsortedModifiers = [];
    modifiers.forEach(function(modifier) {
        var isArbitraryVariant = modifier[0] === "[";
        if (isArbitraryVariant) {
            sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([
                modifier
            ]));
            unsortedModifiers = [];
        } else unsortedModifiers.push(modifier);
    });
    sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
    return sortedModifiers;
}


function $c5fbd87b6c24f0b3$export$56ab4ba5b0b25eb0(config) {
    return {
        cache: (0, $83f7e2d4329bc780$export$cf6a7cbaa5f64437)(config.cacheSize),
        splitModifiers: (0, $0c28dbc97d0ab2b4$export$b5f40ac45a8dd583)(config),
        ...(0, $550799e1245f55b5$export$e3a687438e51f555)(config)
    };
}



var $0a16bc22a487f600$var$SPLIT_CLASSES_REGEX = /\s+/;
function $0a16bc22a487f600$export$b41084d9255a3248(classList, configUtils) {
    var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = new Set();
    return classList.trim().split($0a16bc22a487f600$var$SPLIT_CLASSES_REGEX).map(function(originalClassName) {
        var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
        var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
        if (!classGroupId) {
            if (!maybePostfixModifierPosition) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) return {
                isTailwindClass: false,
                originalClassName: originalClassName
            };
            hasPostfixModifier = false;
        }
        var variantModifier = (0, $0c28dbc97d0ab2b4$export$4f247a60f8a83b3a)(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + (0, $0c28dbc97d0ab2b4$export$61823b46426d06fa) : variantModifier;
        return {
            isTailwindClass: true,
            modifierId: modifierId,
            classGroupId: classGroupId,
            originalClassName: originalClassName,
            hasPostfixModifier: hasPostfixModifier
        };
    }).reverse()// Last class in conflict wins, so we need to filter conflicting classes in reverse order.
    .filter(function(parsed) {
        if (!parsed.isTailwindClass) return true;
        var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.has(classId)) return false;
        classGroupsInConflict.add(classId);
        getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
            return classGroupsInConflict.add(modifierId + group);
        });
        return true;
    }).reverse().map(function(parsed) {
        return parsed.originalClassName;
    }).join(" ");
}


/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ function $b33e0cf1caca0afa$export$a8bbfb445e1f163f() {
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < arguments.length){
        if (argument = arguments[index++]) {
            if (resolvedValue = $b33e0cf1caca0afa$var$toValue(argument)) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}
function $b33e0cf1caca0afa$var$toValue(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $b33e0cf1caca0afa$var$toValue(mix[k])) {
                string && (string += " ");
                string += resolvedValue;
            }
        }
    }
    return string;
}


function $977505d5900d4b4d$export$ea2d4fba4d1bd27f() {
    for(var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++)createConfig[_key] = arguments[_key];
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall = initTailwindMerge;
    function initTailwindMerge(classList) {
        var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
        var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, firstCreateConfig());
        configUtils = (0, $c5fbd87b6c24f0b3$export$56ab4ba5b0b25eb0)(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    }
    function tailwindMerge(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = (0, $0a16bc22a487f600$export$b41084d9255a3248)(classList, configUtils);
        cacheSet(classList, result);
        return result;
    }
    return function callTailwindMerge() {
        return functionToCall((0, $b33e0cf1caca0afa$export$a8bbfb445e1f163f).apply(null, arguments));
    };
}


function $3a8335784d5b9630$export$e176af7b8eefe933(key) {
    var themeGetter = function themeGetter(theme) {
        return theme[key] || [];
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
}


var $6e5479f743d57894$var$arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var $6e5479f743d57894$var$fractionRegex = /^\d+\/\d+$/;
var $6e5479f743d57894$var$stringLengths = /*#__PURE__*/ new Set([
    "px",
    "full",
    "screen"
]);
var $6e5479f743d57894$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $6e5479f743d57894$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
// Shadow always begins with x and y offset separated by underscore
var $6e5479f743d57894$var$shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function $6e5479f743d57894$export$38db3d147cb3433(value) {
    return $6e5479f743d57894$export$7e4aa119212bc614(value) || $6e5479f743d57894$var$stringLengths.has(value) || $6e5479f743d57894$var$fractionRegex.test(value) || $6e5479f743d57894$export$f5e3af6d4c0fbe38(value);
}
function $6e5479f743d57894$export$f5e3af6d4c0fbe38(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "length", $6e5479f743d57894$var$isLengthOnly);
}
function $6e5479f743d57894$export$92dbd3a305a7cb8b(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "size", $6e5479f743d57894$var$isNever);
}
function $6e5479f743d57894$export$57d00f225f425549(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "position", $6e5479f743d57894$var$isNever);
}
function $6e5479f743d57894$export$478a5386e985802b(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "url", $6e5479f743d57894$var$isUrl);
}
function $6e5479f743d57894$export$ea45ce4f1b2d6088(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "number", $6e5479f743d57894$export$7e4aa119212bc614);
}
/**
 * @deprecated Will be removed in next major version. Use `isArbitraryNumber` instead.
 */ var $6e5479f743d57894$export$cd3ce15f42623f06 = $6e5479f743d57894$export$ea45ce4f1b2d6088;
function $6e5479f743d57894$export$7e4aa119212bc614(value) {
    return !Number.isNaN(Number(value));
}
function $6e5479f743d57894$export$e50269385c77c348(value) {
    return value.endsWith("%") && $6e5479f743d57894$export$7e4aa119212bc614(value.slice(0, -1));
}
function $6e5479f743d57894$export$a287f47fed4544b8(value) {
    return $6e5479f743d57894$var$isIntegerOnly(value) || $6e5479f743d57894$var$getIsArbitraryValue(value, "number", $6e5479f743d57894$var$isIntegerOnly);
}
function $6e5479f743d57894$export$5534a8576501817d(value) {
    return $6e5479f743d57894$var$arbitraryValueRegex.test(value);
}
function $6e5479f743d57894$export$ebb65efc98a3b5f7() {
    return true;
}
function $6e5479f743d57894$export$a40791c6b7db5bcc(value) {
    return $6e5479f743d57894$var$tshirtUnitRegex.test(value);
}
function $6e5479f743d57894$export$d01106465b385604(value) {
    return $6e5479f743d57894$var$getIsArbitraryValue(value, "", $6e5479f743d57894$var$isShadow);
}
function $6e5479f743d57894$var$getIsArbitraryValue(value, label, testValue) {
    var result = $6e5479f743d57894$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return result[1] === label;
        return testValue(result[2]);
    }
    return false;
}
function $6e5479f743d57894$var$isLengthOnly(value) {
    return $6e5479f743d57894$var$lengthUnitRegex.test(value);
}
function $6e5479f743d57894$var$isNever() {
    return false;
}
function $6e5479f743d57894$var$isUrl(value) {
    return value.startsWith("url(");
}
function $6e5479f743d57894$var$isIntegerOnly(value) {
    return Number.isInteger(Number(value));
}
function $6e5479f743d57894$var$isShadow(value) {
    return $6e5479f743d57894$var$shadowRegex.test(value);
}


function $39e8cc7bc85c774b$export$ed30944e0fe6ae5c() {
    var colors = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("colors");
    var spacing = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("spacing");
    var blur = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("blur");
    var brightness = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("brightness");
    var borderColor = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("borderColor");
    var borderRadius = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("borderRadius");
    var borderSpacing = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("borderSpacing");
    var borderWidth = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("borderWidth");
    var contrast = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("contrast");
    var grayscale = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("grayscale");
    var hueRotate = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("hueRotate");
    var invert = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("invert");
    var gap = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("gap");
    var gradientColorStops = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("gradientColorStops");
    var gradientColorStopPositions = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("gradientColorStopPositions");
    var inset = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("inset");
    var margin = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("margin");
    var opacity = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("opacity");
    var padding = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("padding");
    var saturate = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("saturate");
    var scale = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("scale");
    var sepia = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("sepia");
    var skew = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("skew");
    var space = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("space");
    var translate = (0, $3a8335784d5b9630$export$e176af7b8eefe933)("translate");
    var getOverscroll = function getOverscroll() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var getOverflow = function getOverflow() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $6e5479f743d57894$export$5534a8576501817d),
            spacing
        ];
    };
    var getSpacingWithArbitrary = function getSpacingWithArbitrary() {
        return [
            (0, $6e5479f743d57894$export$5534a8576501817d),
            spacing
        ];
    };
    var getLengthWithEmpty = function getLengthWithEmpty() {
        return [
            "",
            (0, $6e5479f743d57894$export$38db3d147cb3433)
        ];
    };
    var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary() {
        return [
            "auto",
            (0, $6e5479f743d57894$export$7e4aa119212bc614),
            (0, $6e5479f743d57894$export$5534a8576501817d)
        ];
    };
    var getPositions = function getPositions() {
        return [
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ];
    };
    var getLineStyles = function getLineStyles() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ];
    };
    var getBlendModes = function getBlendModes() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity",
            "plus-lighter"
        ];
    };
    var getAlign = function getAlign() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ];
    };
    var getZeroAndEmpty = function getZeroAndEmpty() {
        return [
            "",
            "0",
            (0, $6e5479f743d57894$export$5534a8576501817d)
        ];
    };
    var getBreaks = function getBreaks() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var getNumber = function getNumber() {
        return [
            (0, $6e5479f743d57894$export$7e4aa119212bc614),
            (0, $6e5479f743d57894$export$ea45ce4f1b2d6088)
        ];
    };
    var getNumberAndArbitrary = function getNumberAndArbitrary() {
        return [
            (0, $6e5479f743d57894$export$7e4aa119212bc614),
            (0, $6e5479f743d57894$export$5534a8576501817d)
        ];
    };
    return {
        cacheSize: 500,
        theme: {
            colors: [
                (0, $6e5479f743d57894$export$ebb65efc98a3b5f7)
            ],
            spacing: [
                (0, $6e5479f743d57894$export$38db3d147cb3433)
            ],
            blur: [
                "none",
                "",
                (0, $6e5479f743d57894$export$a40791c6b7db5bcc),
                (0, $6e5479f743d57894$export$5534a8576501817d)
            ],
            brightness: getNumber(),
            borderColor: [
                colors
            ],
            borderRadius: [
                "none",
                "",
                "full",
                (0, $6e5479f743d57894$export$a40791c6b7db5bcc),
                (0, $6e5479f743d57894$export$5534a8576501817d)
            ],
            borderSpacing: getSpacingWithArbitrary(),
            borderWidth: getLengthWithEmpty(),
            contrast: getNumber(),
            grayscale: getZeroAndEmpty(),
            hueRotate: getNumberAndArbitrary(),
            invert: getZeroAndEmpty(),
            gap: getSpacingWithArbitrary(),
            gradientColorStops: [
                colors
            ],
            gradientColorStopPositions: [
                (0, $6e5479f743d57894$export$e50269385c77c348),
                (0, $6e5479f743d57894$export$f5e3af6d4c0fbe38)
            ],
            inset: getSpacingWithAutoAndArbitrary(),
            margin: getSpacingWithAutoAndArbitrary(),
            opacity: getNumber(),
            padding: getSpacingWithArbitrary(),
            saturate: getNumber(),
            scale: getNumber(),
            sepia: getZeroAndEmpty(),
            skew: getNumberAndArbitrary(),
            space: getSpacingWithArbitrary(),
            translate: getSpacingWithArbitrary()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        (0, $6e5479f743d57894$export$a40791c6b7db5bcc)
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": getBreaks()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": getBreaks()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ "float": [
                {
                    "float": [
                        "right",
                        "left",
                        "none"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [].concat(getPositions(), [
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ])
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: getOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": getOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": getOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": getOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": getOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        inset
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        inset
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        inset
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        inset
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        inset
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        inset
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        inset
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        inset
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        inset
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        (0, $6e5479f743d57894$export$a287f47fed4544b8)
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: getSpacingWithAutoAndArbitrary()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: getZeroAndEmpty()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: getZeroAndEmpty()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        (0, $6e5479f743d57894$export$a287f47fed4544b8)
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        (0, $6e5479f743d57894$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                (0, $6e5479f743d57894$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        (0, $6e5479f743d57894$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                (0, $6e5479f743d57894$export$a287f47fed4544b8)
                            ]
                        },
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": getNumberWithAutoAndArbitrary()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        gap
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        gap
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        gap
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal"
                    ].concat(getAlign())
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [].concat(getAlign(), [
                        "baseline"
                    ])
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        padding
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        padding
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        padding
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        padding
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        margin
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        margin
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        margin
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        margin
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        space
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        space
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        (0, $6e5479f743d57894$export$5534a8576501817d),
                        spacing
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        "min",
                        "max",
                        "fit",
                        (0, $6e5479f743d57894$export$5534a8576501817d),
                        (0, $6e5479f743d57894$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        "0",
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                (0, $6e5479f743d57894$export$a40791c6b7db5bcc)
                            ]
                        },
                        (0, $6e5479f743d57894$export$a40791c6b7db5bcc),
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        (0, $6e5479f743d57894$export$5534a8576501817d),
                        spacing,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        "min",
                        "max",
                        "fit",
                        (0, $6e5479f743d57894$export$5534a8576501817d),
                        (0, $6e5479f743d57894$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        (0, $6e5479f743d57894$export$5534a8576501817d),
                        spacing,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        (0, $6e5479f743d57894$export$a40791c6b7db5bcc),
                        (0, $6e5479f743d57894$export$f5e3af6d4c0fbe38)
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        (0, $6e5479f743d57894$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        (0, $6e5479f743d57894$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        (0, $6e5479f743d57894$export$7e4aa119212bc614),
                        (0, $6e5479f743d57894$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        (0, $6e5479f743d57894$export$5534a8576501817d),
                        (0, $6e5479f743d57894$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        colors
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        colors
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [].concat(getLineStyles(), [
                        "wavy"
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        (0, $6e5479f743d57894$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        (0, $6e5479f743d57894$export$5534a8576501817d),
                        (0, $6e5479f743d57894$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        colors
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: getSpacingWithArbitrary()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ "break": [
                {
                    "break": [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [].concat(getPositions(), [
                        (0, $6e5479f743d57894$export$57d00f225f425549)
                    ])
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        (0, $6e5479f743d57894$export$92dbd3a305a7cb8b)
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        (0, $6e5479f743d57894$export$478a5386e985802b)
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        colors
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        gradientColorStopPositions
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        gradientColorStops
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        gradientColorStops
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        borderRadius
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [].concat(getLineStyles(), [
                        "hidden"
                    ])
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        borderWidth
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: getLineStyles()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        borderColor
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        borderColor
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        borderColor
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        ""
                    ].concat(getLineStyles())
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        (0, $6e5479f743d57894$export$5534a8576501817d),
                        (0, $6e5479f743d57894$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        (0, $6e5479f743d57894$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: getLengthWithEmpty()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        colors
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        (0, $6e5479f743d57894$export$38db3d147cb3433)
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        colors
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        (0, $6e5479f743d57894$export$a40791c6b7db5bcc),
                        (0, $6e5479f743d57894$export$d01106465b385604)
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        (0, $6e5479f743d57894$export$ebb65efc98a3b5f7)
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        opacity
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": getBlendModes()
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": getBlendModes()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        blur
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        brightness
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        contrast
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        (0, $6e5479f743d57894$export$a40791c6b7db5bcc),
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        grayscale
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        invert
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        saturate
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        sepia
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        blur
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        brightness
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        contrast
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        grayscale
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        hueRotate
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        invert
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        opacity
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        saturate
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        sepia
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        borderSpacing
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: getNumberAndArbitrary()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: getNumberAndArbitrary()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        scale
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        scale
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        scale
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        (0, $6e5479f743d57894$export$a287f47fed4544b8),
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        translate
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        translate
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        skew
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        skew
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        colors
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                "appearance-none"
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        colors
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": getSpacingWithArbitrary()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "pinch-zoom",
                        "manipulation",
                        {
                            pan: [
                                "x",
                                "left",
                                "right",
                                "y",
                                "up",
                                "down"
                            ]
                        }
                    ]
                }
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        (0, $6e5479f743d57894$export$5534a8576501817d)
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        colors,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        (0, $6e5479f743d57894$export$38db3d147cb3433),
                        (0, $6e5479f743d57894$export$ea45ce4f1b2d6088)
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        colors,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}


var $df5a6d793fd4ba06$export$b4660bb6000dfbc9 = /*#__PURE__*/ (0, $977505d5900d4b4d$export$ea2d4fba4d1bd27f)((0, $39e8cc7bc85c774b$export$ed30944e0fe6ae5c));


function $56229cc9fc90141d$export$1343a74baacb0543(...inputs) {
    return (0, $df5a6d793fd4ba06$export$b4660bb6000dfbc9)((0, $fecb99b999628060$export$4f5d2d50c9deca37)(inputs));
}
function $56229cc9fc90141d$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
const $56229cc9fc90141d$export$4385e60b38654f68 = (min, max)=>Math.floor(Math.random() * (max - min)) + min;
const $56229cc9fc90141d$export$d02631cccf789723 = (start, end, step = 1)=>{
    let output = [];
    if (typeof end === "undefined") {
        end = start;
        start = 0;
    }
    for(let i = start; i < end; i += step)output.push(i);
    return output;
};
const $56229cc9fc90141d$export$4812e460280c6ef2 = (arr)=>{
    return arr[Math.floor(Math.random() * arr.length)];
};
const $56229cc9fc90141d$export$448332262467e042 = (array)=>{
    let currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle.
    while(currentIndex > 0){
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
};
const $56229cc9fc90141d$export$5f7ec48d69707ddd = (chunkSize, array)=>{
    const chunkedArray = [];
    for(let i = 0; i < array.length; i += chunkSize){
        const sub = array.slice(i, i + chunkSize);
        chunkedArray.push(sub);
    }
    return chunkedArray;
};
const $56229cc9fc90141d$export$4c3569103e7f2532 = (arr1, arr2)=>{
    return [
        ...arr1
    ].filter((x)=>!arr2.includes(x));
};
const $56229cc9fc90141d$export$76a46922e320ce3b = (arr1, arr2)=>{
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
    const difference = $56229cc9fc90141d$export$4c3569103e7f2532(arr1, arr2);
    return difference.length === 0 && arr1.length === arr2.length;
};


const $9aff75f1e9e81163$export$b2539bed5023c21c = $7fe50bc4532e8371$export$be92b6f5f03c0fe9;
const $9aff75f1e9e81163$export$9712d22edc0d78c1 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$54c2e3dc7acea9f5, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground", className),
        ...props
    }));
$9aff75f1e9e81163$export$9712d22edc0d78c1.displayName = $7fe50bc4532e8371$export$54c2e3dc7acea9f5.displayName;
const $9aff75f1e9e81163$export$8114b9fdfdf9f3ba = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$41fb9f06171c75f4, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm", className),
        ...props
    }));
$9aff75f1e9e81163$export$8114b9fdfdf9f3ba.displayName = $7fe50bc4532e8371$export$41fb9f06171c75f4.displayName;
const $9aff75f1e9e81163$export$bd905d70e8fd2ebb = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className),
        ...props
    }));
$9aff75f1e9e81163$export$bd905d70e8fd2ebb.displayName = $7fe50bc4532e8371$export$7c6e2c02157bb7d2.displayName;




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");








var $exYeM = parcelRequire("exYeM");








/* -------------------------------------------------------------------------------------------------
 * Collapsible
 * -----------------------------------------------------------------------------------------------*/ const $75d51ac32d862af6$var$$409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible";
const [$75d51ac32d862af6$var$$409067139f391064$var$createCollapsibleContext, $75d51ac32d862af6$export$952b32dcbe73087a] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($75d51ac32d862af6$var$$409067139f391064$var$COLLAPSIBLE_NAME);
const [$75d51ac32d862af6$var$$409067139f391064$var$CollapsibleProvider, $75d51ac32d862af6$var$$409067139f391064$var$useCollapsibleContext] = $75d51ac32d862af6$var$$409067139f391064$var$createCollapsibleContext($75d51ac32d862af6$var$$409067139f391064$var$COLLAPSIBLE_NAME);
const $75d51ac32d862af6$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , open: openProp , defaultOpen: defaultOpen , disabled: disabled , onOpenChange: onOpenChange , ...collapsibleProps } = props;
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($75d51ac32d862af6$var$$409067139f391064$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        open: open,
        onOpenToggle: (0, $exYeM.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ])
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $75d51ac32d862af6$var$$409067139f391064$var$getState(open),
        "data-disabled": disabled ? "" : undefined
    }, collapsibleProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($75d51ac32d862af6$export$6eb0f7ddcda6131f, {
    displayName: $75d51ac32d862af6$var$$409067139f391064$var$COLLAPSIBLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleTrigger
 * -----------------------------------------------------------------------------------------------*/ const $75d51ac32d862af6$var$$409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger";
const $75d51ac32d862af6$export$c135dce7b15bbbdc = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , ...triggerProps } = props;
    const context = $75d51ac32d862af6$var$$409067139f391064$var$useCollapsibleContext($75d51ac32d862af6$var$$409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $75d51ac32d862af6$var$$409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? "" : undefined,
        disabled: context.disabled
    }, triggerProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($75d51ac32d862af6$export$c135dce7b15bbbdc, {
    displayName: $75d51ac32d862af6$var$$409067139f391064$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleContent
 * -----------------------------------------------------------------------------------------------*/ const $75d51ac32d862af6$var$$409067139f391064$var$CONTENT_NAME = "CollapsibleContent";
const $75d51ac32d862af6$export$aadde00976f34151 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , ...contentProps } = props;
    const context = $75d51ac32d862af6$var$$409067139f391064$var$useCollapsibleContext($75d51ac32d862af6$var$$409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, ({ present: present  })=>/*#__PURE__*/ (0, $exYeM.createElement)($75d51ac32d862af6$var$$409067139f391064$var$CollapsibleContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contentProps, {
            ref: forwardedRef,
            present: present
        })));
});
/*#__PURE__*/ Object.assign($75d51ac32d862af6$export$aadde00976f34151, {
    displayName: $75d51ac32d862af6$var$$409067139f391064$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $75d51ac32d862af6$var$$409067139f391064$var$CollapsibleContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible , present: present , children: children , ...contentProps } = props;
    const context = $75d51ac32d862af6$var$$409067139f391064$var$useCollapsibleContext($75d51ac32d862af6$var$$409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = (0, $exYeM.useState)(present);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const heightRef = (0, $exYeM.useRef)(0);
    const height = heightRef.current;
    const widthRef = (0, $exYeM.useRef)(0);
    const width = widthRef.current; // when opening we want it to immediately open to retrieve dimensions
    // when closing we delay `present` to retrieve dimensions before closing
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = (0, $exYeM.useRef)(isOpen);
    const originalStylesRef = (0, $exYeM.useRef)();
    (0, $exYeM.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            }; // block any animations/transitions so the element renders at its full dimensions
            node.style.transitionDuration = "0s";
            node.style.animationName = "none"; // get width and height from full dimensions
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width; // kick off any animations/transitions that were originally set up if it isn't the initial mount
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    /**
     * depends on `context.open` because it will change to `false`
     * when a close is triggered but `present` will be `false` on
     * animation end (so when close finishes). This allows us to
     * retrieve the dimensions *before* closing.
     */ }, [
        context.open,
        present
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $75d51ac32d862af6$var$$409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? "" : undefined,
        id: context.contentId,
        hidden: !isOpen
    }, contentProps, {
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : undefined,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : undefined,
            ...props.style
        }
    }), isOpen && children);
});
/* -----------------------------------------------------------------------------------------------*/ function $75d51ac32d862af6$var$$409067139f391064$var$getState(open) {
    return open ? "open" : "closed";
}
const $75d51ac32d862af6$export$be92b6f5f03c0fe9 = $75d51ac32d862af6$export$6eb0f7ddcda6131f;
const $75d51ac32d862af6$export$41fb9f06171c75f4 = $75d51ac32d862af6$export$c135dce7b15bbbdc;
const $75d51ac32d862af6$export$7c6e2c02157bb7d2 = $75d51ac32d862af6$export$aadde00976f34151;




/* -------------------------------------------------------------------------------------------------
 * Accordion
 * -----------------------------------------------------------------------------------------------*/ const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME = "Accordion";
const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_KEYS = [
    "Home",
    "End",
    "ArrowDown",
    "ArrowUp",
    "ArrowLeft",
    "ArrowRight"
];
const [$56d436c00328f7d3$var$$1bf158f521e1b1b4$var$Collection, $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useCollection, $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$56d436c00328f7d3$var$$1bf158f521e1b1b4$var$createAccordionContext, $56d436c00328f7d3$export$9748edc328a73be1] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, [
    $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$createCollectionScope,
    (0, $75d51ac32d862af6$export$952b32dcbe73087a)
]);
const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useCollapsibleScope = (0, $75d51ac32d862af6$export$952b32dcbe73087a)();
const $56d436c00328f7d3$export$a766cd26d0d69044 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
    const { type: type , ...accordionProps } = props;
    const singleProps = accordionProps;
    const multipleProps = accordionProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$Collection.Provider, {
        scope: props.__scopeAccordion
    }, type === "multiple" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImplMultiple, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, multipleProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImplSingle, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, singleProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($56d436c00328f7d3$export$a766cd26d0d69044, {
    displayName: $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME
});
$56d436c00328f7d3$export$a766cd26d0d69044.propTypes = {
    type (props) {
        const value = props.value || props.defaultValue;
        if (props.type && ![
            "single",
            "multiple"
        ].includes(props.type)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.");
        if (props.type === "multiple" && typeof value === "string") return new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.");
        if (props.type === "single" && Array.isArray(value)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.");
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const [$56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionValueProvider, $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionValueContext] = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$createAccordionContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionCollapsibleContext] = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$createAccordionContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, {
    collapsible: false
});
const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImplSingle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , collapsible: collapsible = false , ...accordionSingleProps } = props;
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value ? [
            value
        ] : [],
        onItemOpen: setValue,
        onItemClose: (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>collapsible && setValue(""), [
            collapsible,
            setValue
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
        scope: props.__scopeAccordion,
        collapsible: collapsible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, accordionSingleProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImplMultiple = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange = ()=>{} , ...accordionMultipleProps } = props;
    const [value1 = [], setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const handleItemOpen = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleItemClose = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value)=>value !== itemValue)), [
        setValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionValueProvider, {
        scope: props.__scopeAccordion,
        value: value1,
        onItemOpen: handleItemOpen,
        onItemClose: handleItemClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
        scope: props.__scopeAccordion,
        collapsible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, accordionMultipleProps, {
        ref: forwardedRef
    }))));
});
/* -----------------------------------------------------------------------------------------------*/ const [$56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImplProvider, $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionContext] = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$createAccordionContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME);
const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImpl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , disabled: disabled , dir: dir , orientation: orientation = "vertical" , ...accordionProps } = props;
    const accordionRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(accordionRef, forwardedRef);
    const getItems = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useCollection(__scopeAccordion);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const isDirectionLTR = direction === "ltr";
    const handleKeyDown = (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
        var _triggerCollection$cl;
        if (!$56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_KEYS.includes(event.key)) return;
        const target = event.target;
        const triggerCollection = getItems().filter((item)=>{
            var _item$ref$current;
            return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
        });
        const triggerIndex = triggerCollection.findIndex((item)=>item.ref.current === target);
        const triggerCount = triggerCollection.length;
        if (triggerIndex === -1) return; // Prevents page scroll while user is navigating
        event.preventDefault();
        let nextIndex = triggerIndex;
        const homeIndex = 0;
        const endIndex = triggerCount - 1;
        const moveNext = ()=>{
            nextIndex = triggerIndex + 1;
            if (nextIndex > endIndex) nextIndex = homeIndex;
        };
        const movePrev = ()=>{
            nextIndex = triggerIndex - 1;
            if (nextIndex < homeIndex) nextIndex = endIndex;
        };
        switch(event.key){
            case "Home":
                nextIndex = homeIndex;
                break;
            case "End":
                nextIndex = endIndex;
                break;
            case "ArrowRight":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) moveNext();
                    else movePrev();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") moveNext();
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    if (isDirectionLTR) movePrev();
                    else moveNext();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") movePrev();
                break;
        }
        const clampedIndex = nextIndex % triggerCount;
        (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionImplProvider, {
        scope: __scopeAccordion,
        disabled: disabled,
        direction: dir,
        orientation: orientation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$Collection.Slot, {
        scope: __scopeAccordion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, accordionProps, {
        "data-orientation": orientation,
        ref: composedRefs,
        onKeyDown: disabled ? undefined : handleKeyDown
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * AccordionItem
 * -----------------------------------------------------------------------------------------------*/ const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ITEM_NAME = "AccordionItem";
const [$56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionItemProvider, $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionItemContext] = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$createAccordionContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ITEM_NAME);
/**
 * `AccordionItem` contains all of the parts of a collapsible section inside of an `Accordion`.
 */ const $56d436c00328f7d3$export$d99097c13d4dac9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , value: value , ...accordionItemProps } = props;
    const accordionContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
    const valueContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionValueContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
    const collapsibleScope = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    const triggerId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const open1 = value && valueContext.value.includes(value) || false;
    const disabled = accordionContext.disabled || props.disabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$AccordionItemProvider, {
        scope: __scopeAccordion,
        open: open1,
        disabled: disabled,
        triggerId: triggerId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75d51ac32d862af6$export$be92b6f5f03c0fe9), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-orientation": accordionContext.orientation,
        "data-state": $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$getState(open1)
    }, collapsibleScope, accordionItemProps, {
        ref: forwardedRef,
        disabled: disabled,
        open: open1,
        onOpenChange: (open)=>{
            if (open) valueContext.onItemOpen(value);
            else valueContext.onItemClose(value);
        }
    })));
});
/*#__PURE__*/ Object.assign($56d436c00328f7d3$export$d99097c13d4dac9f, {
    displayName: $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AccordionHeader
 * -----------------------------------------------------------------------------------------------*/ const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$HEADER_NAME = "AccordionHeader";
/**
 * `AccordionHeader` contains the content for the parts of an `AccordionItem` that will be visible
 * whether or not its content is collapsed.
 */ const $56d436c00328f7d3$export$5e3e5deaaf81ee41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...headerProps } = props;
    const accordionContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionItemContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$HEADER_NAME, __scopeAccordion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).h3, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-orientation": accordionContext.orientation,
        "data-state": $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$getState(itemContext.open),
        "data-disabled": itemContext.disabled ? "" : undefined
    }, headerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($56d436c00328f7d3$export$5e3e5deaaf81ee41, {
    displayName: $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$HEADER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AccordionTrigger
 * -----------------------------------------------------------------------------------------------*/ const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$TRIGGER_NAME = "AccordionTrigger";
/**
 * `AccordionTrigger` is the trigger that toggles the collapsed state of an `AccordionItem`. It
 * should always be nested inside of an `AccordionHeader`.
 */ const $56d436c00328f7d3$export$94e939b1f85bdd73 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...triggerProps } = props;
    const accordionContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionItemContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionCollapsibleContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
    const collapsibleScope = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$Collection.ItemSlot, {
        scope: __scopeAccordion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75d51ac32d862af6$export$41fb9f06171c75f4), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "aria-disabled": itemContext.open && !collapsibleContext.collapsible || undefined,
        "data-orientation": accordionContext.orientation,
        id: itemContext.triggerId
    }, collapsibleScope, triggerProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($56d436c00328f7d3$export$94e939b1f85bdd73, {
    displayName: $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AccordionContent
 * -----------------------------------------------------------------------------------------------*/ const $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$CONTENT_NAME = "AccordionContent";
/**
 * `AccordionContent` contains the collapsible content for an `AccordionItem`.
 */ const $56d436c00328f7d3$export$985b9a77379b54a0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
    const { __scopeAccordion: __scopeAccordion , ...contentProps } = props;
    const accordionContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$ACCORDION_NAME, __scopeAccordion);
    const itemContext = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useAccordionItemContext($56d436c00328f7d3$var$$1bf158f521e1b1b4$var$CONTENT_NAME, __scopeAccordion);
    const collapsibleScope = $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75d51ac32d862af6$export$7c6e2c02157bb7d2), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        role: "region",
        "aria-labelledby": itemContext.triggerId,
        "data-orientation": accordionContext.orientation
    }, collapsibleScope, contentProps, {
        ref: forwardedRef,
        style: {
            ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
            ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($56d436c00328f7d3$export$985b9a77379b54a0, {
    displayName: $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $56d436c00328f7d3$var$$1bf158f521e1b1b4$var$getState(open) {
    return open ? "open" : "closed";
}
const $56d436c00328f7d3$export$be92b6f5f03c0fe9 = $56d436c00328f7d3$export$a766cd26d0d69044;
const $56d436c00328f7d3$export$6d08773d2e66f8f2 = $56d436c00328f7d3$export$d99097c13d4dac9f;
const $56d436c00328f7d3$export$8b251419efc915eb = $56d436c00328f7d3$export$5e3e5deaaf81ee41;
const $56d436c00328f7d3$export$41fb9f06171c75f4 = $56d436c00328f7d3$export$94e939b1f85bdd73;
const $56d436c00328f7d3$export$7c6e2c02157bb7d2 = $56d436c00328f7d3$export$985b9a77379b54a0;


/**
 * lucide-react v0.288.0 - ISC
 */ 
const $e150fda29aff442d$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("ChevronDown", [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
]);



const $c25d03415198f2ec$export$a766cd26d0d69044 = $56d436c00328f7d3$export$be92b6f5f03c0fe9;
const $c25d03415198f2ec$export$d99097c13d4dac9f = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($56d436c00328f7d3$export$6d08773d2e66f8f2, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("border-b", className),
        ...props
    }));
$c25d03415198f2ec$export$d99097c13d4dac9f.displayName = "AccordionItem";
const $c25d03415198f2ec$export$94e939b1f85bdd73 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , children: children , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($56d436c00328f7d3$export$8b251419efc915eb, {
        className: "flex",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($56d436c00328f7d3$export$41fb9f06171c75f4, {
            ref: ref,
            className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180", className),
            ...props,
            children: [
                children,
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e150fda29aff442d$export$2e2bcd8739ae039), {
                    className: "h-4 w-4 shrink-0 transition-transform duration-200"
                })
            ]
        })
    }));
$c25d03415198f2ec$export$94e939b1f85bdd73.displayName = $56d436c00328f7d3$export$41fb9f06171c75f4.displayName;
const $c25d03415198f2ec$export$985b9a77379b54a0 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , children: children , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($56d436c00328f7d3$export$7c6e2c02157bb7d2, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down", className),
        ...props,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
            className: "pb-4 pt-0",
            children: children
        })
    }));
$c25d03415198f2ec$export$985b9a77379b54a0.displayName = $56d436c00328f7d3$export$7c6e2c02157bb7d2.displayName;




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");







var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");

/**
 * Listens for when the escape key is down
 */ function $34fe34d34d8734af$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $exYeM.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $0516f19b588c56c0$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $exYeM.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $0516f19b588c56c0$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = (0, $exYeM.useContext)($0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $exYeM.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $exYeM.useState)({});
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $0516f19b588c56c0$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $0516f19b588c56c0$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $34fe34d34d8734af$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $exYeM.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $exYeM.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $exYeM.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($0516f19b588c56c0$export$177fb62ff3ec1f22, {
    displayName: $0516f19b588c56c0$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $0516f19b588c56c0$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $0516f19b588c56c0$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = (0, $exYeM.useContext)($0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $exYeM.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($0516f19b588c56c0$export$4d5eb2109db14228, {
    displayName: $0516f19b588c56c0$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $0516f19b588c56c0$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $exYeM.useRef)(false);
    const handleClickRef = (0, $exYeM.useRef)(()=>{});
    (0, $exYeM.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $0516f19b588c56c0$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $0516f19b588c56c0$export$be92b6f5f03c0fe9 = $0516f19b588c56c0$export$177fb62ff3ec1f22;
const $0516f19b588c56c0$export$aecb2ddcb55c95be = $0516f19b588c56c0$export$4d5eb2109db14228;




var $exYeM = parcelRequire("exYeM");



const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $0d95d7873b2aecf3$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container1, setContainer] = (0, $exYeM.useState)(null);
    const onMountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $exYeM.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $exYeM.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (container1) {
            $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusFirst($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$removeLinks($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $exYeM.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($0d95d7873b2aecf3$export$20e40289641fbbb6, {
    displayName: $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(element, { select: select = false  } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $0d95d7873b2aecf3$export$be92b6f5f03c0fe9 = $0d95d7873b2aecf3$export$20e40289641fbbb6;




var $exYeM = parcelRequire("exYeM");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $965ca2171585ad7a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $965ca2171585ad7a$export$602eac185826482c = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body , ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).createPortal(/*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($965ca2171585ad7a$export$602eac185826482c, {
    displayName: $965ca2171585ad7a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $965ca2171585ad7a$export$be92b6f5f03c0fe9 = $965ca2171585ad7a$export$602eac185826482c;





var $exYeM = parcelRequire("exYeM");
/** Number of components which have requested interest to have focus guards */ let $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count = 0;
function $c12fde423b091e9b$export$ac5b58043b79449b(props) {
    $c12fde423b091e9b$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $c12fde423b091e9b$export$b7ece24a22aeda8c() {
    (0, $exYeM.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $c12fde423b091e9b$export$be92b6f5f03c0fe9 = $c12fde423b091e9b$export$ac5b58043b79449b;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};



var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
var $a424de23c132f073$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $a424de23c132f073$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $a424de23c132f073$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $a424de23c132f073$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $584d39a8643d937a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $exYeM = parcelRequire("exYeM");
function $d00d56265ba92762$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $exYeM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $d221d2c5d570aa1d$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $d00d56265ba92762$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



function $f527f4cfb322b92a$var$ItoI(a) {
    return a;
}
function $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $f527f4cfb322b92a$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    return $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware);
}
function $f527f4cfb322b92a$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $f527f4cfb322b92a$var$innerCreateMedium(null);
    medium.options = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4fc5d5f926eb9841$export$e27363444bedfeac = (0, $f527f4cfb322b92a$export$e13ec7dd7a14088d)();


var $6c2939159ce57a12$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $6c2939159ce57a12$export$22940b497e769dee = $exYeM.forwardRef(function(props, parentRef) {
    var ref = $exYeM.useRef(null);
    var _a = $exYeM.useState({
        onScrollCapture: $6c2939159ce57a12$var$nothing,
        onWheelCapture: $6c2939159ce57a12$var$nothing,
        onTouchMoveCapture: $6c2939159ce57a12$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d221d2c5d570aa1d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest), callbacks);
    return $exYeM.createElement($exYeM.Fragment, null, enabled && $exYeM.createElement(SideCar, {
        sideCar: (0, $4fc5d5f926eb9841$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $exYeM.cloneElement($exYeM.Children.only(children), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $exYeM.createElement(Container, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$6c2939159ce57a12$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$6c2939159ce57a12$export$22940b497e769dee.classNames = {
    fullWidth: (0, $a424de23c132f073$export$898e37bbd2a0ae4e),
    zeroRight: (0, $a424de23c132f073$export$1da7500147d4bc3)
};




var $exYeM = parcelRequire("exYeM");
var $20ca6eb20b4dc049$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $exYeM.createElement(Target, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest));
};
$20ca6eb20b4dc049$var$SideCar.isSideCarExport = true;
function $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $20ca6eb20b4dc049$var$SideCar;
}




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $c01c422d43bc8e57$var$currentNonce;
var $c01c422d43bc8e57$export$c5f670b24c0ae95a = function(nonce) {
    $c01c422d43bc8e57$var$currentNonce = nonce;
};
var $c01c422d43bc8e57$export$2b85b721e524d74b = function() {
    if ($c01c422d43bc8e57$var$currentNonce) return $c01c422d43bc8e57$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $00191a54979f785d$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c01c422d43bc8e57$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $00191a54979f785d$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $00191a54979f785d$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $00191a54979f785d$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $00191a54979f785d$var$makeStyleTag()) {
                    $00191a54979f785d$var$injectStyles(stylesheet, style);
                    $00191a54979f785d$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $071c3d40780405a9$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $00191a54979f785d$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $exYeM.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $3d3e09c66c873f3e$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $071c3d40780405a9$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $8c733fa2685d08ec$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $8c733fa2685d08ec$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $8c733fa2685d08ec$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $8c733fa2685d08ec$var$parse(left),
        $8c733fa2685d08ec$var$parse(top),
        $8c733fa2685d08ec$var$parse(right)
    ];
};
var $8c733fa2685d08ec$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $8c733fa2685d08ec$export$efed13b5d0ca3386;
    var offsets = $8c733fa2685d08ec$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $b8129a946e86d087$var$Style = (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $b8129a946e86d087$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $a424de23c132f073$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $a424de23c132f073$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $b8129a946e86d087$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $exYeM.useMemo(function() {
        return (0, $8c733fa2685d08ec$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $exYeM.createElement($b8129a946e86d087$var$Style, {
        styles: $b8129a946e86d087$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $00c689171e355a98$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $00c689171e355a98$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $00c689171e355a98$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
    // @ts-ignore
    window.removeEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
} catch (err) {
    $00c689171e355a98$var$passiveSupported = false;
}
var $00c689171e355a98$export$10a6e88623fa9454 = $00c689171e355a98$var$passiveSupported ? {
    passive: false
} : false;


var $895262f629112328$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $895262f629112328$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$895262f629112328$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $895262f629112328$var$elementCouldBeVScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowY");
};
var $895262f629112328$var$elementCouldBeHScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowX");
};
var $895262f629112328$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $895262f629112328$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $895262f629112328$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $895262f629112328$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $895262f629112328$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $895262f629112328$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$elementCouldBeVScrolled(node) : $895262f629112328$var$elementCouldBeHScrolled(node);
};
var $895262f629112328$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$getVScrollVariables(node) : $895262f629112328$var$getHScrollVariables(node);
};
var $895262f629112328$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $895262f629112328$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $895262f629112328$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $895262f629112328$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($895262f629112328$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $e11a1edcdcbdc39d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $e11a1edcdcbdc39d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $e11a1edcdcbdc39d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $e11a1edcdcbdc39d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $e11a1edcdcbdc39d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $e11a1edcdcbdc39d$var$idCounter = 0;
var $e11a1edcdcbdc39d$var$lockStack = [];
function $e11a1edcdcbdc39d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $exYeM.useRef([]);
    var touchStartRef = $exYeM.useRef([
        0,
        0
    ]);
    var activeAxis = $exYeM.useRef();
    var id = $exYeM.useState($e11a1edcdcbdc39d$var$idCounter++)[0];
    var Style = $exYeM.useState(function() {
        return (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $exYeM.useRef(props);
    $exYeM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $exYeM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($e11a1edcdcbdc39d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $exYeM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $895262f629112328$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $exYeM.useCallback(function(_event) {
        var event = _event;
        if (!$e11a1edcdcbdc39d$var$lockStack.length || $e11a1edcdcbdc39d$var$lockStack[$e11a1edcdcbdc39d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event) : $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $e11a1edcdcbdc39d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($e11a1edcdcbdc39d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $exYeM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $exYeM.useCallback(function(event) {
        touchStartRef.current = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $exYeM.useEffect(function() {
        $e11a1edcdcbdc39d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        return function() {
            $e11a1edcdcbdc39d$var$lockStack = $e11a1edcdcbdc39d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $exYeM.createElement($exYeM.Fragment, null, inert ? $exYeM.createElement(Style, {
        styles: $e11a1edcdcbdc39d$var$generateStyle(id)
    }) : null, removeScrollBar ? $exYeM.createElement((0, $b8129a946e86d087$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $5f000f9080e28e0a$export$2e2bcd8739ae039 = (0, $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce)((0, $4fc5d5f926eb9841$export$e27363444bedfeac), (0, $e11a1edcdcbdc39d$export$a09dbff87b5da2d));


var $471317fac98e876e$var$ReactRemoveScroll = $exYeM.forwardRef(function(props, ref) {
    return $exYeM.createElement((0, $6c2939159ce57a12$export$22940b497e769dee), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $5f000f9080e28e0a$export$2e2bcd8739ae039)
    }));
});
$471317fac98e876e$var$ReactRemoveScroll.classNames = (0, $6c2939159ce57a12$export$22940b497e769dee).classNames;
var $471317fac98e876e$export$2e2bcd8739ae039 = $471317fac98e876e$var$ReactRemoveScroll;


var $ed7fbe99f365bc63$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $ed7fbe99f365bc63$var$counterMap = new WeakMap();
var $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
var $ed7fbe99f365bc63$var$markerMap = {};
var $ed7fbe99f365bc63$var$lockCount = 0;
var $ed7fbe99f365bc63$var$unwrapHost = function(node) {
    return node && (node.host || $ed7fbe99f365bc63$var$unwrapHost(node.parentNode));
};
var $ed7fbe99f365bc63$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $ed7fbe99f365bc63$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $ed7fbe99f365bc63$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $ed7fbe99f365bc63$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$ed7fbe99f365bc63$var$markerMap[markerName]) $ed7fbe99f365bc63$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $ed7fbe99f365bc63$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($ed7fbe99f365bc63$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $ed7fbe99f365bc63$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $ed7fbe99f365bc63$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $ed7fbe99f365bc63$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$ed7fbe99f365bc63$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $ed7fbe99f365bc63$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $ed7fbe99f365bc63$var$lockCount--;
        if (!$ed7fbe99f365bc63$var$lockCount) {
            // clear
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
            $ed7fbe99f365bc63$var$markerMap = {};
        }
    };
};
var $ed7fbe99f365bc63$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $ed7fbe99f365bc63$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $ed7fbe99f365bc63$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $ed7fbe99f365bc63$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($ed7fbe99f365bc63$export$cc95fea82d705fca() ? $ed7fbe99f365bc63$export$59151cc8db999a24 : $ed7fbe99f365bc63$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$createDialogContext, $d624d4ffa9e1ab8a$export$cc702773b8ea3e41] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogProvider, $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$createDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $d624d4ffa9e1ab8a$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = (0, $exYeM.useRef)(null);
    const contentRef = (0, $exYeM.useRef)(null);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        titleId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        descriptionId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $exYeM.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$3ddf2d174ce01153, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $d624d4ffa9e1ab8a$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$2e1e1122cf0cba88, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PortalProvider, $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$createDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $d624d4ffa9e1ab8a$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $exYeM.Children).map(children, (child)=>/*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$dad7c95542bacce0, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $d624d4ffa9e1ab8a$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$usePortalContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$bd1d06c79be19e17, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $exYeM.createElement)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $d624d4ffa9e1ab8a$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$usePortalContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$b6d9565de1e068cf, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $exYeM.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $exYeM.useRef)(false);
    const hasPointerDownOutsideRef = (0, $exYeM.useRef)(false);
    return /*#__PURE__*/ (0, $exYeM.createElement)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $d624d4ffa9e1ab8a$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).h2, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$16f7638e4a34b909, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $d624d4ffa9e1ab8a$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).p, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$94e94c2ec2c954d5, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useDialogContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac, {
    displayName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$d624d4ffa9e1ab8a$export$69b62a49393917d6, $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $e1a745ecb8941240$export$fd42f52fd3ae1109)($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useWarningContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $exYeM.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$useWarningContext($d624d4ffa9e1ab8a$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $exYeM.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9 = $d624d4ffa9e1ab8a$export$3ddf2d174ce01153;
const $d624d4ffa9e1ab8a$export$41fb9f06171c75f4 = $d624d4ffa9e1ab8a$export$2e1e1122cf0cba88;
const $d624d4ffa9e1ab8a$export$602eac185826482c = $d624d4ffa9e1ab8a$export$dad7c95542bacce0;
const $d624d4ffa9e1ab8a$export$c6fdb837b070b4ff = $d624d4ffa9e1ab8a$export$bd1d06c79be19e17;
const $d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2 = $d624d4ffa9e1ab8a$export$b6d9565de1e068cf;
const $d624d4ffa9e1ab8a$export$f99233281efd08a0 = $d624d4ffa9e1ab8a$export$16f7638e4a34b909;
const $d624d4ffa9e1ab8a$export$393edc798c47379d = $d624d4ffa9e1ab8a$export$94e94c2ec2c954d5;
const $d624d4ffa9e1ab8a$export$f39c2d165cd861fe = $d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac;




/* -------------------------------------------------------------------------------------------------
 * AlertDialog
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$ROOT_NAME = "AlertDialog";
const [$6487017786257a53$var$$905f4ae918aab1aa$var$createAlertDialogContext, $6487017786257a53$export$b8891880751c2c5b] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($6487017786257a53$var$$905f4ae918aab1aa$var$ROOT_NAME, [
    (0, $d624d4ffa9e1ab8a$export$cc702773b8ea3e41)
]);
const $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope = (0, $d624d4ffa9e1ab8a$export$cc702773b8ea3e41)();
const $6487017786257a53$export$de466dd8317b0b75 = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...alertDialogProps } = props;
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, dialogScope, alertDialogProps, {
        modal: true
    }));
};
/*#__PURE__*/ Object.assign($6487017786257a53$export$de466dd8317b0b75, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$ROOT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$TRIGGER_NAME = "AlertDialogTrigger";
const $6487017786257a53$export$6edd7a623ef0f40b = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...triggerProps } = props;
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$41fb9f06171c75f4), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, dialogScope, triggerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6487017786257a53$export$6edd7a623ef0f40b, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$PORTAL_NAME = "AlertDialogPortal";
const $6487017786257a53$export$660f2bfdb986706c = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...portalProps } = props;
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$602eac185826482c), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, dialogScope, portalProps));
};
/*#__PURE__*/ Object.assign($6487017786257a53$export$660f2bfdb986706c, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$OVERLAY_NAME = "AlertDialogOverlay";
const $6487017786257a53$export$a707a4895ce23256 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...overlayProps } = props;
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$c6fdb837b070b4ff), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, dialogScope, overlayProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6487017786257a53$export$a707a4895ce23256, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$OVERLAY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogContent
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$CONTENT_NAME = "AlertDialogContent";
const [$6487017786257a53$var$$905f4ae918aab1aa$var$AlertDialogContentProvider, $6487017786257a53$var$$905f4ae918aab1aa$var$useAlertDialogContentContext] = $6487017786257a53$var$$905f4ae918aab1aa$var$createAlertDialogContext($6487017786257a53$var$$905f4ae918aab1aa$var$CONTENT_NAME);
const $6487017786257a53$export$94e6af45f0af4efd = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , children: children , ...contentProps } = props;
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const cancelRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$69b62a49393917d6), {
        contentName: $6487017786257a53$var$$905f4ae918aab1aa$var$CONTENT_NAME,
        titleName: $6487017786257a53$var$$905f4ae918aab1aa$var$TITLE_NAME,
        docsSlug: "alert-dialog"
    }, /*#__PURE__*/ (0, $exYeM.createElement)($6487017786257a53$var$$905f4ae918aab1aa$var$AlertDialogContentProvider, {
        scope: __scopeAlertDialog,
        cancelRef: cancelRef
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        role: "alertdialog"
    }, dialogScope, contentProps, {
        ref: composedRefs,
        onOpenAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(contentProps.onOpenAutoFocus, (event)=>{
            var _cancelRef$current;
            event.preventDefault();
            (_cancelRef$current = cancelRef.current) === null || _cancelRef$current === void 0 || _cancelRef$current.focus({
                preventScroll: true
            });
        }),
        onPointerDownOutside: (event)=>event.preventDefault(),
        onInteractOutside: (event)=>event.preventDefault()
    }), /*#__PURE__*/ (0, $exYeM.createElement)((0, $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45), null, children), false)));
});
/*#__PURE__*/ Object.assign($6487017786257a53$export$94e6af45f0af4efd, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$TITLE_NAME = "AlertDialogTitle";
const $6487017786257a53$export$225e0da62d314b7 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...titleProps } = props;
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$f99233281efd08a0), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, dialogScope, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6487017786257a53$export$225e0da62d314b7, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$DESCRIPTION_NAME = "AlertDialogDescription";
const $6487017786257a53$export$a23b55cde55ad9a5 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...descriptionProps } = props;
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$393edc798c47379d), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, dialogScope, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6487017786257a53$export$a23b55cde55ad9a5, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogAction
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$ACTION_NAME = "AlertDialogAction";
const $6487017786257a53$export$b454f818c58ee85d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...actionProps } = props;
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$f39c2d165cd861fe), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, dialogScope, actionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($6487017786257a53$export$b454f818c58ee85d, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * AlertDialogCancel
 * -----------------------------------------------------------------------------------------------*/ const $6487017786257a53$var$$905f4ae918aab1aa$var$CANCEL_NAME = "AlertDialogCancel";
const $6487017786257a53$export$2f67a923571aaea0 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog , ...cancelProps } = props;
    const { cancelRef: cancelRef  } = $6487017786257a53$var$$905f4ae918aab1aa$var$useAlertDialogContentContext($6487017786257a53$var$$905f4ae918aab1aa$var$CANCEL_NAME, __scopeAlertDialog);
    const dialogScope = $6487017786257a53$var$$905f4ae918aab1aa$var$useDialogScope(__scopeAlertDialog);
    const ref = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, cancelRef);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $d624d4ffa9e1ab8a$export$f39c2d165cd861fe), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, dialogScope, cancelProps, {
        ref: ref
    }));
});
/*#__PURE__*/ Object.assign($6487017786257a53$export$2f67a923571aaea0, {
    displayName: $6487017786257a53$var$$905f4ae918aab1aa$var$CANCEL_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $6487017786257a53$var$$905f4ae918aab1aa$var$DescriptionWarning = ({ contentRef: contentRef  })=>{
    const MESSAGE = `\`${$6487017786257a53$var$$905f4ae918aab1aa$var$CONTENT_NAME}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${$6487017786257a53$var$$905f4ae918aab1aa$var$CONTENT_NAME}\` by passing a \`${$6487017786257a53$var$$905f4ae918aab1aa$var$DESCRIPTION_NAME}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${$6487017786257a53$var$$905f4ae918aab1aa$var$CONTENT_NAME}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
    (0, $exYeM.useEffect)(()=>{
        var _contentRef$current;
        const hasDescription = document.getElementById((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"));
        if (!hasDescription) console.warn(MESSAGE);
    }, [
        MESSAGE,
        contentRef
    ]);
    return null;
};
const $6487017786257a53$export$be92b6f5f03c0fe9 = $6487017786257a53$export$de466dd8317b0b75;
const $6487017786257a53$export$41fb9f06171c75f4 = $6487017786257a53$export$6edd7a623ef0f40b;
const $6487017786257a53$export$602eac185826482c = $6487017786257a53$export$660f2bfdb986706c;
const $6487017786257a53$export$c6fdb837b070b4ff = $6487017786257a53$export$a707a4895ce23256;
const $6487017786257a53$export$7c6e2c02157bb7d2 = $6487017786257a53$export$94e6af45f0af4efd;
const $6487017786257a53$export$e19cd5f9376f8cee = $6487017786257a53$export$b454f818c58ee85d;
const $6487017786257a53$export$848c9b7ead0df967 = $6487017786257a53$export$2f67a923571aaea0;
const $6487017786257a53$export$f99233281efd08a0 = $6487017786257a53$export$225e0da62d314b7;
const $6487017786257a53$export$393edc798c47379d = $6487017786257a53$export$a23b55cde55ad9a5;





var $exYeM = parcelRequire("exYeM");


const $f6c488ee7ea67d84$var$falsyToString = (value)=>typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
const $f6c488ee7ea67d84$export$a274e22fb40f762e = (0, $fecb99b999628060$export$4f5d2d50c9deca37);
const $f6c488ee7ea67d84$export$87dc52566e90b739 = (base, config)=>{
    return (props)=>{
        var ref;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $f6c488ee7ea67d84$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants , defaultVariants: defaultVariants  } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $f6c488ee7ea67d84$var$falsyToString(variantProp) || $f6c488ee7ea67d84$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1)=>{
            let { class: cvClass , className: cvClassName , ...compoundVariantOptions } = param1;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $f6c488ee7ea67d84$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};



const $9cfb09368e977195$export$dca1ee5a936bb312 = (0, $f6c488ee7ea67d84$export$87dc52566e90b739)("inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-30", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            submit: "bg-slate-500 text-destructive-foreground hover:bg-slate-500/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
            share: "border-solid bg-fuchsia-400	basis-1/2 hover:bg-fuchsia-400/80"
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            deselectallsize: "h-10 py-2",
            icon: "h-10 w-10"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $9cfb09368e977195$export$353f5b6fc5456de1 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , variant: variant , size: size , asChild: asChild = false , ...props }, ref)=>{
    const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : "button";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)(Comp, {
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)($9cfb09368e977195$export$dca1ee5a936bb312({
            variant: variant,
            size: size,
            className: className
        })),
        ref: ref,
        ...props
    });
});
$9cfb09368e977195$export$353f5b6fc5456de1.displayName = "Button";


const $e3f6d6e4b2f2b020$export$de466dd8317b0b75 = $6487017786257a53$export$be92b6f5f03c0fe9;
const $e3f6d6e4b2f2b020$export$6edd7a623ef0f40b = $6487017786257a53$export$41fb9f06171c75f4;
const $e3f6d6e4b2f2b020$export$660f2bfdb986706c = $6487017786257a53$export$602eac185826482c;
const $e3f6d6e4b2f2b020$export$a707a4895ce23256 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , children: children , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($6487017786257a53$export$c6fdb837b070b4ff, {
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props,
        ref: ref
    }));
$e3f6d6e4b2f2b020$export$a707a4895ce23256.displayName = $6487017786257a53$export$c6fdb837b070b4ff.displayName;
const $e3f6d6e4b2f2b020$export$94e6af45f0af4efd = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , handleMouseDownOnOverlay: handleMouseDownOnOverlay , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($e3f6d6e4b2f2b020$export$660f2bfdb986706c, {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e3f6d6e4b2f2b020$export$a707a4895ce23256, {
                onMouseDown: handleMouseDownOnOverlay
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($6487017786257a53$export$7c6e2c02157bb7d2, {
                ref: ref,
                className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full", className),
                ...props
            })
        ]
    }));
$e3f6d6e4b2f2b020$export$94e6af45f0af4efd.displayName = $6487017786257a53$export$7c6e2c02157bb7d2.displayName;
const $e3f6d6e4b2f2b020$export$c9359e10414c2de7 = ({ className: className , ...props })=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
$e3f6d6e4b2f2b020$export$c9359e10414c2de7.displayName = "AlertDialogHeader";
const $e3f6d6e4b2f2b020$export$691560c8793e1baf = ({ className: className , ...props })=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("flex flex-row gap-x-4 justify-center", className),
        ...props
    });
$e3f6d6e4b2f2b020$export$691560c8793e1baf.displayName = "AlertDialogFooter";
const $e3f6d6e4b2f2b020$export$225e0da62d314b7 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($6487017786257a53$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("text-lg font-semibold", className),
        ...props
    }));
$e3f6d6e4b2f2b020$export$225e0da62d314b7.displayName = $6487017786257a53$export$f99233281efd08a0.displayName;
const $e3f6d6e4b2f2b020$export$a23b55cde55ad9a5 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($6487017786257a53$export$393edc798c47379d, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("text-sm text-muted-foreground", className),
        ...props
    }));
$e3f6d6e4b2f2b020$export$a23b55cde55ad9a5.displayName = $6487017786257a53$export$393edc798c47379d.displayName;
const $e3f6d6e4b2f2b020$export$b454f818c58ee85d = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($6487017786257a53$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)((0, $9cfb09368e977195$export$dca1ee5a936bb312)(), className),
        ...props
    }));
$e3f6d6e4b2f2b020$export$b454f818c58ee85d.displayName = $6487017786257a53$export$e19cd5f9376f8cee.displayName;
const $e3f6d6e4b2f2b020$export$2f67a923571aaea0 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($6487017786257a53$export$848c9b7ead0df967, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)((0, $9cfb09368e977195$export$dca1ee5a936bb312)({
            variant: "outline"
        }), "mt-2 sm:mt-0", className),
        ...props
    }));
$e3f6d6e4b2f2b020$export$2f67a923571aaea0.displayName = $6487017786257a53$export$848c9b7ead0df967.displayName;


function $338f7003293b487c$var$BaseModal({ title: title = "title" , trigger: trigger , initiallyOpen: initiallyOpen = true , footerElements: footerElements , children: children , actionButtonText: actionButtonText = "Continue" , showActionButton: showActionButton = true  }) {
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(initiallyOpen);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        setIsOpen(initiallyOpen);
    }, [
        initiallyOpen
    ]);
    function handleCloseEvent() {
        setIsOpen(false);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $e3f6d6e4b2f2b020$export$de466dd8317b0b75), {
        open: isOpen,
        onOpenChange: setIsOpen,
        children: [
            !!trigger && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e3f6d6e4b2f2b020$export$6edd7a623ef0f40b), {
                children: trigger
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $e3f6d6e4b2f2b020$export$94e6af45f0af4efd), {
                handleMouseDownOnOverlay: handleCloseEvent,
                onEscapeKeyDown: handleCloseEvent,
                onCloseAutoFocus: (e)=>{
                    e.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $e3f6d6e4b2f2b020$export$c9359e10414c2de7), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e3f6d6e4b2f2b020$export$225e0da62d314b7), {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e3f6d6e4b2f2b020$export$a23b55cde55ad9a5), {
                                children: children
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $e3f6d6e4b2f2b020$export$691560c8793e1baf), {
                        children: [
                            footerElements,
                            showActionButton && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e3f6d6e4b2f2b020$export$b454f818c58ee85d), {
                                onClick: ()=>setIsOpen(false),
                                children: actionButtonText
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $338f7003293b487c$export$2e2bcd8739ae039 = $338f7003293b487c$var$BaseModal;




function $829c75ee96051adf$var$InfoModal() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $338f7003293b487c$export$2e2bcd8739ae039), {
        title: "",
        trigger: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $84da28061cdedf92$export$2e2bcd8739ae039), {
            className: "mr-4"
        }),
        initiallyOpen: false,
        actionButtonText: "Got It!",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9aff75f1e9e81163$export$b2539bed5023c21c), {
            defaultValue: "how-to-play",
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9aff75f1e9e81163$export$9712d22edc0d78c1), {
                    className: "grid w-full grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9aff75f1e9e81163$export$8114b9fdfdf9f3ba), {
                            value: "how-to-play",
                            children: "How To Play"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9aff75f1e9e81163$export$8114b9fdfdf9f3ba), {
                            value: "about-us",
                            children: "About Us"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9aff75f1e9e81163$export$bd905d70e8fd2ebb), {
                    value: "how-to-play",
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$a766cd26d0d69044), {
                            type: "single",
                            collapsible: true,
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$d99097c13d4dac9f), {
                                    value: "item-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$94e939b1f85bdd73), {
                                            children: "What's The Goal?"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$985b9a77379b54a0), {
                                            children: "Find groups of items or names that share something in common."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$d99097c13d4dac9f), {
                                    value: "item-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$94e939b1f85bdd73), {
                                            children: "How Do I Play?"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$985b9a77379b54a0), {
                                            children: "Select the items and tap 'Submit' to check if your guess matches one of the answer categories."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$d99097c13d4dac9f), {
                                    value: "item-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$94e939b1f85bdd73), {
                                            children: "How Many Tries Do I Get?"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$985b9a77379b54a0), {
                                            children: `You can make ${(0, $0560d699d69cf4bb$export$7ea57ed97bda1046)} mistakes before the game ends.`
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9aff75f1e9e81163$export$bd905d70e8fd2ebb), {
                    value: "about-us",
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$a766cd26d0d69044), {
                            type: "single",
                            collapsible: true,
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$d99097c13d4dac9f), {
                                    value: "item-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$94e939b1f85bdd73), {
                                            children: "Who Are Y'all?"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$985b9a77379b54a0), {
                                            children: [
                                                "This project is brought to you by andcomputers, feel free to subscribe to our writing and other experiments.",
                                                " ",
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                    href: "https://andcomputers.io/",
                                                    target: "_blank",
                                                    className: "underline font-bold",
                                                    children: "Check out our writing here."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$d99097c13d4dac9f), {
                                    value: "item-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$94e939b1f85bdd73), {
                                            children: "How Can I Support?"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$985b9a77379b54a0), {
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                                    className: "mb-1",
                                                    children: "If you'd like to support feel free!"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("ul", {
                                                    className: "list-disc",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                                                    children: "Help us make an upcoming puzzle by "
                                                                }),
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                                    href: "mailto:jcp@mail.andcomputers.io",
                                                                    target: "_blank",
                                                                    className: "underline font-bold",
                                                                    children: "emailing the team."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                                                    className: "mt-2 mb-1",
                                                                    children: "Help us pay for servers & time:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("ul", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("li", {
                                                                            children: [
                                                                                " ",
                                                                                "- One-time contribution via",
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                                                    href: "https://buy.stripe.com/7sIg1Udac6xZegodQR",
                                                                                    target: "_blank",
                                                                                    className: "underline font-bold",
                                                                                    children: "Stripe."
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("li", {
                                                                            children: [
                                                                                " ",
                                                                                "- Recurring contributions via",
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                                                    href: "https://www.patreon.com/andcomputers",
                                                                                    target: "_blank",
                                                                                    className: "underline font-bold",
                                                                                    children: "Patreon."
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c25d03415198f2ec$export$d99097c13d4dac9f), {
                                    value: "item-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$94e939b1f85bdd73), {
                                            children: "Any Other Projects to Check Out?"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c25d03415198f2ec$export$985b9a77379b54a0), {
                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                className: "grid grid-flow-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                                        children: "Just a few! "
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                        href: "https://andcomputers.io/",
                                                        target: "_blank",
                                                        className: "underline font-bold",
                                                        children: "- Our writing and thoughts are here."
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                        href: "https://blacktwitter.io/",
                                                        target: "_blank",
                                                        className: "underline font-bold",
                                                        children: "- BlackTwitter"
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                        href: "https://blackwords.andcomputers.io/",
                                                        target: "_blank",
                                                        className: "underline font-bold",
                                                        children: "- Black Wordle"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $829c75ee96051adf$export$2e2bcd8739ae039 = $829c75ee96051adf$var$InfoModal;




function $ce2bbf7743ae7f98$var$Header() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("header", {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h1", {
            className: "font-space-mono",
            children: "Connections"
        })
    });
}
var $ce2bbf7743ae7f98$export$2e2bcd8739ae039 = $ce2bbf7743ae7f98$var$Header;






var $exYeM = parcelRequire("exYeM");

function $c10a8025d61652dc$var$getAllWordsOfGameData({ gameData: gameData  }) {
    const numCategories = gameData.length;
    let allWords = [];
    for(let i = 0; i < numCategories; i++)if (gameData[i]?.words) allWords.push(gameData[i].words);
    else allWords.push(gameData[i]);
    return allWords.flat();
}
function $c10a8025d61652dc$export$d1246a55b993f861({ gameData: gameData  }) {
    let categorySize;
    if (gameData[0]?.words) categorySize = gameData[0].words.length;
    else categorySize = gameData[0].length;
    const allWordsFlattened = $c10a8025d61652dc$var$getAllWordsOfGameData({
        gameData: gameData
    });
    return (0, $56229cc9fc90141d$export$5f7ec48d69707ddd)(categorySize, (0, $56229cc9fc90141d$export$448332262467e042)(allWordsFlattened));
}
function $c10a8025d61652dc$export$872584ef35ecfeaa({ gameData: gameData , guessCandidate: guessCandidate  }) {
    let isCorrect = false;
    let correctWords = "";
    let correctCategory = "";
    let correctImageSrc = null;
    let isGuessOneAway = false;
    let correctDifficulty = null;
    const differencesOfArrays = [];
    for(let i = 0; i < gameData.length; i++){
        correctWords = gameData[i].words;
        correctCategory = gameData[i].category;
        correctDifficulty = gameData[i].difficulty;
        correctImageSrc = gameData[i].imageSrc;
        if ((0, $56229cc9fc90141d$export$76a46922e320ce3b)(guessCandidate, correctWords)) {
            isCorrect = true;
            return {
                isCorrect: isCorrect,
                correctWords: correctWords,
                correctCategory: correctCategory,
                isGuessOneAway: isGuessOneAway,
                correctDifficulty: correctDifficulty,
                correctImageSrc: correctImageSrc
            };
        } else {
            // check size of difference, were doing this twice, but no need to optimize for tiny arrays
            const differenceLength = (0, $56229cc9fc90141d$export$4c3569103e7f2532)(guessCandidate, correctWords).length;
            // store how far off their guess was from category
            differencesOfArrays.push(differenceLength);
        }
    }
    isGuessOneAway = Math.min(...differencesOfArrays) === 1;
    return {
        isCorrect: isCorrect,
        correctWords: correctWords,
        correctCategory: correctCategory,
        isGuessOneAway: isGuessOneAway,
        correctImageSrc: correctImageSrc
    };
}
function $c10a8025d61652dc$export$a7c89472cbd6a2db({ submittedGuesses: submittedGuesses , guessCandidate: guessCandidate  }) {
    for(let i = 0; i < submittedGuesses.length; i++){
        const prevGuess = submittedGuesses[i];
        if ((0, $56229cc9fc90141d$export$76a46922e320ce3b)(guessCandidate, prevGuess)) return true;
    }
    return false;
}
function $c10a8025d61652dc$export$5bf48084bac4ea00({ gd1: gd1 , gd2: gd2  }) {
    if (gd1 == null || gd2 == null) return false;
    if (gd1.length !== gd2.length) return false;
    for(let i = 0; i < gd1.lengthl; i++){
        if (!(0, $56229cc9fc90141d$export$76a46922e320ce3b)(gd1.words[i], gd2.words[i])) return false;
    }
    return true;
}
function $c10a8025d61652dc$export$81af505f04eac98f({ gameData: gameData , submittedGuesses: submittedGuesses  }) {
    const allGameWordsFlattened = $c10a8025d61652dc$var$getAllWordsOfGameData({
        gameData: gameData
    });
    const allGuessesFlattened = $c10a8025d61652dc$var$getAllWordsOfGameData({
        gameData: submittedGuesses
    });
    if (submittedGuesses.length === 0) return false;
    const isSubset = allGuessesFlattened.every((val)=>allGameWordsFlattened.includes(val));
    return isSubset;
}
const $c10a8025d61652dc$export$a63577e223e2a6c9 = (gameData, submittedGuesses)=>{
    const wordToDifficultyMap = {};
    const tiles = $c10a8025d61652dc$export$dbae3455ab69bd40();
    const numCategories = gameData.length;
    const allWords = [];
    for(let i = 0; i < numCategories; i++){
        allWords.push(gameData[i].words);
        let difficulty = gameData[i].difficulty;
        gameData[i].words.map((word)=>wordToDifficultyMap[word] = difficulty);
    }
    const allEmojiRowsArray = [];
    for(let i = 0; i < submittedGuesses.length; i++){
        const submittedGuess = submittedGuesses[i];
        let wordDifficultiesArray = submittedGuess.map((word)=>wordToDifficultyMap[word]);
        const emojiRowForGuess = wordDifficultiesArray.map((wordDifficulty)=>{
            switch(wordDifficulty){
                case 1:
                    return tiles[0];
                case 2:
                    return tiles[1];
                case 3:
                    return tiles[2];
                case 4:
                    return tiles[3];
            }
        }).join("");
        allEmojiRowsArray.push(emojiRowForGuess);
    }
    return `${allEmojiRowsArray.join("\n")}`;
};
function $c10a8025d61652dc$export$dbae3455ab69bd40() {
    let tiles = [];
    tiles.push("\uD83D\uDFE9");
    tiles.push("\uD83D\uDFE8");
    tiles.push("\uD83D\uDFEA");
    tiles.push("\uD83D\uDFE6");
    return tiles;
}




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
var $d192440729d3d1d2$export$3677029976656ab8;
var $d192440729d3d1d2$export$d90250155de6d7e7;
$d192440729d3d1d2$export$3677029976656ab8 = `_7_rvlW_growShrink`;
$d192440729d3d1d2$export$d90250155de6d7e7 = `_7_rvlW_selected`;




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");



/* -------------------------------------------------------------------------------------------------
 * Toggle
 * -----------------------------------------------------------------------------------------------*/ const $13da01a735a5a057$var$$b3bbe2732c13b576$var$NAME = "Toggle";
const $13da01a735a5a057$export$bea8ebba691c5813 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { pressed: pressedProp , defaultPressed: defaultPressed = false , onPressedChange: onPressedChange , ...buttonProps } = props;
    const [pressed = false, setPressed] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : undefined
    }, buttonProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    }));
});
/*#__PURE__*/ Object.assign($13da01a735a5a057$export$bea8ebba691c5813, {
    displayName: $13da01a735a5a057$var$$b3bbe2732c13b576$var$NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $13da01a735a5a057$export$be92b6f5f03c0fe9 = $13da01a735a5a057$export$bea8ebba691c5813;




const $10f75123c395db2c$export$559a8be544a0b762 = (0, $f6c488ee7ea67d84$export$87dc52566e90b739)("inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors lg:hover:bg-muted lg:hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-slate-300/70 data-[state=on]:text-accent-foreground", {
    variants: {
        variant: {
            default: "bg-transparent",
            outline: "border-solid border border-input bg-transparent lg:hover:bg-accent lg:hover:text-accent-foreground"
        },
        size: {
            default: "h-10 px-3",
            sm: "h-9 px-2.5",
            lg: "h-11 px-5"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const $10f75123c395db2c$export$bea8ebba691c5813 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , variant: variant , size: size , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($13da01a735a5a057$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)($10f75123c395db2c$export$559a8be544a0b762({
            variant: variant,
            size: size,
            className: className
        })),
        ...props
    }));
$10f75123c395db2c$export$bea8ebba691c5813.displayName = $13da01a735a5a057$export$be92b6f5f03c0fe9.displayName;




var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
function $e988ad2ce58d9c6e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}


function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}


function $b320e4b5494ae3f6$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $2285621ea3fa8491$export$2e2bcd8739ae039(argument) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $9260a9ed67d17426$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $34df346d5c5052d9$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $e186b8b389b84e48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $d6e6dd41b8cf835a$var$MILLISECONDS_IN_DAY = 86400000;
function $d6e6dd41b8cf835a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $d6e6dd41b8cf835a$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $83985fc780dba6d7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $d6e6dd41b8cf835a$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


function $7e1e49f3280ac08a$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



function $22ec0d2a1df4cb28$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var originalDate = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError("Invalid time value");
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
    if (format !== "extended" && format !== "basic") throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== "date" && representation !== "time" && representation !== "complete") throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
        var month = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
        var year = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
        var minute = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
        var second = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $c0d321040488d36f$export$dfd9b671c89acc8e = 7;
var $c0d321040488d36f$export$3913210603d8e9ae = 365.2425;
var $c0d321040488d36f$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $c0d321040488d36f$export$91246f0b9bd9beff = 60000;
var $c0d321040488d36f$export$7f72910d6dfd237a = 3600000;
var $c0d321040488d36f$export$397c2d5776aa9055 = 1000;
var $c0d321040488d36f$export$4dec998e48f9c246 = -$c0d321040488d36f$export$81caae6e1cc7a622;
var $c0d321040488d36f$export$f2f5ae5a8e2d8f9f = 60;
var $c0d321040488d36f$export$3c58128db900d44e = 3;
var $c0d321040488d36f$export$80d7e435f744f319 = 12;
var $c0d321040488d36f$export$4db7641526e3241f = 4;
var $c0d321040488d36f$export$698aec755e92c695 = 3600;
var $c0d321040488d36f$export$a77c1a7ebebe2a5a = 60;
var $c0d321040488d36f$export$815a9362476d2fe3 = $c0d321040488d36f$export$698aec755e92c695 * 24;
var $c0d321040488d36f$export$34804a017b31e2fe = $c0d321040488d36f$export$815a9362476d2fe3 * 7;
var $c0d321040488d36f$export$7271e9e3478110d1 = $c0d321040488d36f$export$815a9362476d2fe3 * $c0d321040488d36f$export$3913210603d8e9ae;
var $c0d321040488d36f$export$8e6600bbdee7dabb = $c0d321040488d36f$export$7271e9e3478110d1 / 12;
var $c0d321040488d36f$export$be1dccf2de902d31 = $c0d321040488d36f$export$8e6600bbdee7dabb * 3;




function $a5f7651bc4a40a14$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $a5f7651bc4a40a14$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $a5f7651bc4a40a14$var$parseYear(dateStrings.date, additionalDigits);
        date = $a5f7651bc4a40a14$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $a5f7651bc4a40a14$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $a5f7651bc4a40a14$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $a5f7651bc4a40a14$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $a5f7651bc4a40a14$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $a5f7651bc4a40a14$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $a5f7651bc4a40a14$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $a5f7651bc4a40a14$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($a5f7651bc4a40a14$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($a5f7651bc4a40a14$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($a5f7651bc4a40a14$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $a5f7651bc4a40a14$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a5f7651bc4a40a14$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $a5f7651bc4a40a14$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($a5f7651bc4a40a14$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $a5f7651bc4a40a14$var$parseDateUnit(captures[1]);
    var month = $a5f7651bc4a40a14$var$parseDateUnit(captures[2]) - 1;
    var day = $a5f7651bc4a40a14$var$parseDateUnit(captures[3]);
    var week = $a5f7651bc4a40a14$var$parseDateUnit(captures[4]);
    var dayOfWeek = $a5f7651bc4a40a14$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$a5f7651bc4a40a14$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a5f7651bc4a40a14$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$a5f7651bc4a40a14$var$validateDate(year, month, day) || !$a5f7651bc4a40a14$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $a5f7651bc4a40a14$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $a5f7651bc4a40a14$var$parseTime(timeString) {
    var captures = timeString.match($a5f7651bc4a40a14$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $a5f7651bc4a40a14$var$parseTimeUnit(captures[1]);
    var minutes = $a5f7651bc4a40a14$var$parseTimeUnit(captures[2]);
    var seconds = $a5f7651bc4a40a14$var$parseTimeUnit(captures[3]);
    if (!$a5f7651bc4a40a14$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $c0d321040488d36f$export$7f72910d6dfd237a) + minutes * (0, $c0d321040488d36f$export$91246f0b9bd9beff) + seconds * 1000;
}
function $a5f7651bc4a40a14$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $a5f7651bc4a40a14$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($a5f7651bc4a40a14$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$a5f7651bc4a40a14$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $c0d321040488d36f$export$7f72910d6dfd237a) + minutes * (0, $c0d321040488d36f$export$91246f0b9bd9beff));
}
function $a5f7651bc4a40a14$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $a5f7651bc4a40a14$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a5f7651bc4a40a14$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a5f7651bc4a40a14$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($a5f7651bc4a40a14$var$daysInMonths[month] || ($a5f7651bc4a40a14$var$isLeapYearIndex(year) ? 29 : 28));
}
function $a5f7651bc4a40a14$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($a5f7651bc4a40a14$var$isLeapYearIndex(year) ? 366 : 365);
}
function $a5f7651bc4a40a14$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $a5f7651bc4a40a14$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $a5f7651bc4a40a14$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


function $810059001ee523ba$export$2e2bcd8739ae039() {
    return (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(Date.now());
}

/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ function $cad0e8541627e7f0$export$2e2bcd8739ae039() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $d4b97cf4e3084367$exports = {};

$parcel$export($d4b97cf4e3084367$exports, "extract", function () { return $d4b97cf4e3084367$export$f9380c9a627682d3; });
$parcel$export($d4b97cf4e3084367$exports, "parse", function () { return $d4b97cf4e3084367$export$98e6a39c04603d36; });
$parcel$export($d4b97cf4e3084367$exports, "stringify", function () { return $d4b97cf4e3084367$export$fac44ee5b035f737; });
$parcel$export($d4b97cf4e3084367$exports, "parseUrl", function () { return $d4b97cf4e3084367$export$7a5253c0f62e0150; });
$parcel$export($d4b97cf4e3084367$exports, "stringifyUrl", function () { return $d4b97cf4e3084367$export$a8c1621ea79325d3; });
$parcel$export($d4b97cf4e3084367$exports, "pick", function () { return $d4b97cf4e3084367$export$357523c63a2253b9; });
$parcel$export($d4b97cf4e3084367$exports, "exclude", function () { return $d4b97cf4e3084367$export$44c361b8ec72ef7f; });
const $e3f49fb9a7fe1f8f$var$token = "%[a-f0-9]{2}";
const $e3f49fb9a7fe1f8f$var$singleMatcher = new RegExp("(" + $e3f49fb9a7fe1f8f$var$token + ")|([^%]+?)", "gi");
const $e3f49fb9a7fe1f8f$var$multiMatcher = new RegExp("(" + $e3f49fb9a7fe1f8f$var$token + ")+", "gi");
function $e3f49fb9a7fe1f8f$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $e3f49fb9a7fe1f8f$var$decodeComponents(left), $e3f49fb9a7fe1f8f$var$decodeComponents(right));
}
function $e3f49fb9a7fe1f8f$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($e3f49fb9a7fe1f8f$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $e3f49fb9a7fe1f8f$var$decodeComponents(tokens, i).join("");
            tokens = input.match($e3f49fb9a7fe1f8f$var$singleMatcher) || [];
        }
        return input;
    }
}
function $e3f49fb9a7fe1f8f$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    let match = $e3f49fb9a7fe1f8f$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $e3f49fb9a7fe1f8f$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e3f49fb9a7fe1f8f$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function $e3f49fb9a7fe1f8f$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $e3f49fb9a7fe1f8f$var$customDecodeURIComponent(encodedURI);
    }
}


function $e78c9bd53c92ef94$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}


function $e85104af5636d4bb$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $e85104af5636d4bb$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $e85104af5636d4bb$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $e85104af5636d4bb$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}


const $d4b97cf4e3084367$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $d4b97cf4e3084367$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $d4b97cf4e3084367$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $d4b97cf4e3084367$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            "[",
                            $d4b97cf4e3084367$var$encode(index, options),
                            "]=",
                            $d4b97cf4e3084367$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            "[]=",
                            $d4b97cf4e3084367$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            ":list=",
                            $d4b97cf4e3084367$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $d4b97cf4e3084367$var$encode(key, options),
                                keyValueSep,
                                $d4b97cf4e3084367$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $d4b97cf4e3084367$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $d4b97cf4e3084367$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            "=",
                            $d4b97cf4e3084367$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $d4b97cf4e3084367$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $d4b97cf4e3084367$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $d4b97cf4e3084367$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$d4b97cf4e3084367$var$decode(item, options)) : value === null ? value : $d4b97cf4e3084367$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $d4b97cf4e3084367$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$d4b97cf4e3084367$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $d4b97cf4e3084367$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $d4b97cf4e3084367$var$encode(value, options) {
    if (options.encode) return options.strict ? $d4b97cf4e3084367$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $d4b97cf4e3084367$var$decode(value, options) {
    if (options.decode) return (0, $e3f49fb9a7fe1f8f$export$2e2bcd8739ae039)(value);
    return value;
}
function $d4b97cf4e3084367$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $d4b97cf4e3084367$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $d4b97cf4e3084367$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $d4b97cf4e3084367$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $d4b97cf4e3084367$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $d4b97cf4e3084367$export$f9380c9a627682d3(input) {
    input = $d4b97cf4e3084367$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $d4b97cf4e3084367$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $d4b97cf4e3084367$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $d4b97cf4e3084367$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, $e78c9bd53c92ef94$export$2e2bcd8739ae039)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $d4b97cf4e3084367$var$decode(value, options);
        formatter($d4b97cf4e3084367$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $d4b97cf4e3084367$var$parseValue(value2, options);
        else returnValue[key] = $d4b97cf4e3084367$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $d4b97cf4e3084367$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
function $d4b97cf4e3084367$export$fac44ee5b035f737(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    $d4b97cf4e3084367$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $d4b97cf4e3084367$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $d4b97cf4e3084367$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $d4b97cf4e3084367$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $d4b97cf4e3084367$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $d4b97cf4e3084367$var$encode(key, options) + "=" + $d4b97cf4e3084367$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function $d4b97cf4e3084367$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $e78c9bd53c92ef94$export$2e2bcd8739ae039)(url, "#");
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split("?")?.[0] ?? "",
        query: $d4b97cf4e3084367$export$98e6a39c04603d36($d4b97cf4e3084367$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $d4b97cf4e3084367$var$decode(hash, options)
        } : {}
    };
}
function $d4b97cf4e3084367$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$d4b97cf4e3084367$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $d4b97cf4e3084367$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $d4b97cf4e3084367$export$f9380c9a627682d3(object.url);
    const query = {
        ...$d4b97cf4e3084367$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $d4b97cf4e3084367$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $d4b97cf4e3084367$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$d4b97cf4e3084367$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $d4b97cf4e3084367$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$d4b97cf4e3084367$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url , query: query , fragmentIdentifier: fragmentIdentifier  } = $d4b97cf4e3084367$export$7a5253c0f62e0150(input, options);
    return $d4b97cf4e3084367$export$a8c1621ea79325d3({
        url: url,
        query: (0, $e85104af5636d4bb$export$ff05df6c2df24b52)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $d4b97cf4e3084367$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $d4b97cf4e3084367$export$357523c63a2253b9(input, exclusionFilter, options);
}


var $cdd664d6f9e47004$export$2e2bcd8739ae039 = $d4b97cf4e3084367$exports;


const $eee3385e96451a60$export$f22a6422853df92a = [
    [
        {
            category: "Scranton mangers",
            words: [
                "Michael",
                "Dwight",
                "Jim",
                "Andy"
            ],
            difficulty: 1
        },
        {
            category: "Characters in the anex",
            words: [
                "Toby",
                "Ryan",
                "Gabe",
                "Kelly"
            ],
            difficulty: 4
        },
        {
            category: "Mangers of other branches",
            words: [
                "Karen",
                "Josh",
                "Craig",
                "Dan"
            ],
            difficulty: 3
        },
        {
            category: "Women Michael dated",
            words: [
                "Carol",
                "Jan",
                "Concierge Marie",
                "Helene"
            ],
            difficulty: 2
        }
    ]
];


const $20e33653a93a2602$export$883228a582a7567d = ()=>(0, $810059001ee523ba$export$2e2bcd8739ae039)();
const $20e33653a93a2602$export$e7b72760378c0d3b = ()=>(0, $cad0e8541627e7f0$export$2e2bcd8739ae039)();
const $20e33653a93a2602$export$6caa362aa47de0a9 = new Date(2023, 9, 23);
const $20e33653a93a2602$export$f962b3e391165a04 = 7;
const $20e33653a93a2602$export$4bd620cea39ca6a8 = (today)=>{
    const t = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(today);
    let daysSinceLastGame = (0, $83985fc780dba6d7$export$2e2bcd8739ae039)(t, $20e33653a93a2602$export$6caa362aa47de0a9) % $20e33653a93a2602$export$f962b3e391165a04;
    return (0, $9260a9ed67d17426$export$2e2bcd8739ae039)(t, -daysSinceLastGame);
};
const $20e33653a93a2602$export$b4d1281d281145f7 = (today)=>{
    return (0, $9260a9ed67d17426$export$2e2bcd8739ae039)($20e33653a93a2602$export$4bd620cea39ca6a8(today), $20e33653a93a2602$export$f962b3e391165a04);
};
const $20e33653a93a2602$export$f5550a7c9e870a10 = (date)=>{
    if (date < $20e33653a93a2602$export$6caa362aa47de0a9 || date > $20e33653a93a2602$export$883228a582a7567d()) return false;
    return (0, $83985fc780dba6d7$export$2e2bcd8739ae039)($20e33653a93a2602$export$6caa362aa47de0a9, date) % $20e33653a93a2602$export$f962b3e391165a04 === 0;
};
const $20e33653a93a2602$export$ddfa24987dade61b = (gameDate)=>{
    let start = $20e33653a93a2602$export$6caa362aa47de0a9;
    let index = -1;
    console.log($20e33653a93a2602$export$6caa362aa47de0a9);
    do {
        index++;
        start = (0, $9260a9ed67d17426$export$2e2bcd8739ae039)(start, $20e33653a93a2602$export$f962b3e391165a04);
    }while (start <= gameDate);
    return index;
};
const $20e33653a93a2602$export$7d6469d31f34c305 = (index)=>{
    if (index < 0) throw new Error("Invalid index");
    return (0, $eee3385e96451a60$export$f22a6422853df92a)[index % (0, $eee3385e96451a60$export$f22a6422853df92a).length];
};
const $20e33653a93a2602$export$aa83c3a07763586 = (gameDate)=>{
    const nextGameDate = $20e33653a93a2602$export$b4d1281d281145f7(gameDate);
    const index = $20e33653a93a2602$export$ddfa24987dade61b(gameDate);
    const puzzleOfTheDay = $20e33653a93a2602$export$7d6469d31f34c305(index);
    console.log("index for today: ", index);
    return {
        puzzleAnswers: puzzleOfTheDay,
        puzzleGameDate: gameDate,
        puzzleIndex: index,
        dateOfNextPuzzle: nextGameDate.valueOf()
    };
};
const $20e33653a93a2602$export$9a080392f5112997 = ()=>{
    if ($20e33653a93a2602$export$3a4dea89a5aa7ed5()) return $20e33653a93a2602$export$883228a582a7567d();
    const parsed = (0, $cdd664d6f9e47004$export$2e2bcd8739ae039).parse(window.location.search);
    try {
        const d = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)((0, $a5f7651bc4a40a14$export$2e2bcd8739ae039)(parsed.d?.toString()));
        if (d >= $20e33653a93a2602$export$883228a582a7567d() || d < $20e33653a93a2602$export$6caa362aa47de0a9) $20e33653a93a2602$export$762c0c2e53901f0e($20e33653a93a2602$export$883228a582a7567d());
        return d;
    } catch (e) {
        console.log(e);
        return $20e33653a93a2602$export$883228a582a7567d();
    }
};
const $20e33653a93a2602$export$762c0c2e53901f0e = (d)=>{
    try {
        if (d < $20e33653a93a2602$export$883228a582a7567d()) {
            window.location.href = "/?d=" + (0, $22ec0d2a1df4cb28$export$2e2bcd8739ae039)(d, {
                representation: "date"
            });
            return;
        }
    } catch (e) {
        console.log(e);
    }
    window.location.href = "/";
};
const $20e33653a93a2602$export$3a4dea89a5aa7ed5 = ()=>{
    // https://github.com/cwackerfuss/react-wordle/pull/505
    const parsed = (0, $cdd664d6f9e47004$export$2e2bcd8739ae039).parse(window.location.search);
    return parsed === null || !("d" in parsed);
};
const { puzzleAnswers: $20e33653a93a2602$export$943619dc4de0e8da , puzzleGameDate: $20e33653a93a2602$export$fedf7004e34a72fc , puzzleIndex: $20e33653a93a2602$export$3014f1d0d6bd394f , dateOfNextPuzzle: $20e33653a93a2602$export$a20d366458c50e4a  } = $20e33653a93a2602$export$aa83c3a07763586($20e33653a93a2602$export$9a080392f5112997());


const $4a5925ef595e0ef1$export$e8331451049320c2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext();
function $4a5925ef595e0ef1$var$PuzzleDataProvider({ children: children  }) {
    const [gameData, setGameData] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState((0, $20e33653a93a2602$export$943619dc4de0e8da));
    const categorySize = gameData[0].words.length;
    const numCategories = gameData.length;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4a5925ef595e0ef1$export$e8331451049320c2.Provider, {
        value: {
            gameData: gameData,
            numCategories: numCategories,
            categorySize: categorySize
        },
        children: children
    });
}
var $4a5925ef595e0ef1$export$2e2bcd8739ae039 = $4a5925ef595e0ef1$var$PuzzleDataProvider;




const $ab9daf3d1bf20705$var$gameStateKey = "gameState";
const $ab9daf3d1bf20705$export$56041581280517cc = (gameState)=>{
    localStorage.setItem($ab9daf3d1bf20705$var$gameStateKey, JSON.stringify(gameState));
};
const $ab9daf3d1bf20705$export$9c74827dbe230598 = ()=>{
    const state = localStorage.getItem($ab9daf3d1bf20705$var$gameStateKey);
    return state ? JSON.parse(state) : null;
};
const $ab9daf3d1bf20705$var$gameStatKey = "gameStats";
const $ab9daf3d1bf20705$export$bceb2c2841615d22 = (gameStats)=>{
    localStorage.setItem($ab9daf3d1bf20705$var$gameStatKey, JSON.stringify(gameStats));
};
const $ab9daf3d1bf20705$export$f2b270f795666cba = ()=>{
    const stats = localStorage.getItem($ab9daf3d1bf20705$var$gameStatKey);
    return stats ? JSON.parse(stats) : null;
};



const $114a14924666ebd7$export$3f49015a6304186f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext();
function $114a14924666ebd7$var$GameStatusProvider({ children: children  }) {
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $4a5925ef595e0ef1$export$e8331451049320c2));
    const [submittedGuesses, setSubmittedGuesses] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [solvedGameData, setSolvedGameData] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(()=>{
        const loadedState = (0, $ab9daf3d1bf20705$export$9c74827dbe230598)();
        console.log("checking game state!", {
            loadedState: loadedState,
            gd1: gameData,
            gd2: loadedState?.gameData
        });
        if (!(0, $c10a8025d61652dc$export$5bf48084bac4ea00)({
            gd1: gameData,
            gd2: loadedState?.gameData
        })) return [];
        if (!(0, $c10a8025d61652dc$export$81af505f04eac98f)({
            gameData: gameData,
            submittedGuesses: loadedState?.submittedGuesses
        })) return [];
        if (Array.isArray(loadedState?.submittedGuesses)) setSubmittedGuesses(loadedState.submittedGuesses);
        if (Array.isArray(loadedState?.solvedGameData)) return loadedState.solvedGameData;
        return [];
    });
    const [isGameOver, setIsGameOver] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [isGameWon, setIsGameWon] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [guessCandidate, setGuessCandidate] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const numMistakesUsed = submittedGuesses.length - solvedGameData.length;
    // use effect to check if game is won
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (solvedGameData.length === gameData.length) {
            setIsGameOver(true);
            setIsGameWon(true);
        }
        const gameState = {
            submittedGuesses: submittedGuesses,
            solvedGameData: solvedGameData,
            gameData: gameData
        };
        (0, $ab9daf3d1bf20705$export$56041581280517cc)(gameState);
    }, [
        solvedGameData
    ]);
    // use effect to check if all mistakes have been used and end the game accordingly
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (numMistakesUsed >= (0, $0560d699d69cf4bb$export$7ea57ed97bda1046)) {
            setIsGameOver(true);
            setIsGameWon(false);
        }
        const gameState = {
            submittedGuesses: submittedGuesses,
            solvedGameData: solvedGameData,
            gameData: gameData
        };
        (0, $ab9daf3d1bf20705$export$56041581280517cc)(gameState);
    }, [
        submittedGuesses
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($114a14924666ebd7$export$3f49015a6304186f.Provider, {
        value: {
            isGameOver: isGameOver,
            isGameWon: isGameWon,
            numMistakesUsed: numMistakesUsed,
            solvedGameData: solvedGameData,
            setSolvedGameData: setSolvedGameData,
            submittedGuesses: submittedGuesses,
            setSubmittedGuesses: setSubmittedGuesses,
            guessCandidate: guessCandidate,
            setGuessCandidate: setGuessCandidate
        },
        children: children
    });
}
var $114a14924666ebd7$export$2e2bcd8739ae039 = $114a14924666ebd7$var$GameStatusProvider;




function $36bc3e0e590f859e$var$WordButton({ word: word , fullCandidateSize: fullCandidateSize  }) {
    const { guessCandidate: guessCandidate , setGuessCandidate: setGuessCandidate  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $114a14924666ebd7$export$3f49015a6304186f));
    const [isSelected, setIsSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(!!guessCandidate.includes(word));
    const isCandidateListFull = guessCandidate.length == fullCandidateSize;
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        setIsSelected(!!guessCandidate.includes(word));
    }, [
        guessCandidate
    ]);
    function flipSelection() {
        if (isSelected) {
            // remove from candidateGuess
            const updatedGuessCandidate = guessCandidate.filter((w)=>{
                return w !== word;
            });
            setGuessCandidate(updatedGuessCandidate);
            // set state to *not* selected
            setIsSelected(false);
        } else // check if the candidate array is full
        if (!isCandidateListFull) {
            // add to candidateGuess array
            setGuessCandidate([
                ...guessCandidate,
                word
            ]);
            // set state to *selected*
            setIsSelected(true);
        }
    }
    //const fontSizeByWordLength = 9characters works with 0.6rem
    function getFontSize(word) {
        const baseLength = 7;
        const wordLength = word.length;
        let fontSize = 1;
        if (wordLength > baseLength) {
            const numExtraChars = wordLength - baseLength;
            fontSize = fontSize - numExtraChars * 0.1;
            fontSize = Math.max(0.5, fontSize);
            return `${fontSize}em`;
        } else return null;
    }
    // word = "washingtonian";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $10f75123c395db2c$export$bea8ebba691c5813), {
        className: `${$d192440729d3d1d2$export$3677029976656ab8} select-none`,
        variant: "outline",
        pressed: isSelected,
        onClick: flipSelection,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
            style: {
                fontSize: getFontSize(word)
            },
            className: "font-space-mono uppercase sm:text-xs md:text-xs",
            children: word
        })
    });
}
var $36bc3e0e590f859e$export$2e2bcd8739ae039 = $36bc3e0e590f859e$var$WordButton;




var $30c2b5a596d47c14$export$267b06a7460aa7d3;
var $30c2b5a596d47c14$export$434a04ccf8ef5c9a;
var $30c2b5a596d47c14$export$422dc104ec2e5f12;
$30c2b5a596d47c14$export$267b06a7460aa7d3 = `J8PHqW_shake`;
$30c2b5a596d47c14$export$434a04ccf8ef5c9a = `J8PHqW_shake-horizontal`;
$30c2b5a596d47c14$export$422dc104ec2e5f12 = `J8PHqW_tilt-shaking`;
$30c2b5a596d47c14$export$422dc104ec2e5f12;


// src/index.ts
// src/index.ts
// src/hooks/useChain.ts

var $exYeM = parcelRequire("exYeM");
var $fafba8d3e1bed3b4$var$__defProp = Object.defineProperty;
var $fafba8d3e1bed3b4$var$__export = (target, all)=>{
    for(var name in all)$fafba8d3e1bed3b4$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $fafba8d3e1bed3b4$export$cceeabf822b64fc0 = {};
$fafba8d3e1bed3b4$var$__export($fafba8d3e1bed3b4$export$cceeabf822b64fc0, {
    assign: ()=>$fafba8d3e1bed3b4$var$assign,
    colors: ()=>$fafba8d3e1bed3b4$var$colors,
    createStringInterpolator: ()=>$fafba8d3e1bed3b4$var$createStringInterpolator,
    skipAnimation: ()=>$fafba8d3e1bed3b4$var$skipAnimation,
    to: ()=>$fafba8d3e1bed3b4$var$to,
    willAdvance: ()=>$fafba8d3e1bed3b4$var$willAdvance
});
// ../rafz/dist/react-spring_rafz.modern.mjs
var $fafba8d3e1bed3b4$var$updateQueue = $fafba8d3e1bed3b4$var$makeQueue();
var $fafba8d3e1bed3b4$export$27f233d61a9e2fa4 = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$updateQueue);
var $fafba8d3e1bed3b4$var$writeQueue = $fafba8d3e1bed3b4$var$makeQueue();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.write = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$writeQueue);
var $fafba8d3e1bed3b4$var$onStartQueue = $fafba8d3e1bed3b4$var$makeQueue();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onStart = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$onStartQueue);
var $fafba8d3e1bed3b4$var$onFrameQueue = $fafba8d3e1bed3b4$var$makeQueue();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onFrame = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$onFrameQueue);
var $fafba8d3e1bed3b4$var$onFinishQueue = $fafba8d3e1bed3b4$var$makeQueue();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onFinish = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$onFinishQueue);
var $fafba8d3e1bed3b4$var$timeouts = [];
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $fafba8d3e1bed3b4$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $fafba8d3e1bed3b4$var$timeouts.splice(i, 1);
        $fafba8d3e1bed3b4$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $fafba8d3e1bed3b4$var$timeouts.splice($fafba8d3e1bed3b4$var$findTimeout(time), 0, timeout);
    $fafba8d3e1bed3b4$var$pendingCount += 1;
    $fafba8d3e1bed3b4$var$start();
    return timeout;
};
var $fafba8d3e1bed3b4$var$findTimeout = (time)=>~(~$fafba8d3e1bed3b4$var$timeouts.findIndex((t)=>t.time > time) || ~$fafba8d3e1bed3b4$var$timeouts.length);
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $fafba8d3e1bed3b4$var$onStartQueue.delete(fn);
    $fafba8d3e1bed3b4$var$onFrameQueue.delete(fn);
    $fafba8d3e1bed3b4$var$onFinishQueue.delete(fn);
    $fafba8d3e1bed3b4$var$updateQueue.delete(fn);
    $fafba8d3e1bed3b4$var$writeQueue.delete(fn);
};
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.sync = (fn)=>{
    $fafba8d3e1bed3b4$var$sync = true;
    $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $fafba8d3e1bed3b4$var$sync = false;
};
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $fafba8d3e1bed3b4$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $fafba8d3e1bed3b4$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.use = (impl)=>$fafba8d3e1bed3b4$var$nativeRaf = impl;
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.catch = console.error;
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.frameLoop = "always";
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.advance = ()=>{
    if ($fafba8d3e1bed3b4$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $fafba8d3e1bed3b4$var$update();
};
var $fafba8d3e1bed3b4$var$ts = -1;
var $fafba8d3e1bed3b4$var$pendingCount = 0;
var $fafba8d3e1bed3b4$var$sync = false;
function $fafba8d3e1bed3b4$var$schedule(fn, queue) {
    if ($fafba8d3e1bed3b4$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $fafba8d3e1bed3b4$var$start();
    }
}
function $fafba8d3e1bed3b4$var$start() {
    if ($fafba8d3e1bed3b4$var$ts < 0) {
        $fafba8d3e1bed3b4$var$ts = 0;
        if ($fafba8d3e1bed3b4$export$27f233d61a9e2fa4.frameLoop !== "demand") $fafba8d3e1bed3b4$var$nativeRaf($fafba8d3e1bed3b4$var$loop);
    }
}
function $fafba8d3e1bed3b4$var$stop() {
    $fafba8d3e1bed3b4$var$ts = -1;
}
function $fafba8d3e1bed3b4$var$loop() {
    if (~$fafba8d3e1bed3b4$var$ts) {
        $fafba8d3e1bed3b4$var$nativeRaf($fafba8d3e1bed3b4$var$loop);
        $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.batchedUpdates($fafba8d3e1bed3b4$var$update);
    }
}
function $fafba8d3e1bed3b4$var$update() {
    const prevTs = $fafba8d3e1bed3b4$var$ts;
    $fafba8d3e1bed3b4$var$ts = $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.now();
    const count = $fafba8d3e1bed3b4$var$findTimeout($fafba8d3e1bed3b4$var$ts);
    if (count) {
        $fafba8d3e1bed3b4$var$eachSafely($fafba8d3e1bed3b4$var$timeouts.splice(0, count), (t)=>t.handler());
        $fafba8d3e1bed3b4$var$pendingCount -= count;
    }
    if (!$fafba8d3e1bed3b4$var$pendingCount) {
        $fafba8d3e1bed3b4$var$stop();
        return;
    }
    $fafba8d3e1bed3b4$var$onStartQueue.flush();
    $fafba8d3e1bed3b4$var$updateQueue.flush(prevTs ? Math.min(64, $fafba8d3e1bed3b4$var$ts - prevTs) : 16.667);
    $fafba8d3e1bed3b4$var$onFrameQueue.flush();
    $fafba8d3e1bed3b4$var$writeQueue.flush();
    $fafba8d3e1bed3b4$var$onFinishQueue.flush();
}
function $fafba8d3e1bed3b4$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $fafba8d3e1bed3b4$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $fafba8d3e1bed3b4$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $fafba8d3e1bed3b4$var$pendingCount -= current.size;
                $fafba8d3e1bed3b4$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $fafba8d3e1bed3b4$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $fafba8d3e1bed3b4$var$eachSafely(values, each2) {
    values.forEach((value)=>{
        try {
            each2(value);
        } catch (e) {
            $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
// src/helpers.ts
function $fafba8d3e1bed3b4$export$8793edee2d425525() {}
var $fafba8d3e1bed3b4$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $fafba8d3e1bed3b4$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $fafba8d3e1bed3b4$export$248d38f6296296c5(a, b) {
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(a)) {
        if (!$fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $fafba8d3e1bed3b4$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $fafba8d3e1bed3b4$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $fafba8d3e1bed3b4$export$45b10814cc054894 = (a)=>$fafba8d3e1bed3b4$export$226b3eccf92c9ed9.und(a) ? [] : $fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $fafba8d3e1bed3b4$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $fafba8d3e1bed3b4$export$79b2f7037acddd43(items, iterator);
    }
}
var $fafba8d3e1bed3b4$export$7ba486852759e806 = (queue, ...args)=>$fafba8d3e1bed3b4$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $fafba8d3e1bed3b4$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $fafba8d3e1bed3b4$var$createStringInterpolator;
var $fafba8d3e1bed3b4$var$to;
var $fafba8d3e1bed3b4$var$colors = null;
var $fafba8d3e1bed3b4$var$skipAnimation = false;
var $fafba8d3e1bed3b4$var$willAdvance = $fafba8d3e1bed3b4$export$8793edee2d425525;
var $fafba8d3e1bed3b4$var$assign = (globals)=>{
    if (globals.to) $fafba8d3e1bed3b4$var$to = globals.to;
    if (globals.now) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.now = globals.now;
    if (globals.colors !== void 0) $fafba8d3e1bed3b4$var$colors = globals.colors;
    if (globals.skipAnimation != null) $fafba8d3e1bed3b4$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $fafba8d3e1bed3b4$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $fafba8d3e1bed3b4$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.frameLoop = globals.frameLoop;
};
// src/FrameLoop.ts
var $fafba8d3e1bed3b4$var$startQueue = /* @__PURE__ */ new Set();
var $fafba8d3e1bed3b4$var$currentFrame = [];
var $fafba8d3e1bed3b4$var$prevFrame = [];
var $fafba8d3e1bed3b4$var$priority = 0;
var $fafba8d3e1bed3b4$export$a57f5080a3bcc90a = {
    get idle () {
        return !$fafba8d3e1bed3b4$var$startQueue.size && !$fafba8d3e1bed3b4$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($fafba8d3e1bed3b4$var$priority > animation.priority) {
            $fafba8d3e1bed3b4$var$startQueue.add(animation);
            $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onStart($fafba8d3e1bed3b4$var$flushStartQueue);
        } else {
            $fafba8d3e1bed3b4$var$startSafely(animation);
            $fafba8d3e1bed3b4$export$27f233d61a9e2fa4($fafba8d3e1bed3b4$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $fafba8d3e1bed3b4$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($fafba8d3e1bed3b4$var$priority) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onFrame(()=>$fafba8d3e1bed3b4$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $fafba8d3e1bed3b4$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $fafba8d3e1bed3b4$var$currentFrame.splice(prevIndex, 1);
                $fafba8d3e1bed3b4$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $fafba8d3e1bed3b4$var$currentFrame = [];
        $fafba8d3e1bed3b4$var$startQueue.clear();
    }
};
function $fafba8d3e1bed3b4$var$flushStartQueue() {
    $fafba8d3e1bed3b4$var$startQueue.forEach($fafba8d3e1bed3b4$var$startSafely);
    $fafba8d3e1bed3b4$var$startQueue.clear();
    $fafba8d3e1bed3b4$export$27f233d61a9e2fa4($fafba8d3e1bed3b4$var$advance);
}
function $fafba8d3e1bed3b4$var$startSafely(animation) {
    if (!$fafba8d3e1bed3b4$var$currentFrame.includes(animation)) $fafba8d3e1bed3b4$var$startUnsafely(animation);
}
function $fafba8d3e1bed3b4$var$startUnsafely(animation) {
    $fafba8d3e1bed3b4$var$currentFrame.splice($fafba8d3e1bed3b4$var$findIndex($fafba8d3e1bed3b4$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $fafba8d3e1bed3b4$var$advance(dt) {
    const nextFrame = $fafba8d3e1bed3b4$var$prevFrame;
    for(let i = 0; i < $fafba8d3e1bed3b4$var$currentFrame.length; i++){
        const animation = $fafba8d3e1bed3b4$var$currentFrame[i];
        $fafba8d3e1bed3b4$var$priority = animation.priority;
        if (!animation.idle) {
            $fafba8d3e1bed3b4$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $fafba8d3e1bed3b4$var$priority = 0;
    $fafba8d3e1bed3b4$var$prevFrame = $fafba8d3e1bed3b4$var$currentFrame;
    $fafba8d3e1bed3b4$var$prevFrame.length = 0;
    $fafba8d3e1bed3b4$var$currentFrame = nextFrame;
    return $fafba8d3e1bed3b4$var$currentFrame.length > 0;
}
function $fafba8d3e1bed3b4$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $fafba8d3e1bed3b4$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $fafba8d3e1bed3b4$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $fafba8d3e1bed3b4$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $fafba8d3e1bed3b4$var$PERCENTAGE = $fafba8d3e1bed3b4$var$NUMBER + "%";
function $fafba8d3e1bed3b4$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $fafba8d3e1bed3b4$export$8972dc0e6ad9238f = new RegExp("rgb" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$4e46ac54fc82cf3b = new RegExp("rgba" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$PERCENTAGE));
var $fafba8d3e1bed3b4$export$810b04175080204c = new RegExp("hsla" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fafba8d3e1bed3b4$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fafba8d3e1bed3b4$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $fafba8d3e1bed3b4$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $fafba8d3e1bed3b4$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $fafba8d3e1bed3b4$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($fafba8d3e1bed3b4$var$colors && $fafba8d3e1bed3b4$var$colors[color] !== void 0) return $fafba8d3e1bed3b4$var$colors[color];
    if (match = $fafba8d3e1bed3b4$export$8972dc0e6ad9238f.exec(color)) return ($fafba8d3e1bed3b4$var$parse255(match[1]) << 24 | // r
    $fafba8d3e1bed3b4$var$parse255(match[2]) << 16 | // g
    $fafba8d3e1bed3b4$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$4e46ac54fc82cf3b.exec(color)) return ($fafba8d3e1bed3b4$var$parse255(match[1]) << 24 | // r
    $fafba8d3e1bed3b4$var$parse255(match[2]) << 16 | // g
    $fafba8d3e1bed3b4$var$parse255(match[3]) << 8 | // b
    $fafba8d3e1bed3b4$var$parse1(match[4])) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$8f4a7c0bb78e6ea8.exec(color)) return ($fafba8d3e1bed3b4$var$hslToRgb($fafba8d3e1bed3b4$var$parse360(match[1]), // h
    $fafba8d3e1bed3b4$var$parsePercentage(match[2]), // s
    $fafba8d3e1bed3b4$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$810b04175080204c.exec(color)) return ($fafba8d3e1bed3b4$var$hslToRgb($fafba8d3e1bed3b4$var$parse360(match[1]), // h
    $fafba8d3e1bed3b4$var$parsePercentage(match[2]), // s
    $fafba8d3e1bed3b4$var$parsePercentage(match[3])) | $fafba8d3e1bed3b4$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $fafba8d3e1bed3b4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fafba8d3e1bed3b4$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h + 1 / 3);
    const g = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h);
    const b = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $fafba8d3e1bed3b4$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $fafba8d3e1bed3b4$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $fafba8d3e1bed3b4$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $fafba8d3e1bed3b4$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $fafba8d3e1bed3b4$export$61db176b839af1f(input) {
    let int32Color = $fafba8d3e1bed3b4$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $fafba8d3e1bed3b4$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(range)) return $fafba8d3e1bed3b4$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.str(range.output[0])) return $fafba8d3e1bed3b4$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $fafba8d3e1bed3b4$var$findRange(input, inputRange);
        return $fafba8d3e1bed3b4$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $fafba8d3e1bed3b4$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $fafba8d3e1bed3b4$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $fafba8d3e1bed3b4$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $fafba8d3e1bed3b4$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $fafba8d3e1bed3b4$var$c1 = 1.70158;
var $fafba8d3e1bed3b4$var$c2 = $fafba8d3e1bed3b4$var$c1 * 1.525;
var $fafba8d3e1bed3b4$var$c3 = $fafba8d3e1bed3b4$var$c1 + 1;
var $fafba8d3e1bed3b4$var$c4 = 2 * Math.PI / 3;
var $fafba8d3e1bed3b4$var$c5 = 2 * Math.PI / 4.5;
var $fafba8d3e1bed3b4$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $fafba8d3e1bed3b4$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$fafba8d3e1bed3b4$var$c3 * x * x * x - $fafba8d3e1bed3b4$var$c1 * x * x,
    easeOutBack: (x)=>1 + $fafba8d3e1bed3b4$var$c3 * Math.pow(x - 1, 3) + $fafba8d3e1bed3b4$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($fafba8d3e1bed3b4$var$c2 + 1) * 2 * x - $fafba8d3e1bed3b4$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($fafba8d3e1bed3b4$var$c2 + 1) * (x * 2 - 2) + $fafba8d3e1bed3b4$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $fafba8d3e1bed3b4$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $fafba8d3e1bed3b4$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $fafba8d3e1bed3b4$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $fafba8d3e1bed3b4$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $fafba8d3e1bed3b4$var$bounceOut(1 - x),
    easeOutBounce: $fafba8d3e1bed3b4$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $fafba8d3e1bed3b4$var$bounceOut(1 - 2 * x)) / 2 : (1 + $fafba8d3e1bed3b4$var$bounceOut(2 * x - 1)) / 2,
    steps: $fafba8d3e1bed3b4$var$steps
};
// src/fluids.ts
var $fafba8d3e1bed3b4$var$$get = Symbol.for("FluidValue.get");
var $fafba8d3e1bed3b4$var$$observers = Symbol.for("FluidValue.observers");
var $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$fafba8d3e1bed3b4$var$$get]);
var $fafba8d3e1bed3b4$export$e37b7520edd66839 = (arg)=>arg && arg[$fafba8d3e1bed3b4$var$$get] ? arg[$fafba8d3e1bed3b4$var$$get]() : arg;
var $fafba8d3e1bed3b4$export$133f54e9f7cf1796 = (target)=>target[$fafba8d3e1bed3b4$var$$observers] || null;
function $fafba8d3e1bed3b4$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $fafba8d3e1bed3b4$export$31752c40a5fab62a(target, event) {
    const observers = target[$fafba8d3e1bed3b4$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $fafba8d3e1bed3b4$export$8cbca1207adce0c0(observer2, event);
    });
}
var $fafba8d3e1bed3b4$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $fafba8d3e1bed3b4$export$a3b4618659637aa3(this, get);
    }
};
$fafba8d3e1bed3b4$var$$get, $fafba8d3e1bed3b4$var$$observers;
var $fafba8d3e1bed3b4$export$a3b4618659637aa3 = (target, get)=>$fafba8d3e1bed3b4$var$setHidden(target, $fafba8d3e1bed3b4$var$$get, get);
function $fafba8d3e1bed3b4$export$72d604e3f8d000a5(target, observer2) {
    if (target[$fafba8d3e1bed3b4$var$$get]) {
        let observers = target[$fafba8d3e1bed3b4$var$$observers];
        if (!observers) $fafba8d3e1bed3b4$var$setHidden(target, $fafba8d3e1bed3b4$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $fafba8d3e1bed3b4$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$fafba8d3e1bed3b4$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$fafba8d3e1bed3b4$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $fafba8d3e1bed3b4$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $fafba8d3e1bed3b4$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $fafba8d3e1bed3b4$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $fafba8d3e1bed3b4$var$unitRegex = new RegExp(`(${$fafba8d3e1bed3b4$var$numberRegex.source})(%|[a-z]+)`, "i");
var $fafba8d3e1bed3b4$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $fafba8d3e1bed3b4$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $fafba8d3e1bed3b4$var$variableToRgba = (input)=>{
    const [token, fallback] = $fafba8d3e1bed3b4$var$parseCSSVariable(input);
    if (!token || $fafba8d3e1bed3b4$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $fafba8d3e1bed3b4$var$cssVariableRegex.test(fallback)) return $fafba8d3e1bed3b4$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $fafba8d3e1bed3b4$var$parseCSSVariable = (current)=>{
    const match = $fafba8d3e1bed3b4$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $fafba8d3e1bed3b4$var$namedColorRegex;
var $fafba8d3e1bed3b4$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $fafba8d3e1bed3b4$export$4759a013d387347a = (config)=>{
    if (!$fafba8d3e1bed3b4$var$namedColorRegex) $fafba8d3e1bed3b4$var$namedColorRegex = $fafba8d3e1bed3b4$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($fafba8d3e1bed3b4$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $fafba8d3e1bed3b4$export$e37b7520edd66839(value).replace($fafba8d3e1bed3b4$var$cssVariableRegex, $fafba8d3e1bed3b4$var$variableToRgba).replace($fafba8d3e1bed3b4$var$colorRegex, $fafba8d3e1bed3b4$export$61db176b839af1f).replace($fafba8d3e1bed3b4$var$namedColorRegex, $fafba8d3e1bed3b4$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($fafba8d3e1bed3b4$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$fafba8d3e1bed3b4$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$fafba8d3e1bed3b4$var$unitRegex.test(output[0]) && output.find((value)=>$fafba8d3e1bed3b4$var$unitRegex.test(value))?.replace($fafba8d3e1bed3b4$var$numberRegex, "");
        let i = 0;
        return output[0].replace($fafba8d3e1bed3b4$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($fafba8d3e1bed3b4$var$rgbaRegex, $fafba8d3e1bed3b4$var$rgbaRound);
    };
};
// src/deprecations.ts
var $fafba8d3e1bed3b4$export$82e9f45cca5ba907 = "react-spring: ";
var $fafba8d3e1bed3b4$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $fafba8d3e1bed3b4$var$warnInterpolate = $fafba8d3e1bed3b4$export$d2de3aaeafa91619(console.warn);
function $fafba8d3e1bed3b4$export$2abfcde8ae218ba8() {
    $fafba8d3e1bed3b4$var$warnInterpolate(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $fafba8d3e1bed3b4$var$warnDirectCall = $fafba8d3e1bed3b4$export$d2de3aaeafa91619(console.warn);
function $fafba8d3e1bed3b4$export$d99d974913ad3b12() {
    $fafba8d3e1bed3b4$var$warnDirectCall(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $fafba8d3e1bed3b4$export$75bed621f62abfa9(value) {
    return $fafba8d3e1bed3b4$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$fafba8d3e1bed3b4$export$48d7c418edadb60c() && $fafba8d3e1bed3b4$var$cssVariableRegex.test(value) || value in ($fafba8d3e1bed3b4$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $fafba8d3e1bed3b4$var$observer;
var $fafba8d3e1bed3b4$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$handleObservation = (entries)=>entries.forEach(({ target: target , contentRect: contentRect  })=>{
        return $fafba8d3e1bed3b4$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $fafba8d3e1bed3b4$var$resizeElement(handler, target) {
    if (!$fafba8d3e1bed3b4$var$observer) {
        if (typeof ResizeObserver !== "undefined") $fafba8d3e1bed3b4$var$observer = new ResizeObserver($fafba8d3e1bed3b4$var$handleObservation);
    }
    let elementHandlers = $fafba8d3e1bed3b4$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $fafba8d3e1bed3b4$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($fafba8d3e1bed3b4$var$observer) $fafba8d3e1bed3b4$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $fafba8d3e1bed3b4$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $fafba8d3e1bed3b4$var$observer) $fafba8d3e1bed3b4$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $fafba8d3e1bed3b4$var$listeners = /* @__PURE__ */ new Set();
var $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler;
var $fafba8d3e1bed3b4$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $fafba8d3e1bed3b4$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $fafba8d3e1bed3b4$var$resizeWindow = (callback)=>{
    $fafba8d3e1bed3b4$var$listeners.add(callback);
    if (!$fafba8d3e1bed3b4$var$cleanupWindowResizeHandler) $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler = $fafba8d3e1bed3b4$var$createResizeHandler();
    return ()=>{
        $fafba8d3e1bed3b4$var$listeners.delete(callback);
        if (!$fafba8d3e1bed3b4$var$listeners.size && $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler) {
            $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler();
            $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $fafba8d3e1bed3b4$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement  } = {})=>{
    if (container === document.documentElement) return $fafba8d3e1bed3b4$var$resizeWindow(callback);
    else return $fafba8d3e1bed3b4$var$resizeElement(callback, container);
};
// src/progress.ts
var $fafba8d3e1bed3b4$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $fafba8d3e1bed3b4$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $fafba8d3e1bed3b4$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length , position: position  } = $fafba8d3e1bed3b4$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
            axis.progress = $fafba8d3e1bed3b4$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $fafba8d3e1bed3b4$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $fafba8d3e1bed3b4$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement  } = {})=>{
    let containerHandlers = $fafba8d3e1bed3b4$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $fafba8d3e1bed3b4$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $fafba8d3e1bed3b4$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$fafba8d3e1bed3b4$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $fafba8d3e1bed3b4$var$scrollListeners.set(container, listener);
        const target = $fafba8d3e1bed3b4$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $fafba8d3e1bed3b4$var$resizeListeners.set(container, $fafba8d3e1bed3b4$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $fafba8d3e1bed3b4$var$scrollListeners.get(container);
    $fafba8d3e1bed3b4$export$27f233d61a9e2fa4(animateScroll);
    return ()=>{
        $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.cancel(animateScroll);
        const containerHandlers2 = $fafba8d3e1bed3b4$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $fafba8d3e1bed3b4$var$scrollListeners.get(container);
        $fafba8d3e1bed3b4$var$scrollListeners.delete(container);
        if (listener) {
            $fafba8d3e1bed3b4$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $fafba8d3e1bed3b4$var$resizeListeners.get(container)?.();
        }
    };
};
function $fafba8d3e1bed3b4$export$fe4300aa8eebea86(init) {
    const ref = (0, $exYeM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $fafba8d3e1bed3b4$export$700979bc83e7db82 = $fafba8d3e1bed3b4$export$48d7c418edadb60c() ? (0, $exYeM.useEffect) : (0, $exYeM.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $fafba8d3e1bed3b4$var$useIsMounted = ()=>{
    const isMounted = (0, $exYeM.useRef)(false);
    $fafba8d3e1bed3b4$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $fafba8d3e1bed3b4$export$91db9bc4f8ac944a() {
    const update2 = (0, $exYeM.useState)()[1];
    const isMounted = $fafba8d3e1bed3b4$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update2(Math.random());
    };
}
function $fafba8d3e1bed3b4$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $exYeM.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $exYeM.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $fafba8d3e1bed3b4$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $exYeM.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $fafba8d3e1bed3b4$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $fafba8d3e1bed3b4$export$392544347a18b6ea = (effect)=>(0, $exYeM.useEffect)(effect, $fafba8d3e1bed3b4$var$emptyDeps);
var $fafba8d3e1bed3b4$var$emptyDeps = [];
function $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $exYeM.useRef)();
    (0, $exYeM.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $fafba8d3e1bed3b4$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $exYeM.useState)(null);
    $fafba8d3e1bed3b4$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $fafba8d3e1bed3b4$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $exYeM = parcelRequire("exYeM");
// src/Animated.ts


var $exYeM = parcelRequire("exYeM");
var $7bf293f4fe511ca6$var$$node = Symbol.for("Animated:node");
var $7bf293f4fe511ca6$export$3df5e165e801a70f = (value)=>!!value && value[$7bf293f4fe511ca6$var$$node] === value;
var $7bf293f4fe511ca6$export$6b63995194a3a9e4 = (owner)=>owner && owner[$7bf293f4fe511ca6$var$$node];
var $7bf293f4fe511ca6$export$b553cb5b22b81b04 = (owner, node)=>(0, $fafba8d3e1bed3b4$export$5c74248ea0e35446)(owner, $7bf293f4fe511ca6$var$$node, node);
var $7bf293f4fe511ca6$export$ccab2b64c5d440 = (owner)=>owner && owner[$7bf293f4fe511ca6$var$$node] && owner[$7bf293f4fe511ca6$var$$node].getPayload();
var $7bf293f4fe511ca6$export$31627395a3b18e54 = class {
    constructor(){
        $7bf293f4fe511ca6$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5 = class extends $7bf293f4fe511ca6$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done  } = this;
        this.done = false;
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 = class extends $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $fafba8d3e1bed3b4$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $fafba8d3e1bed3b4$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $7bf293f4fe511ca6$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4 = class extends $7bf293f4fe511ca6$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($7bf293f4fe511ca6$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($7bf293f4fe511ca6$var$TreeContext.dependencies && (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(source)) $7bf293f4fe511ca6$var$TreeContext.dependencies.add(source);
        const payload = $7bf293f4fe511ca6$export$ccab2b64c5d440(source);
        if (payload) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $7bf293f4fe511ca6$export$ede394683406942d = class extends $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $7bf293f4fe511ca6$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($7bf293f4fe511ca6$var$makeAnimated));
        return true;
    }
};
function $7bf293f4fe511ca6$var$makeAnimated(value) {
    const nodeType = (0, $fafba8d3e1bed3b4$export$75bed621f62abfa9)(value) ? $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 : $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $7bf293f4fe511ca6$export$e6b77ddbe47b132e(value) {
    const parentNode = $7bf293f4fe511ca6$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(value) ? $7bf293f4fe511ca6$export$ede394683406942d : (0, $fafba8d3e1bed3b4$export$75bed621f62abfa9)(value) ? $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 : $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5;
}
var $7bf293f4fe511ca6$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $exYeM.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $exYeM.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $exYeM.useCallback)((value)=>{
            instanceRef.current = $7bf293f4fe511ca6$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $7bf293f4fe511ca6$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $fafba8d3e1bed3b4$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $7bf293f4fe511ca6$var$PropsObserver(callback, deps);
        const observerRef = (0, $exYeM.useRef)();
        (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(deps, (dep)=>(0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $exYeM.useEffect)(callback, []);
        (0, $fafba8d3e1bed3b4$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $exYeM.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $7bf293f4fe511ca6$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $7bf293f4fe511ca6$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $7bf293f4fe511ca6$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4(props);
    $7bf293f4fe511ca6$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $7bf293f4fe511ca6$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $7bf293f4fe511ca6$var$cacheKey = Symbol.for("AnimatedComponent");
var $7bf293f4fe511ca6$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false , createAnimatedStyle: createAnimatedStyle = (style)=>new $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4(style) , getComponentProps: getComponentProps = (props)=>props  } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $7bf293f4fe511ca6$var$getDisplayName(Component) || "Anonymous";
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $7bf293f4fe511ca6$var$withAnimated(Component, hostConfig));
        else Component = Component[$7bf293f4fe511ca6$var$cacheKey] || (Component[$7bf293f4fe511ca6$var$cacheKey] = $7bf293f4fe511ca6$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(components)) key = $7bf293f4fe511ca6$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $7bf293f4fe511ca6$var$getDisplayName = (arg)=>(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $f1caa117d6d189d7$export$b24b633b1364b94b = class {
};


function $9f726edb03f4840c$var$callProp(value, ...args) {
    return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $9f726edb03f4840c$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(value).includes(key)));
var $9f726edb03f4840c$var$resolveProp = (prop, key)=>(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $9f726edb03f4840c$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $9f726edb03f4840c$var$noopTransform = (value)=>value;
var $9f726edb03f4840c$var$getDefaultProps = (props, transform = $9f726edb03f4840c$var$noopTransform)=>{
    let keys = $9f726edb03f4840c$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $9f726edb03f4840c$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $9f726edb03f4840c$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $9f726edb03f4840c$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$9f726edb03f4840c$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $9f726edb03f4840c$export$b971039a739bf227(props) {
    const to2 = $9f726edb03f4840c$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $9f726edb03f4840c$var$computeGoal(value) {
    value = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(value);
    return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(value) ? value.map($9f726edb03f4840c$var$computeGoal) : (0, $fafba8d3e1bed3b4$export$75bed621f62abfa9)(value) ? (0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $9f726edb03f4840c$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $9f726edb03f4840c$var$isAsyncTo(to2) {
    return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(to2) || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(to2) && (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $9f726edb03f4840c$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $9f726edb03f4840c$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $9f726edb03f4840c$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $9f726edb03f4840c$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $9f726edb03f4840c$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $9f726edb03f4840c$var$defaults = {
    ...$9f726edb03f4840c$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $fafba8d3e1bed3b4$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $9f726edb03f4840c$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $9f726edb03f4840c$var$defaults);
    }
};
function $9f726edb03f4840c$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $9f726edb03f4840c$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $9f726edb03f4840c$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $9f726edb03f4840c$var$defaults)if (config2[key] == null) config2[key] = $9f726edb03f4840c$var$defaults[key];
    let { frequency: frequency , damping: damping  } = config2;
    const { mass: mass  } = config2;
    if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $9f726edb03f4840c$var$sanitizeConfig(config2, props) {
    if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.tension) || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.damping) || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $9f726edb03f4840c$var$emptyArray = [];
var $9f726edb03f4840c$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $9f726edb03f4840c$var$emptyArray;
        this.toValues = null;
        this.fromValues = $9f726edb03f4840c$var$emptyArray;
        this.config = new $9f726edb03f4840c$var$AnimationConfig();
        this.immediate = false;
    }
};
function $9f726edb03f4840c$var$scheduleProps(callId, { key: key , props: props , defaultProps: defaultProps , state: state , actions: actions  }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $9f726edb03f4840c$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $9f726edb03f4840c$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $9f726edb03f4840c$var$matchProp(pause, key);
            delay = $9f726edb03f4840c$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $9f726edb03f4840c$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $9f726edb03f4840c$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $9f726edb03f4840c$var$getNoopResult(target.get()) : $9f726edb03f4840c$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $9f726edb03f4840c$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $9f726edb03f4840c$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $9f726edb03f4840c$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $9f726edb03f4840c$var$runAsync(to2, props, state, target) {
    const { callId: callId , parentId: parentId , onRest: onRest  } = props;
    const { asyncTo: prevTo , promise: prevPromise  } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $9f726edb03f4840c$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $9f726edb03f4840c$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $9f726edb03f4840c$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $9f726edb03f4840c$export$d362d093fa99dc7();
            const skipAnimationSignal = new $9f726edb03f4840c$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) {
                    $9f726edb03f4840c$var$stopAsync(state);
                    skipAnimationSignal.result = $9f726edb03f4840c$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) {
            $9f726edb03f4840c$var$stopAsync(state);
            return $9f726edb03f4840c$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $9f726edb03f4840c$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $9f726edb03f4840c$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $9f726edb03f4840c$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(onRest)) (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $9f726edb03f4840c$var$stopAsync(state, cancelId) {
    (0, $fafba8d3e1bed3b4$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $9f726edb03f4840c$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $9f726edb03f4840c$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $9f726edb03f4840c$var$isFrameValue = (value)=>value instanceof $9f726edb03f4840c$export$8229896f80e2495e;
var $9f726edb03f4840c$var$nextId = 1;
var $9f726edb03f4840c$export$8229896f80e2495e = class extends (0, $fafba8d3e1bed3b4$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $9f726edb03f4840c$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $fafba8d3e1bed3b4$export$2abfcde8ae218ba8)();
        return (0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $fafba8d3e1bed3b4$export$a57f5080a3bcc90a).sort(this);
        (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $9f726edb03f4840c$var$$P = Symbol.for("SpringPhase");
var $9f726edb03f4840c$var$HAS_ANIMATED = 1;
var $9f726edb03f4840c$var$IS_ANIMATING = 2;
var $9f726edb03f4840c$var$IS_PAUSED = 4;
var $9f726edb03f4840c$var$hasAnimated = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$HAS_ANIMATED) > 0;
var $9f726edb03f4840c$var$isAnimating = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$IS_ANIMATING) > 0;
var $9f726edb03f4840c$var$isPaused = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$IS_PAUSED) > 0;
var $9f726edb03f4840c$var$setActiveBit = (target, active)=>active ? target[$9f726edb03f4840c$var$$P] |= $9f726edb03f4840c$var$IS_ANIMATING | $9f726edb03f4840c$var$HAS_ANIMATED : target[$9f726edb03f4840c$var$$P] &= ~$9f726edb03f4840c$var$IS_ANIMATING;
var $9f726edb03f4840c$var$setPausedBit = (target, paused)=>paused ? target[$9f726edb03f4840c$var$$P] |= $9f726edb03f4840c$var$IS_PAUSED : target[$9f726edb03f4840c$var$$P] &= ~$9f726edb03f4840c$var$IS_PAUSED;
// src/SpringValue.ts
var $9f726edb03f4840c$export$5854d13427d5a954 = class extends $9f726edb03f4840c$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $9f726edb03f4840c$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(arg1) || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($9f726edb03f4840c$var$isAnimating(this) || this._state.asyncTo) || $9f726edb03f4840c$var$isPaused(this);
    }
    get goal() {
        return (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $9f726edb03f4840c$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $9f726edb03f4840c$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $9f726edb03f4840c$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues  } = anim;
        const { config: config2  } = anim;
        const payload = (0, $7bf293f4fe511ca6$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $fafba8d3e1bed3b4$export$45b10814cc054894)((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($9f726edb03f4840c$var$isAnimating(this)) {
            const { to: to2 , config: config2  } = this.animation;
            (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$9f726edb03f4840c$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2  } = this.animation;
        this._focus(this.get());
        $9f726edb03f4840c$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2 , from: from  } = props;
        to2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $9f726edb03f4840c$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$9f726edb03f4840c$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(from);
            if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key , defaultProps: defaultProps  } = this;
        if (props.default) Object.assign(defaultProps, $9f726edb03f4840c$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $9f726edb03f4840c$var$resolveProp(value, key) : value));
        $9f726edb03f4840c$var$mergeActiveFn(this, props, "onProps");
        $9f726edb03f4840c$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $9f726edb03f4840c$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$9f726edb03f4840c$var$isPaused(this)) {
                        $9f726edb03f4840c$var$setPausedBit(this, true);
                        (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(state.pauseQueue);
                        $9f726edb03f4840c$var$sendEvent(this, "onPause", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($9f726edb03f4840c$var$isPaused(this)) {
                        $9f726edb03f4840c$var$setPausedBit(this, false);
                        if ($9f726edb03f4840c$var$isAnimating(this)) this._resume();
                        (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(state.resumeQueue);
                        $9f726edb03f4840c$var$sendEvent(this, "onResume", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $9f726edb03f4840c$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($9f726edb03f4840c$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($9f726edb03f4840c$var$getCancelledResult(this));
        }
        const { key: key , defaultProps: defaultProps , animation: anim  } = this;
        const { to: prevTo , from: prevFrom  } = anim;
        let { to: to2 = prevTo , from: from = prevFrom  } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $9f726edb03f4840c$var$isAsyncTo(props.to);
        const { config: config2  } = anim;
        const { decay: decay , velocity: velocity  } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $9f726edb03f4840c$var$mergeConfig(config2, $9f726edb03f4840c$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $9f726edb03f4840c$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
        if (!node || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(to2)) return resolve($9f726edb03f4840c$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(from) && $9f726edb03f4840c$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $9f726edb03f4840c$var$computeGoal(to2);
        const isAnimatable = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(goal) || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(goal) || (0, $fafba8d3e1bed3b4$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $9f726edb03f4840c$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $7bf293f4fe511ca6$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$9f726edb03f4840c$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $fafba8d3e1bed3b4$export$248d38f6296296c5)($9f726edb03f4840c$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(config2.decay, decay) || !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $9f726edb03f4840c$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest  } = anim;
                (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)($9f726edb03f4840c$var$ACTIVE_EVENTS, (type)=>$9f726edb03f4840c$var$mergeActiveFn(this, props, type));
                const result = $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, prevTo));
                (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $9f726edb03f4840c$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($9f726edb03f4840c$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($9f726edb03f4840c$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($9f726edb03f4840c$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $fafba8d3e1bed3b4$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $fafba8d3e1bed3b4$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2  } = this.animation;
        if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(to2)) {
            (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(to2, this);
            if ($9f726edb03f4840c$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2  } = this.animation;
        if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(to2)) (0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(arg);
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $7bf293f4fe511ca6$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $7bf293f4fe511ca6$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $9f726edb03f4840c$var$sendEvent(this, "onStart", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $9f726edb03f4840c$var$callProp(this.animation.onChange, value, this);
        }
        $9f726edb03f4840c$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this).reset((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$9f726edb03f4840c$var$isAnimating(this)) {
            $9f726edb03f4840c$var$setActiveBit(this, true);
            if (!$9f726edb03f4840c$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $fafba8d3e1bed3b4$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($9f726edb03f4840c$var$isAnimating(this)) {
            $9f726edb03f4840c$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $9f726edb03f4840c$var$getCancelledResult(this.get()) : $9f726edb03f4840c$var$getFinishedResult(this.get(), $9f726edb03f4840c$var$checkFinished(this, goal ?? anim.to));
            (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $9f726edb03f4840c$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $9f726edb03f4840c$var$checkFinished(target, to2) {
    const goal = $9f726edb03f4840c$var$computeGoal(to2);
    const value = $9f726edb03f4840c$var$computeGoal(target.get());
    return (0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(value, goal);
}
function $9f726edb03f4840c$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $9f726edb03f4840c$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $9f726edb03f4840c$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $9f726edb03f4840c$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $9f726edb03f4840c$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $9f726edb03f4840c$var$createUpdate(props) {
    const { to: to2 , from: from  } = props = $9f726edb03f4840c$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2)) $9f726edb03f4840c$var$findDefined(to2, keys);
    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(from)) $9f726edb03f4840c$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $9f726edb03f4840c$var$declareUpdate(props) {
    const update2 = $9f726edb03f4840c$var$createUpdate(props);
    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $9f726edb03f4840c$var$getDefaultProps(update2);
    return update2;
}
function $9f726edb03f4840c$var$findDefined(values, keys) {
    (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $9f726edb03f4840c$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $9f726edb03f4840c$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $9f726edb03f4840c$var$getDefaultProp(props, type) ? $9f726edb03f4840c$var$resolveProp(props[type], target.key) : void 0;
}
function $9f726edb03f4840c$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $9f726edb03f4840c$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $9f726edb03f4840c$var$nextId2 = 1;
var $9f726edb03f4840c$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $9f726edb03f4840c$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($9f726edb03f4840c$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue  } = this;
        if (props) queue = (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(props).map($9f726edb03f4840c$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $9f726edb03f4840c$var$prepareKeys(this, queue);
        return $9f726edb03f4840c$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $9f726edb03f4840c$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart , onChange: onChange , onRest: onRest  } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $fafba8d3e1bed3b4$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $fafba8d3e1bed3b4$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $fafba8d3e1bed3b4$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $9f726edb03f4840c$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$9f726edb03f4840c$var$flushUpdate(ctrl, props))).then((results)=>$9f726edb03f4840c$var$getCombinedResult(ctrl, results));
}
async function $9f726edb03f4840c$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys , to: to2 , from: from , loop: loop , onRest: onRest , onResolve: onResolve  } = props;
    const defaults2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(to2) || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)($9f726edb03f4840c$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished , cancelled: cancelled  })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $9f726edb03f4840c$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($9f726edb03f4840c$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $fafba8d3e1bed3b4$export$8793edee2d425525),
            resume: (0, $fafba8d3e1bed3b4$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $9f726edb03f4840c$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($9f726edb03f4840c$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($9f726edb03f4840c$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $9f726edb03f4840c$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $9f726edb03f4840c$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $9f726edb03f4840c$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $9f726edb03f4840c$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $9f726edb03f4840c$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $9f726edb03f4840c$var$createUpdate(props2);
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $9f726edb03f4840c$var$prepareSprings(springs, props2, (key)=>{
            return $9f726edb03f4840c$var$createSpring(key);
        });
    });
    $9f726edb03f4840c$var$setSprings(ctrl, springs);
    return springs;
}
function $9f726edb03f4840c$var$setSprings(ctrl, springs) {
    (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $9f726edb03f4840c$var$createSpring(key, observer) {
    const spring = new $9f726edb03f4840c$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $9f726edb03f4840c$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $9f726edb03f4840c$var$prepareKeys(ctrl, queue) {
    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(queue, (props)=>{
        $9f726edb03f4840c$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $9f726edb03f4840c$var$createSpring(key, ctrl);
        });
    });
}
var $9f726edb03f4840c$export$f12a216ec50d2cf1 = ({ children: children , ...props })=>{
    const inherited = (0, $exYeM.useContext)($9f726edb03f4840c$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $fafba8d3e1bed3b4$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider  } = $9f726edb03f4840c$var$ctx;
    return /* @__PURE__ */ $exYeM.createElement(Provider, {
        value: props
    }, children);
};
var $9f726edb03f4840c$var$ctx = $9f726edb03f4840c$var$makeContext($9f726edb03f4840c$export$f12a216ec50d2cf1, {});
$9f726edb03f4840c$export$f12a216ec50d2cf1.Provider = $9f726edb03f4840c$var$ctx.Provider;
$9f726edb03f4840c$export$f12a216ec50d2cf1.Consumer = $9f726edb03f4840c$var$ctx.Consumer;
function $9f726edb03f4840c$var$makeContext(target, init) {
    Object.assign(target, $exYeM.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $9f726edb03f4840c$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $fafba8d3e1bed3b4$export$d99d974913ad3b12)();
        const results = [];
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $9f726edb03f4840c$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $exYeM.useMemo)(()=>propsFn || arguments.length == 3 ? $9f726edb03f4840c$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $exYeM.useRef)(0);
    const forceUpdate = (0, $fafba8d3e1bed3b4$export$91db9bc4f8ac944a)();
    const state = (0, $exYeM.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $9f726edb03f4840c$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $9f726edb03f4840c$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $9f726edb03f4840c$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($9f726edb03f4840c$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $exYeM.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $exYeM.useMemo)(()=>{
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $9f726edb03f4840c$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $exYeM.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $9f726edb03f4840c$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $9f726edb03f4840c$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$9f726edb03f4840c$var$getSprings(ctrl, updates[i]));
    const context = (0, $exYeM.useContext)($9f726edb03f4840c$export$f12a216ec50d2cf1);
    const prevContext = (0, $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $9f726edb03f4840c$var$hasProps(context);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue  } = state;
        if (queue.length) {
            state.queue = [];
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $9f726edb03f4840c$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $fafba8d3e1bed3b4$export$392544347a18b6ea)(()=>()=>{
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $9f726edb03f4840c$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $9f726edb03f4840c$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $9f726edb03f4840c$var$initSpringRef = ()=>$9f726edb03f4840c$export$2471ae76e2946684();
var $9f726edb03f4840c$export$564bff9c23cad2ca = ()=>(0, $exYeM.useState)($9f726edb03f4840c$var$initSpringRef)[0];
var $9f726edb03f4840c$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $fafba8d3e1bed3b4$export$fe4300aa8eebea86)(()=>new $9f726edb03f4840c$export$5854d13427d5a954(initial, props));
    (0, $fafba8d3e1bed3b4$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $9f726edb03f4840c$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $9f726edb03f4840c$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $9f726edb03f4840c$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $9f726edb03f4840c$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset , sort: sort , trail: trail = 0 , expires: expires = true , exitBeforeEnter: exitBeforeEnter = false , onDestroyed: onDestroyed , ref: propsRef , config: propsConfig  } = propsFn ? propsFn() : props;
    const ref = (0, $exYeM.useMemo)(()=>propsFn || arguments.length == 3 ? $9f726edb03f4840c$export$2471ae76e2946684() : void 0, []);
    const items = (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $exYeM.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $fafba8d3e1bed3b4$export$392544347a18b6ea)(()=>{
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $9f726edb03f4840c$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $9f726edb03f4840c$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>(0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl , item: item , key: key  })=>{
            $9f726edb03f4840c$var$detachRefs(ctrl, ref);
            $9f726edb03f4840c$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $9f726edb03f4840c$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave  } = propsFn ? propsFn() : props;
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $fafba8d3e1bed3b4$export$91db9bc4f8ac944a)();
    const defaultProps = $9f726edb03f4840c$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $exYeM.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $exYeM.useRef)(false);
    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $9f726edb03f4840c$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $9f726edb03f4840c$var$callProp(to2, t.item, i);
        to2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2) ? $9f726edb03f4840c$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $9f726edb03f4840c$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $9f726edb03f4840c$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve  } = payload;
        payload.onResolve = (result)=>{
            $9f726edb03f4840c$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $9f726edb03f4840c$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $9f726edb03f4840c$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $exYeM.useContext)($9f726edb03f4840c$export$f12a216ec50d2cf1);
    const prevContext = (0, $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $9f726edb03f4840c$var$hasProps(context);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase , payload: payload  }, t)=>{
            const { ctrl: ctrl  } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $9f726edb03f4840c$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs  } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $exYeM.createElement(elem.type, {
                ...elem.props,
                key: (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(t.key) || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $9f726edb03f4840c$var$nextKey = 1;
function $9f726edb03f4840c$var$getKeys(items, { key: key , keys: keys = key  }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $9f726edb03f4840c$var$nextKey++;
        });
    }
    return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(keys) ? items : (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(keys);
}
var $9f726edb03f4840c$export$d928051c8cd740b = ({ container: container , ...springOptions } = {})=>{
    const [scrollValues, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $fafba8d3e1bed3b4$export$d4d89fd61e5416ee)(({ x: x , y: y  })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $9f726edb03f4840c$export$e8b771555dc4a003 = ({ container: container , ...springOptions })=>{
    const [sizeValues, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $fafba8d3e1bed3b4$export$45b39e67d4ce4921)(({ width: width , height: height  })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $9f726edb03f4840c$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $9f726edb03f4840c$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $exYeM.useState)(false);
    const ref = (0, $exYeM.useRef)();
    const propsFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {} , from: from = {} , ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root , once: once , amount: amount = "any" , ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $9f726edb03f4840c$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $9f726edb03f4840c$export$a500e5b516cedfc({ children: children , ...props }) {
    return children($9f726edb03f4840c$export$c4af9125706c4d30(props));
}
function $9f726edb03f4840c$export$3b8b9d47fbf8fd2b({ items: items , children: children , ...props }) {
    const trails = $9f726edb03f4840c$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $9f726edb03f4840c$export$be58926105124dd4({ items: items , children: children , ...props }) {
    return $9f726edb03f4840c$export$7b286972b8d8ccbf(items, props)(children);
}
var $9f726edb03f4840c$export$b0cc4f9860136880 = class extends $9f726edb03f4840c$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $fafba8d3e1bed3b4$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $7bf293f4fe511ca6$export$e6b77ddbe47b132e)(value);
        (0, $7bf293f4fe511ca6$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(value, oldValue)) {
            (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $9f726edb03f4840c$var$checkIdle(this._active)) $9f726edb03f4840c$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)) : (0, $fafba8d3e1bed3b4$export$45b10814cc054894)((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$9f726edb03f4840c$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $7bf293f4fe511ca6$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) {
                (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $9f726edb03f4840c$var$becomeIdle(this);
            } else (0, $fafba8d3e1bed3b4$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(source)) (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(source, this);
            if ($9f726edb03f4840c$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(source)) (0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $9f726edb03f4840c$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($9f726edb03f4840c$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $9f726edb03f4840c$var$isIdle(source) {
    return source.idle !== false;
}
function $9f726edb03f4840c$var$checkIdle(active) {
    return !active.size || Array.from(active).every($9f726edb03f4840c$var$isIdle);
}
function $9f726edb03f4840c$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $7bf293f4fe511ca6$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $9f726edb03f4840c$export$2c618a4308a30424 = (source, ...args)=>new $9f726edb03f4840c$export$b0cc4f9860136880(source, args);
var $9f726edb03f4840c$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $fafba8d3e1bed3b4$export$2abfcde8ae218ba8)(), new $9f726edb03f4840c$export$b0cc4f9860136880(source, args));
(0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $fafba8d3e1bed3b4$export$4759a013d387347a,
    to: (source, args)=>new $9f726edb03f4840c$export$b0cc4f9860136880(source, args)
});
var $9f726edb03f4840c$export$722fbec263ad908a = (0, $fafba8d3e1bed3b4$export$a57f5080a3bcc90a).advance;





// src/applyAnimatedValues.ts
var $f9aea5876333360d$var$isCustomPropRE = /^--/;
function $f9aea5876333360d$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$f9aea5876333360d$var$isCustomPropRE.test(name) && !($f9aea5876333360d$var$isUnitlessNumber.hasOwnProperty(name) && $f9aea5876333360d$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $f9aea5876333360d$var$attributeCache = {};
function $f9aea5876333360d$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style: style , children: children , scrollTop: scrollTop , scrollLeft: scrollLeft , viewBox: viewBox , ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $f9aea5876333360d$var$attributeCache[name] || ($f9aea5876333360d$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $f9aea5876333360d$var$dangerousStyleValue(name, style[name]);
        if ($f9aea5876333360d$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $f9aea5876333360d$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $f9aea5876333360d$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $f9aea5876333360d$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$f9aea5876333360d$var$isUnitlessNumber = Object.keys($f9aea5876333360d$var$isUnitlessNumber).reduce((acc, prop)=>{
    $f9aea5876333360d$var$prefixes.forEach((prefix)=>acc[$f9aea5876333360d$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $f9aea5876333360d$var$isUnitlessNumber);
var $f9aea5876333360d$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $f9aea5876333360d$var$pxTransforms = /^(translate)/;
var $f9aea5876333360d$var$degTransforms = /^(rotate|skew)/;
var $f9aea5876333360d$var$addUnit = (value, unit)=>(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $f9aea5876333360d$var$isValueIdentity = (value, id)=>(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$f9aea5876333360d$var$isValueIdentity(v, id)) : (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $f9aea5876333360d$var$AnimatedStyle = class extends (0, $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4) {
    constructor({ x: x , y: y , z: z , ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$f9aea5876333360d$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $f9aea5876333360d$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($f9aea5876333360d$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $f9aea5876333360d$var$pxTransforms.test(key) ? "px" : $f9aea5876333360d$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$f9aea5876333360d$var$addUnit(deg, unit)})`,
                        $f9aea5876333360d$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$f9aea5876333360d$var$addUnit(v, unit)).join(",")})`,
                        $f9aea5876333360d$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $f9aea5876333360d$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $f9aea5876333360d$var$FluidTransform = class extends (0, $fafba8d3e1bed3b4$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(input, (value)=>(0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(value) && (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(input, (value)=>(0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(value) && (0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $f9aea5876333360d$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $97dc602bd7e23afa$exports.unstable_batchedUpdates),
    createStringInterpolator: $fafba8d3e1bed3b4$export$4759a013d387347a,
    colors: $fafba8d3e1bed3b4$export$8f45430ccf837300
});
var $f9aea5876333360d$var$host = (0, $7bf293f4fe511ca6$export$4ee5c78f6dcbcef)($f9aea5876333360d$var$primitives, {
    applyAnimatedValues: $f9aea5876333360d$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $f9aea5876333360d$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop , scrollLeft: scrollLeft , ...props })=>props
});
var $f9aea5876333360d$export$407448d2b89b1813 = $f9aea5876333360d$var$host.animated;








var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");









var $exYeM = parcelRequire("exYeM");
const $93031e4206e8e991$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $93031e4206e8e991$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $93031e4206e8e991$export$803cd8101b6c182b = /*#__PURE__*/ $93031e4206e8e991$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[0], side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[1]), []);
const $93031e4206e8e991$export$96ec731ed4dcb222 = Math.min;
const $93031e4206e8e991$export$8960430cfd85939f = Math.max;
const $93031e4206e8e991$export$2077e0241d6afd3c = Math.round;
const $93031e4206e8e991$export$a3fe094919f356fd = Math.floor;
const $93031e4206e8e991$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $93031e4206e8e991$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $93031e4206e8e991$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $93031e4206e8e991$export$7d15b64cf5a3a4c4(start, value, end) {
    return $93031e4206e8e991$export$8960430cfd85939f(start, $93031e4206e8e991$export$96ec731ed4dcb222(value, end));
}
function $93031e4206e8e991$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $93031e4206e8e991$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $93031e4206e8e991$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $93031e4206e8e991$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $93031e4206e8e991$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $93031e4206e8e991$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($93031e4206e8e991$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $93031e4206e8e991$export$2b57e0052a6d6d4c(placement) {
    return $93031e4206e8e991$export$8a000a963141ac32($93031e4206e8e991$export$f28e8f882010718a(placement));
}
function $93031e4206e8e991$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    const alignmentAxis = $93031e4206e8e991$export$2b57e0052a6d6d4c(placement);
    const length = $93031e4206e8e991$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $93031e4206e8e991$export$496432a3699e50b1(placement) {
    const oppositePlacement = $93031e4206e8e991$export$9c5e28bad23365fa(placement);
    return [
        $93031e4206e8e991$export$2b182c584985588b(placement),
        oppositePlacement,
        $93031e4206e8e991$export$2b182c584985588b(oppositePlacement)
    ];
}
function $93031e4206e8e991$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$93031e4206e8e991$var$oppositeAlignmentMap[alignment]);
}
function $93031e4206e8e991$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $93031e4206e8e991$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    let list = $93031e4206e8e991$var$getSideList($93031e4206e8e991$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($93031e4206e8e991$export$2b182c584985588b));
    }
    return list;
}
function $93031e4206e8e991$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$93031e4206e8e991$var$oppositeSideMap[side]);
}
function $93031e4206e8e991$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $93031e4206e8e991$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $93031e4206e8e991$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $93031e4206e8e991$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $28f1bf2594995773$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference , floating: floating  } = _ref;
    const sideAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $93031e4206e8e991$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $93031e4206e8e991$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $93031e4206e8e991$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $28f1bf2594995773$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform  } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x , y: y  } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name , fn: fn  } = validMiddleware[i];
        const { x: nextX , y: nextY , data: data , reset: reset  } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x , y: y  } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $28f1bf2594995773$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x , y: y , platform: platform , rects: rects , elements: elements , strategy: strategy  } = state;
    const { boundary: boundary = "clippingAncestors" , rootBoundary: rootBoundary = "viewport" , elementContext: elementContext = "floating" , altBoundary: altBoundary = false , padding: padding = 0  } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28f1bf2594995773$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , platform: platform , elements: elements , middlewareData: middlewareData  } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element , padding: padding = 0  } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $93031e4206e8e991$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $93031e4206e8e991$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $28f1bf2594995773$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $93031e4206e8e991$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28f1bf2594995773$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects , middlewareData: middlewareData , placement: placement , platform: platform , elements: elements  } = state;
            const { crossAxis: crossAxis = false , alignment: alignment , allowedPlacements: allowedPlacements = (0, $93031e4206e8e991$export$803cd8101b6c182b) , autoAlignment: autoAlignment = true , ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $93031e4206e8e991$export$803cd8101b6c182b) ? $28f1bf2594995773$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $93031e4206e8e991$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $93031e4206e8e991$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $93031e4206e8e991$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28f1bf2594995773$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement , middlewareData: middlewareData , rects: rects , initialPlacement: initialPlacement , platform: platform , elements: elements  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true , fallbackPlacements: specifiedFallbackPlacements , fallbackStrategy: fallbackStrategy = "bestFit" , fallbackAxisSideDirection: fallbackAxisSideDirection = "none" , flipAlignment: flipAlignment = true , ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $93031e4206e8e991$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $93031e4206e8e991$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $93031e4206e8e991$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $93031e4206e8e991$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $28f1bf2594995773$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $28f1bf2594995773$var$isAnySideFullyClipped(overflow) {
    return (0, $93031e4206e8e991$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28f1bf2594995773$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects  } = state;
            const { strategy: strategy = "referenceHidden" , ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $28f1bf2594995773$var$getBoundingRect(rects) {
    const minX = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $93031e4206e8e991$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $93031e4206e8e991$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $28f1bf2594995773$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $93031e4206e8e991$export$ee05aea0aeecbad4)($28f1bf2594995773$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28f1bf2594995773$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement , elements: elements , rects: rects , platform: platform , strategy: strategy  } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2 , x: x , y: y  } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $28f1bf2594995773$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)($28f1bf2594995773$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $93031e4206e8e991$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $28f1bf2594995773$var$convertValueToCoords(state, options) {
    const { placement: placement , platform: platform , elements: elements  } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis , crossAxis: crossAxis , alignmentAxis: alignmentAxis  } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28f1bf2594995773$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x , y: y  } = state;
            const diffCoords = await $28f1bf2594995773$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28f1bf2594995773$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = false , limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x , y: y  } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } , ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)((0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $93031e4206e8e991$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28f1bf2594995773$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , middlewareData: middlewareData  } = state;
            const { offset: offset = 0 , mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true  } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $93031e4206e8e991$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28f1bf2594995773$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            const { apply: apply = ()=>{} , ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y";
            const { width: width , height: height  } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $93031e4206e8e991$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $93031e4206e8e991$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $e07e1602e4c4ff5c$export$651544f548703224(node) {
    if ($e07e1602e4c4ff5c$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $e07e1602e4c4ff5c$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $e07e1602e4c4ff5c$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($e07e1602e4c4ff5c$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $e07e1602e4c4ff5c$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $e07e1602e4c4ff5c$export$38b2d434cce3ea22(value).Node;
}
function $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $e07e1602e4c4ff5c$export$38b2d434cce3ea22(value).Element;
}
function $e07e1602e4c4ff5c$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $e07e1602e4c4ff5c$export$38b2d434cce3ea22(value).HTMLElement;
}
function $e07e1602e4c4ff5c$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $e07e1602e4c4ff5c$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $e07e1602e4c4ff5c$export$989e911fa9af580a(element) {
    const { overflow: overflow , overflowX: overflowX , overflowY: overflowY , display: display  } = $e07e1602e4c4ff5c$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $e07e1602e4c4ff5c$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($e07e1602e4c4ff5c$export$651544f548703224(element));
}
function $e07e1602e4c4ff5c$export$d6c4e8150c35fed1(element) {
    const webkit = $e07e1602e4c4ff5c$export$78551043582a6a98();
    const css = $e07e1602e4c4ff5c$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $e07e1602e4c4ff5c$export$940d8225183e1404(element) {
    let currentNode = $e07e1602e4c4ff5c$export$4e12058fc4d51d56(element);
    while($e07e1602e4c4ff5c$export$1b3bfaa9684536aa(currentNode) && !$e07e1602e4c4ff5c$export$d1162fb0b6d4cd51(currentNode)){
        if ($e07e1602e4c4ff5c$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $e07e1602e4c4ff5c$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $e07e1602e4c4ff5c$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $e07e1602e4c4ff5c$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($e07e1602e4c4ff5c$export$651544f548703224(node));
}
function $e07e1602e4c4ff5c$export$3735103072e4a80(element) {
    return $e07e1602e4c4ff5c$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $e07e1602e4c4ff5c$export$dc8fc79fa2800137(element) {
    if ($e07e1602e4c4ff5c$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $e07e1602e4c4ff5c$export$4e12058fc4d51d56(node) {
    if ($e07e1602e4c4ff5c$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $e07e1602e4c4ff5c$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $e07e1602e4c4ff5c$export$e495491855dc5418(node);
    return $e07e1602e4c4ff5c$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $e07e1602e4c4ff5c$export$7cd01a57c8ca906c(node) {
    const parentNode = $e07e1602e4c4ff5c$export$4e12058fc4d51d56(node);
    if ($e07e1602e4c4ff5c$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($e07e1602e4c4ff5c$export$1b3bfaa9684536aa(parentNode) && $e07e1602e4c4ff5c$export$989e911fa9af580a(parentNode)) return parentNode;
    return $e07e1602e4c4ff5c$export$7cd01a57c8ca906c(parentNode);
}
function $e07e1602e4c4ff5c$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $e07e1602e4c4ff5c$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $e07e1602e4c4ff5c$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $e07e1602e4c4ff5c$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $e07e1602e4c4ff5c$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $e07e1602e4c4ff5c$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $729e420fd9c85e8f$var$getCssDimensions(element) {
    const css = (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $93031e4206e8e991$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $93031e4206e8e991$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $729e420fd9c85e8f$var$unwrapElement(element) {
    return !(0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $729e420fd9c85e8f$var$getScale(element) {
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    if (!(0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(domElement)) return (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width , height: height , $: $  } = $729e420fd9c85e8f$var$getCssDimensions(domElement);
    let x = ($ ? (0, $93031e4206e8e991$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $93031e4206e8e991$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $729e420fd9c85e8f$var$noOffsets = /*#__PURE__*/ (0, $93031e4206e8e991$export$a397704b5e280835)(0);
function $729e420fd9c85e8f$var$getVisualOffsets(element) {
    const win = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(element);
    if (!(0, $e07e1602e4c4ff5c$export$78551043582a6a98)() || !win.visualViewport) return $729e420fd9c85e8f$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $729e420fd9c85e8f$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $729e420fd9c85e8f$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    let scale = (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(offsetParent)) scale = $729e420fd9c85e8f$var$getScale(offsetParent);
        } else scale = $729e420fd9c85e8f$var$getScale(element);
    }
    const visualOffsets = $729e420fd9c85e8f$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $729e420fd9c85e8f$var$getVisualOffsets(domElement) : (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $729e420fd9c85e8f$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $93031e4206e8e991$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect , offsetParent: offsetParent , strategy: strategy  } = _ref;
    const isOffsetParentAnElement = (0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const offsets = (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $e07e1602e4c4ff5c$export$651544f548703224)(offsetParent) !== "body" || (0, $e07e1602e4c4ff5c$export$989e911fa9af580a)(documentElement)) scroll = (0, $e07e1602e4c4ff5c$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent);
            scale = $729e420fd9c85e8f$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $729e420fd9c85e8f$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $729e420fd9c85e8f$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $729e420fd9c85e8f$var$getBoundingClientRect((0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element)).left + (0, $e07e1602e4c4ff5c$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $729e420fd9c85e8f$var$getDocumentRect(element) {
    const html = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element);
    const scroll = (0, $e07e1602e4c4ff5c$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $93031e4206e8e991$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $93031e4206e8e991$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $729e420fd9c85e8f$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $e07e1602e4c4ff5c$export$3735103072e4a80)(body).direction === "rtl") x += (0, $93031e4206e8e991$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getViewportRect(element, strategy) {
    const win = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(element);
    const html = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $e07e1602e4c4ff5c$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $729e420fd9c85e8f$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(element) ? $729e420fd9c85e8f$var$getScale(element) : (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $729e420fd9c85e8f$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $729e420fd9c85e8f$var$getDocumentRect((0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element));
    else if ((0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $729e420fd9c85e8f$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $729e420fd9c85e8f$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(rect);
}
function $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $e07e1602e4c4ff5c$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(parentNode) || (0, $e07e1602e4c4ff5c$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(parentNode).position === "fixed" || $729e420fd9c85e8f$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $729e420fd9c85e8f$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $e07e1602e4c4ff5c$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(el) && (0, $e07e1602e4c4ff5c$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $e07e1602e4c4ff5c$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(currentNode) && !(0, $e07e1602e4c4ff5c$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $e07e1602e4c4ff5c$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $e07e1602e4c4ff5c$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $e07e1602e4c4ff5c$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $729e420fd9c85e8f$var$getClippingRect(_ref) {
    let { element: element , boundary: boundary , rootBoundary: rootBoundary , strategy: strategy  } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $729e420fd9c85e8f$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $93031e4206e8e991$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $93031e4206e8e991$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $729e420fd9c85e8f$var$getDimensions(element) {
    return $729e420fd9c85e8f$var$getCssDimensions(element);
}
function $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e07e1602e4c4ff5c$export$651544f548703224)(offsetParent) !== "body" || (0, $e07e1602e4c4ff5c$export$989e911fa9af580a)(documentElement)) scroll = (0, $e07e1602e4c4ff5c$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $729e420fd9c85e8f$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(element) || (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $729e420fd9c85e8f$var$getOffsetParent(element, polyfill) {
    const window = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(element);
    if (!(0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $e07e1602e4c4ff5c$export$71535ffaa902797f)(offsetParent) && (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $e07e1602e4c4ff5c$export$651544f548703224)(offsetParent) === "html" || (0, $e07e1602e4c4ff5c$export$651544f548703224)(offsetParent) === "body" && (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $e07e1602e4c4ff5c$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $e07e1602e4c4ff5c$export$940d8225183e1404)(element) || window;
}
const $729e420fd9c85e8f$var$getElementRects = async function(_ref) {
    let { reference: reference , floating: floating , strategy: strategy  } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $729e420fd9c85e8f$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $729e420fd9c85e8f$var$isRTL(element) {
    return (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(element).direction === "rtl";
}
const $729e420fd9c85e8f$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $e07e1602e4c4ff5c$export$e495491855dc5418,
    getClippingRect: $729e420fd9c85e8f$var$getClippingRect,
    getOffsetParent: $729e420fd9c85e8f$var$getOffsetParent,
    getElementRects: $729e420fd9c85e8f$var$getElementRects,
    getClientRects: $729e420fd9c85e8f$var$getClientRects,
    getDimensions: $729e420fd9c85e8f$var$getDimensions,
    getScale: $729e420fd9c85e8f$var$getScale,
    isElement: $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d,
    isRTL: $729e420fd9c85e8f$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $729e420fd9c85e8f$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left , top: top , width: width , height: height  } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $93031e4206e8e991$export$a3fe094919f356fd)(top);
        const insetRight = (0, $93031e4206e8e991$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $93031e4206e8e991$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $93031e4206e8e991$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $93031e4206e8e991$export$8960430cfd85939f)(0, (0, $93031e4206e8e991$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $729e420fd9c85e8f$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true , ancestorResize: ancestorResize = true , elementResize: elementResize = typeof ResizeObserver === "function" , layoutShift: layoutShift = typeof IntersectionObserver === "function" , animationFrame: animationFrame = false  } = options;
    const referenceEl = $729e420fd9c85e8f$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $e07e1602e4c4ff5c$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $e07e1602e4c4ff5c$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $729e420fd9c85e8f$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $729e420fd9c85e8f$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $729e420fd9c85e8f$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $729e420fd9c85e8f$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $729e420fd9c85e8f$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $28f1bf2594995773$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $exYeM = parcelRequire("exYeM");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e0dc3054c0a828de$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element , padding: padding  } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $28f1bf2594995773$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            } else if (element) return (0, $28f1bf2594995773$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $e0dc3054c0a828de$var$index = typeof document !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $e0dc3054c0a828de$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$e0dc3054c0a828de$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$e0dc3054c0a828de$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $e0dc3054c0a828de$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $e0dc3054c0a828de$var$roundByDPR(element, value) {
    const dpr = $e0dc3054c0a828de$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $e0dc3054c0a828de$var$useLatestRef(value) {
    const ref = $exYeM.useRef(value);
    $e0dc3054c0a828de$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */ function $e0dc3054c0a828de$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform , elements: { reference: externalReference , floating: externalFloating  } = {} , transform: transform = true , whileElementsMounted: whileElementsMounted , open: open  } = options;
    const [data, setData] = $exYeM.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $exYeM.useState(middleware);
    if (!$e0dc3054c0a828de$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $exYeM.useState(null);
    const [_floating, _setFloating] = $exYeM.useState(null);
    const setReference = $exYeM.useCallback((node)=>{
        if (node != referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [
        _setReference
    ]);
    const setFloating = $exYeM.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, [
        _setFloating
    ]);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $exYeM.useRef(null);
    const floatingRef = $exYeM.useRef(null);
    const dataRef = $exYeM.useRef(data);
    const whileElementsMountedRef = $e0dc3054c0a828de$var$useLatestRef(whileElementsMounted);
    const platformRef = $e0dc3054c0a828de$var$useLatestRef(platform);
    const update = $exYeM.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $729e420fd9c85e8f$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$e0dc3054c0a828de$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $97dc602bd7e23afa$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $e0dc3054c0a828de$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $exYeM.useRef(false);
    $e0dc3054c0a828de$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $e0dc3054c0a828de$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            else update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef
    ]);
    const refs = $exYeM.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $exYeM.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $exYeM.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $e0dc3054c0a828de$var$roundByDPR(elements.floating, data.x);
        const y = $e0dc3054c0a828de$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$e0dc3054c0a828de$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $exYeM.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}




var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $51f35d4f6c07a0fd$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $51f35d4f6c07a0fd$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).svg, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $exYeM.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($51f35d4f6c07a0fd$export$21b07c8f274aebd5, {
    displayName: $51f35d4f6c07a0fd$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $51f35d4f6c07a0fd$export$be92b6f5f03c0fe9 = $51f35d4f6c07a0fd$export$21b07c8f274aebd5;








var $exYeM = parcelRequire("exYeM");

function $e3071ccbaf099f7e$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $exYeM.useState)(undefined);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $7b6292e260c70ed7$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $7b6292e260c70ed7$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext, $7b6292e260c70ed7$export$722aac194ae923] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperProvider, $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $7b6292e260c70ed7$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = (0, $exYeM.useState)(null);
    return /*#__PURE__*/ (0, $exYeM.createElement)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$badac9ada3a0bdf9, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $7b6292e260c70ed7$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $exYeM.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$ecd4e1ccab6ed6d, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$useContentContext] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $7b6292e260c70ed7$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper , side: side = "bottom" , sideOffset: sideOffset = 0 , align: align = "center" , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , avoidCollisions: avoidCollisions = true , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = "partial" , hideWhenDetached: hideWhenDetached = false , updatePositionStrategy: updatePositionStrategy = "optimized" , onPlaced: onPlaced , ...contentProps } = props;
    const context = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $exYeM.useState)(null);
    const arrowSize = (0, $e3071ccbaf099f7e$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs , floatingStyles: floatingStyles , placement: placement , isPositioned: isPositioned , middlewareData: middlewareData  } = (0, $e0dc3054c0a828de$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $729e420fd9c85e8f$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $28f1bf2594995773$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $28f1bf2594995773$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $28f1bf2594995773$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $28f1bf2594995773$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $28f1bf2594995773$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements , rects: rects , availableWidth: availableWidth , availableHeight: availableHeight  })=>{
                    const { width: anchorWidth , height: anchorHeight  } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $e0dc3054c0a828de$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $28f1bf2594995773$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPlaced);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $exYeM.useState)();
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $exYeM.createElement)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$bc4ae5855d3c4fc, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $7b6292e260c70ed7$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$useContentContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $exYeM.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $51f35d4f6c07a0fd$export$be92b6f5f03c0fe9), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$79d62cd4e10a3fd0, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $7b6292e260c70ed7$export$be92b6f5f03c0fe9 = $7b6292e260c70ed7$export$badac9ada3a0bdf9;
const $7b6292e260c70ed7$export$b688253958b8dfe7 = $7b6292e260c70ed7$export$ecd4e1ccab6ed6d;
const $7b6292e260c70ed7$export$7c6e2c02157bb7d2 = $7b6292e260c70ed7$export$bc4ae5855d3c4fc;
const $7b6292e260c70ed7$export$21b07c8f274aebd5 = $7b6292e260c70ed7$export$79d62cd4e10a3fd0;









/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext, $0f2238d5081ee7b6$export$c8393c9e73286932] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $7b6292e260c70ed7$export$722aac194ae923)
]);
const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $7b6292e260c70ed7$export$722aac194ae923)();
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverProvider, $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext] = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME);
const $0f2238d5081ee7b6$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = false  } = props;
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0, $exYeM.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0, $exYeM.useState)(false);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $exYeM.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $exYeM.useCallback)(()=>setHasCustomAnchor(true), []),
        onCustomAnchorRemove: (0, $exYeM.useCallback)(()=>setHasCustomAnchor(false), []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$5b6b19405a83ff9d, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $0f2238d5081ee7b6$export$96e5381f42521a79 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...anchorProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd , onCustomAnchorRemove: onCustomAnchorRemove  } = context;
    (0, $exYeM.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$96e5381f42521a79, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $0f2238d5081ee7b6$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...triggerProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$7dacb05d26466c3, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PortalProvider, $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePortalContext] = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $0f2238d5081ee7b6$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover , forceMount: forceMount , children: children , container: container  } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$dd679ffb4362d2d4, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $0f2238d5081ee7b6$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePortalContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$d7e1f420b25549ff, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0, $exYeM.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $exYeM.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        })
    })));
});
const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0, $exYeM.useRef)(false);
    const hasPointerDownOutsideRef = (0, $exYeM.useRef)(false);
    return /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , disableOutsidePointerEvents: disableOutsidePointerEvents , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , ...contentProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$7c6e2c02157bb7d2), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
            "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
            "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $0f2238d5081ee7b6$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...closeProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$d6ac43ebaa40d53e, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
const $0f2238d5081ee7b6$export$3152841115e061b2 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover , ...arrowProps } = props;
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$21b07c8f274aebd5), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$3152841115e061b2, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
const $0f2238d5081ee7b6$export$be92b6f5f03c0fe9 = $0f2238d5081ee7b6$export$5b6b19405a83ff9d;
const $0f2238d5081ee7b6$export$b688253958b8dfe7 = $0f2238d5081ee7b6$export$96e5381f42521a79;
const $0f2238d5081ee7b6$export$41fb9f06171c75f4 = $0f2238d5081ee7b6$export$7dacb05d26466c3;
const $0f2238d5081ee7b6$export$602eac185826482c = $0f2238d5081ee7b6$export$dd679ffb4362d2d4;
const $0f2238d5081ee7b6$export$7c6e2c02157bb7d2 = $0f2238d5081ee7b6$export$d7e1f420b25549ff;
const $0f2238d5081ee7b6$export$f39c2d165cd861fe = $0f2238d5081ee7b6$export$d6ac43ebaa40d53e;
const $0f2238d5081ee7b6$export$21b07c8f274aebd5 = $0f2238d5081ee7b6$export$3152841115e061b2;



const $129ef57550f39f98$export$5b6b19405a83ff9d = $0f2238d5081ee7b6$export$be92b6f5f03c0fe9;
const $129ef57550f39f98$export$7dacb05d26466c3 = $0f2238d5081ee7b6$export$41fb9f06171c75f4;
const $129ef57550f39f98$export$d7e1f420b25549ff = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , align: align = "center" , sideOffset: sideOffset = 4 , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0f2238d5081ee7b6$export$602eac185826482c, {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0f2238d5081ee7b6$export$7c6e2c02157bb7d2, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className),
            ...props
        })
    }));
$129ef57550f39f98$export$d7e1f420b25549ff.displayName = $0f2238d5081ee7b6$export$7c6e2c02157bb7d2.displayName;



parcelRequire("exYeM");


const $a64ed14668b3eae9$export$48443d129636634d = (0, $f6c488ee7ea67d84$export$87dc52566e90b739)("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
    variants: {
        variant: {
            default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
            secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
            destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
            outline: "text-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function $a64ed14668b3eae9$export$37acb3580601e69a({ className: className , variant: variant , ...props }) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)($a64ed14668b3eae9$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    });
}


function $88d90183f3ddc7ad$var$WordRow({ words: words  }) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: `grid grid-cols-4 gap-4`,
        children: words.map((word)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $36bc3e0e590f859e$export$2e2bcd8739ae039), {
                word: word,
                fullCandidateSize: words.length
            }, word))
    });
}
function $88d90183f3ddc7ad$export$a73a93adb33205b0({ ...props }) {
    const DIFFICULTY_COLOR_MAP = {
        1: "rgb(74 222 128)",
        2: "rgb(251 191 36)",
        3: "rgb(129 140 248)",
        4: "rgb(34 211 238)"
    };
    const color = `${DIFFICULTY_COLOR_MAP[props.difficulty]}`;
    const [hasBeenClicked, setHasBeenClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const springProps = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        from: {
            opacity: 0,
            transform: "translateY(100%)"
        },
        to: {
            opacity: 1,
            transform: "translateY(0%)"
        },
        delay: 250
    });
    // if there is an image available render it as a popover
    const isImageAvailable = props.imageSrc != null;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).div, {
        style: springProps,
        children: !isImageAvailable ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
            style: {
                backgroundColor: color,
                borderRadius: 8
            },
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                    className: "font-bold pt-2 pl-4",
                    children: props.category
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                    className: "font-thin pb-2 pl-4",
                    children: props.words.join(", ")
                })
            ]
        }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $129ef57550f39f98$export$5b6b19405a83ff9d), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $129ef57550f39f98$export$7dacb05d26466c3), {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "cursor-pointer hover:animate-pulse shadow-md",
                        style: {
                            backgroundColor: color,
                            borderRadius: 8
                        },
                        onClick: ()=>setHasBeenClicked(true),
                        children: [
                            !hasBeenClicked && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a64ed14668b3eae9$export$37acb3580601e69a), {
                                className: "animate-pulse absolute top-0 right-0 mr-2 mt-2",
                                children: "View More"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                className: "font-bold pt-2 pl-4",
                                children: props.category
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                className: "font-thin pb-2 pl-4",
                                children: props.words.join(", ")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $129ef57550f39f98$export$d7e1f420b25549ff), {
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                            src: props.imageSrc
                        })
                    })
                })
            ]
        })
    });
}
function $88d90183f3ddc7ad$var$GameGrid({ gameRows: gameRows , shouldGridShake: shouldGridShake , setShouldGridShake: setShouldGridShake  }) {
    const { submittedGuesses: submittedGuesses , isGameOver: isGameOver , isGameWon: isGameWon , solvedGameData: solvedGameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $114a14924666ebd7$export$3f49015a6304186f));
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $4a5925ef595e0ef1$export$e8331451049320c2));
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const shakeEffect = window.setTimeout(()=>{
            setShouldGridShake(false);
        // this timeout should probably be calculated since it depends on animation values for the grid shake
        }, 2000);
        // cleanup timeout
        return ()=>window.clearTimeout(shakeEffect);
    }, [
        submittedGuesses
    ]);
    const isGameOverAndLost = isGameOver && !isGameWon;
    const isGameOverAndWon = isGameOver && isGameWon;
    const isGameActive = !isGameOver;
    const isGameActiveWithAnySolvedRows = isGameActive && solvedGameData.length > 0;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        children: [
            (isGameOverAndWon || isGameActiveWithAnySolvedRows) && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "grid gap-y-2 pb-2",
                children: solvedGameData.map((solvedRowObj)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($88d90183f3ddc7ad$export$a73a93adb33205b0, {
                        ...solvedRowObj
                    }, solvedRowObj.category))
            }),
            isGameActive && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: `grid gap-y-2 ${shouldGridShake ? $30c2b5a596d47c14$export$267b06a7460aa7d3 : ""}`,
                children: gameRows.map((row, idx)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($88d90183f3ddc7ad$var$WordRow, {
                        words: row
                    }, idx))
            }),
            isGameOverAndLost && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "grid gap-y-2 pb-2",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        children: "The answer categories are below."
                    }),
                    gameData.map((obj)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($88d90183f3ddc7ad$export$a73a93adb33205b0, {
                            ...obj
                        }, obj.category))
                ]
            })
        ]
    });
}
var $88d90183f3ddc7ad$export$2e2bcd8739ae039 = $88d90183f3ddc7ad$var$GameGrid;






var $exYeM = parcelRequire("exYeM");

/**
 * lucide-react v0.288.0 - ISC
 */ 
const $148980da6bce8301$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Circle", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
]);

/**
 * lucide-react v0.288.0 - ISC
 */ 
const $077e870026f08aa4$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("CircleSlash", [
    [
        "line",
        {
            x1: "9",
            x2: "15",
            y1: "15",
            y2: "9",
            key: "1dfufj"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
]);




function $beecaaa3d2850506$var$SingleMistakeDisplay({ isUsed: isUsed  }) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        children: isUsed ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $077e870026f08aa4$export$2e2bcd8739ae039), {
            className: "h-4 w-4 mt-1 stroke-neutral-400"
        }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $148980da6bce8301$export$2e2bcd8739ae039), {
            className: "h-4 w-4 mt-1 fill-green-300 stroke-cyan-300"
        })
    });
}
function $beecaaa3d2850506$var$NumberOfMistakesDisplay() {
    const { numMistakesUsed: numMistakesUsed  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $114a14924666ebd7$export$3f49015a6304186f));
    // array size of number of guess. [1, 2, 3, 4]
    const mistakeRange = (0, $56229cc9fc90141d$export$d02631cccf789723)((0, $0560d699d69cf4bb$export$7ea57ed97bda1046));
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "flex flex-row gap-x-4 justify-center",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                className: "text-base",
                children: "Mistakes Remaining: "
            }),
            mistakeRange.map((el)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($beecaaa3d2850506$var$SingleMistakeDisplay, {
                    isUsed: el < numMistakesUsed
                }, el))
        ]
    });
}
var $beecaaa3d2850506$export$2e2bcd8739ae039 = $beecaaa3d2850506$var$NumberOfMistakesDisplay;






var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");

// https://www.joshwcomeau.com/react/animated-sparkles-in-react/


var $exYeM = parcelRequire("exYeM");

function $8982b5e525c908a4$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $3f33e277193105b2$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3f33e277193105b2$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $8982b5e525c908a4$export$2e2bcd8739ae039)(function(prop) {
    return $3f33e277193105b2$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $exYeM = parcelRequire("exYeM");
var $031c5e26b7af07bf$exports = {};
//
$031c5e26b7af07bf$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $98c7a0c432789d27$export$71ad59f2e432cfe8 = "-ms-";
var $98c7a0c432789d27$export$2c0f367103c8d01c = "-moz-";
var $98c7a0c432789d27$export$39dfd62a25e0fe93 = "-webkit-";
var $98c7a0c432789d27$export$a29989082612d0d9 = "comm";
var $98c7a0c432789d27$export$aa3a2e812ca8570d = "rule";
var $98c7a0c432789d27$export$527d108ccf083c2b = "decl";
var $98c7a0c432789d27$export$d3d35020fa5b54f0 = "@page";
var $98c7a0c432789d27$export$500415a86c544f73 = "@media";
var $98c7a0c432789d27$export$a763edbf796b780a = "@import";
var $98c7a0c432789d27$export$2790aeb8b4e5c826 = "@charset";
var $98c7a0c432789d27$export$1cc683e23b84b133 = "@viewport";
var $98c7a0c432789d27$export$9447a5efea57e862 = "@supports";
var $98c7a0c432789d27$export$ef011b4e114b1fba = "@document";
var $98c7a0c432789d27$export$6aad947bda0f3f46 = "@namespace";
var $98c7a0c432789d27$export$b44a8529a35fcb60 = "@keyframes";
var $98c7a0c432789d27$export$2c16de31893252e6 = "@font-face";
var $98c7a0c432789d27$export$3d846dd52e150c6f = "@counter-style";
var $98c7a0c432789d27$export$22314bfbb57653fe = "@font-feature-values";
var $98c7a0c432789d27$export$d773506282b3cfe6 = "@layer";
var $98c7a0c432789d27$export$2335f513bbd82c6d = Math.abs;
var $98c7a0c432789d27$export$6788812c4e6611e6 = String.fromCharCode;
var $98c7a0c432789d27$export$e6e34fd1f2686227 = Object.assign;
function $98c7a0c432789d27$export$d6af199866bfb566(e, r) {
    return $98c7a0c432789d27$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 0)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 1)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 2)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 3) : 0;
}
function $98c7a0c432789d27$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $98c7a0c432789d27$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $98c7a0c432789d27$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $98c7a0c432789d27$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $98c7a0c432789d27$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $98c7a0c432789d27$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $98c7a0c432789d27$export$36776f635604f274(e) {
    return e.length;
}
function $98c7a0c432789d27$export$f9084667e487ed46(e) {
    return e.length;
}
function $98c7a0c432789d27$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $98c7a0c432789d27$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $98c7a0c432789d27$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$98c7a0c432789d27$export$4659b591c19bdf3d(e, r);
    });
}
var $98c7a0c432789d27$export$53f1d5ea8de3d7c = 1;
var $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1;
var $98c7a0c432789d27$export$f24224f1c91d8156 = 0;
var $98c7a0c432789d27$export$5880b8b5730aff45 = 0;
var $98c7a0c432789d27$export$c0306caf338ac095 = 0;
var $98c7a0c432789d27$export$30a86d91af8ff6e6 = "";
function $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $98c7a0c432789d27$export$53f1d5ea8de3d7c,
        column: $98c7a0c432789d27$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $98c7a0c432789d27$export$784d13d8ee351f07(e, r) {
    return $98c7a0c432789d27$export$e6e34fd1f2686227($98c7a0c432789d27$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $98c7a0c432789d27$export$590e8b2c435046d9(e) {
    while(e.root)e = $98c7a0c432789d27$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $98c7a0c432789d27$export$10d8903dec122b9d(e, e.siblings);
}
function $98c7a0c432789d27$export$eba6f6f03b0a92e7() {
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$232faf9add678146() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 > 0 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, --$98c7a0c432789d27$export$5880b8b5730aff45) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3--, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c--;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$48cfd1e771a65c4f() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 < $98c7a0c432789d27$export$f24224f1c91d8156 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45++) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3++, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c++;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$4d3fb11e950abb9e() {
    return $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$e88cb2efb12ae807() {
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$58adb3bec8346d0f(e, r) {
    return $98c7a0c432789d27$export$2f35ab04d2335697($98c7a0c432789d27$export$30a86d91af8ff6e6, e, r);
}
function $98c7a0c432789d27$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $98c7a0c432789d27$export$2de70f21292aac9e(e) {
    return $98c7a0c432789d27$export$53f1d5ea8de3d7c = $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$f24224f1c91d8156 = $98c7a0c432789d27$export$36776f635604f274($98c7a0c432789d27$export$30a86d91af8ff6e6 = e), $98c7a0c432789d27$export$5880b8b5730aff45 = 0, [];
}
function $98c7a0c432789d27$export$45918ac1574455b1(e) {
    return $98c7a0c432789d27$export$30a86d91af8ff6e6 = "", e;
}
function $98c7a0c432789d27$export$410ac95b9ec204b8(e) {
    return $98c7a0c432789d27$export$87c2784dc9fc4ab($98c7a0c432789d27$export$58adb3bec8346d0f($98c7a0c432789d27$export$5880b8b5730aff45 - 1, $98c7a0c432789d27$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $98c7a0c432789d27$export$660b2ee2d4fb4eff(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$5f8c09e3ae6f64e1($98c7a0c432789d27$export$2de70f21292aac9e(e)));
}
function $98c7a0c432789d27$export$7af1228ff777d175(e) {
    while($98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$4d3fb11e950abb9e())if ($98c7a0c432789d27$export$c0306caf338ac095 < 33) $98c7a0c432789d27$export$48cfd1e771a65c4f();
    else break;
    return $98c7a0c432789d27$export$9e1725a4cfeada27(e) > 2 || $98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $98c7a0c432789d27$export$5f8c09e3ae6f64e1(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095)){
        case 0:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$c0306caf338ac095), e);
            break;
        default:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$c0306caf338ac095), e);
    }
    return e;
}
function $98c7a0c432789d27$export$955ba06d119e085e(e, r) {
    while(--r && $98c7a0c432789d27$export$48cfd1e771a65c4f())if ($98c7a0c432789d27$export$c0306caf338ac095 < 48 || $98c7a0c432789d27$export$c0306caf338ac095 > 102 || $98c7a0c432789d27$export$c0306caf338ac095 > 57 && $98c7a0c432789d27$export$c0306caf338ac095 < 65 || $98c7a0c432789d27$export$c0306caf338ac095 > 70 && $98c7a0c432789d27$export$c0306caf338ac095 < 97) break;
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$e88cb2efb12ae807() + (r < 6 && $98c7a0c432789d27$export$4d3fb11e950abb9e() == 32 && $98c7a0c432789d27$export$48cfd1e771a65c4f() == 32));
}
function $98c7a0c432789d27$export$c889f2fcc19dbf12(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$c0306caf338ac095){
        case e:
            return $98c7a0c432789d27$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $98c7a0c432789d27$export$c889f2fcc19dbf12($98c7a0c432789d27$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $98c7a0c432789d27$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $98c7a0c432789d27$export$48cfd1e771a65c4f();
            break;
    }
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$4254d4e2b3745c4c(e, r) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 57) break;
    else if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 84 && $98c7a0c432789d27$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $98c7a0c432789d27$export$58adb3bec8346d0f(r, $98c7a0c432789d27$export$5880b8b5730aff45 - 1) + "*" + $98c7a0c432789d27$export$6788812c4e6611e6(e === 47 ? e : $98c7a0c432789d27$export$48cfd1e771a65c4f());
}
function $98c7a0c432789d27$export$c2ab62c7bf24634(e) {
    while(!$98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$4d3fb11e950abb9e()))$98c7a0c432789d27$export$48cfd1e771a65c4f();
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$ef7acd7185315e22(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $98c7a0c432789d27$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $98c7a0c432789d27$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var m = c;
    var x = s;
    var y = n;
    var j = k;
    while(w)switch(h = g, g = $98c7a0c432789d27$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $98c7a0c432789d27$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($98c7a0c432789d27$export$f8e21b1e77979a08(j += $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $98c7a0c432789d27$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $98c7a0c432789d27$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $98c7a0c432789d27$export$955ba06d119e085e($98c7a0c432789d27$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($98c7a0c432789d27$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$4a34f930e789283c($98c7a0c432789d27$export$4254d4e2b3745c4c($98c7a0c432789d27$export$48cfd1e771a65c4f(), $98c7a0c432789d27$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $98c7a0c432789d27$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $98c7a0c432789d27$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $98c7a0c432789d27$export$36776f635604f274(j) - l) $98c7a0c432789d27$export$10d8903dec122b9d(p > 32 ? $98c7a0c432789d27$export$f8483753829ec8f3(j + ";", n, a, l - 1, i) : $98c7a0c432789d27$export$f8483753829ec8f3($98c7a0c432789d27$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $98c7a0c432789d27$export$10d8903dec122b9d(y = $98c7a0c432789d27$export$3307ffa7023ede1e(j, r, a, f, o, c, u, k, m = [], x = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $98c7a0c432789d27$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $98c7a0c432789d27$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $98c7a0c432789d27$export$98e6a39c04603d36(e, y, y, n && $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, k, c, m = [], l, x), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $98c7a0c432789d27$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = j = "", l = t;
            break;
        case 58:
            l = 1 + $98c7a0c432789d27$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $98c7a0c432789d27$export$232faf9add678146() == 125) continue;
            }
            switch(j += $98c7a0c432789d27$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($98c7a0c432789d27$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($98c7a0c432789d27$export$4d3fb11e950abb9e() === 45) j += $98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$48cfd1e771a65c4f());
                    v = $98c7a0c432789d27$export$4d3fb11e950abb9e(), o = l = $98c7a0c432789d27$export$36776f635604f274(k = j += $98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $98c7a0c432789d27$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $98c7a0c432789d27$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $98c7a0c432789d27$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $98c7a0c432789d27$export$2f35ab04d2335697(e, p + 1, p = $98c7a0c432789d27$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $98c7a0c432789d27$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $98c7a0c432789d27$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, s === 0 ? $98c7a0c432789d27$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $98c7a0c432789d27$export$4a34f930e789283c(e, r, a, c) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$a29989082612d0d9, $98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$eba6f6f03b0a92e7()), $98c7a0c432789d27$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $98c7a0c432789d27$export$f8483753829ec8f3(e, r, a, n, c) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$527d108ccf083c2b, $98c7a0c432789d27$export$2f35ab04d2335697(e, 0, n), $98c7a0c432789d27$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $98c7a0c432789d27$export$82e9f45cca5ba907(n, c, s) {
    switch($98c7a0c432789d27$export$d6af199866bfb566(n, c)){
        case 5103:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $98c7a0c432789d27$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$2c0f367103c8d01c + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-$1$2" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-item-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-line-pack" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-grow", "") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-pack:$3" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-column-align" + $98c7a0c432789d27$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$98c7a0c432789d27$export$f8e21b1e77979a08(s, "span") ? $98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) : +$98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) - +$98c7a0c432789d27$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($98c7a0c432789d27$export$36776f635604f274(n) - 1 - c > 6) switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $98c7a0c432789d27$export$2c0f367103c8d01c + ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n, "stretch") ? $98c7a0c432789d27$export$82e9f45cca5ba907($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 6) === 121) return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, $98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + ($98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $98c7a0c432789d27$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $98c7a0c432789d27$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $98c7a0c432789d27$export$a763edbf796b780a:
        case $98c7a0c432789d27$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $98c7a0c432789d27$export$a29989082612d0d9:
            return "";
        case $98c7a0c432789d27$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            if (!$98c7a0c432789d27$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $98c7a0c432789d27$export$36776f635604f274(a = $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $98c7a0c432789d27$export$5a7767152ae0305f(e) {
    var r = $98c7a0c432789d27$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $98c7a0c432789d27$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $98c7a0c432789d27$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $98c7a0c432789d27$export$527d108ccf083c2b:
                n.return = $98c7a0c432789d27$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $98c7a0c432789d27$export$b44a8529a35fcb60:
                return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                    $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                        value: $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $98c7a0c432789d27$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $98c7a0c432789d27$export$aa3a2e812ca8570d:
                if (n.length) return $98c7a0c432789d27$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($98c7a0c432789d27$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $98c7a0c432789d27$export$e6e34fd1f2686227(n, {
                                props: $98c7a0c432789d27$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $98c7a0c432789d27$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $98c7a0c432789d27$export$e6e34fd1f2686227(n, {
                                props: $98c7a0c432789d27$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $98c7a0c432789d27$export$76a88f7de6507443(e) {
    switch(e.type){
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $98c7a0c432789d27$export$1be1fc439b849fdf($98c7a0c432789d27$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($98c7a0c432789d27$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $98c7a0c432789d27$export$2f35ab04d2335697(r, 1, $98c7a0c432789d27$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $98c7a0c432789d27$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $98c7a0c432789d27$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $98c7a0c432789d27$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d9cd8dcf50c5790f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $4acf49f6c3e67aec$exports = {};
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = $4acf49f6c3e67aec$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};


var $93948c98236af5c1$var$f = ("undefined" != typeof $4acf49f6c3e67aec$exports && void 0 !== $4acf49f6c3e67aec$exports.env && undefined, "data-styled"), $93948c98236af5c1$export$83d89fbfd8236492 = "6.1.0", $93948c98236af5c1$var$y = "undefined" != typeof window && "HTMLElement" in window, $93948c98236af5c1$var$v = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $4acf49f6c3e67aec$exports && $4acf49f6c3e67aec$exports.env, "undefined" != typeof $4acf49f6c3e67aec$exports && $4acf49f6c3e67aec$exports.env, false)), $93948c98236af5c1$var$g = {}, $93948c98236af5c1$var$S = /invalid hook call/i, $93948c98236af5c1$var$w = new Set, $93948c98236af5c1$var$b = function(t, n) {
    var o, s, i, a, e;
}, $93948c98236af5c1$var$E = Object.freeze([]), $93948c98236af5c1$var$N = Object.freeze({});
function $93948c98236af5c1$var$P(e, t, n) {
    return void 0 === n && (n = $93948c98236af5c1$var$N), e.theme !== n.theme && e.theme || t || n.theme;
}
var $93948c98236af5c1$var$_ = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $93948c98236af5c1$var$C = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $93948c98236af5c1$var$I = /(^-|-$)/g;
function $93948c98236af5c1$var$A(e) {
    return e.replace($93948c98236af5c1$var$C, "-").replace($93948c98236af5c1$var$I, "");
}
var $93948c98236af5c1$var$O = /(a)(d)/gi, $93948c98236af5c1$var$D = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $93948c98236af5c1$var$R(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $93948c98236af5c1$var$D(t % 52) + n;
    return ($93948c98236af5c1$var$D(t % 52) + n).replace($93948c98236af5c1$var$O, "$1-$2");
}
var $93948c98236af5c1$var$T, $93948c98236af5c1$var$k = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $93948c98236af5c1$var$j = function(e) {
    return $93948c98236af5c1$var$k(5381, e);
};
function $93948c98236af5c1$var$x(e) {
    return $93948c98236af5c1$var$R($93948c98236af5c1$var$j(e) >>> 0);
}
function $93948c98236af5c1$var$V(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $93948c98236af5c1$var$F(e) {
    return "string" == typeof e && true;
}
var $93948c98236af5c1$var$M = "function" == typeof Symbol && Symbol.for, $93948c98236af5c1$var$$ = $93948c98236af5c1$var$M ? Symbol.for("react.memo") : 60115, $93948c98236af5c1$var$z = $93948c98236af5c1$var$M ? Symbol.for("react.forward_ref") : 60112, $93948c98236af5c1$var$B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $93948c98236af5c1$var$L = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $93948c98236af5c1$var$G = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $93948c98236af5c1$var$Y = (($93948c98236af5c1$var$T = {})[$93948c98236af5c1$var$z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $93948c98236af5c1$var$T[$93948c98236af5c1$var$$] = $93948c98236af5c1$var$G, $93948c98236af5c1$var$T);
function $93948c98236af5c1$var$W(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $93948c98236af5c1$var$$ ? $93948c98236af5c1$var$G : "$$typeof" in e ? $93948c98236af5c1$var$Y[e.$$typeof] : $93948c98236af5c1$var$B;
}
var $93948c98236af5c1$var$q = Object.defineProperty, $93948c98236af5c1$var$H = Object.getOwnPropertyNames, $93948c98236af5c1$var$U = Object.getOwnPropertySymbols, $93948c98236af5c1$var$J = Object.getOwnPropertyDescriptor, $93948c98236af5c1$var$X = Object.getPrototypeOf, $93948c98236af5c1$var$Z = Object.prototype;
function $93948c98236af5c1$var$K(e, t, n) {
    if ("string" != typeof t) {
        if ($93948c98236af5c1$var$Z) {
            var o = $93948c98236af5c1$var$X(t);
            o && o !== $93948c98236af5c1$var$Z && $93948c98236af5c1$var$K(e, o, n);
        }
        var r = $93948c98236af5c1$var$H(t);
        $93948c98236af5c1$var$U && (r = r.concat($93948c98236af5c1$var$U(t)));
        for(var s = $93948c98236af5c1$var$W(e), i = $93948c98236af5c1$var$W(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $93948c98236af5c1$var$L || n && n[c] || i && c in i || s && c in s)) {
                var l = $93948c98236af5c1$var$J(t, c);
                try {
                    $93948c98236af5c1$var$q(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $93948c98236af5c1$var$Q(e) {
    return "function" == typeof e;
}
function $93948c98236af5c1$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $93948c98236af5c1$var$te(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $93948c98236af5c1$var$ne(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $93948c98236af5c1$var$oe(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $93948c98236af5c1$var$re(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$93948c98236af5c1$var$oe(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $93948c98236af5c1$var$re(e[o], t[o]);
    else if ($93948c98236af5c1$var$oe(t)) for(var o in t)e[o] = $93948c98236af5c1$var$re(e[o], t[o]);
    return e;
}
function $93948c98236af5c1$var$se(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $93948c98236af5c1$var$ie = {};
function $93948c98236af5c1$var$ae() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $93948c98236af5c1$var$ce(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $93948c98236af5c1$var$le = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $93948c98236af5c1$var$ce(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
        return t;
    }, e;
}(), $93948c98236af5c1$var$ue = new Map, $93948c98236af5c1$var$pe = new Map, $93948c98236af5c1$var$de = 1, $93948c98236af5c1$var$he = function(e) {
    if ($93948c98236af5c1$var$ue.has(e)) return $93948c98236af5c1$var$ue.get(e);
    for(; $93948c98236af5c1$var$pe.has($93948c98236af5c1$var$de);)$93948c98236af5c1$var$de++;
    var t = $93948c98236af5c1$var$de++;
    return $93948c98236af5c1$var$ue.set(e, t), $93948c98236af5c1$var$pe.set(t, e), t;
}, $93948c98236af5c1$var$fe = function(e, t) {
    $93948c98236af5c1$var$ue.set(e, t), $93948c98236af5c1$var$pe.set(t, e);
}, $93948c98236af5c1$var$me = "style[".concat($93948c98236af5c1$var$f, "][").concat("data-styled-version", '="').concat("6.1.0", '"]'), $93948c98236af5c1$var$ye = new RegExp("^".concat($93948c98236af5c1$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $93948c98236af5c1$var$ve = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $93948c98236af5c1$var$ge = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($93948c98236af5c1$var$ye);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($93948c98236af5c1$var$fe(u, l), $93948c98236af5c1$var$ve(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $93948c98236af5c1$var$Se() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $93948c98236af5c1$var$we = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($93948c98236af5c1$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($93948c98236af5c1$var$f, "active"), o.setAttribute("data-styled-version", "6.1.0");
    var i = $93948c98236af5c1$var$Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $93948c98236af5c1$var$be = function() {
    function e(e) {
        this.element = $93948c98236af5c1$var$we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $93948c98236af5c1$var$ce(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $93948c98236af5c1$var$Ee = function() {
    function e(e) {
        this.element = $93948c98236af5c1$var$we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $93948c98236af5c1$var$Ne = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $93948c98236af5c1$var$Pe = $93948c98236af5c1$var$y, $93948c98236af5c1$var$_e = {
    isServer: !$93948c98236af5c1$var$y,
    useCSSOMInjection: !$93948c98236af5c1$var$v
}, $93948c98236af5c1$var$Ce = function() {
    function e(e, n, o) {
        void 0 === e && (e = $93948c98236af5c1$var$N), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, $93948c98236af5c1$var$_e), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $93948c98236af5c1$var$y && $93948c98236af5c1$var$Pe && ($93948c98236af5c1$var$Pe = !1, function(e) {
            for(var t = document.querySelectorAll($93948c98236af5c1$var$me), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && "active" !== r.getAttribute($93948c98236af5c1$var$f) && ($93948c98236af5c1$var$ge(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $93948c98236af5c1$var$se(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $93948c98236af5c1$var$pe.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($93948c98236af5c1$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $93948c98236af5c1$var$he(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $93948c98236af5c1$var$Ne(n) : t ? new $93948c98236af5c1$var$be(n) : new $93948c98236af5c1$var$Ee(n);
        }(this.options), new $93948c98236af5c1$var$le(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($93948c98236af5c1$var$he(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($93948c98236af5c1$var$he(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($93948c98236af5c1$var$he(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $93948c98236af5c1$var$Ie = /&/g, $93948c98236af5c1$var$Ae = /^\s*\/\/.*$/gm;
function $93948c98236af5c1$var$Oe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $93948c98236af5c1$var$Oe(e.children, t)), e;
    });
}
function $93948c98236af5c1$var$De(e) {
    var t, n, o, r = void 0 === e ? $93948c98236af5c1$var$N : e, s = r.options, i = void 0 === s ? $93948c98236af5c1$var$N : s, a = r.plugins, c = void 0 === a ? $93948c98236af5c1$var$E : a, l = function(e, o, r) {
        return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $98c7a0c432789d27$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($93948c98236af5c1$var$Ie, n).replace(o, l));
    }), i.prefix && u.push($98c7a0c432789d27$export$e08c7d021b829b7a), u.push($98c7a0c432789d27$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($93948c98236af5c1$var$Ae, ""), l = $98c7a0c432789d27$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $93948c98236af5c1$var$Oe(l, i.namespace));
        var p = [];
        return $98c7a0c432789d27$export$dfdc1655ccc5b9cb(l, $98c7a0c432789d27$export$5a7767152ae0305f(u.concat($98c7a0c432789d27$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $93948c98236af5c1$var$ce(15), $93948c98236af5c1$var$k(e, t.name);
    }, 5381).toString() : "", p;
}
var $93948c98236af5c1$var$Re = new $93948c98236af5c1$var$Ce, $93948c98236af5c1$var$Te = $93948c98236af5c1$var$De(), $93948c98236af5c1$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $93948c98236af5c1$var$Re,
    stylis: $93948c98236af5c1$var$Te
}), $93948c98236af5c1$export$91317688fc694efa = $93948c98236af5c1$export$8c190ef828af4c86.Consumer, $93948c98236af5c1$var$xe = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(void 0);
function $93948c98236af5c1$var$Ve() {
    return (0, $exYeM.useContext)($93948c98236af5c1$export$8c190ef828af4c86);
}
function $93948c98236af5c1$export$a473771da2f0ff7c(e) {
    var t = (0, $exYeM.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $93948c98236af5c1$var$Ve().styleSheet, l = (0, $exYeM.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $exYeM.useMemo)(function() {
        return $93948c98236af5c1$var$De({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $exYeM.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($031c5e26b7af07bf$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $exYeM.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$var$xe.Provider, {
        value: u
    }, e.children));
}
var $93948c98236af5c1$var$Me = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $93948c98236af5c1$var$Te);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $93948c98236af5c1$var$se(this, function() {
            throw $93948c98236af5c1$var$ce(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $93948c98236af5c1$var$Te), this.name + e.hash;
    }, e;
}(), $93948c98236af5c1$var$$e = function(e) {
    return e >= "A" && e <= "Z";
};
function $93948c98236af5c1$var$ze(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $93948c98236af5c1$var$$e(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $93948c98236af5c1$var$Be = function(e) {
    return null == e || !1 === e || "" === e;
}, $93948c98236af5c1$var$Le = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$93948c98236af5c1$var$Be(i) && (Array.isArray(i) && i.isCss || $93948c98236af5c1$var$Q(i) ? r.push("".concat($93948c98236af5c1$var$ze(s), ":"), i, ";") : $93948c98236af5c1$var$oe(i) ? r.push.apply(r, (0, $3433e5a3eb89c040$export$1216008129fb82ed)((0, $3433e5a3eb89c040$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $93948c98236af5c1$var$Le(i), !1), [
            "}"
        ], !1)) : r.push("".concat($93948c98236af5c1$var$ze(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $d9cd8dcf50c5790f$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $93948c98236af5c1$var$Ge(e, t, n, o) {
    if ($93948c98236af5c1$var$Be(e)) return [];
    if ($93948c98236af5c1$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($93948c98236af5c1$var$Q(e)) {
        if (!$93948c98236af5c1$var$Q(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $93948c98236af5c1$var$Ge(r, t, n, o);
    }
    var s;
    return e instanceof $93948c98236af5c1$var$Me ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $93948c98236af5c1$var$oe(e) ? $93948c98236af5c1$var$Le(e) : Array.isArray(e) ? Array.prototype.concat.apply($93948c98236af5c1$var$E, e.map(function(e) {
        return $93948c98236af5c1$var$Ge(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $93948c98236af5c1$var$Ye(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($93948c98236af5c1$var$Q(n) && !$93948c98236af5c1$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $93948c98236af5c1$var$We = $93948c98236af5c1$var$j("6.1.0"), $93948c98236af5c1$var$qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $93948c98236af5c1$var$Ye(e), this.componentId = t, this.baseHash = $93948c98236af5c1$var$k($93948c98236af5c1$var$We, t), this.baseStyle = n, $93948c98236af5c1$var$Ce.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $93948c98236af5c1$var$te(o, this.staticRulesId);
            else {
                var r = $93948c98236af5c1$var$ne($93948c98236af5c1$var$Ge(this.rules, e, t, n)), s = $93948c98236af5c1$var$R($93948c98236af5c1$var$k(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $93948c98236af5c1$var$te(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $93948c98236af5c1$var$k(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $93948c98236af5c1$var$ne($93948c98236af5c1$var$Ge(u, e, t, n));
                    a = $93948c98236af5c1$var$k(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $93948c98236af5c1$var$R(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $93948c98236af5c1$var$te(o, d);
            }
        }
        return o;
    }, e;
}(), $93948c98236af5c1$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(void 0), $93948c98236af5c1$export$b631efc24e9d5e2f = $93948c98236af5c1$export$2c657da244d00bd6.Consumer;
function $93948c98236af5c1$export$93d4e7f90805808f() {
    var e = (0, $exYeM.useContext)($93948c98236af5c1$export$2c657da244d00bd6);
    if (!e) throw $93948c98236af5c1$var$ce(18);
    return e;
}
function $93948c98236af5c1$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), r = (0, $exYeM.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $93948c98236af5c1$var$ce(14);
            if ($93948c98236af5c1$var$Q(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $93948c98236af5c1$var$ce(8);
            return n ? (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $93948c98236af5c1$var$Ze = {}, $93948c98236af5c1$var$Ke = new Set;
function $93948c98236af5c1$var$Qe(e, r, s) {
    var i = $93948c98236af5c1$export$7ba318d8d2f06c76(e), a = e, c = !$93948c98236af5c1$var$F(e), p = r.attrs, d = void 0 === p ? $93948c98236af5c1$var$E : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $93948c98236af5c1$var$A(e);
        $93948c98236af5c1$var$Ze[n] = ($93948c98236af5c1$var$Ze[n] || 0) + 1;
        var o = "".concat(n, "-").concat($93948c98236af5c1$var$x("6.1.0" + n + $93948c98236af5c1$var$Ze[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $93948c98236af5c1$var$F(e) ? "styled.".concat(e) : "Styled(".concat($93948c98236af5c1$var$V(e), ")");
    }(e) : m, v = r.displayName && r.componentId ? "".concat($93948c98236af5c1$var$A(r.displayName), "-").concat(r.componentId) : r.componentId || f, g = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, S = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var w = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var C = r.shouldForwardProp;
            S = function(e, t) {
                return w(e, t) && C(e, t);
            };
        } else S = w;
    }
    var I = new $93948c98236af5c1$var$qe(s, v, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), m = $93948c98236af5c1$var$Ve(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = function(e, n, o) {
                for(var r, s = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $93948c98236af5c1$var$Q(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $93948c98236af5c1$var$te(s[c], a[c]) : "style" === c ? (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $93948c98236af5c1$var$te(s.className, n.className)), s;
            }(i, r, $93948c98236af5c1$var$P(r, f, c) || $93948c98236af5c1$var$N), g = v.as || h, S = {};
            for(var w in v)void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w || ("forwardedAs" === w ? S.as = v.forwardedAs : y && !y(w, g) || (S[w] = v[w], y));
            var b = function(e, t) {
                var n = $93948c98236af5c1$var$Ve(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, v);
            var E = $93948c98236af5c1$var$te(p, d);
            return b && (E += " " + b), v.className && (E += " " + v.className), S[$93948c98236af5c1$var$F(g) && !$93948c98236af5c1$var$_.has(g) ? "class" : "className"] = E, S.ref = s, (0, $exYeM.createElement)(g, S);
        }(D, e, r);
    }
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(O);
    return D.attrs = g, D.componentStyle = I, D.shouldForwardProp = S, D.foldedComponentIds = i ? $93948c98236af5c1$var$te(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = v, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$93948c98236af5c1$var$re(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $93948c98236af5c1$var$se(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $93948c98236af5c1$var$K(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $93948c98236af5c1$var$et(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $93948c98236af5c1$var$tt = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $93948c98236af5c1$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($93948c98236af5c1$var$Q(t) || $93948c98236af5c1$var$oe(t)) {
        var r = t;
        return $93948c98236af5c1$var$tt($93948c98236af5c1$var$Ge($93948c98236af5c1$var$et($93948c98236af5c1$var$E, (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
            r
        ], n, !0))));
    }
    var s = t;
    return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? $93948c98236af5c1$var$Ge(s) : $93948c98236af5c1$var$tt($93948c98236af5c1$var$Ge($93948c98236af5c1$var$et(s, n)));
}
function $93948c98236af5c1$var$ot(n, o, r) {
    if (void 0 === r && (r = $93948c98236af5c1$var$N), !o) throw $93948c98236af5c1$var$ce(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $93948c98236af5c1$var$ot(n, o, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $93948c98236af5c1$var$ot(n, o, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $93948c98236af5c1$var$rt = function(e) {
    return $93948c98236af5c1$var$ot($93948c98236af5c1$var$Qe, e);
}, $93948c98236af5c1$export$2e2bcd8739ae039 = $93948c98236af5c1$var$rt;
$93948c98236af5c1$var$_.forEach(function(e) {
    $93948c98236af5c1$export$2e2bcd8739ae039[e] = $93948c98236af5c1$var$rt(e);
});
var $93948c98236af5c1$var$it = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $93948c98236af5c1$var$Ye(e), $93948c98236af5c1$var$Ce.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($93948c98236af5c1$var$ne($93948c98236af5c1$var$Ge(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $93948c98236af5c1$var$Ce.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $93948c98236af5c1$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($93948c98236af5c1$var$x(JSON.stringify(i))), c = new $93948c98236af5c1$var$it(i, a);
    var l = function(e) {
        var t = $93948c98236af5c1$var$Ve(), n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $93948c98236af5c1$var$g, o, s);
        else {
            var i = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, n), {
                theme: $93948c98236af5c1$var$P(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(l);
}
function $93948c98236af5c1$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $93948c98236af5c1$var$ne($93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $93948c98236af5c1$var$x(r);
    return new $93948c98236af5c1$var$Me(s, r);
}
function $93948c98236af5c1$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(function(n, r) {
        var s = $93948c98236af5c1$var$P(n, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(e, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return $93948c98236af5c1$var$K(n, e);
}
var $93948c98236af5c1$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $93948c98236af5c1$var$Se(), o = $93948c98236af5c1$var$ne([
                n && 'nonce="'.concat(n, '"'),
                "".concat($93948c98236af5c1$var$f, '="true"'),
                "".concat("data-styled-version", '="').concat("6.1.0", '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $93948c98236af5c1$var$ce(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $93948c98236af5c1$var$ce(2);
            var r = ((n = {})[$93948c98236af5c1$var$f] = "", n["data-styled-version"] = "6.1.0", n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $93948c98236af5c1$var$Se();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("style", (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $93948c98236af5c1$var$Ce({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $93948c98236af5c1$var$ce(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $93948c98236af5c1$var$ce(3);
    }, e;
}(), $93948c98236af5c1$export$5c87cfe6c475f500 = {
    StyleSheet: $93948c98236af5c1$var$Ce,
    mainSheet: $93948c98236af5c1$var$Re
};
var $93948c98236af5c1$var$dt = "__sc-".concat($93948c98236af5c1$var$f, "__");



// https://www.joshwcomeau.com/snippets/react-hooks/use-prefers-reduced-motion/

var $exYeM = parcelRequire("exYeM");
const $c6ed583881ec8ae3$var$QUERY = "(prefers-reduced-motion: no-preference)";
const $c6ed583881ec8ae3$var$isRenderingOnServer = typeof window === "undefined";
const $c6ed583881ec8ae3$var$getInitialState = ()=>{
    // For our initial server render, we won't know if the user
    // prefers reduced motion, but it doesn't matter. This value
    // will be overwritten on the client, before any animations
    // occur.
    return $c6ed583881ec8ae3$var$isRenderingOnServer ? true : !window.matchMedia($c6ed583881ec8ae3$var$QUERY).matches;
};
function $c6ed583881ec8ae3$var$usePrefersReducedMotion() {
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState($c6ed583881ec8ae3$var$getInitialState);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const mediaQueryList = window.matchMedia($c6ed583881ec8ae3$var$QUERY);
        const listener = (event)=>{
            setPrefersReducedMotion(!event.matches);
        };
        if (mediaQueryList.addEventListener) mediaQueryList.addEventListener("change", listener);
        else mediaQueryList.addListener(listener);
        return ()=>{
            if (mediaQueryList.removeEventListener) mediaQueryList.removeEventListener("change", listener);
            else mediaQueryList.removeListener(listener);
        };
    }, []);
    return prefersReducedMotion;
}
var $c6ed583881ec8ae3$export$2e2bcd8739ae039 = $c6ed583881ec8ae3$var$usePrefersReducedMotion;


// Utility helper for random number generation
// https://www.joshwcomeau.com/snippets/react-hooks/use-random-interval/

var $exYeM = parcelRequire("exYeM");
const $baae4eb6078f682d$var$random = (min, max)=>Math.floor(Math.random() * (max - min)) + min;
const $baae4eb6078f682d$var$useRandomInterval = (callback, minDelay, maxDelay)=>{
    const timeoutId = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    const savedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        let isEnabled = typeof minDelay === "number" && typeof maxDelay === "number";
        if (isEnabled) {
            const handleTick = ()=>{
                const nextTickAt = $baae4eb6078f682d$var$random(minDelay, maxDelay);
                timeoutId.current = window.setTimeout(()=>{
                    savedCallback.current();
                    handleTick();
                }, nextTickAt);
            };
            handleTick();
        }
        return ()=>window.clearTimeout(timeoutId.current);
    }, [
        minDelay,
        maxDelay
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(function() {
        window.clearTimeout(timeoutId.current);
    }, []);
    return cancel;
};
var $baae4eb6078f682d$export$2e2bcd8739ae039 = $baae4eb6078f682d$var$useRandomInterval;


const $0932a81fde21ae00$var$DEFAULT_COLOR = "#FFC700";
const $0932a81fde21ae00$var$generateSparkle = (color)=>{
    const sparkle = {
        id: String((0, $56229cc9fc90141d$export$4385e60b38654f68)(10000, 99999)),
        createdAt: Date.now(),
        color: color,
        size: (0, $56229cc9fc90141d$export$4385e60b38654f68)(10, 20),
        style: {
            top: (0, $56229cc9fc90141d$export$4385e60b38654f68)(0, 100) + "%",
            left: (0, $56229cc9fc90141d$export$4385e60b38654f68)(0, 100) + "%",
            zIndex: 3
        }
    };
    return sparkle;
};
const $0932a81fde21ae00$var$Sparkles = ({ color: color = $0932a81fde21ae00$var$DEFAULT_COLOR , children: children , ...delegated })=>{
    const [sparkles, setSparkles] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(()=>{
        return (0, $56229cc9fc90141d$export$d02631cccf789723)(3).map(()=>$0932a81fde21ae00$var$generateSparkle(color));
    });
    const prefersReducedMotion = (0, $c6ed583881ec8ae3$export$2e2bcd8739ae039)();
    (0, $baae4eb6078f682d$export$2e2bcd8739ae039)(()=>{
        const sparkle = $0932a81fde21ae00$var$generateSparkle(color);
        const now = Date.now();
        const nextSparkles = sparkles.filter((sp)=>{
            const delta = now - sp.createdAt;
            return delta < 750;
        });
        nextSparkles.push(sparkle);
        setSparkles(nextSparkles);
    }, prefersReducedMotion ? null : 50, prefersReducedMotion ? null : 450);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($0932a81fde21ae00$var$Wrapper, {
        ...delegated,
        children: [
            sparkles.map((sparkle)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0932a81fde21ae00$var$Sparkle, {
                    color: sparkle.color,
                    size: sparkle.size,
                    style: sparkle.style
                }, sparkle.id)),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0932a81fde21ae00$var$ChildWrapper, {
                children: children
            })
        ]
    });
};
const $0932a81fde21ae00$var$Sparkle = ({ size: size , color: color , style: style  })=>{
    const path = "M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0932a81fde21ae00$var$SparkleWrapper, {
        style: style,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0932a81fde21ae00$var$SparkleSvg, {
            width: size,
            height: size,
            viewBox: "0 0 68 68",
            fill: "none",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: path,
                fill: color
            })
        })
    });
};
const $0932a81fde21ae00$var$comeInOut = (0, $93948c98236af5c1$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`;
const $0932a81fde21ae00$var$spin = (0, $93948c98236af5c1$export$d25ddfdf17c3ad3e)`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
`;
const $0932a81fde21ae00$var$Wrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039).span`
  display: inline-block;
  position: relative;
`;
const $0932a81fde21ae00$var$SparkleWrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039).span`
  position: absolute;
  display: block;
  pointer-events: none;
  @media (prefers-reduced-motion: no-preference) {
    animation: ${$0932a81fde21ae00$var$comeInOut} 700ms forwards;
  }
`;
const $0932a81fde21ae00$var$SparkleSvg = (0, $93948c98236af5c1$export$2e2bcd8739ae039).svg`
  display: block;
  @media (prefers-reduced-motion: no-preference) {
    animation: ${$0932a81fde21ae00$var$spin} 1000ms linear;
  }
`;
const $0932a81fde21ae00$var$ChildWrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039).strong`
  position: relative;
  z-index: 1;
  font-weight: bold;
`;
var $0932a81fde21ae00$export$2e2bcd8739ae039 = $0932a81fde21ae00$var$Sparkles;





// Inspired by react-hot-toast library

var $exYeM = parcelRequire("exYeM");
const $4577ad0c1cb23611$var$TOAST_LIMIT = 1;
const $4577ad0c1cb23611$var$TOAST_REMOVE_DELAY = 1000000;
const $4577ad0c1cb23611$var$actionTypes = {
    ADD_TOAST: "ADD_TOAST",
    UPDATE_TOAST: "UPDATE_TOAST",
    DISMISS_TOAST: "DISMISS_TOAST",
    REMOVE_TOAST: "REMOVE_TOAST"
};
let $4577ad0c1cb23611$var$count = 0;
function $4577ad0c1cb23611$var$genId() {
    $4577ad0c1cb23611$var$count = ($4577ad0c1cb23611$var$count + 1) % Number.MAX_VALUE;
    return $4577ad0c1cb23611$var$count.toString();
}
const $4577ad0c1cb23611$var$toastTimeouts = new Map();
const $4577ad0c1cb23611$var$addToRemoveQueue = (toastId)=>{
    if ($4577ad0c1cb23611$var$toastTimeouts.has(toastId)) return;
    const timeout = setTimeout(()=>{
        $4577ad0c1cb23611$var$toastTimeouts.delete(toastId);
        $4577ad0c1cb23611$var$dispatch({
            type: "REMOVE_TOAST",
            toastId: toastId
        });
    }, $4577ad0c1cb23611$var$TOAST_REMOVE_DELAY);
    $4577ad0c1cb23611$var$toastTimeouts.set(toastId, timeout);
};
const $4577ad0c1cb23611$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case "ADD_TOAST":
            return {
                ...state,
                toasts: [
                    action.toast,
                    ...state.toasts
                ].slice(0, $4577ad0c1cb23611$var$TOAST_LIMIT)
            };
        case "UPDATE_TOAST":
            return {
                ...state,
                toasts: state.toasts.map((t)=>t.id === action.toast.id ? {
                        ...t,
                        ...action.toast
                    } : t)
            };
        case "DISMISS_TOAST":
            {
                const { toastId: toastId  } = action;
                // ! Side effects ! - This could be extracted into a dismissToast() action,
                // but I'll keep it here for simplicity
                if (toastId) $4577ad0c1cb23611$var$addToRemoveQueue(toastId);
                else state.toasts.forEach((toast)=>{
                    $4577ad0c1cb23611$var$addToRemoveQueue(toast.id);
                });
                return {
                    ...state,
                    toasts: state.toasts.map((t)=>t.id === toastId || toastId === undefined ? {
                            ...t,
                            open: false
                        } : t)
                };
            }
        case "REMOVE_TOAST":
            if (action.toastId === undefined) return {
                ...state,
                toasts: []
            };
            return {
                ...state,
                toasts: state.toasts.filter((t)=>t.id !== action.toastId)
            };
    }
};
const $4577ad0c1cb23611$var$listeners = [];
let $4577ad0c1cb23611$var$memoryState = {
    toasts: []
};
function $4577ad0c1cb23611$var$dispatch(action) {
    $4577ad0c1cb23611$var$memoryState = $4577ad0c1cb23611$export$1650419e431d3ba3($4577ad0c1cb23611$var$memoryState, action);
    $4577ad0c1cb23611$var$listeners.forEach((listener)=>{
        listener($4577ad0c1cb23611$var$memoryState);
    });
}
function $4577ad0c1cb23611$export$b410431fab84fa58({ ...props }) {
    const id = $4577ad0c1cb23611$var$genId();
    const update = (props)=>$4577ad0c1cb23611$var$dispatch({
            type: "UPDATE_TOAST",
            toast: {
                ...props,
                id: id
            }
        });
    const dismiss = ()=>$4577ad0c1cb23611$var$dispatch({
            type: "DISMISS_TOAST",
            toastId: id
        });
    $4577ad0c1cb23611$var$dispatch({
        type: "ADD_TOAST",
        toast: {
            ...props,
            id: id,
            open: true,
            onOpenChange: (open)=>{
                if (!open) dismiss();
            }
        }
    });
    return {
        id: id,
        dismiss: dismiss,
        update: update
    };
}
function $4577ad0c1cb23611$export$a407b657d3044108() {
    const [state, setState] = $exYeM.useState($4577ad0c1cb23611$var$memoryState);
    $exYeM.useEffect(()=>{
        $4577ad0c1cb23611$var$listeners.push(setState);
        return ()=>{
            const index = $4577ad0c1cb23611$var$listeners.indexOf(setState);
            if (index > -1) $4577ad0c1cb23611$var$listeners.splice(index, 1);
        };
    }, [
        state
    ]);
    return {
        ...state,
        toast: $4577ad0c1cb23611$export$b410431fab84fa58,
        dismiss: (toastId)=>$4577ad0c1cb23611$var$dispatch({
                type: "DISMISS_TOAST",
                toastId: toastId
            })
    };
}



var $kSiIs = parcelRequire("kSiIs");



// Share logic from here: https://github.com/cwackerfuss/react-wordle/blob/main/src/lib/share.ts
const $dfc0fc68e087e286$var$webShareApiDeviceTypes = [
    "mobile",
    "smarttv",
    "wearable"
];
const $dfc0fc68e087e286$var$parser = new (0, $kSiIs.UAParser)();
const $dfc0fc68e087e286$var$browser = $dfc0fc68e087e286$var$parser.getBrowser();
const $dfc0fc68e087e286$var$device = $dfc0fc68e087e286$var$parser.getDevice();
const $dfc0fc68e087e286$export$45a7387fb8fe733b = (gameData, submittedGuesses, handleShareToClipboard, handleShareFailure, includeGameLink = true)=>{
    const GAME_URL = window.location.href;
    const textToShare = `${(0, $0560d699d69cf4bb$export$3f68a6c8e931da17)} #${(0, $20e33653a93a2602$export$3014f1d0d6bd394f)}\n\n` + (0, $c10a8025d61652dc$export$a63577e223e2a6c9)(gameData, submittedGuesses, true) + `${includeGameLink ? "\n\n" + GAME_URL : ""}`;
    const shareData = {
        text: textToShare
    };
    let shareSuccess = false;
    try {
        if ($dfc0fc68e087e286$var$attemptShare(shareData)) {
            navigator.share(shareData);
            shareSuccess = true;
        }
    } catch (error) {
        shareSuccess = false;
    }
    try {
        if (!shareSuccess) {
            if (navigator.clipboard) navigator.clipboard.writeText(textToShare).then(handleShareToClipboard).catch(handleShareFailure);
            else handleShareFailure();
        }
    } catch (error) {
        handleShareFailure();
    }
};
const $dfc0fc68e087e286$var$attemptShare = (shareData)=>{
    return(// Deliberately exclude Firefox Mobile, because its Web Share API isn't working correctly
    $dfc0fc68e087e286$var$browser.name?.toUpperCase().indexOf("FIREFOX") === -1 && $dfc0fc68e087e286$var$webShareApiDeviceTypes.indexOf($dfc0fc68e087e286$var$device.type ?? "") !== -1 && navigator.canShare && navigator.canShare(shareData) && navigator.share);
};




function $5785a8a4a36b00ae$var$ShareScoreButton({ buttonText: buttonText = "Share" , className: className = ""  }) {
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $4a5925ef595e0ef1$export$e8331451049320c2));
    const { submittedGuesses: submittedGuesses  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $114a14924666ebd7$export$3f49015a6304186f));
    const { toast: toast  } = (0, $4577ad0c1cb23611$export$a407b657d3044108)();
    function handleShareToClipboard() {
        toast({
            label: "Notification",
            title: "",
            description: "Copied to clipboard!"
        });
    }
    function handleShareFailure() {
        toast({
            label: "Notification",
            title: "",
            description: "Was unable to copy to clipboard / share."
        });
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $0932a81fde21ae00$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9cfb09368e977195$export$353f5b6fc5456de1), {
            className: (0, $56229cc9fc90141d$export$1343a74baacb0543)(className, "w-full"),
            variant: "share",
            onClick: ()=>(0, $dfc0fc68e087e286$export$45a7387fb8fe733b)(gameData, submittedGuesses, handleShareToClipboard, handleShareFailure, true),
            children: buttonText
        })
    });
}
var $5785a8a4a36b00ae$export$2e2bcd8739ae039 = $5785a8a4a36b00ae$var$ShareScoreButton;





parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $839799496b62fb71$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839799496b62fb71$var$ReactIs, $839799496b62fb71$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$839799496b62fb71$exports = (parcelRequire("jpdgm"))();


function $8773dc2386917d2a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8773dc2386917d2a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8773dc2386917d2a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8773dc2386917d2a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8773dc2386917d2a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8773dc2386917d2a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8773dc2386917d2a$var$_setPrototypeOf(subClass, superClass);
}
function $8773dc2386917d2a$var$_getPrototypeOf(o) {
    $8773dc2386917d2a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8773dc2386917d2a$var$_getPrototypeOf(o);
}
function $8773dc2386917d2a$var$_setPrototypeOf(o, p) {
    $8773dc2386917d2a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8773dc2386917d2a$var$_setPrototypeOf(o, p);
}
function $8773dc2386917d2a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8773dc2386917d2a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8773dc2386917d2a$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $8773dc2386917d2a$var$_assertThisInitialized(self);
}
function $8773dc2386917d2a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8773dc2386917d2a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8773dc2386917d2a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8773dc2386917d2a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8773dc2386917d2a$var$_possibleConstructorReturn(this, result);
    };
}
function $8773dc2386917d2a$var$_toConsumableArray(arr) {
    return $8773dc2386917d2a$var$_arrayWithoutHoles(arr) || $8773dc2386917d2a$var$_iterableToArray(arr) || $8773dc2386917d2a$var$_unsupportedIterableToArray(arr) || $8773dc2386917d2a$var$_nonIterableSpread();
}
function $8773dc2386917d2a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8773dc2386917d2a$var$_arrayLikeToArray(arr);
}
function $8773dc2386917d2a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $8773dc2386917d2a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8773dc2386917d2a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8773dc2386917d2a$var$_arrayLikeToArray(o, minLen);
}
function $8773dc2386917d2a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8773dc2386917d2a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8773dc2386917d2a$export$3cdc770bf8b2ed3d(value) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var strValue = String(value);
    if (length === 0) return strValue;
    var match = strValue.match(/(.*?)([0-9]+)(.*)/);
    var prefix = match ? match[1] : "";
    var suffix = match ? match[3] : "";
    var strNo = match ? match[2] : strValue;
    var paddedNo = strNo.length >= length ? strNo : ($8773dc2386917d2a$var$_toConsumableArray(Array(length)).map(function() {
        return "0";
    }).join("") + strNo).slice(length * -1);
    return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var $8773dc2386917d2a$var$timeDeltaFormatOptionsDefaults = {
    daysInHours: false,
    zeroPadTime: 2
};
function $8773dc2386917d2a$export$46f653e95d33dab0(date) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$now = options.now, now = _options$now === void 0 ? Date.now : _options$now, _options$precision = options.precision, precision = _options$precision === void 0 ? 0 : _options$precision, controlled = options.controlled, _options$offsetTime = options.offsetTime, offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime, overtime = options.overtime;
    var startTimestamp;
    if (typeof date === "string") startTimestamp = new Date(date).getTime();
    else if (date instanceof Date) startTimestamp = date.getTime();
    else startTimestamp = date;
    if (!controlled) startTimestamp += offsetTime;
    var timeLeft = controlled ? startTimestamp : startTimestamp - now();
    var clampedPrecision = Math.min(20, Math.max(0, precision));
    var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1000).toFixed(clampedPrecision)) * 1000);
    var seconds = Math.abs(total) / 1000;
    return {
        total: total,
        days: Math.floor(seconds / 86400),
        hours: Math.floor(seconds / 3600 % 24),
        minutes: Math.floor(seconds / 60 % 60),
        seconds: Math.floor(seconds % 60),
        milliseconds: Number((seconds % 1 * 1000).toFixed()),
        completed: total <= 0
    };
}
function $8773dc2386917d2a$export$ef2fb803ce7a43db(timeDelta, options) {
    var days = timeDelta.days, hours = timeDelta.hours, minutes = timeDelta.minutes, seconds = timeDelta.seconds;
    var _Object$assign = Object.assign(Object.assign({}, $8773dc2386917d2a$var$timeDeltaFormatOptionsDefaults), options), daysInHours = _Object$assign.daysInHours, zeroPadTime = _Object$assign.zeroPadTime, _Object$assign$zeroPa = _Object$assign.zeroPadDays, zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;
    var zeroPadTimeLength = Math.min(2, zeroPadTime);
    var formattedHours = daysInHours ? $8773dc2386917d2a$export$3cdc770bf8b2ed3d(hours + days * 24, zeroPadTime) : $8773dc2386917d2a$export$3cdc770bf8b2ed3d(hours, zeroPadTimeLength);
    return {
        days: daysInHours ? "" : $8773dc2386917d2a$export$3cdc770bf8b2ed3d(days, zeroPadDays),
        hours: formattedHours,
        minutes: $8773dc2386917d2a$export$3cdc770bf8b2ed3d(minutes, zeroPadTimeLength),
        seconds: $8773dc2386917d2a$export$3cdc770bf8b2ed3d(seconds, zeroPadTimeLength)
    };
}
var $8773dc2386917d2a$var$Countdown = function(_React$Component) {
    $8773dc2386917d2a$var$_inherits(Countdown, _React$Component);
    var _super = $8773dc2386917d2a$var$_createSuper(Countdown);
    function Countdown() {
        var _this;
        $8773dc2386917d2a$var$_classCallCheck(this, Countdown);
        _this = _super.apply(this, arguments);
        _this.state = {
            count: _this.props.count || 3
        };
        _this.startCountdown = function() {
            _this.interval = window.setInterval(function() {
                var count = _this.state.count - 1;
                if (count === 0) {
                    _this.stopCountdown();
                    _this.props.onComplete && _this.props.onComplete();
                } else _this.setState(function(prevState) {
                    return {
                        count: prevState.count - 1
                    };
                });
            }, 1000);
        };
        _this.stopCountdown = function() {
            clearInterval(_this.interval);
        };
        _this.addTime = function(seconds) {
            _this.stopCountdown();
            _this.setState(function(prevState) {
                return {
                    count: prevState.count + seconds
                };
            }, _this.startCountdown);
        };
        return _this;
    }
    $8773dc2386917d2a$var$_createClass(Countdown, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCountdown();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearInterval(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children ? (0, $exYeM.cloneElement)(this.props.children, {
                    count: this.state.count
                }) : null;
            }
        }
    ]);
    return Countdown;
}((0, $exYeM.Component));
$8773dc2386917d2a$var$Countdown.propTypes = {
    count: (0, $839799496b62fb71$exports.number),
    children: (0, $839799496b62fb71$exports.element),
    onComplete: (0, $839799496b62fb71$exports.func)
};
var $8773dc2386917d2a$var$Countdown$1 = function(_React$Component) {
    $8773dc2386917d2a$var$_inherits(Countdown$1, _React$Component);
    var _super = $8773dc2386917d2a$var$_createSuper(Countdown$1);
    function Countdown$1(props) {
        var _this;
        $8773dc2386917d2a$var$_classCallCheck(this, Countdown$1);
        _this = _super.call(this, props);
        _this.mounted = false;
        _this.initialTimestamp = _this.calcOffsetStartTimestamp();
        _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
        _this.offsetTime = 0;
        _this.legacyMode = false;
        _this.legacyCountdownRef = (0, $exYeM.createRef)();
        _this.tick = function() {
            var timeDelta = _this.calcTimeDelta();
            var callback = timeDelta.completed && !_this.props.overtime ? undefined : _this.props.onTick;
            _this.setTimeDeltaState(timeDelta, undefined, callback);
        };
        _this.start = function() {
            if (_this.isStarted()) return;
            var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
            _this.offsetStartTimestamp = 0;
            _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;
            var timeDelta = _this.calcTimeDelta();
            _this.setTimeDeltaState(timeDelta, "STARTED", _this.props.onStart);
            if (!_this.props.controlled && (!timeDelta.completed || _this.props.overtime)) {
                _this.clearTimer();
                _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
            }
        };
        _this.pause = function() {
            if (_this.isPaused()) return;
            _this.clearTimer();
            _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
            _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
        };
        _this.stop = function() {
            if (_this.isStopped()) return;
            _this.clearTimer();
            _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
            _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;
            _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
        };
        _this.isStarted = function() {
            return _this.isStatus("STARTED");
        };
        _this.isPaused = function() {
            return _this.isStatus("PAUSED");
        };
        _this.isStopped = function() {
            return _this.isStatus("STOPPED");
        };
        _this.isCompleted = function() {
            return _this.isStatus("COMPLETED");
        };
        if (props.date) {
            var timeDelta = _this.calcTimeDelta();
            _this.state = {
                timeDelta: timeDelta,
                status: timeDelta.completed ? "COMPLETED" : "STOPPED"
            };
        } else _this.legacyMode = true;
        return _this;
    }
    $8773dc2386917d2a$var$_createClass(Countdown$1, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.legacyMode) return;
                this.mounted = true;
                if (this.props.onMount) this.props.onMount(this.calcTimeDelta());
                if (this.props.autoStart) this.start();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.legacyMode) return;
                if (this.props.date !== prevProps.date) {
                    this.initialTimestamp = this.calcOffsetStartTimestamp();
                    this.offsetStartTimestamp = this.initialTimestamp;
                    this.offsetTime = 0;
                    this.setTimeDeltaState(this.calcTimeDelta());
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.legacyMode) return;
                this.mounted = false;
                this.clearTimer();
            }
        },
        {
            key: "calcTimeDelta",
            value: function calcTimeDelta$1() {
                var _this$props = this.props, date = _this$props.date, now = _this$props.now, precision = _this$props.precision, controlled = _this$props.controlled, overtime = _this$props.overtime;
                return $8773dc2386917d2a$export$46f653e95d33dab0(date, {
                    now: now,
                    precision: precision,
                    controlled: controlled,
                    offsetTime: this.offsetTime,
                    overtime: overtime
                });
            }
        },
        {
            key: "calcOffsetStartTimestamp",
            value: function calcOffsetStartTimestamp() {
                return Date.now();
            }
        },
        {
            key: "addTime",
            value: function addTime(seconds) {
                this.legacyCountdownRef.current.addTime(seconds);
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                window.clearInterval(this.interval);
            }
        },
        {
            key: "isStatus",
            value: function isStatus(status) {
                return this.state.status === status;
            }
        },
        {
            key: "setTimeDeltaState",
            value: function setTimeDeltaState(timeDelta, status, callback) {
                var _this2 = this;
                if (!this.mounted) return;
                var completing = timeDelta.completed && !this.state.timeDelta.completed;
                var completedOnStart = timeDelta.completed && status === "STARTED";
                if (completing && !this.props.overtime) this.clearTimer();
                var onDone = function onDone() {
                    if (callback) callback(_this2.state.timeDelta);
                    if (_this2.props.onComplete && (completing || completedOnStart)) _this2.props.onComplete(timeDelta, completedOnStart);
                };
                return this.setState(function(prevState) {
                    var newStatus = status || prevState.status;
                    if (timeDelta.completed && !_this2.props.overtime) newStatus = "COMPLETED";
                    else if (!status && newStatus === "COMPLETED") newStatus = "STOPPED";
                    return {
                        timeDelta: timeDelta,
                        status: newStatus
                    };
                }, onDone);
            }
        },
        {
            key: "getApi",
            value: function getApi() {
                return this.api = this.api || {
                    start: this.start,
                    pause: this.pause,
                    stop: this.stop,
                    isStarted: this.isStarted,
                    isPaused: this.isPaused,
                    isStopped: this.isStopped,
                    isCompleted: this.isCompleted
                };
            }
        },
        {
            key: "getRenderProps",
            value: function getRenderProps() {
                var _this$props2 = this.props, daysInHours = _this$props2.daysInHours, zeroPadTime = _this$props2.zeroPadTime, zeroPadDays = _this$props2.zeroPadDays;
                var timeDelta = this.state.timeDelta;
                return Object.assign(Object.assign({}, timeDelta), {
                    api: this.getApi(),
                    props: this.props,
                    formatted: $8773dc2386917d2a$export$ef2fb803ce7a43db(timeDelta, {
                        daysInHours: daysInHours,
                        zeroPadTime: zeroPadTime,
                        zeroPadDays: zeroPadDays
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.legacyMode) {
                    var _this$props3 = this.props, count = _this$props3.count, _children = _this$props3.children, onComplete = _this$props3.onComplete;
                    return (0, $exYeM.createElement)($8773dc2386917d2a$var$Countdown, {
                        ref: this.legacyCountdownRef,
                        count: count,
                        onComplete: onComplete
                    }, _children);
                }
                var _this$props4 = this.props, className = _this$props4.className, overtime = _this$props4.overtime, children = _this$props4.children, renderer = _this$props4.renderer;
                var renderProps = this.getRenderProps();
                if (renderer) return renderer(renderProps);
                if (children && this.state.timeDelta.completed && !overtime) return (0, $exYeM.cloneElement)(children, {
                    countdown: renderProps
                });
                var _renderProps$formatte = renderProps.formatted, days = _renderProps$formatte.days, hours = _renderProps$formatte.hours, minutes = _renderProps$formatte.minutes, seconds = _renderProps$formatte.seconds;
                return (0, $exYeM.createElement)("span", {
                    className: className
                }, renderProps.total < 0 ? "-" : "", days, days ? ":" : "", hours, ":", minutes, ":", seconds);
            }
        }
    ]);
    return Countdown$1;
}((0, $exYeM.Component));
$8773dc2386917d2a$var$Countdown$1.defaultProps = Object.assign(Object.assign({}, $8773dc2386917d2a$var$timeDeltaFormatOptionsDefaults), {
    controlled: false,
    intervalDelay: 1000,
    precision: 0,
    autoStart: true
});
$8773dc2386917d2a$var$Countdown$1.propTypes = {
    date: (0, $839799496b62fb71$exports.oneOfType)([
        (0, $839799496b62fb71$exports.instanceOf)(Date),
        (0, $839799496b62fb71$exports.string),
        (0, $839799496b62fb71$exports.number)
    ]),
    daysInHours: (0, $839799496b62fb71$exports.bool),
    zeroPadTime: (0, $839799496b62fb71$exports.number),
    zeroPadDays: (0, $839799496b62fb71$exports.number),
    controlled: (0, $839799496b62fb71$exports.bool),
    intervalDelay: (0, $839799496b62fb71$exports.number),
    precision: (0, $839799496b62fb71$exports.number),
    autoStart: (0, $839799496b62fb71$exports.bool),
    overtime: (0, $839799496b62fb71$exports.bool),
    className: (0, $839799496b62fb71$exports.string),
    children: (0, $839799496b62fb71$exports.element),
    renderer: (0, $839799496b62fb71$exports.func),
    now: (0, $839799496b62fb71$exports.func),
    onMount: (0, $839799496b62fb71$exports.func),
    onStart: (0, $839799496b62fb71$exports.func),
    onPause: (0, $839799496b62fb71$exports.func),
    onStop: (0, $839799496b62fb71$exports.func),
    onTick: (0, $839799496b62fb71$exports.func),
    onComplete: (0, $839799496b62fb71$exports.func)
};
var $8773dc2386917d2a$export$2e2bcd8739ae039 = $8773dc2386917d2a$var$Countdown$1;



// Renderer callback with condition
const $3e05a86555e33446$var$renderer = ({ days: days , hours: hours , minutes: minutes , seconds: seconds , completed: completed  })=>{
    //ChatGPT Assisted
    // Render a countdown
    if (completed) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
        className: "font-[600]",
        children: "New Game Available! Refresh Your Browser."
    });
    const timeParts = [];
    if (days > 0) timeParts.push(`${days} Day${days > 1 ? "s" : ""}`);
    if (hours > 0) timeParts.push(`${hours} Hour${hours > 1 ? "s" : ""}`);
    if (minutes > 0) timeParts.push(`${minutes} Minute${minutes > 1 ? "s" : ""}`);
    // Create a sentence based on the time parts
    let timeLeftString = "Next Puzzle Released in ";
    if (timeParts.length > 2) {
        timeLeftString += timeParts.slice(0, -1).join(", ");
        timeLeftString += `, and ${timeParts.slice(-1)}`;
    } else if (timeParts.length == 2) timeLeftString += `${timeParts[0]} and ${timeParts[1]}`;
    else timeLeftString += timeParts[0];
    // Create a sentence based on the time parts
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        children: timeLeftString
    });
};
function $3e05a86555e33446$var$CountdownToNextPuzzle() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: "flex flex-row place-content-center mt-4",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8773dc2386917d2a$export$2e2bcd8739ae039), {
            className: "text-lg text-gray-900",
            renderer: $3e05a86555e33446$var$renderer,
            date: (0, $20e33653a93a2602$export$a20d366458c50e4a),
            intervalDelay: 1000
        })
    });
}
var $3e05a86555e33446$export$2e2bcd8739ae039 = $3e05a86555e33446$var$CountdownToNextPuzzle;





function $2c961eea6ce58655$var$GameLostModal({ open: open  }) {
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $4a5925ef595e0ef1$export$e8331451049320c2));
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $338f7003293b487c$export$2e2bcd8739ae039), {
        title: "You lost.",
        initiallyOpen: open,
        footerElements: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5785a8a4a36b00ae$export$2e2bcd8739ae039), {}),
        showActionButton: false,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "grid gap-y-2",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        className: "text-lg font-[500] text-center",
                        children: "Better luck next time. The correct answers are below."
                    }),
                    gameData.map((obj)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $88d90183f3ddc7ad$export$a73a93adb33205b0), {
                            ...obj
                        }, obj.category))
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $3e05a86555e33446$export$2e2bcd8739ae039), {})
        ]
    });
}
var $2c961eea6ce58655$export$2e2bcd8739ae039 = $2c961eea6ce58655$var$GameLostModal;






var $exYeM = parcelRequire("exYeM");





function $4bbf5d51114ba904$var$GameWonModal({ open: open , submittedGuesses: submittedGuesses  }) {
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $4a5925ef595e0ef1$export$e8331451049320c2));
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $338f7003293b487c$export$2e2bcd8739ae039), {
        title: "You won the game!",
        initiallyOpen: open,
        footerElements: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5785a8a4a36b00ae$export$2e2bcd8739ae039), {}),
        showActionButton: false,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                children: "Great job, share your results!"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "justify-center",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                        className: "text-center whitespace-pre",
                        children: [
                            "\n",
                            (0, $c10a8025d61652dc$export$a63577e223e2a6c9)(gameData, submittedGuesses)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $3e05a86555e33446$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
var $4bbf5d51114ba904$export$2e2bcd8739ae039 = $4bbf5d51114ba904$var$GameWonModal;






var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 *  Separator
 * -----------------------------------------------------------------------------------------------*/ const $7ba30cd052dfd695$var$$89eedd556c436f6a$var$NAME = "Separator";
const $7ba30cd052dfd695$var$$89eedd556c436f6a$var$DEFAULT_ORIENTATION = "horizontal";
const $7ba30cd052dfd695$var$$89eedd556c436f6a$var$ORIENTATIONS = [
    "horizontal",
    "vertical"
];
const $7ba30cd052dfd695$export$1ff3c3f08ae963c0 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { decorative: decorative , orientation: orientationProp = $7ba30cd052dfd695$var$$89eedd556c436f6a$var$DEFAULT_ORIENTATION , ...domProps } = props;
    const orientation = $7ba30cd052dfd695$var$$89eedd556c436f6a$var$isValidOrientation(orientationProp) ? orientationProp : $7ba30cd052dfd695$var$$89eedd556c436f6a$var$DEFAULT_ORIENTATION; // `aria-orientation` defaults to `horizontal` so we only need it if `orientation` is vertical
    const ariaOrientation = orientation === "vertical" ? orientation : undefined;
    const semanticProps = decorative ? {
        role: "none"
    } : {
        "aria-orientation": ariaOrientation,
        role: "separator"
    };
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-orientation": orientation
    }, semanticProps, domProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($7ba30cd052dfd695$export$1ff3c3f08ae963c0, {
    displayName: $7ba30cd052dfd695$var$$89eedd556c436f6a$var$NAME
});
$7ba30cd052dfd695$export$1ff3c3f08ae963c0.propTypes = {
    orientation (props, propName, componentName) {
        const propValue = props[propName];
        const strVal = String(propValue);
        if (propValue && !$7ba30cd052dfd695$var$$89eedd556c436f6a$var$isValidOrientation(propValue)) return new Error($7ba30cd052dfd695$var$$89eedd556c436f6a$var$getInvalidOrientationError(strVal, componentName));
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ // Split this out for clearer readability of the error message.
function $7ba30cd052dfd695$var$$89eedd556c436f6a$var$getInvalidOrientationError(value, componentName) {
    return `Invalid prop \`orientation\` of value \`${value}\` supplied to \`${componentName}\`, expected one of:
  - horizontal
  - vertical

Defaulting to \`${$7ba30cd052dfd695$var$$89eedd556c436f6a$var$DEFAULT_ORIENTATION}\`.`;
}
function $7ba30cd052dfd695$var$$89eedd556c436f6a$var$isValidOrientation(orientation) {
    return $7ba30cd052dfd695$var$$89eedd556c436f6a$var$ORIENTATIONS.includes(orientation);
}
const $7ba30cd052dfd695$export$be92b6f5f03c0fe9 = $7ba30cd052dfd695$export$1ff3c3f08ae963c0;



const $1af14bb17819bdb0$export$1ff3c3f08ae963c0 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , orientation: orientation = "horizontal" , decorative: decorative = true , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7ba30cd052dfd695$export$be92b6f5f03c0fe9, {
        ref: ref,
        decorative: decorative,
        orientation: orientation,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("shrink-0 bg-border", orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", className),
        ...props
    }));
$1af14bb17819bdb0$export$1ff3c3f08ae963c0.displayName = $7ba30cd052dfd695$export$be92b6f5f03c0fe9.displayName;




var $exYeM = parcelRequire("exYeM");
var $90c08e8577660937$exports = {};
var $1917dfad82bbbf6b$exports = {};
var $3d51ebcbbf9b4734$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3d51ebcbbf9b4734$var$nativeCeil = Math.ceil, $3d51ebcbbf9b4734$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $3d51ebcbbf9b4734$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $3d51ebcbbf9b4734$var$nativeMax($3d51ebcbbf9b4734$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$3d51ebcbbf9b4734$exports = $3d51ebcbbf9b4734$var$baseRange;


var $f8ab7f41928d2285$exports = {};
var $6f80be9883321bbe$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6f80be9883321bbe$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$6f80be9883321bbe$exports = $6f80be9883321bbe$var$eq;


var $887f7dd95a2dee62$exports = {};
var $63bef038e059393f$exports = {};
var $852d1f971b259156$exports = {};
var $a090581360ce8173$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Built-in value references. */ var $a090581360ce8173$var$Symbol = $8ThvE.Symbol;
$a090581360ce8173$exports = $a090581360ce8173$var$Symbol;


var $f2cc4cee927d37c7$exports = {};

/** Used for built-in method references. */ var $f2cc4cee927d37c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2cc4cee927d37c7$var$hasOwnProperty = $f2cc4cee927d37c7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2cc4cee927d37c7$var$nativeObjectToString = $f2cc4cee927d37c7$var$objectProto.toString;
/** Built-in value references. */ var $f2cc4cee927d37c7$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f2cc4cee927d37c7$var$getRawTag(value) {
    var isOwn = $f2cc4cee927d37c7$var$hasOwnProperty.call(value, $f2cc4cee927d37c7$var$symToStringTag), tag = value[$f2cc4cee927d37c7$var$symToStringTag];
    try {
        value[$f2cc4cee927d37c7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f2cc4cee927d37c7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f2cc4cee927d37c7$var$symToStringTag] = tag;
        else delete value[$f2cc4cee927d37c7$var$symToStringTag];
    }
    return result;
}
$f2cc4cee927d37c7$exports = $f2cc4cee927d37c7$var$getRawTag;


var $934b51efa189f09c$exports = {};
/** Used for built-in method references. */ var $934b51efa189f09c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $934b51efa189f09c$var$nativeObjectToString = $934b51efa189f09c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $934b51efa189f09c$var$objectToString(value) {
    return $934b51efa189f09c$var$nativeObjectToString.call(value);
}
$934b51efa189f09c$exports = $934b51efa189f09c$var$objectToString;


/** `Object#toString` result references. */ var $852d1f971b259156$var$nullTag = "[object Null]", $852d1f971b259156$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $852d1f971b259156$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $852d1f971b259156$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $852d1f971b259156$var$undefinedTag : $852d1f971b259156$var$nullTag;
    return $852d1f971b259156$var$symToStringTag && $852d1f971b259156$var$symToStringTag in Object(value) ? $f2cc4cee927d37c7$exports(value) : $934b51efa189f09c$exports(value);
}
$852d1f971b259156$exports = $852d1f971b259156$var$baseGetTag;


var $db5dfd0661742a1a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $db5dfd0661742a1a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$db5dfd0661742a1a$exports = $db5dfd0661742a1a$var$isObject;


/** `Object#toString` result references. */ var $63bef038e059393f$var$asyncTag = "[object AsyncFunction]", $63bef038e059393f$var$funcTag = "[object Function]", $63bef038e059393f$var$genTag = "[object GeneratorFunction]", $63bef038e059393f$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $63bef038e059393f$var$isFunction(value) {
    if (!$db5dfd0661742a1a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $852d1f971b259156$exports(value);
    return tag == $63bef038e059393f$var$funcTag || tag == $63bef038e059393f$var$genTag || tag == $63bef038e059393f$var$asyncTag || tag == $63bef038e059393f$var$proxyTag;
}
$63bef038e059393f$exports = $63bef038e059393f$var$isFunction;


var $9ad3d04370aa37c9$exports = {};
/** Used as references for various `Number` constants. */ var $9ad3d04370aa37c9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $9ad3d04370aa37c9$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $9ad3d04370aa37c9$var$MAX_SAFE_INTEGER;
}
$9ad3d04370aa37c9$exports = $9ad3d04370aa37c9$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $887f7dd95a2dee62$var$isArrayLike(value) {
    return value != null && $9ad3d04370aa37c9$exports(value.length) && !$63bef038e059393f$exports(value);
}
$887f7dd95a2dee62$exports = $887f7dd95a2dee62$var$isArrayLike;


var $1a5c8861aefb5e25$exports = {};
/** Used as references for various `Number` constants. */ var $1a5c8861aefb5e25$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $1a5c8861aefb5e25$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1a5c8861aefb5e25$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $1a5c8861aefb5e25$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $1a5c8861aefb5e25$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$1a5c8861aefb5e25$exports = $1a5c8861aefb5e25$var$isIndex;



/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $f8ab7f41928d2285$var$isIterateeCall(value, index, object) {
    if (!$db5dfd0661742a1a$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $887f7dd95a2dee62$exports(object) && $1a5c8861aefb5e25$exports(index, object.length) : type == "string" && index in object) return $6f80be9883321bbe$exports(object[index], value);
    return false;
}
$f8ab7f41928d2285$exports = $f8ab7f41928d2285$var$isIterateeCall;


var $5a6bac89763f60ef$exports = {};
var $e588870a06e690e1$exports = {};
var $3b7784db2f170e31$exports = {};
var $85eafef3a7f213a3$exports = {};
/** Used to match a single whitespace character. */ var $85eafef3a7f213a3$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $85eafef3a7f213a3$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $85eafef3a7f213a3$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$85eafef3a7f213a3$exports = $85eafef3a7f213a3$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $3b7784db2f170e31$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3b7784db2f170e31$var$baseTrim(string) {
    return string ? string.slice(0, $85eafef3a7f213a3$exports(string) + 1).replace($3b7784db2f170e31$var$reTrimStart, "") : string;
}
$3b7784db2f170e31$exports = $3b7784db2f170e31$var$baseTrim;



var $b7350b23d035986b$exports = {};

var $5475ba594a8bdf91$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5475ba594a8bdf91$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$5475ba594a8bdf91$exports = $5475ba594a8bdf91$var$isObjectLike;


/** `Object#toString` result references. */ var $b7350b23d035986b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7350b23d035986b$var$isSymbol(value) {
    return typeof value == "symbol" || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $b7350b23d035986b$var$symbolTag;
}
$b7350b23d035986b$exports = $b7350b23d035986b$var$isSymbol;


/** Used as references for various `Number` constants. */ var $e588870a06e690e1$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e588870a06e690e1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e588870a06e690e1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e588870a06e690e1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e588870a06e690e1$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e588870a06e690e1$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($b7350b23d035986b$exports(value)) return $e588870a06e690e1$var$NAN;
    if ($db5dfd0661742a1a$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $db5dfd0661742a1a$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $3b7784db2f170e31$exports(value);
    var isBinary = $e588870a06e690e1$var$reIsBinary.test(value);
    return isBinary || $e588870a06e690e1$var$reIsOctal.test(value) ? $e588870a06e690e1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e588870a06e690e1$var$reIsBadHex.test(value) ? $e588870a06e690e1$var$NAN : +value;
}
$e588870a06e690e1$exports = $e588870a06e690e1$var$toNumber;


/** Used as references for various `Number` constants. */ var $5a6bac89763f60ef$var$INFINITY = 1 / 0, $5a6bac89763f60ef$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $5a6bac89763f60ef$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $e588870a06e690e1$exports(value);
    if (value === $5a6bac89763f60ef$var$INFINITY || value === -$5a6bac89763f60ef$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $5a6bac89763f60ef$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$5a6bac89763f60ef$exports = $5a6bac89763f60ef$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $1917dfad82bbbf6b$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $f8ab7f41928d2285$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $5a6bac89763f60ef$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $5a6bac89763f60ef$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $5a6bac89763f60ef$exports(step);
        return $3d51ebcbbf9b4734$exports(start, end, step, fromRight);
    };
}
$1917dfad82bbbf6b$exports = $1917dfad82bbbf6b$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $90c08e8577660937$var$range = $1917dfad82bbbf6b$exports();
$90c08e8577660937$exports = $90c08e8577660937$var$range;




function $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $exYeM = parcelRequire("exYeM");
var $3e937fab5d08b2fc$exports = {};
"use strict";
var $8a650a96b5a43f0f$exports = {};
"use strict";

$8a650a96b5a43f0f$exports = (parcelRequire("beWdq"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3e937fab5d08b2fc$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3e937fab5d08b2fc$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3e937fab5d08b2fc$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3e937fab5d08b2fc$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3e937fab5d08b2fc$var$TYPE_STATICS = {};
$3e937fab5d08b2fc$var$TYPE_STATICS[$8a650a96b5a43f0f$exports.ForwardRef] = $3e937fab5d08b2fc$var$FORWARD_REF_STATICS;
$3e937fab5d08b2fc$var$TYPE_STATICS[$8a650a96b5a43f0f$exports.Memo] = $3e937fab5d08b2fc$var$MEMO_STATICS;
function $3e937fab5d08b2fc$var$getStatics(component) {
    // React v16.11 and below
    if ($8a650a96b5a43f0f$exports.isMemo(component)) return $3e937fab5d08b2fc$var$MEMO_STATICS;
     // React v16.12 and above
    return $3e937fab5d08b2fc$var$TYPE_STATICS[component["$$typeof"]] || $3e937fab5d08b2fc$var$REACT_STATICS;
}
var $3e937fab5d08b2fc$var$defineProperty = Object.defineProperty;
var $3e937fab5d08b2fc$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3e937fab5d08b2fc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3e937fab5d08b2fc$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3e937fab5d08b2fc$var$getPrototypeOf = Object.getPrototypeOf;
var $3e937fab5d08b2fc$var$objectPrototype = Object.prototype;
function $3e937fab5d08b2fc$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3e937fab5d08b2fc$var$objectPrototype) {
            var inheritedComponent = $3e937fab5d08b2fc$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3e937fab5d08b2fc$var$objectPrototype) $3e937fab5d08b2fc$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3e937fab5d08b2fc$var$getOwnPropertyNames(sourceComponent);
        if ($3e937fab5d08b2fc$var$getOwnPropertySymbols) keys = keys.concat($3e937fab5d08b2fc$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3e937fab5d08b2fc$var$getStatics(targetComponent);
        var sourceStatics = $3e937fab5d08b2fc$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3e937fab5d08b2fc$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3e937fab5d08b2fc$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3e937fab5d08b2fc$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$3e937fab5d08b2fc$exports = $3e937fab5d08b2fc$var$hoistNonReactStatics;



var $exYeM = parcelRequire("exYeM");



var $d332f38c4fed81fc$exports = {};
"use strict";
Object.defineProperty($d332f38c4fed81fc$exports, "__esModule", {
    value: true
});
$d332f38c4fed81fc$exports.default = $d332f38c4fed81fc$var$getDisplayName;
function $d332f38c4fed81fc$var$getDisplayName(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


function $49d8224d32e74ea5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $49d8224d32e74ea5$var$_extends() {
    $49d8224d32e74ea5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $49d8224d32e74ea5$var$_extends.apply(this, arguments);
}
function $49d8224d32e74ea5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $49d8224d32e74ea5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $49d8224d32e74ea5$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && !Array.isArray(obj);
}
function $49d8224d32e74ea5$var$createThemeProvider(context) {
    var ThemeProvider = /*#__PURE__*/ function(_React$Component) {
        $49d8224d32e74ea5$var$_inheritsLoose(ThemeProvider, _React$Component);
        function ThemeProvider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            $49d8224d32e74ea5$var$_defineProperty($49d8224d32e74ea5$var$_assertThisInitialized($49d8224d32e74ea5$var$_assertThisInitialized(_this)), "cachedTheme", void 0);
            $49d8224d32e74ea5$var$_defineProperty($49d8224d32e74ea5$var$_assertThisInitialized($49d8224d32e74ea5$var$_assertThisInitialized(_this)), "lastOuterTheme", void 0);
            $49d8224d32e74ea5$var$_defineProperty($49d8224d32e74ea5$var$_assertThisInitialized($49d8224d32e74ea5$var$_assertThisInitialized(_this)), "lastTheme", void 0);
            $49d8224d32e74ea5$var$_defineProperty($49d8224d32e74ea5$var$_assertThisInitialized($49d8224d32e74ea5$var$_assertThisInitialized(_this)), "renderProvider", function(outerTheme) {
                var children = _this.props.children;
                return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(context.Provider, {
                    value: _this.getTheme(outerTheme)
                }, children);
            });
            return _this;
        }
        var _proto = ThemeProvider.prototype;
        // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
        _proto.getTheme = function getTheme(outerTheme) {
            if (this.props.theme !== this.lastTheme || outerTheme !== this.lastOuterTheme || !this.cachedTheme) {
                this.lastOuterTheme = outerTheme;
                this.lastTheme = this.props.theme;
                if (typeof this.lastTheme === "function") {
                    var theme = this.props.theme;
                    this.cachedTheme = theme(outerTheme);
                } else {
                    var _theme = this.props.theme;
                    this.cachedTheme = outerTheme ? $49d8224d32e74ea5$var$_extends({}, outerTheme, _theme) : _theme;
                }
            }
            return this.cachedTheme;
        };
        _proto.render = function render() {
            var children = this.props.children;
            if (!children) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(context.Consumer, null, this.renderProvider);
        };
        return ThemeProvider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component);
    return ThemeProvider;
}
function $49d8224d32e74ea5$var$createWithTheme(context) {
    return function hoc(Component) {
        var withTheme = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(context.Consumer, null, function(theme) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Component, $49d8224d32e74ea5$var$_extends({
                    theme: theme,
                    ref: ref
                }, props));
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($3e937fab5d08b2fc$exports)))(withTheme, Component);
        return withTheme;
    };
}
function $49d8224d32e74ea5$var$createUseTheme(context) {
    var useTheme = function useTheme() {
        var theme = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext(context);
        return theme;
    };
    return useTheme;
}
function $49d8224d32e74ea5$export$c0de29a8ef9dbf92(context) {
    return {
        context: context,
        withTheme: $49d8224d32e74ea5$var$createWithTheme(context),
        useTheme: $49d8224d32e74ea5$var$createUseTheme(context),
        ThemeProvider: $49d8224d32e74ea5$var$createThemeProvider(context)
    };
}
var $49d8224d32e74ea5$export$2c657da244d00bd6 = (0, $exYeM.createContext)();
var $49d8224d32e74ea5$var$_createTheming = $49d8224d32e74ea5$export$c0de29a8ef9dbf92($49d8224d32e74ea5$export$2c657da244d00bd6), $49d8224d32e74ea5$export$e8748c6a27b910dc = $49d8224d32e74ea5$var$_createTheming.withTheme, $49d8224d32e74ea5$export$d8964aec282183a3 = $49d8224d32e74ea5$var$_createTheming.ThemeProvider, $49d8224d32e74ea5$export$93d4e7f90805808f = $49d8224d32e74ea5$var$_createTheming.useTheme;


var $99c42cf5bc34ebf5$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $99c42cf5bc34ebf5$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $99c42cf5bc34ebf5$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $99c42cf5bc34ebf5$var$_typeof(document)) === "object" && document.nodeType === 9;
var $99c42cf5bc34ebf5$export$2e2bcd8739ae039 = $99c42cf5bc34ebf5$export$4e09c449d6c407f7;





var $939ae4b3e02e6842$var$isProduction = true;
function $939ae4b3e02e6842$var$warning(condition, message) {
    if (!$939ae4b3e02e6842$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $939ae4b3e02e6842$export$2e2bcd8739ae039 = $939ae4b3e02e6842$var$warning;




function $bbd5d0b4a89d436f$export$2e2bcd8739ae039(input, hint) {
    if ((0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $99406aaafdabc25e$export$2e2bcd8739ae039(arg) {
    var key = (0, $bbd5d0b4a89d436f$export$2e2bcd8739ae039)(arg, "string");
    return (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $49c8709106076573$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $99406aaafdabc25e$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $49c8709106076573$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $49c8709106076573$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $49c8709106076573$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $438ae88f4b206ba2$export$2e2bcd8739ae039(o, p) {
    $438ae88f4b206ba2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $438ae88f4b206ba2$export$2e2bcd8739ae039(o, p);
}


function $6ace560ed589c934$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $438ae88f4b206ba2$export$2e2bcd8739ae039)(subClass, superClass);
}


function $8b81dd4f51678982$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $cba9cac93def5758$var$plainObjectConstrurctor = {}.constructor;
function $cba9cac93def5758$var$cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map($cba9cac93def5758$var$cloneStyle);
    if (style.constructor !== $cba9cac93def5758$var$plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = $cba9cac93def5758$var$cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function $cba9cac93def5758$export$56e87122f905fac0(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = $cba9cac93def5758$var$cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var $cba9cac93def5758$var$join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var $cba9cac93def5758$export$5ac341d5e3cf9273 = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += $cba9cac93def5758$var$join(value[i], " ");
    }
    else cssValue = $cba9cac93def5758$var$join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function $cba9cac93def5758$var$getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function $cba9cac93def5758$var$indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function $cba9cac93def5758$var$toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = $cba9cac93def5758$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += $cba9cac93def5758$var$indentStr(prop + ":" + space + $cba9cac93def5758$export$5ac341d5e3cf9273(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += $cba9cac93def5758$var$indentStr(_prop + ":" + space + $cba9cac93def5758$export$5ac341d5e3cf9273(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += $cba9cac93def5758$var$indentStr(_prop2 + ":" + space + $cba9cac93def5758$export$5ac341d5e3cf9273(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return $cba9cac93def5758$var$indentStr("" + selector + space + "{" + result, indent) + $cba9cac93def5758$var$indentStr("}", indent);
}
var $cba9cac93def5758$var$escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var $cba9cac93def5758$var$nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var $cba9cac93def5758$var$escape = function(str) {
    return $cba9cac93def5758$var$nativeEscape ? $cba9cac93def5758$var$nativeEscape(str) : str.replace($cba9cac93def5758$var$escapeRegex, "\\$1");
};
var $cba9cac93def5758$var$BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var $cba9cac93def5758$var$StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $6ace560ed589c934$export$2e2bcd8739ae039)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $8b81dd4f51678982$export$2e2bcd8739ae039)((0, $8b81dd4f51678982$export$2e2bcd8739ae039)(_this)), sheet);
            _this.selectorText = "." + $cba9cac93def5758$var$escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = $cba9cac93def5758$export$5ac341d5e3cf9273(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            allowEmpty: true
        }) : options;
        return $cba9cac93def5758$var$toCss(this.selectorText, this.style, opts);
    };
    (0, $49c8709106076573$export$2e2bcd8739ae039)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}($cba9cac93def5758$var$BaseStyleRule);
var $cba9cac93def5758$var$pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new $cba9cac93def5758$var$StyleRule(key, style, options);
    }
};
var $cba9cac93def5758$var$defaultToStringOptions = {
    indent: 1,
    children: true
};
var $cba9cac93def5758$var$atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var $cba9cac93def5758$var$ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match($cba9cac93def5758$var$atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new $cba9cac93def5758$export$d9da2a13178d3d68((0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $cba9cac93def5758$var$defaultToStringOptions;
        var _getWhitespaceSymbols = $cba9cac93def5758$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $cba9cac93def5758$var$defaultToStringOptions.indent;
        if (options.children == null) options.children = $cba9cac93def5758$var$defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var $cba9cac93def5758$var$keyRegExp = /@container|@media|@supports\s+/;
var $cba9cac93def5758$var$pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return $cba9cac93def5758$var$keyRegExp.test(key) ? new $cba9cac93def5758$var$ConditionalRule(key, styles, options) : null;
    }
};
var $cba9cac93def5758$var$defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var $cba9cac93def5758$var$nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var $cba9cac93def5758$var$KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match($cba9cac93def5758$var$nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : $cba9cac93def5758$var$escape(generateId(this, sheet));
        this.rules = new $cba9cac93def5758$export$d9da2a13178d3d68((0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $cba9cac93def5758$var$defaultToStringOptions$1;
        var _getWhitespaceSymbols = $cba9cac93def5758$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $cba9cac93def5758$var$defaultToStringOptions$1.indent;
        if (options.children == null) options.children = $cba9cac93def5758$var$defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var $cba9cac93def5758$var$keyRegExp$1 = /@keyframes\s+/;
var $cba9cac93def5758$var$refRegExp = /\$([\w-]+)/g;
var $cba9cac93def5758$var$findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace($cba9cac93def5758$var$refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var $cba9cac93def5758$var$replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = $cba9cac93def5758$var$findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var $cba9cac93def5758$var$pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && $cba9cac93def5758$var$keyRegExp$1.test(key) ? new $cba9cac93def5758$var$KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) $cba9cac93def5758$var$replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) $cba9cac93def5758$var$replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return $cba9cac93def5758$var$findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return $cba9cac93def5758$var$findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var $cba9cac93def5758$var$KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $6ace560ed589c934$export$2e2bcd8739ae039)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            allowEmpty: true
        }) : options;
        return $cba9cac93def5758$var$toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}($cba9cac93def5758$var$BaseStyleRule);
var $cba9cac93def5758$var$pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new $cba9cac93def5758$var$KeyframeRule(key, style, options);
        return null;
    }
};
var $cba9cac93def5758$var$FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = $cba9cac93def5758$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += $cba9cac93def5758$var$toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return $cba9cac93def5758$var$toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var $cba9cac93def5758$var$keyRegExp$2 = /@font-face/;
var $cba9cac93def5758$var$pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return $cba9cac93def5758$var$keyRegExp$2.test(key) ? new $cba9cac93def5758$var$FontFaceRule(key, style, options) : null;
    }
};
var $cba9cac93def5758$var$ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return $cba9cac93def5758$var$toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var $cba9cac93def5758$var$pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new $cba9cac93def5758$var$ViewportRule(key, style, options) : null;
    }
};
var $cba9cac93def5758$var$SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var $cba9cac93def5758$var$keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var $cba9cac93def5758$var$pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in $cba9cac93def5758$var$keysMap ? new $cba9cac93def5758$var$SimpleRule(key, value, options) : null;
    }
};
var $cba9cac93def5758$var$plugins = [
    $cba9cac93def5758$var$pluginStyleRule,
    $cba9cac93def5758$var$pluginConditionalRule,
    $cba9cac93def5758$var$pluginKeyframesRule,
    $cba9cac93def5758$var$pluginKeyframeRule,
    $cba9cac93def5758$var$pluginFontFaceRule,
    $cba9cac93def5758$var$pluginViewportRule,
    $cba9cac93def5758$var$pluginSimpleRule
];
var $cba9cac93def5758$var$defaultUpdateOptions = {
    process: true
};
var $cba9cac93def5758$var$forceUpdateOptions = {
    force: true,
    process: true
};
var $cba9cac93def5758$export$d9da2a13178d3d68 = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + $cba9cac93def5758$var$escape(this.classes[key]);
        var rule = $cba9cac93def5758$export$56e87122f905fac0(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof $cba9cac93def5758$var$StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof $cba9cac93def5758$var$KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof $cba9cac93def5758$var$StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof $cba9cac93def5758$var$KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = $cba9cac93def5758$var$defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, $cba9cac93def5758$var$forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, $cba9cac93def5758$var$forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = $cba9cac93def5758$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var $cba9cac93def5758$var$StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new $cba9cac93def5758$export$d9da2a13178d3d68(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var $cba9cac93def5758$var$PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var $cba9cac93def5758$export$bcb2f1d96ff51db3 = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = $cba9cac93def5758$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $49c8709106076573$export$2e2bcd8739ae039)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var $cba9cac93def5758$export$d1f2fc3a3d47c5af = new $cba9cac93def5758$export$bcb2f1d96ff51db3();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var $cba9cac93def5758$var$globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var $cba9cac93def5758$var$ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if ($cba9cac93def5758$var$globalThis$1[$cba9cac93def5758$var$ns] == null) $cba9cac93def5758$var$globalThis$1[$cba9cac93def5758$var$ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var $cba9cac93def5758$var$moduleId = $cba9cac93def5758$var$globalThis$1[$cba9cac93def5758$var$ns]++;
var $cba9cac93def5758$var$maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var $cba9cac93def5758$export$ddff9cce7c732c82 = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + $cba9cac93def5758$var$moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + $cba9cac93def5758$var$moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var $cba9cac93def5758$var$memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var $cba9cac93def5758$var$getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var $cba9cac93def5758$var$setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = $cba9cac93def5758$export$5ac341d5e3cf9273(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var $cba9cac93def5758$var$removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var $cba9cac93def5758$var$setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var $cba9cac93def5758$var$getHead = $cba9cac93def5758$var$memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function $cba9cac93def5758$var$findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function $cba9cac93def5758$var$findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function $cba9cac93def5758$var$findCommentNode(text) {
    var head = $cba9cac93def5758$var$getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function $cba9cac93def5758$var$findPrevNode(options) {
    var registry = $cba9cac93def5758$export$d1f2fc3a3d47c5af.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = $cba9cac93def5758$var$findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = $cba9cac93def5758$var$findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = $cba9cac93def5758$var$findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function $cba9cac93def5758$var$insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = $cba9cac93def5758$var$findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    $cba9cac93def5758$var$getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var $cba9cac93def5758$var$getNonce = $cba9cac93def5758$var$memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var $cba9cac93def5758$var$_insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var $cba9cac93def5758$var$getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var $cba9cac93def5758$var$createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var $cba9cac93def5758$var$DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = $cba9cac93def5758$var$getPropertyValue;
        this.setProperty = $cba9cac93def5758$var$setProperty;
        this.removeProperty = $cba9cac93def5758$var$removeProperty;
        this.setSelector = $cba9cac93def5758$var$setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) $cba9cac93def5758$export$d1f2fc3a3d47c5af.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || $cba9cac93def5758$var$createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = $cba9cac93def5758$var$getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        $cba9cac93def5758$var$insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = $cba9cac93def5758$var$getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = $cba9cac93def5758$var$_insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = $cba9cac93def5758$var$getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = $cba9cac93def5758$var$_insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof $cba9cac93def5758$var$StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var $cba9cac93def5758$var$instanceCounter = 0;
var $cba9cac93def5758$var$Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = $cba9cac93def5758$var$instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new $cba9cac93def5758$var$PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: $cba9cac93def5758$export$ddff9cce7c732c82,
            Renderer: (0, $99c42cf5bc34ebf5$export$2e2bcd8739ae039) ? $cba9cac93def5758$var$DomRenderer : null,
            plugins: []
        };
        this.generateId = $cba9cac93def5758$export$ddff9cce7c732c82({
            minify: false
        });
        for(var i = 0; i < $cba9cac93def5758$var$plugins.length; i++)this.plugins.use($cba9cac93def5758$var$plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = $cba9cac93def5758$export$d1f2fc3a3d47c5af.index === 0 ? 0 : $cba9cac93def5758$export$d1f2fc3a3d47c5af.index + 1;
        var sheet = new $cba9cac93def5758$var$StyleSheet(styles, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        $cba9cac93def5758$export$d1f2fc3a3d47c5af.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = $cba9cac93def5758$export$56e87122f905fac0(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var $cba9cac93def5758$export$185802fd694ee1f5 = function createJss(options) {
    return new $cba9cac93def5758$var$Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var $cba9cac93def5758$export$c72bb5031d779271 = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $939ae4b3e02e6842$export$2e2bcd8739ae039)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $939ae4b3e02e6842$export$2e2bcd8739ae039)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $49c8709106076573$export$2e2bcd8739ae039)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var $cba9cac93def5758$export$2305122a7d881dec = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function $cba9cac93def5758$export$8558f2aefa046992(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = $cba9cac93def5758$export$8558f2aefa046992(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var $cba9cac93def5758$var$index = $cba9cac93def5758$export$185802fd694ee1f5();
var $cba9cac93def5758$export$2e2bcd8739ae039 = $cba9cac93def5758$var$index;




var $42b4b68d084fa55c$var$now = Date.now();
var $42b4b68d084fa55c$var$fnValuesNs = "fnValues" + $42b4b68d084fa55c$var$now;
var $42b4b68d084fa55c$var$fnRuleNs = "fnStyle" + ++$42b4b68d084fa55c$var$now;
var $42b4b68d084fa55c$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $cba9cac93def5758$export$56e87122f905fac0)(name, {}, options);
            rule[$42b4b68d084fa55c$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($42b4b68d084fa55c$var$fnValuesNs in rule || $42b4b68d084fa55c$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$42b4b68d084fa55c$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$42b4b68d084fa55c$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$42b4b68d084fa55c$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $42b4b68d084fa55c$export$2e2bcd8739ae039 = $42b4b68d084fa55c$var$functionPlugin;



var $flL8Q = parcelRequire("flL8Q");

var $6e4fa1f6b88d7ebf$var$isObservable = function isObservable(value) {
    return value && value[0, $flL8Q.default] && value === value[0, $flL8Q.default]();
};
var $6e4fa1f6b88d7ebf$var$observablePlugin = function observablePlugin(updateOptions) {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (!$6e4fa1f6b88d7ebf$var$isObservable(decl)) return null;
            var style$ = decl;
            var rule = (0, $cba9cac93def5758$export$56e87122f905fac0)(name, {}, options); // TODO
            // Call `stream.subscribe()` returns a subscription, which should be explicitly
            // unsubscribed from when we know this sheet is no longer needed.
            style$.subscribe(function(style) {
                for(var prop in style)rule.prop(prop, style[prop], updateOptions);
            });
            return rule;
        },
        onProcessRule: function onProcessRule(rule) {
            if (rule && rule.type !== "style") return;
            var styleRule = rule;
            var style = styleRule.style;
            var _loop = function _loop(prop) {
                var value = style[prop];
                if (!$6e4fa1f6b88d7ebf$var$isObservable(value)) return "continue";
                delete style[prop];
                value.subscribe({
                    next: function next(nextValue) {
                        styleRule.prop(prop, nextValue, updateOptions);
                    }
                });
            };
            for(var prop in style){
                var _ret = _loop(prop);
                if (_ret === "continue") continue;
            }
        }
    };
};
var $6e4fa1f6b88d7ebf$export$2e2bcd8739ae039 = $6e4fa1f6b88d7ebf$var$observablePlugin;



var $62f769051974495b$var$semiWithNl = /;\n/;
/**
 * Naive CSS parser.
 * - Supports only rule body (no selectors)
 * - Requires semicolon and new line after the value (except of last line)
 * - No nested rules support
 */ var $62f769051974495b$var$parse = function parse(cssText) {
    var style = {};
    var split = cssText.split($62f769051974495b$var$semiWithNl);
    for(var i = 0; i < split.length; i++){
        var decl = (split[i] || "").trim();
        if (!decl) continue;
        var colonIndex = decl.indexOf(":");
        if (colonIndex === -1) continue;
        var prop = decl.substr(0, colonIndex).trim();
        var value = decl.substr(colonIndex + 1).trim();
        style[prop] = value;
    }
    return style;
};
var $62f769051974495b$var$onProcessRule = function onProcessRule(rule) {
    if (typeof rule.style === "string") rule.style = $62f769051974495b$var$parse(rule.style);
};
function $62f769051974495b$var$templatePlugin() {
    return {
        onProcessRule: $62f769051974495b$var$onProcessRule
    };
}
var $62f769051974495b$export$2e2bcd8739ae039 = $62f769051974495b$var$templatePlugin;




var $67854698fd5546eb$var$at = "@global";
var $67854698fd5546eb$var$atPrefix = "@global ";
var $67854698fd5546eb$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $67854698fd5546eb$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $cba9cac93def5758$export$d9da2a13178d3d68)((0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $67854698fd5546eb$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $67854698fd5546eb$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($67854698fd5546eb$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $67854698fd5546eb$var$separatorRegExp = /\s*,\s*/g;
function $67854698fd5546eb$var$addScope(selector, scope) {
    var parts = selector.split($67854698fd5546eb$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $67854698fd5546eb$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$67854698fd5546eb$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
        selector: $67854698fd5546eb$var$addScope(name, rule.selector)
    }));
    delete style[$67854698fd5546eb$var$at];
}
function $67854698fd5546eb$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $67854698fd5546eb$var$at.length) !== $67854698fd5546eb$var$at) continue;
        var selector = $67854698fd5546eb$var$addScope(prop.substr($67854698fd5546eb$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $67854698fd5546eb$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $67854698fd5546eb$var$at) return new $67854698fd5546eb$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $67854698fd5546eb$var$atPrefix.length) === $67854698fd5546eb$var$atPrefix) return new $67854698fd5546eb$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $67854698fd5546eb$var$handleNestedGlobalContainerRule(rule, sheet);
        $67854698fd5546eb$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $67854698fd5546eb$export$2e2bcd8739ae039 = $67854698fd5546eb$var$jssGlobal;




var $f54ed90349595f99$var$isObject = function isObject(obj) {
    return obj && typeof obj === "object" && !Array.isArray(obj);
};
var $f54ed90349595f99$var$valueNs = "extendCurrValue" + Date.now();
function $f54ed90349595f99$var$mergeExtend(style, rule, sheet, newStyle) {
    var extendType = typeof style.extend; // Extend using a rule name.
    if (extendType === "string") {
        if (!sheet) return;
        var refRule = sheet.getRule(style.extend);
        if (!refRule) return;
        if (refRule === rule) return;
        var parent = refRule.options.parent;
        if (parent) {
            var originalStyle = parent.rules.raw[style.extend];
            $f54ed90349595f99$var$extend(originalStyle, rule, sheet, newStyle);
        }
        return;
    } // Extend using an array.
    if (Array.isArray(style.extend)) {
        for(var index = 0; index < style.extend.length; index++){
            var singleExtend = style.extend[index];
            var singleStyle = typeof singleExtend === "string" ? (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, style, {
                extend: singleExtend
            }) : style.extend[index];
            $f54ed90349595f99$var$extend(singleStyle, rule, sheet, newStyle);
        }
        return;
    } // Extend is a style object.
    for(var prop in style.extend){
        if (prop === "extend") {
            $f54ed90349595f99$var$extend(style.extend.extend, rule, sheet, newStyle);
            continue;
        }
        if ($f54ed90349595f99$var$isObject(style.extend[prop])) {
            if (!(prop in newStyle)) newStyle[prop] = {};
            $f54ed90349595f99$var$extend(style.extend[prop], rule, sheet, newStyle[prop]);
            continue;
        }
        newStyle[prop] = style.extend[prop];
    }
}
function $f54ed90349595f99$var$mergeRest(style, rule, sheet, newStyle) {
    // Copy base style.
    for(var prop in style){
        if (prop === "extend") continue;
        if ($f54ed90349595f99$var$isObject(newStyle[prop]) && $f54ed90349595f99$var$isObject(style[prop])) {
            $f54ed90349595f99$var$extend(style[prop], rule, sheet, newStyle[prop]);
            continue;
        }
        if ($f54ed90349595f99$var$isObject(style[prop])) {
            newStyle[prop] = $f54ed90349595f99$var$extend(style[prop], rule, sheet);
            continue;
        }
        newStyle[prop] = style[prop];
    }
}
/**
 * Recursively extend styles.
 */ function $f54ed90349595f99$var$extend(style, rule, sheet, newStyle) {
    if (newStyle === void 0) newStyle = {};
    $f54ed90349595f99$var$mergeExtend(style, rule, sheet, newStyle);
    $f54ed90349595f99$var$mergeRest(style, rule, sheet, newStyle);
    return newStyle;
}
/**
 * Handle `extend` property.
 */ function $f54ed90349595f99$var$jssExtend() {
    function onProcessStyle(style, rule, sheet) {
        if ("extend" in style) return $f54ed90349595f99$var$extend(style, rule, sheet);
        return style;
    }
    function onChangeValue(value, prop, rule) {
        if (prop !== "extend") return value; // Value is empty, remove properties set previously.
        if (value == null || value === false) {
            for(var key in rule[$f54ed90349595f99$var$valueNs])rule.prop(key, null);
            rule[$f54ed90349595f99$var$valueNs] = null;
            return null;
        }
        if (typeof value === "object") {
            for(var _key in value)rule.prop(_key, value[_key]);
            rule[$f54ed90349595f99$var$valueNs] = value;
        } // Make sure we don't set the value in the core.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $f54ed90349595f99$export$2e2bcd8739ae039 = $f54ed90349595f99$var$jssExtend;




var $ac0de8e429364ad0$var$separatorRegExp = /\s*,\s*/g;
var $ac0de8e429364ad0$var$parentRegExp = /&/g;
var $ac0de8e429364ad0$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $ac0de8e429364ad0$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($ac0de8e429364ad0$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($ac0de8e429364ad0$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($ac0de8e429364ad0$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($ac0de8e429364ad0$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $ac0de8e429364ad0$export$2e2bcd8739ae039 = $ac0de8e429364ad0$var$jssNested;



/**
 * Set selector.
 *
 * @param original rule
 * @param className class string
 * @return flag indicating function was successfull or not
 */ function $1ea5bc1a193abf5c$var$registerClass(rule, className) {
    // Skip falsy values
    if (!className) return true; // Support array of class names `{composes: ['foo', 'bar']}`
    if (Array.isArray(className)) {
        for(var index = 0; index < className.length; index++){
            var isSetted = $1ea5bc1a193abf5c$var$registerClass(rule, className[index]);
            if (!isSetted) return false;
        }
        return true;
    } // Support space separated class names `{composes: 'foo bar'}`
    if (className.indexOf(" ") > -1) return $1ea5bc1a193abf5c$var$registerClass(rule, className.split(" "));
    var parent = rule.options.parent; // It is a ref to a local rule.
    if (className[0] === "$") {
        var refRule = parent.getRule(className.substr(1));
        if (!refRule) return false;
        if (refRule === rule) return false;
        parent.classes[rule.key] += " " + parent.classes[refRule.key];
        return true;
    }
    parent.classes[rule.key] += " " + className;
    return true;
}
/**
 * Convert compose property to additional class, remove property from original styles.
 */ function $1ea5bc1a193abf5c$var$jssCompose() {
    function onProcessStyle(style, rule) {
        if (!("composes" in style)) return style;
        $1ea5bc1a193abf5c$var$registerClass(rule, style.composes); // Remove composes property to prevent infinite loop.
        delete style.composes;
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $1ea5bc1a193abf5c$export$2e2bcd8739ae039 = $1ea5bc1a193abf5c$var$jssCompose;


/* eslint-disable no-var, prefer-template */ var $42bf0e3f399dc5d8$var$uppercasePattern = /[A-Z]/g;
var $42bf0e3f399dc5d8$var$msPattern = /^ms-/;
var $42bf0e3f399dc5d8$var$cache = {};
function $42bf0e3f399dc5d8$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $42bf0e3f399dc5d8$var$hyphenateStyleName(name) {
    if ($42bf0e3f399dc5d8$var$cache.hasOwnProperty(name)) return $42bf0e3f399dc5d8$var$cache[name];
    var hName = name.replace($42bf0e3f399dc5d8$var$uppercasePattern, $42bf0e3f399dc5d8$var$toHyphenLower);
    return $42bf0e3f399dc5d8$var$cache[name] = $42bf0e3f399dc5d8$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $42bf0e3f399dc5d8$export$2e2bcd8739ae039 = $42bf0e3f399dc5d8$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $83144772649fb8e0$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $42bf0e3f399dc5d8$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($83144772649fb8e0$var$convertCase);
        else converted.fallbacks = $83144772649fb8e0$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $83144772649fb8e0$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $83144772649fb8e0$var$convertCase(style[index]);
            return style;
        }
        return $83144772649fb8e0$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $42bf0e3f399dc5d8$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $83144772649fb8e0$export$2e2bcd8739ae039 = $83144772649fb8e0$var$camelCase;



var $f3ab654ace932c04$var$px = (0, $cba9cac93def5758$export$2305122a7d881dec) && CSS ? CSS.px : "px";
var $f3ab654ace932c04$var$ms = (0, $cba9cac93def5758$export$2305122a7d881dec) && CSS ? CSS.ms : "ms";
var $f3ab654ace932c04$var$percent = (0, $cba9cac93def5758$export$2305122a7d881dec) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $f3ab654ace932c04$var$defaultUnits = {
    // Animation properties
    "animation-delay": $f3ab654ace932c04$var$ms,
    "animation-duration": $f3ab654ace932c04$var$ms,
    // Background properties
    "background-position": $f3ab654ace932c04$var$px,
    "background-position-x": $f3ab654ace932c04$var$px,
    "background-position-y": $f3ab654ace932c04$var$px,
    "background-size": $f3ab654ace932c04$var$px,
    // Border Properties
    border: $f3ab654ace932c04$var$px,
    "border-bottom": $f3ab654ace932c04$var$px,
    "border-bottom-left-radius": $f3ab654ace932c04$var$px,
    "border-bottom-right-radius": $f3ab654ace932c04$var$px,
    "border-bottom-width": $f3ab654ace932c04$var$px,
    "border-left": $f3ab654ace932c04$var$px,
    "border-left-width": $f3ab654ace932c04$var$px,
    "border-radius": $f3ab654ace932c04$var$px,
    "border-right": $f3ab654ace932c04$var$px,
    "border-right-width": $f3ab654ace932c04$var$px,
    "border-top": $f3ab654ace932c04$var$px,
    "border-top-left-radius": $f3ab654ace932c04$var$px,
    "border-top-right-radius": $f3ab654ace932c04$var$px,
    "border-top-width": $f3ab654ace932c04$var$px,
    "border-width": $f3ab654ace932c04$var$px,
    "border-block": $f3ab654ace932c04$var$px,
    "border-block-end": $f3ab654ace932c04$var$px,
    "border-block-end-width": $f3ab654ace932c04$var$px,
    "border-block-start": $f3ab654ace932c04$var$px,
    "border-block-start-width": $f3ab654ace932c04$var$px,
    "border-block-width": $f3ab654ace932c04$var$px,
    "border-inline": $f3ab654ace932c04$var$px,
    "border-inline-end": $f3ab654ace932c04$var$px,
    "border-inline-end-width": $f3ab654ace932c04$var$px,
    "border-inline-start": $f3ab654ace932c04$var$px,
    "border-inline-start-width": $f3ab654ace932c04$var$px,
    "border-inline-width": $f3ab654ace932c04$var$px,
    "border-start-start-radius": $f3ab654ace932c04$var$px,
    "border-start-end-radius": $f3ab654ace932c04$var$px,
    "border-end-start-radius": $f3ab654ace932c04$var$px,
    "border-end-end-radius": $f3ab654ace932c04$var$px,
    // Margin properties
    margin: $f3ab654ace932c04$var$px,
    "margin-bottom": $f3ab654ace932c04$var$px,
    "margin-left": $f3ab654ace932c04$var$px,
    "margin-right": $f3ab654ace932c04$var$px,
    "margin-top": $f3ab654ace932c04$var$px,
    "margin-block": $f3ab654ace932c04$var$px,
    "margin-block-end": $f3ab654ace932c04$var$px,
    "margin-block-start": $f3ab654ace932c04$var$px,
    "margin-inline": $f3ab654ace932c04$var$px,
    "margin-inline-end": $f3ab654ace932c04$var$px,
    "margin-inline-start": $f3ab654ace932c04$var$px,
    // Padding properties
    padding: $f3ab654ace932c04$var$px,
    "padding-bottom": $f3ab654ace932c04$var$px,
    "padding-left": $f3ab654ace932c04$var$px,
    "padding-right": $f3ab654ace932c04$var$px,
    "padding-top": $f3ab654ace932c04$var$px,
    "padding-block": $f3ab654ace932c04$var$px,
    "padding-block-end": $f3ab654ace932c04$var$px,
    "padding-block-start": $f3ab654ace932c04$var$px,
    "padding-inline": $f3ab654ace932c04$var$px,
    "padding-inline-end": $f3ab654ace932c04$var$px,
    "padding-inline-start": $f3ab654ace932c04$var$px,
    // Mask properties
    "mask-position-x": $f3ab654ace932c04$var$px,
    "mask-position-y": $f3ab654ace932c04$var$px,
    "mask-size": $f3ab654ace932c04$var$px,
    // Width and height properties
    height: $f3ab654ace932c04$var$px,
    width: $f3ab654ace932c04$var$px,
    "min-height": $f3ab654ace932c04$var$px,
    "max-height": $f3ab654ace932c04$var$px,
    "min-width": $f3ab654ace932c04$var$px,
    "max-width": $f3ab654ace932c04$var$px,
    // Position properties
    bottom: $f3ab654ace932c04$var$px,
    left: $f3ab654ace932c04$var$px,
    top: $f3ab654ace932c04$var$px,
    right: $f3ab654ace932c04$var$px,
    inset: $f3ab654ace932c04$var$px,
    "inset-block": $f3ab654ace932c04$var$px,
    "inset-block-end": $f3ab654ace932c04$var$px,
    "inset-block-start": $f3ab654ace932c04$var$px,
    "inset-inline": $f3ab654ace932c04$var$px,
    "inset-inline-end": $f3ab654ace932c04$var$px,
    "inset-inline-start": $f3ab654ace932c04$var$px,
    // Shadow properties
    "box-shadow": $f3ab654ace932c04$var$px,
    "text-shadow": $f3ab654ace932c04$var$px,
    // Column properties
    "column-gap": $f3ab654ace932c04$var$px,
    "column-rule": $f3ab654ace932c04$var$px,
    "column-rule-width": $f3ab654ace932c04$var$px,
    "column-width": $f3ab654ace932c04$var$px,
    // Font and text properties
    "font-size": $f3ab654ace932c04$var$px,
    "font-size-delta": $f3ab654ace932c04$var$px,
    "letter-spacing": $f3ab654ace932c04$var$px,
    "text-decoration-thickness": $f3ab654ace932c04$var$px,
    "text-indent": $f3ab654ace932c04$var$px,
    "text-stroke": $f3ab654ace932c04$var$px,
    "text-stroke-width": $f3ab654ace932c04$var$px,
    "word-spacing": $f3ab654ace932c04$var$px,
    // Motion properties
    motion: $f3ab654ace932c04$var$px,
    "motion-offset": $f3ab654ace932c04$var$px,
    // Outline properties
    outline: $f3ab654ace932c04$var$px,
    "outline-offset": $f3ab654ace932c04$var$px,
    "outline-width": $f3ab654ace932c04$var$px,
    // Perspective properties
    perspective: $f3ab654ace932c04$var$px,
    "perspective-origin-x": $f3ab654ace932c04$var$percent,
    "perspective-origin-y": $f3ab654ace932c04$var$percent,
    // Transform properties
    "transform-origin": $f3ab654ace932c04$var$percent,
    "transform-origin-x": $f3ab654ace932c04$var$percent,
    "transform-origin-y": $f3ab654ace932c04$var$percent,
    "transform-origin-z": $f3ab654ace932c04$var$percent,
    // Transition properties
    "transition-delay": $f3ab654ace932c04$var$ms,
    "transition-duration": $f3ab654ace932c04$var$ms,
    // Alignment properties
    "vertical-align": $f3ab654ace932c04$var$px,
    "flex-basis": $f3ab654ace932c04$var$px,
    // Some random properties
    "shape-margin": $f3ab654ace932c04$var$px,
    size: $f3ab654ace932c04$var$px,
    gap: $f3ab654ace932c04$var$px,
    // Grid properties
    grid: $f3ab654ace932c04$var$px,
    "grid-gap": $f3ab654ace932c04$var$px,
    "row-gap": $f3ab654ace932c04$var$px,
    "grid-row-gap": $f3ab654ace932c04$var$px,
    "grid-column-gap": $f3ab654ace932c04$var$px,
    "grid-template-rows": $f3ab654ace932c04$var$px,
    "grid-template-columns": $f3ab654ace932c04$var$px,
    "grid-auto-rows": $f3ab654ace932c04$var$px,
    "grid-auto-columns": $f3ab654ace932c04$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $f3ab654ace932c04$var$px,
    "box-shadow-y": $f3ab654ace932c04$var$px,
    "box-shadow-blur": $f3ab654ace932c04$var$px,
    "box-shadow-spread": $f3ab654ace932c04$var$px,
    "font-line-height": $f3ab654ace932c04$var$px,
    "text-shadow-x": $f3ab654ace932c04$var$px,
    "text-shadow-y": $f3ab654ace932c04$var$px,
    "text-shadow-blur": $f3ab654ace932c04$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $f3ab654ace932c04$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $f3ab654ace932c04$var$units = $f3ab654ace932c04$var$addCamelCasedVersion($f3ab654ace932c04$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $f3ab654ace932c04$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $f3ab654ace932c04$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $f3ab654ace932c04$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $f3ab654ace932c04$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $f3ab654ace932c04$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $f3ab654ace932c04$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $f3ab654ace932c04$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $f3ab654ace932c04$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $f3ab654ace932c04$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $f3ab654ace932c04$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $f3ab654ace932c04$export$2e2bcd8739ae039 = $f3ab654ace932c04$var$defaultUnit;


/**
 * A scheme for converting properties from array to regular style.
 * All properties listed below will be transformed to a string separated by space.
 */ var $6957d61447a27509$var$propArray = {
    "background-size": true,
    "background-position": true,
    border: true,
    "border-bottom": true,
    "border-left": true,
    "border-top": true,
    "border-right": true,
    "border-radius": true,
    "border-image": true,
    "border-width": true,
    "border-style": true,
    "border-color": true,
    "box-shadow": true,
    flex: true,
    margin: true,
    padding: true,
    outline: true,
    "transform-origin": true,
    transform: true,
    transition: true
};
var $6957d61447a27509$var$propArrayInObj = {
    position: true,
    // background-position
    size: true // background-size
};
var $6957d61447a27509$var$propObj = {
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    background: {
        attachment: null,
        color: null,
        image: null,
        position: null,
        repeat: null
    },
    border: {
        width: null,
        style: null,
        color: null
    },
    "border-top": {
        width: null,
        style: null,
        color: null
    },
    "border-right": {
        width: null,
        style: null,
        color: null
    },
    "border-bottom": {
        width: null,
        style: null,
        color: null
    },
    "border-left": {
        width: null,
        style: null,
        color: null
    },
    outline: {
        width: null,
        style: null,
        color: null
    },
    "list-style": {
        type: null,
        position: null,
        image: null
    },
    transition: {
        property: null,
        duration: null,
        "timing-function": null,
        timingFunction: null,
        // Needed for avoiding comilation issues with jss-plugin-camel-case
        delay: null
    },
    animation: {
        name: null,
        duration: null,
        "timing-function": null,
        timingFunction: null,
        // Needed to avoid compilation issues with jss-plugin-camel-case
        delay: null,
        "iteration-count": null,
        iterationCount: null,
        // Needed to avoid compilation issues with jss-plugin-camel-case
        direction: null,
        "fill-mode": null,
        fillMode: null,
        // Needed to avoid compilation issues with jss-plugin-camel-case
        "play-state": null,
        playState: null // Needed to avoid compilation issues with jss-plugin-camel-case
    },
    "box-shadow": {
        x: 0,
        y: 0,
        blur: 0,
        spread: 0,
        color: null,
        inset: null
    },
    "text-shadow": {
        x: 0,
        y: 0,
        blur: null,
        color: null
    }
};
var $6957d61447a27509$var$customPropObj = {
    border: {
        radius: "border-radius",
        image: "border-image",
        width: "border-width",
        style: "border-style",
        color: "border-color"
    },
    "border-bottom": {
        width: "border-bottom-width",
        style: "border-bottom-style",
        color: "border-bottom-color"
    },
    "border-top": {
        width: "border-top-width",
        style: "border-top-style",
        color: "border-top-color"
    },
    "border-left": {
        width: "border-left-width",
        style: "border-left-style",
        color: "border-left-color"
    },
    "border-right": {
        width: "border-right-width",
        style: "border-right-style",
        color: "border-right-color"
    },
    background: {
        size: "background-size",
        image: "background-image"
    },
    font: {
        style: "font-style",
        variant: "font-variant",
        weight: "font-weight",
        stretch: "font-stretch",
        size: "font-size",
        family: "font-family",
        lineHeight: "line-height",
        // Needed to avoid compilation issues with jss-plugin-camel-case
        "line-height": "line-height"
    },
    flex: {
        grow: "flex-grow",
        basis: "flex-basis",
        direction: "flex-direction",
        wrap: "flex-wrap",
        flow: "flex-flow",
        shrink: "flex-shrink"
    },
    align: {
        self: "align-self",
        items: "align-items",
        content: "align-content"
    },
    grid: {
        "template-columns": "grid-template-columns",
        templateColumns: "grid-template-columns",
        "template-rows": "grid-template-rows",
        templateRows: "grid-template-rows",
        "template-areas": "grid-template-areas",
        templateAreas: "grid-template-areas",
        template: "grid-template",
        "auto-columns": "grid-auto-columns",
        autoColumns: "grid-auto-columns",
        "auto-rows": "grid-auto-rows",
        autoRows: "grid-auto-rows",
        "auto-flow": "grid-auto-flow",
        autoFlow: "grid-auto-flow",
        row: "grid-row",
        column: "grid-column",
        "row-start": "grid-row-start",
        rowStart: "grid-row-start",
        "row-end": "grid-row-end",
        rowEnd: "grid-row-end",
        "column-start": "grid-column-start",
        columnStart: "grid-column-start",
        "column-end": "grid-column-end",
        columnEnd: "grid-column-end",
        area: "grid-area",
        gap: "grid-gap",
        "row-gap": "grid-row-gap",
        rowGap: "grid-row-gap",
        "column-gap": "grid-column-gap",
        columnGap: "grid-column-gap"
    }
};
/* eslint-disable no-use-before-define */ /**
 * Map values by given prop.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {String} original rule
 * @return {String} mapped values
 */ function $6957d61447a27509$var$mapValuesByProp(value, prop, rule) {
    return value.map(function(item) {
        return $6957d61447a27509$var$objectToArray(item, prop, rule, false, true);
    });
}
/**
 * Convert array to nested array, if needed
 */ function $6957d61447a27509$var$processArray(value, prop, scheme, rule) {
    if (scheme[prop] == null) return value;
    if (value.length === 0) return [];
    if (Array.isArray(value[0])) return $6957d61447a27509$var$processArray(value[0], prop, scheme, rule);
    if (typeof value[0] === "object") return $6957d61447a27509$var$mapValuesByProp(value, prop, rule);
    return [
        value
    ];
}
/**
 * Convert object to array.
 */ function $6957d61447a27509$var$objectToArray(value, prop, rule, isFallback, isInArray) {
    if (!($6957d61447a27509$var$propObj[prop] || $6957d61447a27509$var$customPropObj[prop])) return [];
    var result = []; // Check if exists any non-standard property
    if ($6957d61447a27509$var$customPropObj[prop]) // eslint-disable-next-line no-param-reassign
    value = $6957d61447a27509$var$customPropsToStyle(value, rule, $6957d61447a27509$var$customPropObj[prop], isFallback);
     // Pass throught all standart props
    if (Object.keys(value).length) for(var baseProp in $6957d61447a27509$var$propObj[prop]){
        if (value[baseProp]) {
            if (Array.isArray(value[baseProp])) result.push($6957d61447a27509$var$propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(" "));
            else result.push(value[baseProp]);
            continue;
        } // Add default value from props config.
        if ($6957d61447a27509$var$propObj[prop][baseProp] != null) result.push($6957d61447a27509$var$propObj[prop][baseProp]);
    }
    if (!result.length || isInArray) return result;
    return [
        result
    ];
}
/**
 * Convert custom properties values to styles adding them to rule directly
 */ function $6957d61447a27509$var$customPropsToStyle(value, rule, customProps, isFallback) {
    for(var prop in customProps){
        var propName = customProps[prop]; // If current property doesn't exist already in rule - add new one
        if (typeof value[prop] !== "undefined" && (isFallback || !rule.prop(propName))) {
            var _styleDetector;
            var appendedValue = $6957d61447a27509$var$styleDetector((_styleDetector = {}, _styleDetector[propName] = value[prop], _styleDetector), rule)[propName]; // Add style directly in rule
            if (isFallback) rule.style.fallbacks[propName] = appendedValue;
            else rule.style[propName] = appendedValue;
        } // Delete converted property to avoid double converting
        delete value[prop];
    }
    return value;
}
/**
 * Detect if a style needs to be converted.
 */ function $6957d61447a27509$var$styleDetector(style, rule, isFallback) {
    for(var prop in style){
        var value = style[prop];
        if (Array.isArray(value)) // Check double arrays to avoid recursion.
        {
            if (!Array.isArray(value[0])) {
                if (prop === "fallbacks") {
                    for(var index = 0; index < style.fallbacks.length; index++)style.fallbacks[index] = $6957d61447a27509$var$styleDetector(style.fallbacks[index], rule, true);
                    continue;
                }
                style[prop] = $6957d61447a27509$var$processArray(value, prop, $6957d61447a27509$var$propArray, rule); // Avoid creating properties with empty values
                if (!style[prop].length) delete style[prop];
            }
        } else if (typeof value === "object") {
            if (prop === "fallbacks") {
                style.fallbacks = $6957d61447a27509$var$styleDetector(style.fallbacks, rule, true);
                continue;
            }
            style[prop] = $6957d61447a27509$var$objectToArray(value, prop, rule, isFallback); // Avoid creating properties with empty values
            if (!style[prop].length) delete style[prop];
        } else if (style[prop] === "") delete style[prop];
    }
    return style;
}
/**
 * Adds possibility to write expanded styles.
 */ function $6957d61447a27509$var$jssExpand() {
    function onProcessStyle(style, rule) {
        if (!style || rule.type !== "style") return style;
        if (Array.isArray(style)) {
            // Pass rules one by one and reformat them
            for(var index = 0; index < style.length; index++)style[index] = $6957d61447a27509$var$styleDetector(style[index], rule);
            return style;
        }
        return $6957d61447a27509$var$styleDetector(style, rule);
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $6957d61447a27509$export$2e2bcd8739ae039 = $6957d61447a27509$var$jssExpand;



function $40d28a29bc3d0243$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $05bae60b5059fa29$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $40d28a29bc3d0243$export$2e2bcd8739ae039)(arr);
}


function $82a9c213e7b5e835$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $2fa5c1109958a2fc$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $40d28a29bc3d0243$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $40d28a29bc3d0243$export$2e2bcd8739ae039)(o, minLen);
}


function $457e940208e3f1f6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d03f1413c8055345$export$2e2bcd8739ae039(arr) {
    return (0, $05bae60b5059fa29$export$2e2bcd8739ae039)(arr) || (0, $82a9c213e7b5e835$export$2e2bcd8739ae039)(arr) || (0, $2fa5c1109958a2fc$export$2e2bcd8739ae039)(arr) || (0, $457e940208e3f1f6$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $b9fd8a90a4644211$var$js = "";
var $b9fd8a90a4644211$var$css = "";
var $b9fd8a90a4644211$var$vendor = "";
var $b9fd8a90a4644211$var$browser = "";
var $b9fd8a90a4644211$var$isTouch = (0, $99c42cf5bc34ebf5$export$2e2bcd8739ae039) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $99c42cf5bc34ebf5$export$2e2bcd8739ae039) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $b9fd8a90a4644211$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $b9fd8a90a4644211$var$_document$createEleme = document.createElement("p"), $b9fd8a90a4644211$var$style = $b9fd8a90a4644211$var$_document$createEleme.style;
    var $b9fd8a90a4644211$var$testProp = "Transform";
    for(var $b9fd8a90a4644211$var$key in $b9fd8a90a4644211$var$jsCssMap)if ($b9fd8a90a4644211$var$key + $b9fd8a90a4644211$var$testProp in $b9fd8a90a4644211$var$style) {
        $b9fd8a90a4644211$var$js = $b9fd8a90a4644211$var$key;
        $b9fd8a90a4644211$var$css = $b9fd8a90a4644211$var$jsCssMap[$b9fd8a90a4644211$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($b9fd8a90a4644211$var$js === "Webkit" && "msHyphens" in $b9fd8a90a4644211$var$style) {
        $b9fd8a90a4644211$var$js = "ms";
        $b9fd8a90a4644211$var$css = $b9fd8a90a4644211$var$jsCssMap.ms;
        $b9fd8a90a4644211$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($b9fd8a90a4644211$var$js === "Webkit" && "-apple-trailing-word" in $b9fd8a90a4644211$var$style) $b9fd8a90a4644211$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $b9fd8a90a4644211$export$82e9f45cca5ba907 = {
    js: $b9fd8a90a4644211$var$js,
    css: $b9fd8a90a4644211$var$css,
    vendor: $b9fd8a90a4644211$var$vendor,
    browser: $b9fd8a90a4644211$var$browser,
    isTouch: $b9fd8a90a4644211$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $b9fd8a90a4644211$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $b9fd8a90a4644211$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $b9fd8a90a4644211$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $b9fd8a90a4644211$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "Webkit") return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $b9fd8a90a4644211$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $b9fd8a90a4644211$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $b9fd8a90a4644211$var$camelize(str) {
    return str.replace($b9fd8a90a4644211$var$regExp, $b9fd8a90a4644211$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $b9fd8a90a4644211$var$pascalize(str) {
    return $b9fd8a90a4644211$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $b9fd8a90a4644211$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($b9fd8a90a4644211$var$camelize(longhand) in style) return prop;
            if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js + $b9fd8a90a4644211$var$pascalize(longhand) in style) return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $b9fd8a90a4644211$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.vendor === "apple" && !$b9fd8a90a4644211$export$82e9f45cca5ba907.isTouch) return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $b9fd8a90a4644211$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $b9fd8a90a4644211$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $b9fd8a90a4644211$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "Webkit" || $b9fd8a90a4644211$export$82e9f45cca5ba907.js === "ms" && $b9fd8a90a4644211$export$82e9f45cca5ba907.browser !== "edge") return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $b9fd8a90a4644211$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "Moz" || $b9fd8a90a4644211$export$82e9f45cca5ba907.js === "ms" || $b9fd8a90a4644211$export$82e9f45cca5ba907.vendor === "apple") return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $b9fd8a90a4644211$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $b9fd8a90a4644211$var$pascalize(prop);
            return jsProp in style ? $b9fd8a90a4644211$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $b9fd8a90a4644211$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $b9fd8a90a4644211$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $b9fd8a90a4644211$export$82e9f45cca5ba907.js + $b9fd8a90a4644211$var$pascalize(newProp) in style ? $b9fd8a90a4644211$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $b9fd8a90a4644211$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $b9fd8a90a4644211$var$camelize(prop) in style ? prop : false;
    }
};
var $b9fd8a90a4644211$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $b9fd8a90a4644211$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js + pascalized in style) return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $b9fd8a90a4644211$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "ms") return "" + $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $b9fd8a90a4644211$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($b9fd8a90a4644211$export$82e9f45cca5ba907.js === "ms") return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $b9fd8a90a4644211$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $b9fd8a90a4644211$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $b9fd8a90a4644211$var$propMap[prop];
        if (!newProp) return false;
        return $b9fd8a90a4644211$export$82e9f45cca5ba907.js + $b9fd8a90a4644211$var$pascalize(newProp) in style ? $b9fd8a90a4644211$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $b9fd8a90a4644211$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $b9fd8a90a4644211$var$propKeys = Object.keys($b9fd8a90a4644211$var$propMap$1);
var $b9fd8a90a4644211$var$prefixCss = function prefixCss(p) {
    return $b9fd8a90a4644211$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $b9fd8a90a4644211$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($b9fd8a90a4644211$var$propKeys.indexOf(prop) > -1) {
            var newProp = $b9fd8a90a4644211$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $b9fd8a90a4644211$export$82e9f45cca5ba907.js + $b9fd8a90a4644211$var$pascalize(newProp) in style ? $b9fd8a90a4644211$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($b9fd8a90a4644211$export$82e9f45cca5ba907.js + $b9fd8a90a4644211$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($b9fd8a90a4644211$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $b9fd8a90a4644211$var$plugins = [
    $b9fd8a90a4644211$var$appearence,
    $b9fd8a90a4644211$var$colorAdjust,
    $b9fd8a90a4644211$var$mask,
    $b9fd8a90a4644211$var$textOrientation,
    $b9fd8a90a4644211$var$transform,
    $b9fd8a90a4644211$var$transition,
    $b9fd8a90a4644211$var$writingMode,
    $b9fd8a90a4644211$var$userSelect,
    $b9fd8a90a4644211$var$breakPropsOld,
    $b9fd8a90a4644211$var$inlineLogicalOld,
    $b9fd8a90a4644211$var$unprefixed,
    $b9fd8a90a4644211$var$prefixed,
    $b9fd8a90a4644211$var$scrollSnap,
    $b9fd8a90a4644211$var$overscrollBehavior,
    $b9fd8a90a4644211$var$flex2012,
    $b9fd8a90a4644211$var$flex2009
];
var $b9fd8a90a4644211$var$propertyDetectors = $b9fd8a90a4644211$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $b9fd8a90a4644211$var$noPrefill = $b9fd8a90a4644211$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $d03f1413c8055345$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $b9fd8a90a4644211$var$el;
var $b9fd8a90a4644211$var$cache = {};
if (0, $99c42cf5bc34ebf5$export$2e2bcd8739ae039) {
    $b9fd8a90a4644211$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $b9fd8a90a4644211$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $b9fd8a90a4644211$var$key$1 in $b9fd8a90a4644211$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($b9fd8a90a4644211$var$key$1)) $b9fd8a90a4644211$var$cache[$b9fd8a90a4644211$var$computed[$b9fd8a90a4644211$var$key$1]] = $b9fd8a90a4644211$var$computed[$b9fd8a90a4644211$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $b9fd8a90a4644211$var$noPrefill.forEach(function(x) {
        return delete $b9fd8a90a4644211$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $b9fd8a90a4644211$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$b9fd8a90a4644211$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($b9fd8a90a4644211$var$cache[prop] != null) return $b9fd8a90a4644211$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $b9fd8a90a4644211$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $b9fd8a90a4644211$var$propertyDetectors.length; i++){
        $b9fd8a90a4644211$var$cache[prop] = $b9fd8a90a4644211$var$propertyDetectors[i](prop, $b9fd8a90a4644211$var$el.style, options); // Break loop, if value found.
        if ($b9fd8a90a4644211$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $b9fd8a90a4644211$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $b9fd8a90a4644211$var$cache[prop];
}
var $b9fd8a90a4644211$var$cache$1 = {};
var $b9fd8a90a4644211$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $b9fd8a90a4644211$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $b9fd8a90a4644211$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $b9fd8a90a4644211$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $b9fd8a90a4644211$export$ce097f82c2e4551a(p1) : ", " + $b9fd8a90a4644211$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $99c42cf5bc34ebf5$export$2e2bcd8739ae039) $b9fd8a90a4644211$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $b9fd8a90a4644211$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$b9fd8a90a4644211$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($b9fd8a90a4644211$var$cache$1[cacheKey] != null) return $b9fd8a90a4644211$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $b9fd8a90a4644211$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $b9fd8a90a4644211$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($b9fd8a90a4644211$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($b9fd8a90a4644211$var$transPropsRegExp, $b9fd8a90a4644211$var$prefixTransitionCallback);
    else if ($b9fd8a90a4644211$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $b9fd8a90a4644211$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $b9fd8a90a4644211$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $b9fd8a90a4644211$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($b9fd8a90a4644211$var$el$1.style[property] === "") {
            $b9fd8a90a4644211$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $b9fd8a90a4644211$var$el$1.style[property] = ""; // Write current value to cache.
    $b9fd8a90a4644211$var$cache$1[cacheKey] = prefixedValue;
    return $b9fd8a90a4644211$var$cache$1[cacheKey];
}



/**
 * Add vendor prefix to a property name when needed.
 */ function $22d4de0c349dbe71$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $b9fd8a90a4644211$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $b9fd8a90a4644211$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $b9fd8a90a4644211$export$511766124059c277)(supportedProp, (0, $cba9cac93def5758$export$5ac341d5e3cf9273)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $b9fd8a90a4644211$export$511766124059c277)(prop, (0, $cba9cac93def5758$export$5ac341d5e3cf9273)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $22d4de0c349dbe71$export$2e2bcd8739ae039 = $22d4de0c349dbe71$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $76a0686b28cf4835$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $76a0686b28cf4835$export$2e2bcd8739ae039 = $76a0686b28cf4835$var$jssPropsSort;


var $478fde94ad87c0c2$var$create = function create(options) {
    if (options === void 0) options = {};
    return {
        plugins: [
            (0, $42b4b68d084fa55c$export$2e2bcd8739ae039)(),
            (0, $6e4fa1f6b88d7ebf$export$2e2bcd8739ae039)(options.observable),
            (0, $62f769051974495b$export$2e2bcd8739ae039)(),
            (0, $67854698fd5546eb$export$2e2bcd8739ae039)(),
            (0, $f54ed90349595f99$export$2e2bcd8739ae039)(),
            (0, $ac0de8e429364ad0$export$2e2bcd8739ae039)(),
            (0, $1ea5bc1a193abf5c$export$2e2bcd8739ae039)(),
            (0, $83144772649fb8e0$export$2e2bcd8739ae039)(),
            (0, $f3ab654ace932c04$export$2e2bcd8739ae039)(options.defaultUnit),
            (0, $6957d61447a27509$export$2e2bcd8739ae039)(),
            (0, $22d4de0c349dbe71$export$2e2bcd8739ae039)(),
            (0, $76a0686b28cf4835$export$2e2bcd8739ae039)()
        ]
    };
};
var $478fde94ad87c0c2$export$2e2bcd8739ae039 = $478fde94ad87c0c2$var$create;


function $83e3783accc5ff33$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $83e3783accc5ff33$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    var len = arrA.length;
    if (arrB.length !== len) return false;
    for(var i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}


function $0ef2c7853016f282$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $0ef2c7853016f282$export$2e2bcd8739ae039 = $0ef2c7853016f282$var$memoize;


var $4108f1be9398bcb3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $4108f1be9398bcb3$var$index = (0, $0ef2c7853016f282$export$2e2bcd8739ae039)(function(prop) {
    return $4108f1be9398bcb3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $4108f1be9398bcb3$export$2e2bcd8739ae039 = $4108f1be9398bcb3$var$index;




// Since we are in a single sheet mode, user shouldn't care about this.
var $5f9f3bff4405f80f$var$MAX_RULES_PER_SHEET = 10000;
var $5f9f3bff4405f80f$var$defaultJss = (0, $cba9cac93def5758$export$185802fd694ee1f5)((0, $478fde94ad87c0c2$export$2e2bcd8739ae039)());
var $5f9f3bff4405f80f$export$185802fd694ee1f5 = function createCss(jss) {
    if (jss === void 0) jss = $5f9f3bff4405f80f$var$defaultJss;
    var cache = new Map();
    var ruleIndex = 0;
    var sheet;
    var getSheet = function getSheet() {
        if (!sheet || sheet.rules.index.length > $5f9f3bff4405f80f$var$MAX_RULES_PER_SHEET) sheet = jss.createStyleSheet().attach();
        return sheet;
    };
    function css() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments; // We can avoid the need for stringification with a babel plugin,
        // which could generate a hash at build time and add it to the object.
        var argsStr = JSON.stringify(args);
        var cached = cache.get(argsStr);
        if (cached) return cached.className;
        var flatArgs = []; // Flatten arguments which can be
        // - style objects
        // - array of style objects
        // - arrays of style objects
        for(var argIndex in args){
            var arg = args[argIndex];
            if (!Array.isArray(arg)) {
                flatArgs.push(arg);
                continue;
            }
            for(var innerArgIndex = 0; innerArgIndex < arg.length; innerArgIndex++)flatArgs.push(arg[innerArgIndex]);
        }
        var mergedStyle = {};
        var labels = [];
        for(var i = 0; i < flatArgs.length; i++){
            var style = flatArgs[i];
            if (!style) continue;
            var styleObject = style; // It can be a class name that css() has previously generated.
            if (typeof style === "string") {
                // eslint-disable-next-line no-shadow
                var _cached = cache.get(style);
                if (_cached) {
                    // eslint-disable-next-line prefer-spread
                    if (_cached.labels.length) labels.push.apply(labels, _cached.labels);
                    styleObject = _cached.style;
                }
            }
            if (styleObject.label && labels.indexOf(styleObject.label) === -1) labels.push(styleObject.label);
            Object.assign(mergedStyle, styleObject);
        }
        delete mergedStyle.label;
        var label = labels.length === 0 ? "css" : labels.join("-");
        var key = label + "-" + ruleIndex++;
        getSheet().addRule(key, mergedStyle);
        var className = getSheet().classes[key];
        var cacheValue = {
            style: mergedStyle,
            labels: labels,
            className: className
        };
        cache.set(argsStr, cacheValue);
        cache.set(className, cacheValue);
        return className;
    } // For testing only.
    css.getSheet = getSheet;
    return css;
};
var $5f9f3bff4405f80f$var$css = $5f9f3bff4405f80f$export$185802fd694ee1f5();
var $5f9f3bff4405f80f$export$2e2bcd8739ae039 = $5f9f3bff4405f80f$var$css;


var $4528a0b99e8f2c5b$var$getDisplayName = function getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
};
var $4528a0b99e8f2c5b$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (Array.isArray(lastArgs) && args.length === lastArgs.length) {
            var isSame = true;
            for(var i = 0; i < args.length; i++)if (args[i] !== lastArgs[i]) isSame = false;
            if (isSame) return lastResult;
        }
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};
var $4528a0b99e8f2c5b$var$mergeClasses = function mergeClasses(baseClasses, additionalClasses) {
    var combinedClasses = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, baseClasses);
    for(var name in additionalClasses)combinedClasses[name] = name in combinedClasses ? combinedClasses[name] + " " + additionalClasses[name] : additionalClasses[name];
    return combinedClasses;
};
/**
 * Global index counter to preserve source order.
 * As we create the style sheet during componentWillMount lifecycle,
 * children are handled after the parents, so the order of style elements would
 * be parent->child. It is a problem though when a parent passes a className
 * which needs to override any childs styles. StyleSheet of the child has a higher
 * specificity, because of the source order.
 * So our solution is to render sheets them in the reverse order child->sheet, so
 * that parent has a higher specificity.
 *
 * We start at [Number.MIN_SAFE_INTEGER] to always insert sheets from react-jss first before any
 * sheet which might be inserted manually by the user.
 */ var $4528a0b99e8f2c5b$var$index = Number.MIN_SAFE_INTEGER || -1000000000;
var $4528a0b99e8f2c5b$var$getSheetIndex = function getSheetIndex() {
    return $4528a0b99e8f2c5b$var$index++;
};
var $4528a0b99e8f2c5b$export$193e6193848b8f2a = (0, $exYeM.createContext)({
    classNamePrefix: "",
    disableStylesGeneration: false,
    isSSR: !(0, $99c42cf5bc34ebf5$export$2e2bcd8739ae039)
});
var $4528a0b99e8f2c5b$var$defaultManagers = new Map();
var $4528a0b99e8f2c5b$var$getManager = function getManager(context, managerId) {
    // If `managers` map is present in the context, we use it in order to
    // let JssProvider reset them when new response has to render server-side.
    var managers = context.managers;
    if (managers) {
        if (!managers[managerId]) managers[managerId] = new (0, $cba9cac93def5758$export$c72bb5031d779271)();
        return managers[managerId];
    }
    var manager = $4528a0b99e8f2c5b$var$defaultManagers.get(managerId);
    if (!manager) {
        manager = new (0, $cba9cac93def5758$export$c72bb5031d779271)();
        $4528a0b99e8f2c5b$var$defaultManagers.set(managerId, manager);
    }
    return manager;
};
var $4528a0b99e8f2c5b$var$manageSheet = function manageSheet(options) {
    var sheet = options.sheet, context = options.context, index = options.index, theme = options.theme;
    if (!sheet) return;
    var manager = $4528a0b99e8f2c5b$var$getManager(context, index);
    manager.manage(theme);
    if (context.registry) context.registry.add(sheet);
};
var $4528a0b99e8f2c5b$var$unmanageSheet = function unmanageSheet(options) {
    if (!options.sheet) return;
    var manager = $4528a0b99e8f2c5b$var$getManager(options.context, options.index);
    manager.unmanage(options.theme);
};
var $4528a0b99e8f2c5b$export$da211f3899f3fa9c = (0, $cba9cac93def5758$export$185802fd694ee1f5)((0, $478fde94ad87c0c2$export$2e2bcd8739ae039)());
var $4528a0b99e8f2c5b$var$sheetsMeta = new WeakMap();
var $4528a0b99e8f2c5b$var$getMeta = function getMeta(sheet) {
    return $4528a0b99e8f2c5b$var$sheetsMeta.get(sheet);
};
var $4528a0b99e8f2c5b$var$addMeta = function addMeta(sheet, meta) {
    $4528a0b99e8f2c5b$var$sheetsMeta.set(sheet, meta);
};
var $4528a0b99e8f2c5b$var$getStyles = function getStyles(options) {
    var styles = options.styles;
    if (typeof styles !== "function") return styles;
    return styles(options.theme);
};
function $4528a0b99e8f2c5b$var$getSheetOptions(options, link) {
    var minify;
    if (options.context.id && options.context.id.minify != null) minify = options.context.id.minify;
    var classNamePrefix = options.context.classNamePrefix || "";
    if (options.name && !minify) classNamePrefix += options.name.replace(/\s/g, "-") + "-";
    var meta = "";
    if (options.name) meta = options.name + ", ";
    meta += typeof options.styles === "function" ? "Themed" : "Unthemed";
    return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, options.sheetOptions, {
        index: options.index,
        meta: meta,
        classNamePrefix: classNamePrefix,
        link: link,
        generateId: options.sheetOptions && options.sheetOptions.generateId ? options.sheetOptions.generateId : options.context.generateId
    });
}
var $4528a0b99e8f2c5b$var$createStyleSheet = function createStyleSheet(options) {
    if (options.context.disableStylesGeneration) return undefined;
    var manager = $4528a0b99e8f2c5b$var$getManager(options.context, options.index);
    var existingSheet = manager.get(options.theme);
    if (existingSheet) return existingSheet;
    var jss = options.context.jss || $4528a0b99e8f2c5b$export$da211f3899f3fa9c;
    var styles = $4528a0b99e8f2c5b$var$getStyles(options);
    var dynamicStyles = (0, $cba9cac93def5758$export$8558f2aefa046992)(styles);
    var sheet = jss.createStyleSheet(styles, $4528a0b99e8f2c5b$var$getSheetOptions(options, dynamicStyles !== null));
    $4528a0b99e8f2c5b$var$addMeta(sheet, {
        dynamicStyles: dynamicStyles,
        styles: styles
    });
    manager.add(options.theme, sheet);
    return sheet;
};
var $4528a0b99e8f2c5b$var$removeDynamicRules = function removeDynamicRules(sheet, rules) {
    // Loop over each dynamic rule and remove the dynamic rule
    // We can't just remove the whole sheet as this has all of the rules for every component instance
    for(var key in rules)sheet.deleteRule(rules[key]);
};
var $4528a0b99e8f2c5b$var$updateDynamicRules = function updateDynamicRules(data, sheet, rules) {
    // Loop over each dynamic rule and update it
    // We can't just update the whole sheet as this has all of the rules for every component instance
    for(var key in rules)sheet.updateOne(rules[key], data);
};
var $4528a0b99e8f2c5b$var$addDynamicRules = function addDynamicRules(sheet, data) {
    var meta = $4528a0b99e8f2c5b$var$getMeta(sheet);
    if (!meta) return undefined;
    var rules = {}; // Loop over each dynamic rule and add it to the stylesheet
    for(var key in meta.dynamicStyles){
        var initialRuleCount = sheet.rules.index.length;
        var originalRule = sheet.addRule(key, meta.dynamicStyles[key]); // Loop through all created rules, fixes updating dynamic rules
        for(var i = initialRuleCount; i < sheet.rules.index.length; i++){
            var rule = sheet.rules.index[i];
            sheet.updateOne(rule, data); // If it's the original rule, we need to add it by the correct key so the hook and hoc
            // can correctly concat the dynamic class with the static one
            rules[originalRule === rule ? key : rule.key] = rule;
        }
    }
    return rules;
};
var $4528a0b99e8f2c5b$var$getSheetClasses = function getSheetClasses(sheet, dynamicRules) {
    if (!dynamicRules) return sheet.classes;
    var meta = $4528a0b99e8f2c5b$var$getMeta(sheet);
    if (!meta) return sheet.classes;
    var classes = {};
    for(var key in meta.styles){
        classes[key] = sheet.classes[key];
        if (key in dynamicRules) classes[key] += " " + sheet.classes[dynamicRules[key].key];
    }
    return classes;
};
function $4528a0b99e8f2c5b$var$getUseInsertionEffect(isSSR) {
    return isSSR ? (0, $exYeM.useEffect) : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useInsertionEffect || // React 18+ (https://github.com/reactwg/react-18/discussions/110)
    (0, $exYeM.useLayoutEffect);
}
var $4528a0b99e8f2c5b$var$noTheme = {};
var $4528a0b99e8f2c5b$export$644d15e5a9a5f175 = function createUseStyles(styles, options) {
    if (options === void 0) options = {};
    var _options = options, _options$index = _options.index, index = _options$index === void 0 ? $4528a0b99e8f2c5b$var$getSheetIndex() : _options$index, theming = _options.theming, name = _options.name, sheetOptions = (0, $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039)(_options, [
        "index",
        "theming",
        "name"
    ]);
    var ThemeContext$1 = theming && theming.context || (0, $49d8224d32e74ea5$export$2c657da244d00bd6);
    var useTheme = function useTheme(theme) {
        if (typeof styles === "function") return theme || (0, $exYeM.useContext)(ThemeContext$1) || $4528a0b99e8f2c5b$var$noTheme;
        return $4528a0b99e8f2c5b$var$noTheme;
    };
    var emptyObject = {};
    return function useStyles(data) {
        var isFirstMount = (0, $exYeM.useRef)(true);
        var context = (0, $exYeM.useContext)($4528a0b99e8f2c5b$export$193e6193848b8f2a);
        var theme = useTheme(data && data.theme);
        var _useMemo = (0, $exYeM.useMemo)(function() {
            var newSheet = $4528a0b99e8f2c5b$var$createStyleSheet({
                context: context,
                styles: styles,
                name: name,
                theme: theme,
                index: index,
                sheetOptions: sheetOptions
            });
            if (newSheet && context.isSSR) // manage immediately during SSRs. browsers will manage the sheet through useInsertionEffect below
            $4528a0b99e8f2c5b$var$manageSheet({
                index: index,
                context: context,
                sheet: newSheet,
                theme: theme
            });
            return [
                newSheet,
                newSheet ? $4528a0b99e8f2c5b$var$addDynamicRules(newSheet, data) : null
            ];
        }, [
            context,
            theme
        ]), sheet = _useMemo[0], dynamicRules = _useMemo[1];
        $4528a0b99e8f2c5b$var$getUseInsertionEffect(context.isSSR)(function() {
            // We only need to update the rules on a subsequent update and not in the first mount
            if (sheet && dynamicRules && !isFirstMount.current) $4528a0b99e8f2c5b$var$updateDynamicRules(data, sheet, dynamicRules);
        }, [
            data
        ]);
        $4528a0b99e8f2c5b$var$getUseInsertionEffect(context.isSSR)(function() {
            if (sheet) $4528a0b99e8f2c5b$var$manageSheet({
                index: index,
                context: context,
                sheet: sheet,
                theme: theme
            });
            return function() {
                if (sheet) {
                    $4528a0b99e8f2c5b$var$unmanageSheet({
                        index: index,
                        context: context,
                        sheet: sheet,
                        theme: theme
                    }); // when sheet changes, remove related dynamic rules
                    if (dynamicRules) $4528a0b99e8f2c5b$var$removeDynamicRules(sheet, dynamicRules);
                }
            };
        }, [
            sheet
        ]);
        var classes = (0, $exYeM.useMemo)(function() {
            return sheet && dynamicRules ? $4528a0b99e8f2c5b$var$getSheetClasses(sheet, dynamicRules) : emptyObject;
        }, [
            sheet,
            dynamicRules
        ]);
        (0, $exYeM.useDebugValue)(classes);
        (0, $exYeM.useDebugValue)(theme === $4528a0b99e8f2c5b$var$noTheme ? "No theme" : theme);
        (0, $exYeM.useEffect)(function() {
            isFirstMount.current = false;
        });
        return classes;
    };
};
var $4528a0b99e8f2c5b$var$NoRenderer = function NoRenderer(props) {
    return props.children || null;
};
/**
 * HOC creator function that wrapps the user component.
 *
 * `withStyles(styles, [options])(Component)`
 */ var $4528a0b99e8f2c5b$export$99b4b78fb79d96b3 = function createWithStyles(styles, options) {
    if (options === void 0) options = {};
    var _options = options, _options$index = _options.index, index = _options$index === void 0 ? $4528a0b99e8f2c5b$var$getSheetIndex() : _options$index, theming = _options.theming, injectTheme = _options.injectTheme, sheetOptions = (0, $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039)(_options, [
        "index",
        "theming",
        "injectTheme"
    ]);
    var ThemeContext$1 = theming ? theming.context : (0, $49d8224d32e74ea5$export$2c657da244d00bd6);
    return function(InnerComponent) {
        if (InnerComponent === void 0) InnerComponent = $4528a0b99e8f2c5b$var$NoRenderer;
        var displayName = $4528a0b99e8f2c5b$var$getDisplayName(InnerComponent);
        var mergeClassesProp = $4528a0b99e8f2c5b$var$memoize(function(sheetClasses, classesProp) {
            return classesProp ? $4528a0b99e8f2c5b$var$mergeClasses(sheetClasses, classesProp) : sheetClasses;
        });
        var hookOptions = Object.assign(sheetOptions, {
            theming: theming,
            index: index,
            name: displayName
        });
        var useStyles = $4528a0b99e8f2c5b$export$644d15e5a9a5f175(styles, hookOptions);
        var WithStyles = (0, $exYeM.forwardRef)(function(props, ref) {
            var theme = (0, $exYeM.useContext)(ThemeContext$1);
            var newProps = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props);
            if (injectTheme && newProps.theme == null) newProps.theme = theme;
            var sheetClasses = useStyles(newProps);
            var classes = mergeClassesProp(sheetClasses, props.classes);
            return (0, $exYeM.createElement)(InnerComponent, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, newProps, {
                classes: classes,
                ref: ref
            }));
        });
        WithStyles.displayName = "WithStyles(" + displayName + ")";
        WithStyles.defaultProps = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, InnerComponent.defaultProps);
        WithStyles.InnerComponent = InnerComponent;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3e937fab5d08b2fc$exports)))(WithStyles, InnerComponent);
    };
};
var $4528a0b99e8f2c5b$var$initialContext = {};
function $4528a0b99e8f2c5b$export$5c4291a09aa0f577(props) {
    var managersRef = (0, $exYeM.useRef)({});
    var prevContextRef = (0, $exYeM.useRef)();
    var registryRef = (0, $exYeM.useRef)(null);
    var createContext = function createContext(parentContext, prevContext) {
        if (prevContext === void 0) prevContext = $4528a0b99e8f2c5b$var$initialContext;
        var registry = props.registry, classNamePrefix = props.classNamePrefix, jss = props.jss, generateId = props.generateId, disableStylesGeneration = props.disableStylesGeneration, media = props.media, id = props.id, isSSR = props.isSSR;
        var context = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, parentContext);
        if (registry) {
            context.registry = registry; // This way we identify a new request on the server, because user will create
            // a new Registry instance for each.
            if (registry !== registryRef.current) {
                // We reset managers because we have to regenerate all sheets for the new request.
                managersRef.current = {};
                registryRef.current = registry;
            }
        }
        context.managers = managersRef.current;
        if (id !== undefined) context.id = id;
        if (generateId !== undefined) context.generateId = generateId;
        else if (!context.generateId || !prevContext || context.id !== prevContext.id) context.generateId = (0, $cba9cac93def5758$export$ddff9cce7c732c82)(context.id);
        if (classNamePrefix) context.classNamePrefix = (context.classNamePrefix || "") + classNamePrefix;
        if (media !== undefined) context.media = media;
        if (jss) context.jss = jss;
        if (disableStylesGeneration !== undefined) context.disableStylesGeneration = disableStylesGeneration;
        if (isSSR !== undefined) context.isSSR = isSSR;
        if (prevContext && (0, $83e3783accc5ff33$export$3e67810a3f0e9f1c)(prevContext, context)) return prevContext;
        return context;
    };
    var renderProvider = function renderProvider(parentContext) {
        var children = props.children;
        var context = createContext(parentContext, prevContextRef.current);
        prevContextRef.current = context;
        return (0, $exYeM.createElement)($4528a0b99e8f2c5b$export$193e6193848b8f2a.Provider, {
            value: context
        }, children);
    };
    return (0, $exYeM.createElement)($4528a0b99e8f2c5b$export$193e6193848b8f2a.Consumer, null, renderProvider);
}
var $4528a0b99e8f2c5b$var$parseStyles = function parseStyles(args) {
    var dynamicStyles = [];
    var staticStyle;
    var labels = []; // Not using ...rest to optimize perf.
    for(var key in args){
        var style = args[key];
        if (!style) continue;
        if (typeof style === "function") dynamicStyles.push(style);
        else {
            if (!staticStyle) staticStyle = {};
            Object.assign(staticStyle, style);
            var _staticStyle = staticStyle, _label = _staticStyle.label;
            if (_label) {
                if (labels.indexOf(_label) === -1) labels.push(_label);
            }
        }
    }
    var styles = {};
    var label = labels.length === 0 ? "sc" : labels.join("-");
    if (staticStyle) {
        // Label should not leak to the core.
        if ("label" in staticStyle) delete staticStyle.label;
        styles[label] = staticStyle;
    } // When there is only one function rule, we don't need to wrap it.
    if (dynamicStyles.length === 1) styles.scd = dynamicStyles[0];
     // We create a new function rule which will call all other function rules
    // and merge the styles they return.
    if (dynamicStyles.length > 1) styles.scd = function(props) {
        var merged = {};
        for(var i = 0; i < dynamicStyles.length; i++){
            var dynamicStyle = dynamicStyles[i](props);
            if (dynamicStyle) Object.assign(merged, dynamicStyle);
        }
        return merged;
    };
    return {
        styles: styles,
        label: label
    };
};
var $4528a0b99e8f2c5b$var$shouldForwardPropSymbol = Symbol("react-jss-styled");
var $4528a0b99e8f2c5b$var$getShouldForwardProp = function getShouldForwardProp(tagOrComponent, options) {
    var shouldForwardProp = options.shouldForwardProp;
    var childShouldForwardProp = tagOrComponent[$4528a0b99e8f2c5b$var$shouldForwardPropSymbol];
    var finalShouldForwardProp = shouldForwardProp || childShouldForwardProp;
    if (shouldForwardProp && childShouldForwardProp) finalShouldForwardProp = function finalShouldForwardProp(prop) {
        return childShouldForwardProp(prop) && shouldForwardProp(prop);
    };
    return finalShouldForwardProp;
};
var $4528a0b99e8f2c5b$var$getChildProps = function getChildProps(props, shouldForwardProp, isTag) {
    var childProps = {};
    for(var prop in props){
        if (shouldForwardProp) {
            if (shouldForwardProp(prop) === true) childProps[prop] = props[prop];
            continue;
        } // We don't want to pass non-dom props to the DOM.
        if (isTag) {
            if ((0, $4108f1be9398bcb3$export$2e2bcd8739ae039)(prop)) childProps[prop] = props[prop];
            continue;
        }
        childProps[prop] = props[prop];
    }
    return childProps;
}; // eslint-disable-next-line no-unused-vars
var $4528a0b99e8f2c5b$export$3817b7a54a07cec7 = function configureStyled(tagOrComponent, options) {
    if (options === void 0) options = {};
    var _options = options, theming = _options.theming;
    var isTag = typeof tagOrComponent === "string";
    var ThemeContext$1 = theming ? theming.context : (0, $49d8224d32e74ea5$export$2c657da244d00bd6);
    var shouldForwardProp = $4528a0b99e8f2c5b$var$getShouldForwardProp(tagOrComponent, options);
    var _options2 = options, _ = _options2.shouldForwardProp, hookOptions = (0, $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039)(_options2, [
        "shouldForwardProp"
    ]);
    return function createStyledComponent() {
        // eslint-disable-next-line prefer-rest-params
        var _parseStyles = $4528a0b99e8f2c5b$var$parseStyles(arguments), styles = _parseStyles.styles, label = _parseStyles.label;
        var useStyles = $4528a0b99e8f2c5b$export$644d15e5a9a5f175(styles, hookOptions);
        var Styled = function Styled(props) {
            var as = props.as, className = props.className;
            var theme = (0, $exYeM.useContext)(ThemeContext$1);
            var propsWithTheme = Object.assign({
                theme: theme
            }, props);
            var classes = useStyles(propsWithTheme);
            var childProps = $4528a0b99e8f2c5b$var$getChildProps(props, shouldForwardProp, isTag);
            var classNames = ((classes[label] || classes.sc || "") + " " + (classes.scd || "")).trim();
            childProps.className = className ? className + " " + classNames : classNames;
            if (!isTag && shouldForwardProp) tagOrComponent[$4528a0b99e8f2c5b$var$shouldForwardPropSymbol] = shouldForwardProp;
            if (isTag && as) return (0, $exYeM.createElement)(as, childProps);
            return (0, $exYeM.createElement)(tagOrComponent, childProps);
        };
        return Styled;
    };
};
/* eslint-disable prefer-rest-params, prefer-spread */ var $4528a0b99e8f2c5b$export$e961a3d853e7ed35 = function create(css) {
    if (css === void 0) css = (0, $5f9f3bff4405f80f$export$2e2bcd8739ae039);
    return function createElement$1(type, props) {
        var args = arguments;
        if (props && props.css) {
            var className = css(props.css);
            var newProps = Object.assign({}, props);
            newProps.className = props.className ? props.className + " " + className : className;
            delete newProps.css;
            args[1] = newProps;
        }
        return (0, $exYeM.createElement).apply(undefined, args);
    };
};
var $4528a0b99e8f2c5b$export$34b9dba7ce09269b = $4528a0b99e8f2c5b$export$e961a3d853e7ed35();
var $4528a0b99e8f2c5b$export$2e2bcd8739ae039 = $4528a0b99e8f2c5b$export$99b4b78fb79d96b3;


var $69657479beae5299$exports = {};
var $0c68677767f4642e$exports = {};

var $8ThvE = parcelRequire("8ThvE");
var $e3b1273dfa4fd1c1$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $e3b1273dfa4fd1c1$var$toInteger(value) {
    var result = $5a6bac89763f60ef$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$e3b1273dfa4fd1c1$exports = $e3b1273dfa4fd1c1$var$toInteger;



var $22f1dff9b3c6ff0c$exports = {};
var $c59f41c766f8804e$exports = {};

var $c0d7b47ee8b12bf1$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $c0d7b47ee8b12bf1$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$c0d7b47ee8b12bf1$exports = $c0d7b47ee8b12bf1$var$arrayMap;


var $8cb3ae215df00a00$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $8cb3ae215df00a00$var$isArray = Array.isArray;
$8cb3ae215df00a00$exports = $8cb3ae215df00a00$var$isArray;



/** Used as references for various `Number` constants. */ var $c59f41c766f8804e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $c59f41c766f8804e$var$symbolProto = $a090581360ce8173$exports ? $a090581360ce8173$exports.prototype : undefined, $c59f41c766f8804e$var$symbolToString = $c59f41c766f8804e$var$symbolProto ? $c59f41c766f8804e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $c59f41c766f8804e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($8cb3ae215df00a00$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $c0d7b47ee8b12bf1$exports(value, $c59f41c766f8804e$var$baseToString) + "";
    if ($b7350b23d035986b$exports(value)) return $c59f41c766f8804e$var$symbolToString ? $c59f41c766f8804e$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$c59f41c766f8804e$var$INFINITY ? "-0" : result;
}
$c59f41c766f8804e$exports = $c59f41c766f8804e$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $22f1dff9b3c6ff0c$var$toString(value) {
    return value == null ? "" : $c59f41c766f8804e$exports(value);
}
$22f1dff9b3c6ff0c$exports = $22f1dff9b3c6ff0c$var$toString;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0c68677767f4642e$var$nativeIsFinite = $8ThvE.isFinite, $0c68677767f4642e$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $0c68677767f4642e$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $e588870a06e690e1$exports(number);
        precision = precision == null ? 0 : $0c68677767f4642e$var$nativeMin($e3b1273dfa4fd1c1$exports(precision), 292);
        if (precision && $0c68677767f4642e$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($22f1dff9b3c6ff0c$exports(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = ($22f1dff9b3c6ff0c$exports(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
        }
        return func(number);
    };
}
$0c68677767f4642e$exports = $0c68677767f4642e$var$createRound;


/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */ var $69657479beae5299$var$round = $0c68677767f4642e$exports("round");
$69657479beae5299$exports = $69657479beae5299$var$round;


var $cd9547e820692bcd$exports = {};
var $6219f680e6e19178$exports = {};
var $bfbd466526f8d698$exports = {};
var $8bfbce7e35b86105$exports = {};
var $9655ef897f0bbdba$exports = {};
var $ed640afc4605eeaf$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $ed640afc4605eeaf$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$ed640afc4605eeaf$exports = $ed640afc4605eeaf$var$listCacheClear;


var $8dacab0aad959c1a$exports = {};
var $a5c18ae4f7c751db$exports = {};

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a5c18ae4f7c751db$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6f80be9883321bbe$exports(array[length][0], key)) return length;
    }
    return -1;
}
$a5c18ae4f7c751db$exports = $a5c18ae4f7c751db$var$assocIndexOf;


/** Used for built-in method references. */ var $8dacab0aad959c1a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8dacab0aad959c1a$var$splice = $8dacab0aad959c1a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8dacab0aad959c1a$var$listCacheDelete(key) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8dacab0aad959c1a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$8dacab0aad959c1a$exports = $8dacab0aad959c1a$var$listCacheDelete;


var $822f7d857aa2dcb8$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $822f7d857aa2dcb8$var$listCacheGet(key) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$822f7d857aa2dcb8$exports = $822f7d857aa2dcb8$var$listCacheGet;


var $5edb34374c74a495$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5edb34374c74a495$var$listCacheHas(key) {
    return $a5c18ae4f7c751db$exports(this.__data__, key) > -1;
}
$5edb34374c74a495$exports = $5edb34374c74a495$var$listCacheHas;


var $315b693937a70245$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $315b693937a70245$var$listCacheSet(key, value) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$315b693937a70245$exports = $315b693937a70245$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9655ef897f0bbdba$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$9655ef897f0bbdba$var$ListCache.prototype.clear = $ed640afc4605eeaf$exports;
$9655ef897f0bbdba$var$ListCache.prototype["delete"] = $8dacab0aad959c1a$exports;
$9655ef897f0bbdba$var$ListCache.prototype.get = $822f7d857aa2dcb8$exports;
$9655ef897f0bbdba$var$ListCache.prototype.has = $5edb34374c74a495$exports;
$9655ef897f0bbdba$var$ListCache.prototype.set = $315b693937a70245$exports;
$9655ef897f0bbdba$exports = $9655ef897f0bbdba$var$ListCache;


var $f4765b9de3cd25a2$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f4765b9de3cd25a2$var$stackClear() {
    this.__data__ = new $9655ef897f0bbdba$exports;
    this.size = 0;
}
$f4765b9de3cd25a2$exports = $f4765b9de3cd25a2$var$stackClear;


var $4e48da7de9bc0080$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4e48da7de9bc0080$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$4e48da7de9bc0080$exports = $4e48da7de9bc0080$var$stackDelete;


var $21c09588dffa6b32$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $21c09588dffa6b32$var$stackGet(key) {
    return this.__data__.get(key);
}
$21c09588dffa6b32$exports = $21c09588dffa6b32$var$stackGet;


var $2739006159eb7a0c$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2739006159eb7a0c$var$stackHas(key) {
    return this.__data__.has(key);
}
$2739006159eb7a0c$exports = $2739006159eb7a0c$var$stackHas;


var $0ab5431b23eb293c$exports = {};

var $1b8f1205e4056240$exports = {};
var $97e6c72a80d118d2$exports = {};
var $105e649bd3deec51$exports = {};

var $989d09d10c86a3af$exports = {};
var $69576d09d95c0935$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Used to detect overreaching core-js shims. */ var $69576d09d95c0935$var$coreJsData = $8ThvE["__core-js_shared__"];
$69576d09d95c0935$exports = $69576d09d95c0935$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $989d09d10c86a3af$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($69576d09d95c0935$exports && $69576d09d95c0935$exports.keys && $69576d09d95c0935$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $989d09d10c86a3af$var$isMasked(func) {
    return !!$989d09d10c86a3af$var$maskSrcKey && $989d09d10c86a3af$var$maskSrcKey in func;
}
$989d09d10c86a3af$exports = $989d09d10c86a3af$var$isMasked;



var $3d1b4ae41857d3b0$exports = {};
/** Used for built-in method references. */ var $3d1b4ae41857d3b0$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3d1b4ae41857d3b0$var$funcToString = $3d1b4ae41857d3b0$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3d1b4ae41857d3b0$var$toSource(func) {
    if (func != null) {
        try {
            return $3d1b4ae41857d3b0$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$3d1b4ae41857d3b0$exports = $3d1b4ae41857d3b0$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $105e649bd3deec51$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $105e649bd3deec51$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $105e649bd3deec51$var$funcProto = Function.prototype, $105e649bd3deec51$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $105e649bd3deec51$var$funcToString = $105e649bd3deec51$var$funcProto.toString;
/** Used to check objects for own properties. */ var $105e649bd3deec51$var$hasOwnProperty = $105e649bd3deec51$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $105e649bd3deec51$var$reIsNative = RegExp("^" + $105e649bd3deec51$var$funcToString.call($105e649bd3deec51$var$hasOwnProperty).replace($105e649bd3deec51$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $105e649bd3deec51$var$baseIsNative(value) {
    if (!$db5dfd0661742a1a$exports(value) || $989d09d10c86a3af$exports(value)) return false;
    var pattern = $63bef038e059393f$exports(value) ? $105e649bd3deec51$var$reIsNative : $105e649bd3deec51$var$reIsHostCtor;
    return pattern.test($3d1b4ae41857d3b0$exports(value));
}
$105e649bd3deec51$exports = $105e649bd3deec51$var$baseIsNative;


var $5c63d0177b86ffa5$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $5c63d0177b86ffa5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$5c63d0177b86ffa5$exports = $5c63d0177b86ffa5$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $97e6c72a80d118d2$var$getNative(object, key) {
    var value = $5c63d0177b86ffa5$exports(object, key);
    return $105e649bd3deec51$exports(value) ? value : undefined;
}
$97e6c72a80d118d2$exports = $97e6c72a80d118d2$var$getNative;



var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $1b8f1205e4056240$var$Map = $97e6c72a80d118d2$exports($8ThvE, "Map");
$1b8f1205e4056240$exports = $1b8f1205e4056240$var$Map;


var $f6389c21d76f2f82$exports = {};
var $b06f33fda863a736$exports = {};
var $1e733182a9700f13$exports = {};
var $8fe1870119bc2ce4$exports = {};
var $1a89124de4ced368$exports = {};

/* Built-in method references that are verified to be native. */ var $1a89124de4ced368$var$nativeCreate = $97e6c72a80d118d2$exports(Object, "create");
$1a89124de4ced368$exports = $1a89124de4ced368$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $8fe1870119bc2ce4$var$hashClear() {
    this.__data__ = $1a89124de4ced368$exports ? $1a89124de4ced368$exports(null) : {};
    this.size = 0;
}
$8fe1870119bc2ce4$exports = $8fe1870119bc2ce4$var$hashClear;


var $7b046508d0c4b2bb$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7b046508d0c4b2bb$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$7b046508d0c4b2bb$exports = $7b046508d0c4b2bb$var$hashDelete;


var $570123ba6240e679$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $570123ba6240e679$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $570123ba6240e679$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $570123ba6240e679$var$hasOwnProperty = $570123ba6240e679$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $570123ba6240e679$var$hashGet(key) {
    var data = this.__data__;
    if ($1a89124de4ced368$exports) {
        var result = data[key];
        return result === $570123ba6240e679$var$HASH_UNDEFINED ? undefined : result;
    }
    return $570123ba6240e679$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$570123ba6240e679$exports = $570123ba6240e679$var$hashGet;


var $75e6b0027cb55f48$exports = {};

/** Used for built-in method references. */ var $75e6b0027cb55f48$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75e6b0027cb55f48$var$hasOwnProperty = $75e6b0027cb55f48$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $75e6b0027cb55f48$var$hashHas(key) {
    var data = this.__data__;
    return $1a89124de4ced368$exports ? data[key] !== undefined : $75e6b0027cb55f48$var$hasOwnProperty.call(data, key);
}
$75e6b0027cb55f48$exports = $75e6b0027cb55f48$var$hashHas;


var $315cb19b5f7dc6c3$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $315cb19b5f7dc6c3$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $315cb19b5f7dc6c3$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $1a89124de4ced368$exports && value === undefined ? $315cb19b5f7dc6c3$var$HASH_UNDEFINED : value;
    return this;
}
$315cb19b5f7dc6c3$exports = $315cb19b5f7dc6c3$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1e733182a9700f13$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$1e733182a9700f13$var$Hash.prototype.clear = $8fe1870119bc2ce4$exports;
$1e733182a9700f13$var$Hash.prototype["delete"] = $7b046508d0c4b2bb$exports;
$1e733182a9700f13$var$Hash.prototype.get = $570123ba6240e679$exports;
$1e733182a9700f13$var$Hash.prototype.has = $75e6b0027cb55f48$exports;
$1e733182a9700f13$var$Hash.prototype.set = $315cb19b5f7dc6c3$exports;
$1e733182a9700f13$exports = $1e733182a9700f13$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b06f33fda863a736$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $1e733182a9700f13$exports,
        "map": new ($1b8f1205e4056240$exports || $9655ef897f0bbdba$exports),
        "string": new $1e733182a9700f13$exports
    };
}
$b06f33fda863a736$exports = $b06f33fda863a736$var$mapCacheClear;


var $5f4eea80c864f4a3$exports = {};
var $ee96f1b7eaa44ac5$exports = {};
var $3bd39081531a18a3$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $3bd39081531a18a3$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$3bd39081531a18a3$exports = $3bd39081531a18a3$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ee96f1b7eaa44ac5$var$getMapData(map, key) {
    var data = map.__data__;
    return $3bd39081531a18a3$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$ee96f1b7eaa44ac5$exports = $ee96f1b7eaa44ac5$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5f4eea80c864f4a3$var$mapCacheDelete(key) {
    var result = $ee96f1b7eaa44ac5$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$5f4eea80c864f4a3$exports = $5f4eea80c864f4a3$var$mapCacheDelete;


var $54d2d6191fb8ab24$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $54d2d6191fb8ab24$var$mapCacheGet(key) {
    return $ee96f1b7eaa44ac5$exports(this, key).get(key);
}
$54d2d6191fb8ab24$exports = $54d2d6191fb8ab24$var$mapCacheGet;


var $e8338a2a89515313$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8338a2a89515313$var$mapCacheHas(key) {
    return $ee96f1b7eaa44ac5$exports(this, key).has(key);
}
$e8338a2a89515313$exports = $e8338a2a89515313$var$mapCacheHas;


var $26a7fc4b70d5469b$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $26a7fc4b70d5469b$var$mapCacheSet(key, value) {
    var data = $ee96f1b7eaa44ac5$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$26a7fc4b70d5469b$exports = $26a7fc4b70d5469b$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f6389c21d76f2f82$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$f6389c21d76f2f82$var$MapCache.prototype.clear = $b06f33fda863a736$exports;
$f6389c21d76f2f82$var$MapCache.prototype["delete"] = $5f4eea80c864f4a3$exports;
$f6389c21d76f2f82$var$MapCache.prototype.get = $54d2d6191fb8ab24$exports;
$f6389c21d76f2f82$var$MapCache.prototype.has = $e8338a2a89515313$exports;
$f6389c21d76f2f82$var$MapCache.prototype.set = $26a7fc4b70d5469b$exports;
$f6389c21d76f2f82$exports = $f6389c21d76f2f82$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $0ab5431b23eb293c$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $0ab5431b23eb293c$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $9655ef897f0bbdba$exports) {
        var pairs = data.__data__;
        if (!$1b8f1205e4056240$exports || pairs.length < $0ab5431b23eb293c$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $f6389c21d76f2f82$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$0ab5431b23eb293c$exports = $0ab5431b23eb293c$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8bfbce7e35b86105$var$Stack(entries) {
    var data = this.__data__ = new $9655ef897f0bbdba$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8bfbce7e35b86105$var$Stack.prototype.clear = $f4765b9de3cd25a2$exports;
$8bfbce7e35b86105$var$Stack.prototype["delete"] = $4e48da7de9bc0080$exports;
$8bfbce7e35b86105$var$Stack.prototype.get = $21c09588dffa6b32$exports;
$8bfbce7e35b86105$var$Stack.prototype.has = $2739006159eb7a0c$exports;
$8bfbce7e35b86105$var$Stack.prototype.set = $0ab5431b23eb293c$exports;
$8bfbce7e35b86105$exports = $8bfbce7e35b86105$var$Stack;


var $d78075cec53d5845$exports = {};
var $32da07863e46acec$exports = {};

var $868090bb248ca2fc$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $868090bb248ca2fc$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $868090bb248ca2fc$var$setCacheAdd(value) {
    this.__data__.set(value, $868090bb248ca2fc$var$HASH_UNDEFINED);
    return this;
}
$868090bb248ca2fc$exports = $868090bb248ca2fc$var$setCacheAdd;


var $ba2e6a93841338dc$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $ba2e6a93841338dc$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$ba2e6a93841338dc$exports = $ba2e6a93841338dc$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $32da07863e46acec$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $f6389c21d76f2f82$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$32da07863e46acec$var$SetCache.prototype.add = $32da07863e46acec$var$SetCache.prototype.push = $868090bb248ca2fc$exports;
$32da07863e46acec$var$SetCache.prototype.has = $ba2e6a93841338dc$exports;
$32da07863e46acec$exports = $32da07863e46acec$var$SetCache;


var $71c492a50c15e5ea$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $71c492a50c15e5ea$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$71c492a50c15e5ea$exports = $71c492a50c15e5ea$var$arraySome;


var $c0081f1c22a5c7b6$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c0081f1c22a5c7b6$var$cacheHas(cache, key) {
    return cache.has(key);
}
$c0081f1c22a5c7b6$exports = $c0081f1c22a5c7b6$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $d78075cec53d5845$var$COMPARE_PARTIAL_FLAG = 1, $d78075cec53d5845$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $d78075cec53d5845$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d78075cec53d5845$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $d78075cec53d5845$var$COMPARE_UNORDERED_FLAG ? new $32da07863e46acec$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$71c492a50c15e5ea$exports(other, function(othValue, othIndex) {
                if (!$c0081f1c22a5c7b6$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$d78075cec53d5845$exports = $d78075cec53d5845$var$equalArrays;


var $a632bfd5cacb9484$exports = {};

var $ddf8457b0c355418$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Built-in value references. */ var $ddf8457b0c355418$var$Uint8Array = $8ThvE.Uint8Array;
$ddf8457b0c355418$exports = $ddf8457b0c355418$var$Uint8Array;




var $65965bd4fe27ade2$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $65965bd4fe27ade2$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$65965bd4fe27ade2$exports = $65965bd4fe27ade2$var$mapToArray;


var $eee7f5e5109334c4$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $eee7f5e5109334c4$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$eee7f5e5109334c4$exports = $eee7f5e5109334c4$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $a632bfd5cacb9484$var$COMPARE_PARTIAL_FLAG = 1, $a632bfd5cacb9484$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $a632bfd5cacb9484$var$boolTag = "[object Boolean]", $a632bfd5cacb9484$var$dateTag = "[object Date]", $a632bfd5cacb9484$var$errorTag = "[object Error]", $a632bfd5cacb9484$var$mapTag = "[object Map]", $a632bfd5cacb9484$var$numberTag = "[object Number]", $a632bfd5cacb9484$var$regexpTag = "[object RegExp]", $a632bfd5cacb9484$var$setTag = "[object Set]", $a632bfd5cacb9484$var$stringTag = "[object String]", $a632bfd5cacb9484$var$symbolTag = "[object Symbol]";
var $a632bfd5cacb9484$var$arrayBufferTag = "[object ArrayBuffer]", $a632bfd5cacb9484$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $a632bfd5cacb9484$var$symbolProto = $a090581360ce8173$exports ? $a090581360ce8173$exports.prototype : undefined, $a632bfd5cacb9484$var$symbolValueOf = $a632bfd5cacb9484$var$symbolProto ? $a632bfd5cacb9484$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a632bfd5cacb9484$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $a632bfd5cacb9484$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $a632bfd5cacb9484$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $ddf8457b0c355418$exports(object), new $ddf8457b0c355418$exports(other))) return false;
            return true;
        case $a632bfd5cacb9484$var$boolTag:
        case $a632bfd5cacb9484$var$dateTag:
        case $a632bfd5cacb9484$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6f80be9883321bbe$exports(+object, +other);
        case $a632bfd5cacb9484$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $a632bfd5cacb9484$var$regexpTag:
        case $a632bfd5cacb9484$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $a632bfd5cacb9484$var$mapTag:
            var convert = $65965bd4fe27ade2$exports;
        case $a632bfd5cacb9484$var$setTag:
            var isPartial = bitmask & $a632bfd5cacb9484$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $eee7f5e5109334c4$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $a632bfd5cacb9484$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $d78075cec53d5845$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $a632bfd5cacb9484$var$symbolTag:
            if ($a632bfd5cacb9484$var$symbolValueOf) return $a632bfd5cacb9484$var$symbolValueOf.call(object) == $a632bfd5cacb9484$var$symbolValueOf.call(other);
    }
    return false;
}
$a632bfd5cacb9484$exports = $a632bfd5cacb9484$var$equalByTag;


var $b4663e3cbde1ff22$exports = {};
var $860bb4b6843d7563$exports = {};
var $9d3e3231281d182b$exports = {};
var $3fc9dba05ba16d53$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3fc9dba05ba16d53$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$3fc9dba05ba16d53$exports = $3fc9dba05ba16d53$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9d3e3231281d182b$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $8cb3ae215df00a00$exports(object) ? result : $3fc9dba05ba16d53$exports(result, symbolsFunc(object));
}
$9d3e3231281d182b$exports = $9d3e3231281d182b$var$baseGetAllKeys;


var $0eabf8f27c57cf11$exports = {};
var $68bbccdd4a21a80e$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $68bbccdd4a21a80e$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$68bbccdd4a21a80e$exports = $68bbccdd4a21a80e$var$arrayFilter;


var $11b31dfc90d4eeeb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $11b31dfc90d4eeeb$var$stubArray() {
    return [];
}
$11b31dfc90d4eeeb$exports = $11b31dfc90d4eeeb$var$stubArray;


/** Used for built-in method references. */ var $0eabf8f27c57cf11$var$objectProto = Object.prototype;
/** Built-in value references. */ var $0eabf8f27c57cf11$var$propertyIsEnumerable = $0eabf8f27c57cf11$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0eabf8f27c57cf11$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $0eabf8f27c57cf11$var$getSymbols = !$0eabf8f27c57cf11$var$nativeGetSymbols ? $11b31dfc90d4eeeb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $68bbccdd4a21a80e$exports($0eabf8f27c57cf11$var$nativeGetSymbols(object), function(symbol) {
        return $0eabf8f27c57cf11$var$propertyIsEnumerable.call(object, symbol);
    });
};
$0eabf8f27c57cf11$exports = $0eabf8f27c57cf11$var$getSymbols;


var $b104760b34d6b7b1$exports = {};
var $1a01a48c6e6e7ac2$exports = {};
var $29cd5707c05bf6b8$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $29cd5707c05bf6b8$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$29cd5707c05bf6b8$exports = $29cd5707c05bf6b8$var$baseTimes;


var $c09020d853f4dd56$exports = {};
var $673e072344569ebe$exports = {};


/** `Object#toString` result references. */ var $673e072344569ebe$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $673e072344569ebe$var$baseIsArguments(value) {
    return $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $673e072344569ebe$var$argsTag;
}
$673e072344569ebe$exports = $673e072344569ebe$var$baseIsArguments;



/** Used for built-in method references. */ var $c09020d853f4dd56$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c09020d853f4dd56$var$hasOwnProperty = $c09020d853f4dd56$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $c09020d853f4dd56$var$propertyIsEnumerable = $c09020d853f4dd56$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $c09020d853f4dd56$var$isArguments = $673e072344569ebe$exports(function() {
    return arguments;
}()) ? $673e072344569ebe$exports : function(value) {
    return $5475ba594a8bdf91$exports(value) && $c09020d853f4dd56$var$hasOwnProperty.call(value, "callee") && !$c09020d853f4dd56$var$propertyIsEnumerable.call(value, "callee");
};
$c09020d853f4dd56$exports = $c09020d853f4dd56$var$isArguments;




var $7HKs8 = parcelRequire("7HKs8");

var $32e7db2a0777bb6d$exports = {};
var $404e7686b4834cf1$exports = {};



/** `Object#toString` result references. */ var $404e7686b4834cf1$var$argsTag = "[object Arguments]", $404e7686b4834cf1$var$arrayTag = "[object Array]", $404e7686b4834cf1$var$boolTag = "[object Boolean]", $404e7686b4834cf1$var$dateTag = "[object Date]", $404e7686b4834cf1$var$errorTag = "[object Error]", $404e7686b4834cf1$var$funcTag = "[object Function]", $404e7686b4834cf1$var$mapTag = "[object Map]", $404e7686b4834cf1$var$numberTag = "[object Number]", $404e7686b4834cf1$var$objectTag = "[object Object]", $404e7686b4834cf1$var$regexpTag = "[object RegExp]", $404e7686b4834cf1$var$setTag = "[object Set]", $404e7686b4834cf1$var$stringTag = "[object String]", $404e7686b4834cf1$var$weakMapTag = "[object WeakMap]";
var $404e7686b4834cf1$var$arrayBufferTag = "[object ArrayBuffer]", $404e7686b4834cf1$var$dataViewTag = "[object DataView]", $404e7686b4834cf1$var$float32Tag = "[object Float32Array]", $404e7686b4834cf1$var$float64Tag = "[object Float64Array]", $404e7686b4834cf1$var$int8Tag = "[object Int8Array]", $404e7686b4834cf1$var$int16Tag = "[object Int16Array]", $404e7686b4834cf1$var$int32Tag = "[object Int32Array]", $404e7686b4834cf1$var$uint8Tag = "[object Uint8Array]", $404e7686b4834cf1$var$uint8ClampedTag = "[object Uint8ClampedArray]", $404e7686b4834cf1$var$uint16Tag = "[object Uint16Array]", $404e7686b4834cf1$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $404e7686b4834cf1$var$typedArrayTags = {};
$404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$float32Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$float64Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int8Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int16Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int32Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint8Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint8ClampedTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint16Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint32Tag] = true;
$404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$argsTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$arrayTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$arrayBufferTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$boolTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$dataViewTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$dateTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$errorTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$funcTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$mapTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$numberTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$objectTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$regexpTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$setTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$stringTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $404e7686b4834cf1$var$baseIsTypedArray(value) {
    return $5475ba594a8bdf91$exports(value) && $9ad3d04370aa37c9$exports(value.length) && !!$404e7686b4834cf1$var$typedArrayTags[$852d1f971b259156$exports(value)];
}
$404e7686b4834cf1$exports = $404e7686b4834cf1$var$baseIsTypedArray;


var $a37b20fb7156577b$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a37b20fb7156577b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$a37b20fb7156577b$exports = $a37b20fb7156577b$var$baseUnary;



var $7vc1R = parcelRequire("7vc1R");
/* Node.js helper references. */ var $32e7db2a0777bb6d$var$nodeIsTypedArray = $7vc1R && $7vc1R.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $32e7db2a0777bb6d$var$isTypedArray = $32e7db2a0777bb6d$var$nodeIsTypedArray ? $a37b20fb7156577b$exports($32e7db2a0777bb6d$var$nodeIsTypedArray) : $404e7686b4834cf1$exports;
$32e7db2a0777bb6d$exports = $32e7db2a0777bb6d$var$isTypedArray;


/** Used for built-in method references. */ var $1a01a48c6e6e7ac2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1a01a48c6e6e7ac2$var$hasOwnProperty = $1a01a48c6e6e7ac2$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1a01a48c6e6e7ac2$var$arrayLikeKeys(value, inherited) {
    var isArr = $8cb3ae215df00a00$exports(value), isArg = !isArr && $c09020d853f4dd56$exports(value), isBuff = !isArr && !isArg && $7HKs8(value), isType = !isArr && !isArg && !isBuff && $32e7db2a0777bb6d$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $29cd5707c05bf6b8$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1a01a48c6e6e7ac2$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $1a5c8861aefb5e25$exports(key, length)))) result.push(key);
    return result;
}
$1a01a48c6e6e7ac2$exports = $1a01a48c6e6e7ac2$var$arrayLikeKeys;


var $eb634362e8bab00b$exports = {};
var $9fb63971f28e98ce$exports = {};
/** Used for built-in method references. */ var $9fb63971f28e98ce$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $9fb63971f28e98ce$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $9fb63971f28e98ce$var$objectProto;
    return value === proto;
}
$9fb63971f28e98ce$exports = $9fb63971f28e98ce$var$isPrototype;


var $d1eeca103b9aa761$exports = {};
var $10bd1c09b9f64069$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $10bd1c09b9f64069$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$10bd1c09b9f64069$exports = $10bd1c09b9f64069$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $d1eeca103b9aa761$var$nativeKeys = $10bd1c09b9f64069$exports(Object.keys, Object);
$d1eeca103b9aa761$exports = $d1eeca103b9aa761$var$nativeKeys;


/** Used for built-in method references. */ var $eb634362e8bab00b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eb634362e8bab00b$var$hasOwnProperty = $eb634362e8bab00b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $eb634362e8bab00b$var$baseKeys(object) {
    if (!$9fb63971f28e98ce$exports(object)) return $d1eeca103b9aa761$exports(object);
    var result = [];
    for(var key in Object(object))if ($eb634362e8bab00b$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$eb634362e8bab00b$exports = $eb634362e8bab00b$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $b104760b34d6b7b1$var$keys(object) {
    return $887f7dd95a2dee62$exports(object) ? $1a01a48c6e6e7ac2$exports(object) : $eb634362e8bab00b$exports(object);
}
$b104760b34d6b7b1$exports = $b104760b34d6b7b1$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $860bb4b6843d7563$var$getAllKeys(object) {
    return $9d3e3231281d182b$exports(object, $b104760b34d6b7b1$exports, $0eabf8f27c57cf11$exports);
}
$860bb4b6843d7563$exports = $860bb4b6843d7563$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $b4663e3cbde1ff22$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $b4663e3cbde1ff22$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b4663e3cbde1ff22$var$hasOwnProperty = $b4663e3cbde1ff22$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b4663e3cbde1ff22$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b4663e3cbde1ff22$var$COMPARE_PARTIAL_FLAG, objProps = $860bb4b6843d7563$exports(object), objLength = objProps.length, othProps = $860bb4b6843d7563$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $b4663e3cbde1ff22$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$b4663e3cbde1ff22$exports = $b4663e3cbde1ff22$var$equalObjects;


var $e16b2168665de4fd$exports = {};
var $17dcac0166b81916$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $17dcac0166b81916$var$DataView = $97e6c72a80d118d2$exports($8ThvE, "DataView");
$17dcac0166b81916$exports = $17dcac0166b81916$var$DataView;



var $94f6808d7ce0e1fd$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $94f6808d7ce0e1fd$var$Promise = $97e6c72a80d118d2$exports($8ThvE, "Promise");
$94f6808d7ce0e1fd$exports = $94f6808d7ce0e1fd$var$Promise;


var $1a2f39184944fa46$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $1a2f39184944fa46$var$Set = $97e6c72a80d118d2$exports($8ThvE, "Set");
$1a2f39184944fa46$exports = $1a2f39184944fa46$var$Set;


var $7138f8441ce5e43e$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $7138f8441ce5e43e$var$WeakMap = $97e6c72a80d118d2$exports($8ThvE, "WeakMap");
$7138f8441ce5e43e$exports = $7138f8441ce5e43e$var$WeakMap;




/** `Object#toString` result references. */ var $e16b2168665de4fd$var$mapTag = "[object Map]", $e16b2168665de4fd$var$objectTag = "[object Object]", $e16b2168665de4fd$var$promiseTag = "[object Promise]", $e16b2168665de4fd$var$setTag = "[object Set]", $e16b2168665de4fd$var$weakMapTag = "[object WeakMap]";
var $e16b2168665de4fd$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $e16b2168665de4fd$var$dataViewCtorString = $3d1b4ae41857d3b0$exports($17dcac0166b81916$exports), $e16b2168665de4fd$var$mapCtorString = $3d1b4ae41857d3b0$exports($1b8f1205e4056240$exports), $e16b2168665de4fd$var$promiseCtorString = $3d1b4ae41857d3b0$exports($94f6808d7ce0e1fd$exports), $e16b2168665de4fd$var$setCtorString = $3d1b4ae41857d3b0$exports($1a2f39184944fa46$exports), $e16b2168665de4fd$var$weakMapCtorString = $3d1b4ae41857d3b0$exports($7138f8441ce5e43e$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $e16b2168665de4fd$var$getTag = $852d1f971b259156$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($17dcac0166b81916$exports && $e16b2168665de4fd$var$getTag(new $17dcac0166b81916$exports(new ArrayBuffer(1))) != $e16b2168665de4fd$var$dataViewTag || $1b8f1205e4056240$exports && $e16b2168665de4fd$var$getTag(new $1b8f1205e4056240$exports) != $e16b2168665de4fd$var$mapTag || $94f6808d7ce0e1fd$exports && $e16b2168665de4fd$var$getTag($94f6808d7ce0e1fd$exports.resolve()) != $e16b2168665de4fd$var$promiseTag || $1a2f39184944fa46$exports && $e16b2168665de4fd$var$getTag(new $1a2f39184944fa46$exports) != $e16b2168665de4fd$var$setTag || $7138f8441ce5e43e$exports && $e16b2168665de4fd$var$getTag(new $7138f8441ce5e43e$exports) != $e16b2168665de4fd$var$weakMapTag) $e16b2168665de4fd$var$getTag = function(value) {
    var result = $852d1f971b259156$exports(value), Ctor = result == $e16b2168665de4fd$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $3d1b4ae41857d3b0$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $e16b2168665de4fd$var$dataViewCtorString:
            return $e16b2168665de4fd$var$dataViewTag;
        case $e16b2168665de4fd$var$mapCtorString:
            return $e16b2168665de4fd$var$mapTag;
        case $e16b2168665de4fd$var$promiseCtorString:
            return $e16b2168665de4fd$var$promiseTag;
        case $e16b2168665de4fd$var$setCtorString:
            return $e16b2168665de4fd$var$setTag;
        case $e16b2168665de4fd$var$weakMapCtorString:
            return $e16b2168665de4fd$var$weakMapTag;
    }
    return result;
};
$e16b2168665de4fd$exports = $e16b2168665de4fd$var$getTag;




var $7HKs8 = parcelRequire("7HKs8");

/** Used to compose bitmasks for value comparisons. */ var $bfbd466526f8d698$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $bfbd466526f8d698$var$argsTag = "[object Arguments]", $bfbd466526f8d698$var$arrayTag = "[object Array]", $bfbd466526f8d698$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $bfbd466526f8d698$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bfbd466526f8d698$var$hasOwnProperty = $bfbd466526f8d698$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bfbd466526f8d698$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $8cb3ae215df00a00$exports(object), othIsArr = $8cb3ae215df00a00$exports(other), objTag = objIsArr ? $bfbd466526f8d698$var$arrayTag : $e16b2168665de4fd$exports(object), othTag = othIsArr ? $bfbd466526f8d698$var$arrayTag : $e16b2168665de4fd$exports(other);
    objTag = objTag == $bfbd466526f8d698$var$argsTag ? $bfbd466526f8d698$var$objectTag : objTag;
    othTag = othTag == $bfbd466526f8d698$var$argsTag ? $bfbd466526f8d698$var$objectTag : othTag;
    var objIsObj = objTag == $bfbd466526f8d698$var$objectTag, othIsObj = othTag == $bfbd466526f8d698$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $7HKs8(object)) {
        if (!$7HKs8(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $8bfbce7e35b86105$exports);
        return objIsArr || $32e7db2a0777bb6d$exports(object) ? $d78075cec53d5845$exports(object, other, bitmask, customizer, equalFunc, stack) : $a632bfd5cacb9484$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $bfbd466526f8d698$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $bfbd466526f8d698$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $bfbd466526f8d698$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $8bfbce7e35b86105$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $8bfbce7e35b86105$exports);
    return $b4663e3cbde1ff22$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$bfbd466526f8d698$exports = $bfbd466526f8d698$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $6219f680e6e19178$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$5475ba594a8bdf91$exports(value) && !$5475ba594a8bdf91$exports(other)) return value !== value && other !== other;
    return $bfbd466526f8d698$exports(value, other, bitmask, customizer, $6219f680e6e19178$var$baseIsEqual, stack);
}
$6219f680e6e19178$exports = $6219f680e6e19178$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $cd9547e820692bcd$var$isEqual(value, other) {
    return $6219f680e6e19178$exports(value, other);
}
$cd9547e820692bcd$exports = $cd9547e820692bcd$var$isEqual;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $450b349cbf00b834$var$__assign = function() {
    $450b349cbf00b834$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $450b349cbf00b834$var$__assign.apply(this, arguments);
};
function $450b349cbf00b834$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $450b349cbf00b834$var$mapRange = function(value, x1, y1, x2, y2) {
    return (value - x1) * (y2 - x2) / (y1 - x1) + x2;
};
var $450b349cbf00b834$var$rotate = function(degree, amount) {
    var result = degree + amount;
    return result > 360 ? result - 360 : result;
};
var $450b349cbf00b834$var$coinFlip = function() {
    return Math.random() > 0.5;
};
// avoid this for circles, as it will have no visual effect
var $450b349cbf00b834$var$zAxisRotation = [
    0,
    0,
    1
];
var $450b349cbf00b834$var$rotationTransforms = [
    // dual axis rotations (a bit more realistic)
    [
        1,
        1,
        0
    ],
    [
        1,
        0,
        1
    ],
    [
        0,
        1,
        1
    ],
    // single axis rotations (a bit dumber)
    [
        1,
        0,
        0
    ],
    [
        0,
        1,
        0
    ],
    $450b349cbf00b834$var$zAxisRotation
];
var $450b349cbf00b834$var$shouldBeCircle = function(rotationIndex) {
    return !(0, (/*@__PURE__*/$parcel$interopDefault($cd9547e820692bcd$exports)))($450b349cbf00b834$var$rotationTransforms[rotationIndex], $450b349cbf00b834$var$zAxisRotation) && $450b349cbf00b834$var$coinFlip();
};
var $450b349cbf00b834$var$ROTATION_SPEED_MIN = 200; // minimum possible duration of single particle full rotation
var $450b349cbf00b834$var$ROTATION_SPEED_MAX = 800; // maximum possible duration of single particle full rotation
var $450b349cbf00b834$var$CRAZY_PARTICLES_FREQUENCY = 0.1; // 0-1 frequency of crazy curvy unpredictable particles
var $450b349cbf00b834$var$CRAZY_PARTICLE_CRAZINESS = 0.25; // 0-1 how crazy these crazy particles are
var $450b349cbf00b834$var$BEZIER_MEDIAN = 0.5; // utility for mid-point bezier curves, to ensure smooth motion paths
var $450b349cbf00b834$var$rotationKeyframes = $450b349cbf00b834$var$rotationTransforms.reduce(function(acc, xyz, i) {
    var _a;
    return $450b349cbf00b834$var$__assign($450b349cbf00b834$var$__assign({}, acc), (_a = {}, _a["@keyframes rotation-".concat(i)] = {
        "50%": {
            transform: "rotate3d(".concat(xyz.map(function(v) {
                return v / 2;
            }).join(), ", 180deg)")
        },
        "100%": {
            transform: "rotate3d(".concat(xyz.join(), ", 360deg)")
        }
    }, _a));
}, {});
var $450b349cbf00b834$var$confettiKeyframes = function(degrees, height, width) {
    var y = typeof height === "string" ? height : "".concat(height, "px");
    var xLandingPoints = degrees.reduce(function(acc, degree, i) {
        var _a;
        var landingPoint = $450b349cbf00b834$var$mapRange(Math.abs($450b349cbf00b834$var$rotate(degree, 90) - 180), 0, 180, -width / 2, width / 2);
        return $450b349cbf00b834$var$__assign($450b349cbf00b834$var$__assign({}, acc), (_a = {}, _a["@keyframes x-axis-".concat(i)] = {
            to: {
                transform: "translateX(".concat(landingPoint, "px)")
            }
        }, _a));
    }, {});
    return $450b349cbf00b834$var$__assign({
        "@keyframes y-axis": {
            to: {
                transform: "translateY(".concat(y, ")")
            }
        }
    }, xLandingPoints);
};
var $450b349cbf00b834$var$confettoStyle = function(particle, duration, force, size, i) {
    var _a;
    var rotation = Math.round(Math.random() * ($450b349cbf00b834$var$ROTATION_SPEED_MAX - $450b349cbf00b834$var$ROTATION_SPEED_MIN) + $450b349cbf00b834$var$ROTATION_SPEED_MIN);
    var rotationIndex = Math.round(Math.random() * ($450b349cbf00b834$var$rotationTransforms.length - 1));
    var durationChaos = duration - Math.round(Math.random() * 1000);
    var shouldBeCrazy = Math.random() < $450b349cbf00b834$var$CRAZY_PARTICLES_FREQUENCY;
    var isCircle = $450b349cbf00b834$var$shouldBeCircle(rotationIndex);
    // x-axis disturbance, roughly the distance the particle will initially deviate from its target
    var x1 = shouldBeCrazy ? (0, (/*@__PURE__*/$parcel$interopDefault($69657479beae5299$exports)))(Math.random() * $450b349cbf00b834$var$CRAZY_PARTICLE_CRAZINESS, 2) : 0;
    var x2 = x1 * -1;
    var x3 = x1;
    // x-axis arc of explosion, so 90deg and 270deg particles have curve of 1, 0deg and 180deg have 0
    var x4 = (0, (/*@__PURE__*/$parcel$interopDefault($69657479beae5299$exports)))(Math.abs($450b349cbf00b834$var$mapRange(Math.abs($450b349cbf00b834$var$rotate(particle.degree, 90) - 180), 0, 180, -1, 1)), 4);
    // roughly how fast particle reaches end of its explosion curve
    var y1 = (0, (/*@__PURE__*/$parcel$interopDefault($69657479beae5299$exports)))(Math.random() * $450b349cbf00b834$var$BEZIER_MEDIAN, 4);
    // roughly maps to the distance particle goes before reaching free-fall
    var y2 = (0, (/*@__PURE__*/$parcel$interopDefault($69657479beae5299$exports)))(Math.random() * force * ($450b349cbf00b834$var$coinFlip() ? 1 : -1), 4);
    // roughly how soon the particle transitions from explosion to free-fall
    var y3 = $450b349cbf00b834$var$BEZIER_MEDIAN;
    // roughly the ease of free-fall
    var y4 = (0, (/*@__PURE__*/$parcel$interopDefault($69657479beae5299$exports)))(Math.max($450b349cbf00b834$var$mapRange(Math.abs(particle.degree - 180), 0, 180, force, -force), 0), 4);
    return _a = {}, _a["&#confetti-particle-".concat(i)] = {
        animation: "$x-axis-".concat(i, " ").concat(durationChaos, "ms forwards cubic-bezier(").concat(x1, ", ").concat(x2, ", ").concat(x3, ", ").concat(x4, ")"),
        "& > div": {
            width: isCircle ? size : Math.round(Math.random() * 4) + size / 2,
            height: isCircle ? size : Math.round(Math.random() * 2) + size,
            animation: "$y-axis ".concat(durationChaos, "ms forwards cubic-bezier(").concat(y1, ", ").concat(y2, ", ").concat(y3, ", ").concat(y4, ")"),
            "&:after": $450b349cbf00b834$var$__assign({
                backgroundColor: particle.color,
                animation: "$rotation-".concat(rotationIndex, " ").concat(rotation, "ms infinite linear")
            }, isCircle ? {
                borderRadius: "50%"
            } : {})
        }
    }, _a;
};
var $450b349cbf00b834$var$useStyles = function(_a) {
    var particles = _a.particles, duration = _a.duration, height = _a.height, width = _a.width, force = _a.force, particleSize = _a.particleSize;
    var confettiStyles = particles.reduce(function(acc, particle, i) {
        return $450b349cbf00b834$var$__assign($450b349cbf00b834$var$__assign({}, acc), $450b349cbf00b834$var$confettoStyle(particle, duration, force, particleSize, i));
    }, {});
    return (0, $4528a0b99e8f2c5b$export$644d15e5a9a5f175)($450b349cbf00b834$var$__assign($450b349cbf00b834$var$__assign($450b349cbf00b834$var$__assign({}, $450b349cbf00b834$var$rotationKeyframes), $450b349cbf00b834$var$confettiKeyframes(particles.map(function(particle) {
        return particle.degree;
    }), height, width)), {
        container: {
            width: 0,
            height: 0,
            position: "relative"
        },
        screen: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: "hidden",
            pointerEvents: "none"
        },
        particle: $450b349cbf00b834$var$__assign($450b349cbf00b834$var$__assign({}, confettiStyles), {
            "& > div": {
                position: "absolute",
                left: 0,
                top: 0,
                "&:after": {
                    content: "''",
                    display: "block",
                    width: "100%",
                    height: "100%"
                }
            }
        })
    }), {
        name: "confetti-explosion"
    });
};
var $450b349cbf00b834$var$FORCE = 0.5; // 0-1 roughly the vertical force at which particles initially explode
var $450b349cbf00b834$var$SIZE = 12; // max height for particle rectangles, diameter for particle circles
var $450b349cbf00b834$var$HEIGHT = "120vh"; // distance particles will fall from initial explosion point
var $450b349cbf00b834$var$WIDTH = 1000; // horizontal spread of particles in pixels
var $450b349cbf00b834$var$PARTICLE_COUNT = 100;
var $450b349cbf00b834$var$DURATION = 2200;
var $450b349cbf00b834$var$COLORS = [
    "#FFC700",
    "#FF0000",
    "#2E3191",
    "#41BBC7"
];
var $450b349cbf00b834$var$createParticles = function(count, colors) {
    var increment = 360 / count;
    return (0, (/*@__PURE__*/$parcel$interopDefault($90c08e8577660937$exports)))(count).map(function(index) {
        return {
            color: colors[index % colors.length],
            degree: increment * index
        };
    });
};
function $450b349cbf00b834$export$2e2bcd8739ae039(_a) {
    var _b = _a.particleCount, particleCount = _b === void 0 ? $450b349cbf00b834$var$PARTICLE_COUNT : _b, _c = _a.duration, duration = _c === void 0 ? $450b349cbf00b834$var$DURATION : _c, _d = _a.colors, colors = _d === void 0 ? $450b349cbf00b834$var$COLORS : _d, _e = _a.particleSize, particleSize = _e === void 0 ? $450b349cbf00b834$var$SIZE : _e, _f = _a.force, force = _f === void 0 ? $450b349cbf00b834$var$FORCE : _f, _g = _a.height, height = _g === void 0 ? $450b349cbf00b834$var$HEIGHT : _g, _h = _a.width, width = _h === void 0 ? $450b349cbf00b834$var$WIDTH : _h, zIndex = _a.zIndex, onComplete = _a.onComplete, props = $450b349cbf00b834$var$__rest(_a, [
        "particleCount",
        "duration",
        "colors",
        "particleSize",
        "force",
        "height",
        "width",
        "zIndex",
        "onComplete"
    ]);
    var _j = $exYeM.useState(), origin = _j[0], setOrigin = _j[1];
    var particles = $450b349cbf00b834$var$createParticles(particleCount, colors);
    var classes = $450b349cbf00b834$var$useStyles({
        particles: particles,
        duration: duration,
        particleSize: particleSize,
        force: force,
        width: width,
        height: height
    })();
    var originRef = $exYeM.useCallback(function(node) {
        if (node) {
            var _a = node.getBoundingClientRect(), top_1 = _a.top, left = _a.left;
            setOrigin({
                top: top_1,
                left: left
            });
        }
    }, []);
    $exYeM.useEffect(function() {
        if (typeof onComplete === "function") {
            var timeout_1 = setTimeout(onComplete, duration);
            return function() {
                return clearTimeout(timeout_1);
            };
        }
    }, [
        duration,
        onComplete
    ]);
    return (0, $7ead0b1397a835ed$exports.jsx)("div", $450b349cbf00b834$var$__assign({
        ref: originRef,
        className: classes.container
    }, props, {
        children: origin && (0, $97dc602bd7e23afa$exports.createPortal)((0, $7ead0b1397a835ed$exports.jsx)("div", $450b349cbf00b834$var$__assign({
            className: classes.screen
        }, zIndex ? {
            style: {
                zIndex: zIndex
            }
        } : null, {
            children: (0, $7ead0b1397a835ed$exports.jsx)("div", $450b349cbf00b834$var$__assign({
                style: {
                    position: "absolute",
                    top: origin.top,
                    left: origin.left
                }
            }, {
                children: particles.map(function(particle, i) {
                    return (0, $7ead0b1397a835ed$exports.jsx)("div", $450b349cbf00b834$var$__assign({
                        id: "confetti-particle-".concat(i),
                        className: classes.particle
                    }, {
                        children: (0, $7ead0b1397a835ed$exports.jsx)("div", {})
                    }), particle.degree);
                })
            }))
        })), document.body)
    }));
}






var $exYeM = parcelRequire("exYeM");


/**
 * lucide-react v0.288.0 - ISC
 */ 
const $82b4aed4336fccaf$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("SendHorizontal", [
    [
        "path",
        {
            d: "m3 3 3 9-3 9 19-9Z",
            key: "1aobqy"
        }
    ],
    [
        "path",
        {
            d: "M6 12h16",
            key: "s4cdu5"
        }
    ]
]);

/**
 * lucide-react v0.288.0 - ISC
 */ 
const $bddb89744f992361$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Shuffle", [
    [
        "path",
        {
            d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22",
            key: "1wmou1"
        }
    ],
    [
        "path",
        {
            d: "m18 2 4 4-4 4",
            key: "pucp1d"
        }
    ],
    [
        "path",
        {
            d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2",
            key: "10bdb2"
        }
    ],
    [
        "path",
        {
            d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8",
            key: "vgxac0"
        }
    ],
    [
        "path",
        {
            d: "m18 14 4 4-4 4",
            key: "10pe0f"
        }
    ]
]);

/**
 * lucide-react v0.288.0 - ISC
 */ 
const $1a719a14cd697b5c$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("Undo", [
    [
        "path",
        {
            d: "M3 7v6h6",
            key: "1v2h90"
        }
    ],
    [
        "path",
        {
            d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13",
            key: "1r6uu6"
        }
    ]
]);





function $ce11fc0de04d3f48$var$GameControlButtonsPanel({ shuffledRows: shuffledRows , setShuffledRows: setShuffledRows , setGridShake: setGridShake  }) {
    const { isGameOver: isGameOver , guessCandidate: guessCandidate , setGuessCandidate: setGuessCandidate , submittedGuesses: submittedGuesses , setSubmittedGuesses: setSubmittedGuesses , solvedGameData: solvedGameData , setSolvedGameData: setSolvedGameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $114a14924666ebd7$export$3f49015a6304186f));
    const { gameData: gameData , categorySize: categorySize  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $4a5925ef595e0ef1$export$e8331451049320c2));
    const { toast: toast  } = (0, $4577ad0c1cb23611$export$a407b657d3044108)();
    function deselectAll() {
        setGuessCandidate([]);
    }
    function submitCandidateGuess() {
        // check that its a valid guess by size
        if (guessCandidate.length !== categorySize) return;
        // check that the guess hasnt already been submitted previously
        if ((0, $c10a8025d61652dc$export$a7c89472cbd6a2db)({
            submittedGuesses: submittedGuesses,
            guessCandidate: guessCandidate
        })) {
            toast({
                label: "Notification",
                title: "Repeated Guess",
                description: "You previously made this guess!"
            });
            return;
        }
        // add guess to state
        setSubmittedGuesses([
            ...submittedGuesses,
            guessCandidate
        ]);
        // check if the guess is correct
        const { isCorrect: isCorrect , correctWords: correctWords , correctCategory: correctCategory , isGuessOneAway: isGuessOneAway , correctDifficulty: correctDifficulty , correctImageSrc: correctImageSrc  } = (0, $c10a8025d61652dc$export$872584ef35ecfeaa)({
            guessCandidate: guessCandidate,
            gameData: gameData
        });
        // if the guess is correct:
        // set it as solved in game data
        if (isCorrect) {
            setSolvedGameData([
                ...solvedGameData,
                {
                    category: correctCategory,
                    words: correctWords,
                    difficulty: correctDifficulty,
                    imageSrc: correctImageSrc
                }
            ]);
            setGuessCandidate([]);
        } else {
            // Shake the grid to give feedback that they were wrong
            setGridShake(true);
            if (isGuessOneAway) toast({
                label: "Notification",
                title: "Close Guess",
                description: "You were one guess away from correctly guessing a category!"
            });
        }
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "grid grid-cols-3 gap-4",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9cfb09368e977195$export$353f5b6fc5456de1), {
                disabled: isGameOver,
                variant: "secondary",
                onClick: ()=>setShuffledRows((0, $c10a8025d61652dc$export$d1246a55b993f861)({
                        gameData: shuffledRows
                    })),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bddb89744f992361$export$2e2bcd8739ae039), {
                        className: "h-4 w-4 mr-2",
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        className: "select-none",
                        children: "Shuffle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9cfb09368e977195$export$353f5b6fc5456de1), {
                size: "deselectallsize",
                disabled: isGameOver,
                variant: "secondary",
                onClick: deselectAll,
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $1a719a14cd697b5c$export$2e2bcd8739ae039), {
                        className: "h-4 w-4 mr-2",
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        className: "select-none",
                        children: "Deselect All"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9cfb09368e977195$export$353f5b6fc5456de1), {
                variant: "submit",
                onClick: submitCandidateGuess,
                disabled: isGameOver || guessCandidate.length !== categorySize,
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $82b4aed4336fccaf$export$2e2bcd8739ae039), {
                        className: "h-4 w-4 mr-2",
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        className: "select-none",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
}
var $ce11fc0de04d3f48$export$2e2bcd8739ae039 = $ce11fc0de04d3f48$var$GameControlButtonsPanel;






var $exYeM = parcelRequire("exYeM");







function $e53dc3a666164c84$var$ViewResultsModal() {
    const { submittedGuesses: submittedGuesses  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $114a14924666ebd7$export$3f49015a6304186f));
    const { gameData: gameData  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $4a5925ef595e0ef1$export$e8331451049320c2));
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $338f7003293b487c$export$2e2bcd8739ae039), {
        title: "",
        trigger: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9cfb09368e977195$export$353f5b6fc5456de1), {
            variant: "submit",
            className: "w-full",
            children: "View Results"
        }),
        initiallyOpen: false,
        showActionButton: false,
        footerElements: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5785a8a4a36b00ae$export$2e2bcd8739ae039), {
            buttonText: "Share Your Score!"
        }),
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
            className: "flex flex-col place-content-center",
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                    className: "text-center font-[600]",
                    children: "Your Guesses Are Represented Below"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                    className: "text-center whitespace-pre mb-2",
                    children: [
                        "\n",
                        (0, $c10a8025d61652dc$export$a63577e223e2a6c9)(gameData, submittedGuesses)
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $3e05a86555e33446$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $e53dc3a666164c84$export$2e2bcd8739ae039 = $e53dc3a666164c84$var$ViewResultsModal;




function $b60d5ef55411eecc$var$Game() {
    const { gameData: gameData , categorySize: categorySize , numCategories: numCategories  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $4a5925ef595e0ef1$export$e8331451049320c2));
    const { submittedGuesses: submittedGuesses , solvedGameData: solvedGameData , isGameOver: isGameOver , isGameWon: isGameWon  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $114a14924666ebd7$export$3f49015a6304186f));
    const [shuffledRows, setShuffledRows] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState((0, $c10a8025d61652dc$export$d1246a55b993f861)({
        gameData: gameData
    }));
    const [isEndGameModalOpen, setisEndGameModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [gridShake, setGridShake] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showConfetti, setShowConfetti] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    // use effect to update Game Grid after a row has been correctly solved
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const categoriesToRemoveFromRows = solvedGameData.map((data)=>data.category);
        const dataLeftForRows = gameData.filter((data)=>{
            return !categoriesToRemoveFromRows.includes(data.category);
        });
        if (dataLeftForRows.length > 0) setShuffledRows((0, $c10a8025d61652dc$export$d1246a55b993f861)({
            gameData: dataLeftForRows
        }));
    }, [
        solvedGameData
    ]);
    // Handle End Game!
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (!isGameOver) return;
        // extra delay for game won to allow confetti to show
        const modalDelay = isGameWon ? 2000 : 250;
        const delayModalOpen = window.setTimeout(()=>{
            setisEndGameModalOpen(true);
            //unmount confetti after modal opens
            setShowConfetti(false);
        }, modalDelay);
        if (isGameWon) setShowConfetti(true);
        return ()=>window.clearTimeout(delayModalOpen);
    }, [
        isGameOver
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("h3", {
                className: "text-xl text-center mt-4",
                children: [
                    "Create ",
                    numCategories,
                    " groups of ",
                    categorySize
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: `game-wrapper`,
                children: [
                    isGameOver && isGameWon ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4bbf5d51114ba904$export$2e2bcd8739ae039), {
                        open: isEndGameModalOpen,
                        submittedGuesses: submittedGuesses
                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2c961eea6ce58655$export$2e2bcd8739ae039), {
                        open: isEndGameModalOpen,
                        submittedGuesses: submittedGuesses
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $88d90183f3ddc7ad$export$2e2bcd8739ae039), {
                        gameRows: shuffledRows,
                        shouldGridShake: gridShake,
                        setShouldGridShake: setGridShake
                    }),
                    showConfetti && isGameOver && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "grid place-content-center",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $450b349cbf00b834$export$2e2bcd8739ae039), {
                            particleCount: 100,
                            force: 0.8,
                            duration: 2500
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $1af14bb17819bdb0$export$1ff3c3f08ae963c0), {}),
                    !isGameOver ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $beecaaa3d2850506$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $ce11fc0de04d3f48$export$2e2bcd8739ae039), {
                                shuffledRows: shuffledRows,
                                setShuffledRows: setShuffledRows,
                                setGridShake: setGridShake
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e53dc3a666164c84$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
var $b60d5ef55411eecc$export$2e2bcd8739ae039 = $b60d5ef55411eecc$var$Game;







var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");














var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $4ed20962d3818fe0$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $4ed20962d3818fe0$export$439d29a4e110a164 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($4ed20962d3818fe0$export$439d29a4e110a164, {
    displayName: $4ed20962d3818fe0$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $4ed20962d3818fe0$export$be92b6f5f03c0fe9 = $4ed20962d3818fe0$export$439d29a4e110a164;


/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
const [$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$Collection, $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useCollection, $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)("Toast");
const [$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createToastContext, $b2f94c4ddacb0237$export$8a359da18fbc9073] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)("Toast", [
    $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createCollectionScope
]);
const [$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastProviderProvider, $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext] = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createToastContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$PROVIDER_NAME);
const $b2f94c4ddacb0237$export$f5d03d415824e0e = (props)=>{
    const { __scopeToast: __scopeToast , label: label = "Notification" , duration: duration = 5000 , swipeDirection: swipeDirection = "right" , swipeThreshold: swipeThreshold = 50 , children: children  } = props;
    const [viewport, setViewport] = (0, $exYeM.useState)(null);
    const [toastCount, setToastCount] = (0, $exYeM.useState)(0);
    const isFocusedToastEscapeKeyDownRef = (0, $exYeM.useRef)(false);
    const isClosePausedRef = (0, $exYeM.useRef)(false);
    return /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0, $exYeM.useCallback)(()=>setToastCount((prevCount)=>prevCount + 1), []),
        onToastRemove: (0, $exYeM.useCallback)(()=>setToastCount((prevCount)=>prevCount - 1), []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$b2f94c4ddacb0237$export$f5d03d415824e0e.propTypes = {
    label (props) {
        if (props.label && typeof props.label === "string" && !props.label.trim()) {
            const error = `Invalid prop \`label\` supplied to \`${$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$f5d03d415824e0e, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    "F8"
];
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
const $b2f94c4ddacb0237$export$6192c2425ecfd989 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , hotkey: hotkey = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY , label: label = "Notifications ({hotkey})" , ...viewportProps } = props;
    const context = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    const getItems = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useCollection(__scopeToast);
    const wrapperRef = (0, $exYeM.useRef)(null);
    const headFocusProxyRef = (0, $exYeM.useRef)(null);
    const tailFocusProxyRef = (0, $exYeM.useRef)(null);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    const hasToasts = context.toastCount > 0;
    (0, $exYeM.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key);
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        hotkey
    ]);
    (0, $exYeM.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        const viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            const handlePause = ()=>{
                if (!context.isClosePausedRef.current) {
                    const pauseEvent = new CustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            const handleResume = ()=>{
                if (context.isClosePausedRef.current) {
                    const resumeEvent = new CustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            const handleFocusOutResume = (event)=>{
                const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            const handlePointerLeaveResume = ()=>{
                const isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener("focusin", handlePause);
            wrapper.addEventListener("focusout", handleFocusOutResume);
            wrapper.addEventListener("pointermove", handlePause);
            wrapper.addEventListener("pointerleave", handlePointerLeaveResume);
            window.addEventListener("blur", handlePause);
            window.addEventListener("focus", handleResume);
            return ()=>{
                wrapper.removeEventListener("focusin", handlePause);
                wrapper.removeEventListener("focusout", handleFocusOutResume);
                wrapper.removeEventListener("pointermove", handlePause);
                wrapper.removeEventListener("pointerleave", handlePointerLeaveResume);
                window.removeEventListener("blur", handlePause);
                window.removeEventListener("focus", handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    const getSortedTabbableCandidates = (0, $exYeM.useCallback)(({ tabbingDirection: tabbingDirection  })=>{
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem)=>{
            const toastNode = toastItem.ref.current;
            const toastTabbableCandidates = [
                toastNode,
                ...$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
            ];
            return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0, $exYeM.useEffect)(()=>{
        const viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            const handleKeyDown = (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === "Tab" && !isMetaKey;
                if (isTabKey) {
                    const focusedElement = document.activeElement;
                    const isTabbingBackwards = event.shiftKey;
                    const targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
                    const sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    const index = sortedCandidates.findIndex((candidate)=>candidate === focusedElement);
                    if ($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener("keydown", handleKeyDown);
            return ()=>viewport.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$aecb2ddcb55c95be), {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace("{hotkey}", hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : "none"
        }
    }, hasToasts && /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "forwards"
            });
            $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).ol, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "backwards"
            });
            $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$6192c2425ecfd989, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , onFocusFromOutsideViewport: onFocusFromOutsideViewport , ...proxyProps } = props;
    const context = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4ed20962d3818fe0$export$439d29a4e110a164), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: "fixed"
        },
        onFocus: (event)=>{
            var _context$viewport;
            const prevFocusedElement = event.relatedTarget;
            const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FocusProxy, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME = "Toast";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
const $b2f94c4ddacb0237$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , ...toastProps } = props;
    const [open = true, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: ()=>setOpen(false),
        onPause: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(props.onPause),
        onResume: (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(props.onResume),
        onSwipeStart: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onSwipeStart, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onSwipeMove, (event)=>{
            const { x: x , y: y  } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "move");
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y}px`);
        }),
        onSwipeCancel: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onSwipeCancel, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "cancel");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onSwipeEnd, (event)=>{
            const { x: x , y: y  } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "end");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y}px`);
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$8d8dc7d5f743331b, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastInteractiveProvider, $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastInteractiveContext] = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$createToastContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME, {
    onClose () {}
});
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , type: type = "foreground" , duration: durationProp , open: open , onClose: onClose , onEscapeKeyDown: onEscapeKeyDown , onPause: onPause , onResume: onResume , onSwipeStart: onSwipeStart , onSwipeMove: onSwipeMove , onSwipeCancel: onSwipeCancel , onSwipeEnd: onSwipeEnd , ...toastProps } = props;
    const context = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [node1, setNode] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const pointerStartRef = (0, $exYeM.useRef)(null);
    const swipeDeltaRef = (0, $exYeM.useRef)(null);
    const duration1 = durationProp || context.duration;
    const closeTimerStartTimeRef = (0, $exYeM.useRef)(0);
    const closeTimerRemainingTimeRef = (0, $exYeM.useRef)(duration1);
    const closeTimerRef = (0, $exYeM.useRef)(0);
    const { onToastAdd: onToastAdd , onToastRemove: onToastRemove  } = context;
    const handleClose = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(()=>{
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    const startTimer = (0, $exYeM.useCallback)((duration)=>{
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0, $exYeM.useEffect)(()=>{
        const viewport = context.viewport;
        if (viewport) {
            const handleResume = ()=>{
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            const handlePause = ()=>{
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return ()=>{
                viewport.removeEventListener($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0, $exYeM.useEffect)(()=>{
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0, $exYeM.useEffect)(()=>{
        onToastAdd();
        return ()=>onToastRemove();
    }, [
        onToastAdd,
        onToastRemove
    ]);
    const announceTextContent = (0, $exYeM.useMemo)(()=>{
        return node1 ? $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, announceTextContent && /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0, $97dc602bd7e23afa$exports.createPortal)(/*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$be92b6f5f03c0fe9), {
        asChild: true,
        onEscapeKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(onEscapeKeyDown, ()=>{
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).li, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? "open" : "closed",
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: {
            userSelect: "none",
            touchAction: "none",
            ...props.style
        },
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key !== "Escape") return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (!pointerStartRef.current) return;
            const x = event.clientX - pointerStartRef.current.x;
            const y = event.clientY - pointerStartRef.current.y;
            const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            const isHorizontalSwipe = [
                "left",
                "right"
            ].includes(context.swipeDirection);
            const clamp = [
                "left",
                "up"
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            const clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            const clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
            const delta = {
                x: clampedX,
                y: clampedY
            };
            const eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerUp, (event1)=>{
            const delta = swipeDeltaRef.current;
            const target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                const toast = event1.currentTarget;
                const eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener("click", (event)=>event.preventDefault(), {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type (props) {
        if (props.type && ![
            "foreground",
            "background"
        ].includes(props.type)) {
            const error = `Invalid prop \`type\` supplied to \`${$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounce = (props)=>{
    const { __scopeToast: __scopeToast , children: children , ...announceProps } = props;
    const context = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastProviderContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [renderAnnounceText, setRenderAnnounceText] = (0, $exYeM.useState)(false);
    const [isAnnounced, setIsAnnounced] = (0, $exYeM.useState)(false); // render text content in the next frame to ensure toast is announced in NVDA
    $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useNextFrame(()=>setRenderAnnounceText(true)); // cleanup after announcing
    (0, $exYeM.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsAnnounced(true), 1000);
        return ()=>window.clearTimeout(timer);
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4ed20962d3818fe0$export$439d29a4e110a164), announceProps, renderAnnounceText && /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TITLE_NAME = "ToastTitle";
const $b2f94c4ddacb0237$export$16d42d7c29b95a4 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...titleProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$16d42d7c29b95a4, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$DESCRIPTION_NAME = "ToastDescription";
const $b2f94c4ddacb0237$export$ecddd96c53621d9a = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...descriptionProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$ecddd96c53621d9a, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
const $b2f94c4ddacb0237$export$3019feecfda683d2 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { altText: altText , ...actionProps } = props;
    if (!altText) return null;
    return /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$export$811e70f61c205839, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, actionProps, {
        ref: forwardedRef
    })));
});
$b2f94c4ddacb0237$export$3019feecfda683d2.propTypes = {
    altText (props) {
        if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ACTION_NAME}\``);
        return null;
    }
};
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$3019feecfda683d2, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
const $b2f94c4ddacb0237$export$811e70f61c205839 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , ...closeProps } = props;
    const interactiveContext = $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useToastInteractiveContext($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $exYeM.createElement)($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($b2f94c4ddacb0237$export$811e70f61c205839, {
    displayName: $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast , altText: altText , ...announceExcludeProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getAnnounceTextContent(container) {
    const textContent = [];
    const childNodes = Array.from(container.childNodes);
    childNodes.forEach((node)=>{
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isHTMLElement(node)) {
            const isHidden = node.ariaHidden || node.hidden || node.style.display === "none";
            const isExcluded = node.dataset.radixToastAnnounceExclude === "";
            if (!isHidden) {
                if (isExcluded) {
                    const altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else textContent.push(...$b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getAnnounceTextContent(node));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const currentTarget = detail.originalEvent.currentTarget;
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
const $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0)=>{
    const deltaX = Math.abs(delta.x);
    const deltaY = Math.abs(delta.y);
    const isDeltaX = deltaX > deltaY;
    if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$useNextFrame(callback = ()=>{}) {
    const fn = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(callback);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        let raf1 = 0;
        let raf2 = 0;
        raf1 = window.requestAnimationFrame(()=>raf2 = window.requestAnimationFrame(fn));
        return ()=>{
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $b2f94c4ddacb0237$var$$054eb8030ebde76e$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
const $b2f94c4ddacb0237$export$2881499e37b75b9a = $b2f94c4ddacb0237$export$f5d03d415824e0e;
const $b2f94c4ddacb0237$export$d5c6c08dc2d3ca7 = $b2f94c4ddacb0237$export$6192c2425ecfd989;
const $b2f94c4ddacb0237$export$be92b6f5f03c0fe9 = $b2f94c4ddacb0237$export$8d8dc7d5f743331b;
const $b2f94c4ddacb0237$export$f99233281efd08a0 = $b2f94c4ddacb0237$export$16d42d7c29b95a4;
const $b2f94c4ddacb0237$export$393edc798c47379d = $b2f94c4ddacb0237$export$ecddd96c53621d9a;
const $b2f94c4ddacb0237$export$e19cd5f9376f8cee = $b2f94c4ddacb0237$export$3019feecfda683d2;
const $b2f94c4ddacb0237$export$f39c2d165cd861fe = $b2f94c4ddacb0237$export$811e70f61c205839;




/**
 * lucide-react v0.288.0 - ISC
 */ 
const $5710fed419a1c745$export$2e2bcd8739ae039 = (0, $84967fc29334d97c$export$2e2bcd8739ae039)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);



const $5ea512f5a1fde33b$export$f5d03d415824e0e = $b2f94c4ddacb0237$export$2881499e37b75b9a;
const $5ea512f5a1fde33b$export$6192c2425ecfd989 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($965ca2171585ad7a$export$be92b6f5f03c0fe9, {
        className: "fixed z-[200]",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($b2f94c4ddacb0237$export$d5c6c08dc2d3ca7, {
            ref: ref,
            className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]", className),
            ...props
        })
    }));
$5ea512f5a1fde33b$export$6192c2425ecfd989.displayName = $b2f94c4ddacb0237$export$d5c6c08dc2d3ca7.displayName;
const $5ea512f5a1fde33b$var$toastVariants = (0, $f6c488ee7ea67d84$export$87dc52566e90b739)("group pointer-events-auto z-160 relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full", {
    variants: {
        variant: {
            default: "border bg-background text-foreground",
            destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
const $5ea512f5a1fde33b$export$8d8dc7d5f743331b = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , variant: variant , ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($b2f94c4ddacb0237$export$be92b6f5f03c0fe9, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)($5ea512f5a1fde33b$var$toastVariants({
            variant: variant
        }), className),
        ...props
    });
});
$5ea512f5a1fde33b$export$8d8dc7d5f743331b.displayName = $b2f94c4ddacb0237$export$be92b6f5f03c0fe9.displayName;
const $5ea512f5a1fde33b$export$3019feecfda683d2 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($b2f94c4ddacb0237$export$e19cd5f9376f8cee, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive", className),
        ...props
    }));
$5ea512f5a1fde33b$export$3019feecfda683d2.displayName = $b2f94c4ddacb0237$export$e19cd5f9376f8cee.displayName;
const $5ea512f5a1fde33b$export$811e70f61c205839 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($b2f94c4ddacb0237$export$f39c2d165cd861fe, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600", className),
        "toast-close": "",
        ...props,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5710fed419a1c745$export$2e2bcd8739ae039), {
            className: "h-4 w-4"
        })
    }));
$5ea512f5a1fde33b$export$811e70f61c205839.displayName = $b2f94c4ddacb0237$export$f39c2d165cd861fe.displayName;
const $5ea512f5a1fde33b$export$16d42d7c29b95a4 = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($b2f94c4ddacb0237$export$f99233281efd08a0, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("text-sm font-semibold", className),
        ...props
    }));
$5ea512f5a1fde33b$export$16d42d7c29b95a4.displayName = $b2f94c4ddacb0237$export$f99233281efd08a0.displayName;
const $5ea512f5a1fde33b$export$ecddd96c53621d9a = /*#__PURE__*/ $exYeM.forwardRef(({ className: className , ...props }, ref)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($b2f94c4ddacb0237$export$393edc798c47379d, {
        ref: ref,
        className: (0, $56229cc9fc90141d$export$1343a74baacb0543)("text-sm opacity-90", className),
        ...props
    }));
$5ea512f5a1fde33b$export$ecddd96c53621d9a.displayName = $b2f94c4ddacb0237$export$393edc798c47379d.displayName;



function $55d4185f67cfefab$export$fb98e3a2a4cd92d7() {
    const { toasts: toasts  } = (0, $4577ad0c1cb23611$export$a407b657d3044108)();
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5ea512f5a1fde33b$export$f5d03d415824e0e), {
        children: [
            toasts.map(function({ id: id , title: title , description: description , action: action , ...props }) {
                return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5ea512f5a1fde33b$export$8d8dc7d5f743331b), {
                    ...props,
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "grid gap-1",
                            children: [
                                title && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5ea512f5a1fde33b$export$16d42d7c29b95a4), {
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5ea512f5a1fde33b$export$ecddd96c53621d9a), {
                                    children: description
                                })
                            ]
                        }),
                        action,
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5ea512f5a1fde33b$export$811e70f61c205839), {})
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5ea512f5a1fde33b$export$6192c2425ecfd989), {})
        ]
    });
}




function $adee9df12d2c2787$var$App() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a5925ef595e0ef1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $114a14924666ebd7$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $55d4185f67cfefab$export$fb98e3a2a4cd92d7), {}),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $ce2bbf7743ae7f98$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b60d5ef55411eecc$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}
var $adee9df12d2c2787$export$2e2bcd8739ae039 = $adee9df12d2c2787$var$App;






const $b8f9b7833fa37166$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)(document.querySelector("#root"));
$b8f9b7833fa37166$var$root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adee9df12d2c2787$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.cabda5b3.js.map
